/* globals jQuery */

(function($) {
  // Selector to select only not already processed elements
  $.expr[":"].notmdproc = function(obj){
    if ($(obj).data("mdproc")) {
      return false;
    } else {
      return true;
    }
  };

  function _isChar(evt) {
    if (typeof evt.which == "undefined") {
      return true;
    } else if (typeof evt.which == "number" && evt.which > 0) {
      return !evt.ctrlKey && !evt.metaKey && !evt.altKey && evt.which != 8 && evt.which != 9;
    }
    return false;
  }

  $.material =  {
    "options": {
      // These options set what will be started by $.material.init()
      "input": true,
      "ripples": true,
      "checkbox": true,
      "togglebutton": true,
      "radio": true,
      "arrive": true,
      "autofill": false,

      "withRipples": [
        ".btn:not(.btn-link)",
        ".card-image",
        ".navbar a:not(.withoutripple)",
        ".dropdown-menu a",
        ".nav-tabs a:not(.withoutripple)",
        ".withripple"
      ].join(","),
      "inputElements": "input.form-control, textarea.form-control, select.form-control",
      "checkboxElements": ".checkbox > label > input[type=checkbox]",
      "togglebuttonElements": ".togglebutton > label > input[type=checkbox]",
      "radioElements": ".radio > label > input[type=radio]"
    },
    "checkbox": function(selector) {
      // Add fake-checkbox to material checkboxes
      $((selector) ? selector : this.options.checkboxElements)
      .filter(":notmdproc")
      .data("mdproc", true)
      .after("<span class=checkbox-material><span class=check></span></span>");
    },
    "togglebutton": function(selector) {
      // Add fake-checkbox to material checkboxes
      $((selector) ? selector : this.options.togglebuttonElements)
      .filter(":notmdproc")
      .data("mdproc", true)
      .after("<span class=toggle></span>");
    },
    "radio": function(selector) {
      // Add fake-radio to material radios
      $((selector) ? selector : this.options.radioElements)
      .filter(":notmdproc")
      .data("mdproc", true)
      .after("<span class=circle></span><span class=check></span>");
    },
    "input": function(selector) {
      $((selector) ? selector : this.options.inputElements)
      .filter(":notmdproc")
      .data("mdproc", true)
      .each( function() {
        var $this = $(this);

        if (!$(this).attr("data-hint") && !$this.hasClass("floating-label")) {
          return;
        }
        $this.wrap("<div class=form-control-wrapper></div>");
        $this.after("<span class=material-input></span>");

        // Add floating label if required
        if ($this.hasClass("floating-label")) {
          var placeholder = $this.attr("placeholder");
          $this.attr("placeholder", null).removeClass("floating-label");
          $this.after("<div class=floating-label>" + placeholder + "</div>");
        }

        // Add hint label if required
        if ($this.attr("data-hint")) {
          $this.after("<div class=hint>" + $this.attr("data-hint") + "</div>");
        }

        // Set as empty if is empty (damn I must improve this...)
        if ($this.val() === null || $this.val() == "undefined" || $this.val() === "") {
          $this.addClass("empty");
        }

        // Support for file input
        if ($this.parent().next().is("[type=file]")) {
          $this.parent().addClass("fileinput");
          var $input = $this.parent().next().detach();
          $this.after($input);
        }
      });

      $(document)
      .on("change", ".checkbox input[type=checkbox]", function() { $(this).blur(); })
      .on("keydown paste", ".form-control", function(e) {
        if(_isChar(e)) {
          $(this).removeClass("empty");
        }
      })
      .on("keyup change", ".form-control", function() {
        var $this = $(this);
        if ($this.val() === "" && (typeof $this[0].checkValidity != "undefined" && $this[0].checkValidity())) {
          $this.addClass("empty");
        } else {
          $this.removeClass("empty");
        }
      })
      .on("focus", ".form-control-wrapper.fileinput", function() {
        $(this).find("input").addClass("focus");
      })
      .on("blur", ".form-control-wrapper.fileinput", function() {
        $(this).find("input").removeClass("focus");
      })
      .on("change", ".form-control-wrapper.fileinput [type=file]", function() {
        var value = "";
        $.each($(this)[0].files, function(i, file) {
          value += file.name + ", ";
        });
        value = value.substring(0, value.length - 2);
        if (value) {
          $(this).prev().removeClass("empty");
        } else {
          $(this).prev().addClass("empty");
        }
        $(this).prev().val(value);
      });
    },
    "ripples": function(selector) {
      $((selector) ? selector : this.options.withRipples).ripples();
    },
    "autofill": function() {

      // This part of code will detect autofill when the page is loading (username and password inputs for example)
      var loading = setInterval(function() {
        $("input[type!=checkbox]").each(function() {
          if ($(this).val() && $(this).val() !== $(this).attr("value")) {
            $(this).trigger("change");
          }
        });
      }, 100);

      // After 10 seconds we are quite sure all the needed inputs are autofilled then we can stop checking them
      setTimeout(function() {
        clearInterval(loading);
      }, 10000);
      // Now we just listen on inputs of the focused form (because user can select from the autofill dropdown only when the input has focus)
      var focused;
      $(document)
      .on("focus", "input", function() {
        var $inputs = $(this).parents("form").find("input").not("[type=file]");
        focused = setInterval(function() {
          $inputs.each(function() {
            if ($(this).val() !== $(this).attr("value")) {
              $(this).trigger("change");
            }
          });
        }, 100);
      })
      .on("blur", "input", function() {
        clearInterval(focused);
      });
    },
    "init": function() {
      if ($.fn.ripples && this.options.ripples) {
        this.ripples();
      }
      if (this.options.input) {
        this.input();
      }
      if (this.options.checkbox) {
        this.checkbox();
      }
      if (this.options.togglebutton) {
        this.togglebutton();
      }
      if (this.options.radio) {
        this.radio();
      }
      if (this.options.autofill) {
        this.autofill();
      }

      if (document.arrive && this.options.arrive) {
        if ($.fn.ripples && this.options.ripples) {
          $(document).arrive(this.options.withRipples, function() {
            $.material.ripples($(this));
          });
        }
        if (this.options.input) {
          $(document).arrive(this.options.inputElements, function() {
            $.material.input($(this));
          });
        }
        if (this.options.checkbox) {
          $(document).arrive(this.options.checkboxElements, function() {
            $.material.checkbox($(this));
          });
        }
        if (this.options.radio) {
          $(document).arrive(this.options.radioElements, function() {
            $.material.radio($(this));
          });
        }
        if (this.options.togglebutton) {
          $(document).arrive(this.options.togglebuttonElements, function() {
            $.material.togglebutton($(this));
          });
        }

      }
    }
  };

})(jQuery);

/* Copyright 2014+, Federico Zivolo, LICENSE at https://github.com/FezVrasta/bootstrap-material-design/blob/master/LICENSE.md */
/* globals jQuery, navigator */

(function($, window, document, undefined) {

  "use strict";

  /**
   * Define the name of the plugin
   */
  var ripples = "ripples";


  /**
   * Get an instance of the plugin
   */
  var self = null;


  /**
   * Define the defaults of the plugin
   */
  var defaults = {};


  /**
   * Create the main plugin function
   */
  function Ripples(element, options) {
    self = this;

    this.element = $(element);

    this.options = $.extend({}, defaults, options);

    this._defaults = defaults;
    this._name = ripples;

    this.init();
  }


  /**
   * Initialize the plugin
   */
  Ripples.prototype.init = function() {
    var $element  = this.element;

    $element.on("mousedown touchstart", function(event) {
      /**
       * Verify if the user is just touching on a device and return if so
       */
      if(self.isTouch() && event.type === "mousedown") {
        return;
      }


      /**
       * Verify if the current element already has a ripple wrapper element and
       * creates if it doesn't
       */
      if(!($element.find(".ripple-wrapper").length)) {
        $element.append("<div class=\"ripple-wrapper\"></div>");
      }


      /**
       * Find the ripple wrapper
       */
      var $wrapper = $element.children(".ripple-wrapper");


      /**
       * Get relY and relX positions
       */
      var relY = self.getRelY($wrapper, event);
      var relX = self.getRelX($wrapper, event);


      /**
       * If relY and/or relX are false, return the event
       */
      if(!relY && !relX) {
        return;
      }


      /**
       * Get the ripple color
       */
      var rippleColor = self.getRipplesColor($element);


      /**
       * Create the ripple element
       */
      var $ripple = $("<div></div>");

      $ripple
      .addClass("ripple")
      .css({
        "left": relX,
        "top": relY,
        "background-color": rippleColor
      });


      /**
       * Append the ripple to the wrapper
       */
      $wrapper.append($ripple);


      /**
       * Make sure the ripple has the styles applied (ugly hack but it works)
       */
      (function() { return window.getComputedStyle($ripple[0]).opacity; })();


      /**
       * Turn on the ripple animation
       */
      self.rippleOn($element, $ripple);


      /**
       * Call the rippleEnd function when the transition "on" ends
       */
      setTimeout(function() {
        self.rippleEnd($ripple);
      }, 500);


      /**
       * Detect when the user leaves the element
       */
      $element.on("mouseup mouseleave touchend", function() {
        $ripple.data("mousedown", "off");

        if($ripple.data("animating") === "off") {
          self.rippleOut($ripple);
        }
      });

    });
  };


  /**
   * Get the new size based on the element height/width and the ripple width
   */
  Ripples.prototype.getNewSize = function($element, $ripple) {

    return (Math.max($element.outerWidth(), $element.outerHeight()) / $ripple.outerWidth()) * 2.5;
  };


  /**
   * Get the relX
   */
  Ripples.prototype.getRelX = function($wrapper,  event) {
    var wrapperOffset = $wrapper.offset();

    if(!self.isTouch()) {
      /**
       * Get the mouse position relative to the ripple wrapper
       */
      return event.pageX - wrapperOffset.left;
    } else {
      /**
       * Make sure the user is using only one finger and then get the touch
       * position relative to the ripple wrapper
       */
      event = event.originalEvent;

      if(event.touches.length !== 1) {
        return event.touches[0].pageX - wrapperOffset.left;
      }

      return false;
    }
  };


  /**
   * Get the relY
   */
  Ripples.prototype.getRelY = function($wrapper, event) {
    var wrapperOffset = $wrapper.offset();

    if(!self.isTouch()) {
      /**
       * Get the mouse position relative to the ripple wrapper
       */
      return event.pageY - wrapperOffset.top;
    } else {
      /**
       * Make sure the user is using only one finger and then get the touch
       * position relative to the ripple wrapper
       */
      event = event.originalEvent;

      if(event.touches.length !== 1) {
        return event.touches[0].pageY - wrapperOffset.top;
      }

      return false;
    }
  };


  /**
   * Get the ripple color
   */
  Ripples.prototype.getRipplesColor = function($element) {

    var color = $element.data("ripple-color") ? $element.data("ripple-color") : window.getComputedStyle($element[0]).color;

    return color;
  };


  /**
   * Verify if the client browser has transistion support
   */
  Ripples.prototype.hasTransitionSupport = function() {
    var thisBody  = document.body || document.documentElement;
    var thisStyle = thisBody.style;

    var support = (
      thisStyle.transition !== undefined ||
      thisStyle.WebkitTransition !== undefined ||
      thisStyle.MozTransition !== undefined ||
      thisStyle.MsTransition !== undefined ||
      thisStyle.OTransition !== undefined
    );

    return support;
  };


  /**
   * Verify if the client is using a mobile device
   */
  Ripples.prototype.isTouch = function() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };


  /**
   * End the animation of the ripple
   */
  Ripples.prototype.rippleEnd = function($ripple) {
    $ripple.data("animating", "off");

    if($ripple.data("mousedown") === "off") {
      self.rippleOut($ripple);
    }
  };


  /**
   * Turn off the ripple effect
   */
  Ripples.prototype.rippleOut = function($ripple) {
    $ripple.off();

    if(self.hasTransitionSupport()) {
      $ripple.addClass("ripple-out");
    } else {
      $ripple.animate({"opacity": 0}, 100, function() {
        $ripple.trigger("transitionend");
      });
    }

    $ripple.on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function() {
      $ripple.remove();
    });
  };


  /**
   * Turn on the ripple effect
   */
  Ripples.prototype.rippleOn = function($element, $ripple) {
    var size = self.getNewSize($element, $ripple);

    if(self.hasTransitionSupport()) {
      $ripple
      .css({
        "-ms-transform": "scale(" + size + ")",
        "-moz-transform": "scale(" + size + ")",
        "-webkit-transform": "scale(" + size + ")",
        "transform": "scale(" + size + ")"
      })
      .addClass("ripple-on")
      .data("animating", "on")
      .data("mousedown", "on");
    } else {
      $ripple.animate({
        "width": Math.max($element.outerWidth(), $element.outerHeight()) * 2,
        "height": Math.max($element.outerWidth(), $element.outerHeight()) * 2,
        "margin-left": Math.max($element.outerWidth(), $element.outerHeight()) * (-1),
        "margin-top": Math.max($element.outerWidth(), $element.outerHeight()) * (-1),
        "opacity": 0.2
      }, 500, function() {
        $ripple.trigger("transitionend");
      });
    }
  };


  /**
   * Create the jquery plugin function
   */
  $.fn.ripples = function(options) {
    return this.each(function() {
      if(!$.data(this, "plugin_" + ripples)) {
        $.data(this, "plugin_" + ripples, new Ripples(this, options));
      }
    });
  };

})(jQuery, window, document);

/*
 * Verto HTML5/Javascript Telephony Signaling and Control Protocol Stack for FreeSWITCH
 * Copyright (C) 2005-2014, Anthony Minessale II <anthm@freeswitch.org>
 *
 * Version: MPL 1.1
 *
 * The contents of this file are subject to the Mozilla Public License Version
 * 1.1 (the "License"); you may not use this file except in compliance with
 * the License. You may obtain a copy of the License at
 * http://www.mozilla.org/MPL/
 *
 * Software distributed under the License is distributed on an "AS IS" basis,
 * WITHOUT WARRANTY OF ANY KIND, either express or implied. See the License
 * for the specific language governing rights and limitations under the
 * License.
 *
 * The Original Code is jquery.jsonrpclient.js modified for Verto HTML5/Javascript Telephony Signaling and Control Protocol Stack for FreeSWITCH
 *
 * The Initial Developer of the Original Code is
 * Textalk AB http://textalk.se/
 * Portions created by the Initial Developer are Copyright (C)
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *
 * Anthony Minessale II <anthm@freeswitch.org>
 *
 * jquery.jsonrpclient.js - JSON RPC client code
 *
 */
/**
 * This plugin requires jquery.json.js to be available, or at least the methods $.toJSON and
 * $.parseJSON.
 *
 * The plan is to make use of websockets if they are available, but work just as well with only
 * http if not.
 *
 * Usage example:
 *
 *   var foo = new $.JsonRpcClient({ ajaxUrl: '/backend/jsonrpc' });
 *   foo.call(
 *     'bar', [ 'A parameter', 'B parameter' ],
 *     function(result) { alert('Foo bar answered: ' + result.my_answer); },
 *     function(error)  { console.log('There was an error', error); }
 *   );
 *
 * More examples are available in README.md
 */
(function ($) {
  /**
   * @fn new
   * @memberof $.JsonRpcClient
   *
   * @param options An object stating the backends:
   *                ajaxUrl    A url (relative or absolute) to a http(s) backend.
   *                socketUrl  A url (relative of absolute) to a ws(s) backend.
   *                onmessage  A socket message handler for other messages (non-responses).
   *                getSocket  A function returning a WebSocket or null.
   *                           It must take an onmessage_cb and bind it to the onmessage event
   *                           (or chain it before/after some other onmessage handler).
   *                           Or, it could return null if no socket is available.
   *                           The returned instance must have readyState <= 1, and if less than 1,
   *                           react to onopen binding.
   */
  $.JsonRpcClient = function (options) {
    var self = this;
    this.options = $.extend({
      ajaxUrl: null,
      socketUrl: null, ///< The ws-url for default getSocket.
      onmessage: null, ///< Other onmessage-handler.
      login: null, /// auth login
      passwd: null, /// auth passwd
      sessid: null,
      loginParams: null,
      userVariables: null,
      getSocket: function (onmessage_cb) {
        return self._getSocket(onmessage_cb);
      }
    }, options);

    self.ws_cnt = 0;

    // Declare an instance version of the onmessage callback to wrap 'this'.
    this.wsOnMessage = function (event) {
      self._wsOnMessage(event);
    };
  };

  /// Holding the WebSocket on default getsocket.
  $.JsonRpcClient.prototype._ws_socket = null;

  /// Object <id>: { success_cb: cb, error_cb: cb }
  $.JsonRpcClient.prototype._ws_callbacks = {};

  /// The next JSON-RPC request id.
  $.JsonRpcClient.prototype._current_id = 1;


  $.JsonRpcClient.prototype.speedTest = function (bytes, cb) {
    var socket = this.options.getSocket(this.wsOnMessage);
    if (socket !== null) {
      this.speedCB = cb;
      this.speedBytes = bytes;
      socket.send("#SPU " + bytes);

      var loops = bytes / 1024;
      var rem = bytes % 1024;
      var i;
      var data = new Array(1024).join(".");
      for (i = 0; i < loops; i++) {
        socket.send("#SPB " + data);
      }

      if (rem) {
        socket.send("#SPB " + data);
      }

      socket.send("#SPE");
    }
  };


  /**
   * @fn call
   * @memberof $.JsonRpcClient
   *
   * @param method     The method to run on JSON-RPC server.
   * @param params     The params; an array or object.
   * @param success_cb A callback for successful request.
   * @param error_cb   A callback for error.
   */
  $.JsonRpcClient.prototype.call = function (method, params, success_cb, error_cb) {
    // Construct the JSON-RPC 2.0 request.

    if (!params) {
      params = {};
    }

    if (this.options.sessid) {
      params.sessid = this.options.sessid;
    }

    var request = {
      jsonrpc: '2.0',
      method: method,
      params: params,
      id: this._current_id++  // Increase the id counter to match request/response
    };

    if (!success_cb) {
      success_cb = function (e) {
        console.log("Success: ", e);
      };
    }

    if (!error_cb) {
      error_cb = function (e) {
        console.log("Error: ", e);
      };
    }

    // Try making a WebSocket call.
    var socket = this.options.getSocket(this.wsOnMessage);
    if (socket !== null) {
      this._wsCall(socket, request, success_cb, error_cb);
      return;
    }

    // No WebSocket, and no HTTP backend?  This won't work.
    if (this.options.ajaxUrl === null) {
      throw "$.JsonRpcClient.call used with no websocket and no http endpoint.";
    }

    $.ajax({
      type: 'POST',
      url: this.options.ajaxUrl,
      data: $.toJSON(request),
      dataType: 'json',
      cache: false,

      success: function (data) {
        if ('error' in data) error_cb(data.error, this);
        success_cb(data.result, this);
      },

      // JSON-RPC Server could return non-200 on error
      error: function (jqXHR, textStatus, errorThrown) {
        try {
          var response = $.parseJSON(jqXHR.responseText);

          if ('console' in window) console.log(response);

          error_cb(response.error, this);
        } catch (err) {
          // Perhaps the responseText wasn't really a jsonrpc-error.
          error_cb({error: jqXHR.responseText}, this);
        }
      }
    });
  };

  /**
   * Notify sends a command to the server that won't need a response.  In http, there is probably
   * an empty response - that will be dropped, but in ws there should be no response at all.
   *
   * This is very similar to call, but has no id and no handling of callbacks.
   *
   * @fn notify
   * @memberof $.JsonRpcClient
   *
   * @param method     The method to run on JSON-RPC server.
   * @param params     The params; an array or object.
   */
  $.JsonRpcClient.prototype.notify = function (method, params) {
    // Construct the JSON-RPC 2.0 request.

    if (this.options.sessid) {
      params.sessid = this.options.sessid;
    }

    var request = {
      jsonrpc: '2.0',
      method: method,
      params: params
    };

    // Try making a WebSocket call.
    var socket = this.options.getSocket(this.wsOnMessage);
    if (socket !== null) {
      this._wsCall(socket, request);
      return;
    }

    // No WebSocket, and no HTTP backend?  This won't work.
    if (this.options.ajaxUrl === null) {
      throw "$.JsonRpcClient.notify used with no websocket and no http endpoint.";
    }

    $.ajax({
      type: 'POST',
      url: this.options.ajaxUrl,
      data: $.toJSON(request),
      dataType: 'json',
      cache: false
    });
  };

  /**
   * Make a batch-call by using a callback.
   *
   * The callback will get an object "batch" as only argument.  On batch, you can call the methods
   * "call" and "notify" just as if it was a normal $.JsonRpcClient object, and all calls will be
   * sent as a batch call then the callback is done.
   *
   * @fn batch
   * @memberof $.JsonRpcClient
   *
   * @param callback    The main function which will get a batch handler to run call and notify on.
   * @param all_done_cb A callback function to call after all results have been handled.
   * @param error_cb    A callback function to call if there is an error from the server.
   *                    Note, that batch calls should always get an overall success, and the
   *                    only error
   */
  $.JsonRpcClient.prototype.batch = function (callback, all_done_cb, error_cb) {
    var batch = new $.JsonRpcClient._batchObject(this, all_done_cb, error_cb);
    callback(batch);
    batch._execute();
  };

  /**
   * The default getSocket handler.
   *
   * @param onmessage_cb The callback to be bound to onmessage events on the socket.
   *
   * @fn _getSocket
   * @memberof $.JsonRpcClient
   */

  $.JsonRpcClient.prototype.socketReady = function () {
    if (this._ws_socket === null || this._ws_socket.readyState > 1) {
      return false;
    }

    return true;
  };

  $.JsonRpcClient.prototype.closeSocket = function () {
    var self = this;
    if (self.socketReady()) {
      self._ws_socket.onclose = function (w) {
        console.log("Closing Socket");
      };
      self._ws_socket.close();
    }
  };

  $.JsonRpcClient.prototype.loginData = function (params) {
    var self = this;
    self.options.login = params.login;
    self.options.passwd = params.passwd;
    self.options.loginParams = params.loginParams;
    self.options.userVariables = params.userVariables;
  };

  $.JsonRpcClient.prototype.connectSocket = function (onmessage_cb) {
    var self = this;

    if (self.to) {
      clearTimeout(self.to);
    }

    if (!self.socketReady()) {
      self.authing = false;

      if (self._ws_socket) {
        delete self._ws_socket;
      }

      // No socket, or dying socket, let's get a new one.
      self._ws_socket = new WebSocket(self.options.socketUrl);

      if (self._ws_socket) {
        // Set up onmessage handler.
        self._ws_socket.onmessage = onmessage_cb;
        self._ws_socket.onclose = function (w) {
          if (!self.ws_sleep) {
            self.ws_sleep = 1000;
          }

          if (self.options.onWSClose) {
            self.options.onWSClose(self);
          }

          if (self.ws_cnt > 10 && self.options.wsFallbackURL) {
            self.options.socketUrl = self.options.wsFallbackURL;
          }

          console.error("Websocket Lost " + self.ws_cnt + " sleep: " + self.ws_sleep + "msec");

          self.to = setTimeout(function () {
            console.log("Attempting Reconnection....");
            self.connectSocket(onmessage_cb);
          }, self.ws_sleep);

          self.ws_cnt++;

          if (self.ws_sleep < 3000 && (self.ws_cnt % 10) === 0) {
            self.ws_sleep += 1000;
          }
        };

        // Set up sending of message for when the socket is open.
        self._ws_socket.onopen = function () {
          if (self.to) {
            clearTimeout(self.to);
          }
          self.ws_sleep = 1000;
          self.ws_cnt = 0;
          if (self.options.onWSConnect) {
            self.options.onWSConnect(self);
          }

          var req;
          // Send the requests.
          while ((req = $.JsonRpcClient.q.pop())) {
            self._ws_socket.send(req);
          }
        };
      }
    }

    return self._ws_socket ? true : false;
  };

  $.JsonRpcClient.prototype.stopRetrying = function () {
    if (self.to)
      clearTimeout(self.to);
  }

  $.JsonRpcClient.prototype._getSocket = function (onmessage_cb) {
    // If there is no ws url set, we don't have a socket.
    // Likewise, if there is no window.WebSocket.
    if (this.options.socketUrl === null || !("WebSocket" in window)) return null;

    this.connectSocket(onmessage_cb);

    return this._ws_socket;
  };

  /**
   * Queue to save messages delivered when websocket is not ready
   */
  $.JsonRpcClient.q = [];

  /**
   * Internal handler to dispatch a JRON-RPC request through a websocket.
   *
   * @fn _wsCall
   * @memberof $.JsonRpcClient
   */
  $.JsonRpcClient.prototype._wsCall = function (socket, request, success_cb, error_cb) {
    var request_json = $.toJSON(request);

    if (socket.readyState < 1) {
      // The websocket is not open yet; we have to set sending of the message in onopen.
      self = this; // In closure below, this is set to the WebSocket.  Use self instead.
      $.JsonRpcClient.q.push(request_json);
    } else {
      // We have a socket and it should be ready to send on.
      socket.send(request_json);
    }

    // Setup callbacks.  If there is an id, this is a call and not a notify.
    if ('id' in request && typeof success_cb !== 'undefined') {
      this._ws_callbacks[request.id] = {
        request: request_json,
        request_obj: request,
        success_cb: success_cb,
        error_cb: error_cb
      };
    }
  };

  /**
   * Internal handler for the websocket messages.  It determines if the message is a JSON-RPC
   * response, and if so, tries to couple it with a given callback.  Otherwise, it falls back to
   * given external onmessage-handler, if any.
   *
   * @param event The websocket onmessage-event.
   */
  $.JsonRpcClient.prototype._wsOnMessage = function (event) {
    // Check if this could be a JSON RPC message.
    var response;

    // Special sub proto
    if (event.data[0] == "#" && event.data[1] == "S" && event.data[2] == "P") {
      if (event.data[3] == "U") {
        this.up_dur = parseInt(event.data.substring(4));
      } else if (this.speedCB && event.data[3] == "D") {
        this.down_dur = parseInt(event.data.substring(4));

        var up_kps = (((this.speedBytes * 8) / (this.up_dur / 1000)) / 1024).toFixed(0);
        var down_kps = (((this.speedBytes * 8) / (this.down_dur / 1000)) / 1024).toFixed(0);

        console.info("Speed Test: Up: " + up_kps + " Down: " + down_kps);
        var cb = this.speedCB;
        this.speedCB = null;
        cb(event, {
          upDur: this.up_dur,
          downDur: this.down_dur,
          upKPS: up_kps,
          downKPS: down_kps
        });
      }

      return;
    }


    try {
      response = $.parseJSON(event.data);

      /// @todo Make using the jsonrcp 2.0 check optional, to use this on JSON-RPC 1 backends.

      if (typeof response === 'object' &&
        'jsonrpc' in response &&
        response.jsonrpc === '2.0') {

        /// @todo Handle bad response (without id).

        // If this is an object with result, it is a response.
        if ('result' in response && this._ws_callbacks[response.id]) {
          // Get the success callback.
          var success_cb = this._ws_callbacks[response.id].success_cb;

          /*
                          // set the sessid if present
                          if ('sessid' in response.result && !this.options.sessid || (this.options.sessid != response.result.sessid)) {
                              this.options.sessid = response.result.sessid;
                              if (this.options.sessid) {
                                  console.log("setting session UUID to: " + this.options.sessid);
                              }
                          }
          */
          // Delete the callback from the storage.
          delete this._ws_callbacks[response.id];

          // Run callback with result as parameter.
          success_cb(response.result, this);
          return;
        } else if ('error' in response && this._ws_callbacks[response.id]) {
          // If this is an object with error, it is an error response.

          // Get the error callback.
          var error_cb = this._ws_callbacks[response.id].error_cb;
          var orig_req = this._ws_callbacks[response.id].request;

          // if this is an auth request, send the credentials and resend the failed request
          if (!self.authing && response.error.code == -32000 && self.options.login && self.options.passwd) {
            self.authing = true;

            this.call("login", {
                login: self.options.login,
                passwd: self.options.passwd,
                loginParams: self.options.loginParams,
                userVariables: self.options.userVariables
              },
              this._ws_callbacks[response.id].request_obj.method == "login" ?
                function (e) {
                  self.authing = false;
                  console.debug("Logged in");
                  delete self._ws_callbacks[response.id];

                  if (self.options.onWSLogin) {
                    self.options.onWSLogin(true, self);
                  }
                }

                :

                function (e) {
                  self.authing = false;
                  console.log("logged in, resending request id: " + response.id);
                  var socket = self.options.getSocket(self.wsOnMessage);
                  if (socket !== null) {
                    socket.send(orig_req);
                  }
                  if (self.options.onWSLogin) {
                    self.options.onWSLogin(true, self);
                  }
                },

              function (e) {
                console.log("error logging in, request id:", response.id);
                delete self._ws_callbacks[response.id];
                error_cb(response.error, this);
                if (self.options.onWSLogin) {
                  self.options.onWSLogin(false, self);
                }
              });
            return;
          }

          // Delete the callback from the storage.
          delete this._ws_callbacks[response.id];

          // Run callback with the error object as parameter.
          error_cb(response.error, this);
          return;
        }
      }
    } catch (err) {
      // Probably an error while parsing a non json-string as json.  All real JSON-RPC cases are
      // handled above, and the fallback method is called below.
      console.log("ERROR: " + err);
      return;
    }

    // This is not a JSON-RPC response.  Call the fallback message handler, if given.
    if (typeof this.options.onmessage === 'function') {
      event.eventData = response;
      if (!event.eventData) {
        event.eventData = {};
      }

      var reply = this.options.onmessage(event);

      if (reply && typeof reply === "object" && event.eventData.id) {
        var msg = {
          jsonrpc: "2.0",
          id: event.eventData.id,
          result: reply
        };

        var socket = self.options.getSocket(self.wsOnMessage);
        if (socket !== null) {
          socket.send($.toJSON(msg));
        }
      }
    }
  };


  /************************************************************************************************
   * Batch object with methods
   ************************************************************************************************/

  /**
   * Handling object for batch calls.
   */
  $.JsonRpcClient._batchObject = function (jsonrpcclient, all_done_cb, error_cb) {
    // Array of objects to hold the call and notify requests.  Each objects will have the request
    // object, and unless it is a notify, success_cb and error_cb.
    this._requests = [];

    this.jsonrpcclient = jsonrpcclient;
    this.all_done_cb = all_done_cb;
    this.error_cb = typeof error_cb === 'function' ? error_cb : function () {
    };

  };

  /**
   * @sa $.JsonRpcClient.prototype.call
   */
  $.JsonRpcClient._batchObject.prototype.call = function (method, params, success_cb, error_cb) {

    if (!params) {
      params = {};
    }

    if (this.options.sessid) {
      params.sessid = this.options.sessid;
    }

    if (!success_cb) {
      success_cb = function (e) {
        console.log("Success: ", e);
      };
    }

    if (!error_cb) {
      error_cb = function (e) {
        console.log("Error: ", e);
      };
    }

    this._requests.push({
      request: {
        jsonrpc: '2.0',
        method: method,
        params: params,
        id: this.jsonrpcclient._current_id++  // Use the client's id series.
      },
      success_cb: success_cb,
      error_cb: error_cb
    });
  };

  /**
   * @sa $.JsonRpcClient.prototype.notify
   */
  $.JsonRpcClient._batchObject.prototype.notify = function (method, params) {
    if (this.options.sessid) {
      params.sessid = this.options.sessid;
    }

    this._requests.push({
      request: {
        jsonrpc: '2.0',
        method: method,
        params: params
      }
    });
  };

  /**
   * Executes the batched up calls.
   */
  $.JsonRpcClient._batchObject.prototype._execute = function () {
    var self = this;

    if (this._requests.length === 0) return; // All done :P

    // Collect all request data and sort handlers by request id.
    var batch_request = [];
    var handlers = {};
    var i = 0;
    var call;
    var success_cb;
    var error_cb;

    // If we have a WebSocket, just send the requests individually like normal calls.
    var socket = self.jsonrpcclient.options.getSocket(self.jsonrpcclient.wsOnMessage);
    if (socket !== null) {
      for (i = 0; i < this._requests.length; i++) {
        call = this._requests[i];
        success_cb = ('success_cb' in call) ? call.success_cb : undefined;
        error_cb = ('error_cb' in call) ? call.error_cb : undefined;
        self.jsonrpcclient._wsCall(socket, call.request, success_cb, error_cb);
      }

      if (typeof all_done_cb === 'function') all_done_cb(result);
      return;
    }

    for (i = 0; i < this._requests.length; i++) {
      call = this._requests[i];
      batch_request.push(call.request);

      // If the request has an id, it should handle returns (otherwise it's a notify).
      if ('id' in call.request) {
        handlers[call.request.id] = {
          success_cb: call.success_cb,
          error_cb: call.error_cb
        };
      }
    }

    success_cb = function (data) {
      self._batchCb(data, handlers, self.all_done_cb);
    };

    // No WebSocket, and no HTTP backend?  This won't work.
    if (self.jsonrpcclient.options.ajaxUrl === null) {
      throw "$.JsonRpcClient.batch used with no websocket and no http endpoint.";
    }

    // Send request
    $.ajax({
      url: self.jsonrpcclient.options.ajaxUrl,
      data: $.toJSON(batch_request),
      dataType: 'json',
      cache: false,
      type: 'POST',

      // Batch-requests should always return 200
      error: function (jqXHR, textStatus, errorThrown) {
        self.error_cb(jqXHR, textStatus, errorThrown);
      },
      success: success_cb
    });
  };

  /**
   * Internal helper to match the result array from a batch call to their respective callbacks.
   *
   * @fn _batchCb
   * @memberof $.JsonRpcClient
   */
  $.JsonRpcClient._batchObject.prototype._batchCb = function (result, handlers, all_done_cb) {
    for (var i = 0; i < result.length; i++) {
      var response = result[i];

      // Handle error
      if ('error' in response) {
        if (response.id === null || !(response.id in handlers)) {
          // An error on a notify?  Just log it to the console.
          if ('console' in window) console.log(response);
        } else {
          handlers[response.id].error_cb(response.error, this);
        }
      } else {
        // Here we should always have a correct id and no error.
        if (!(response.id in handlers) && 'console' in window) {
          console.log(response);
        } else {
          handlers[response.id].success_cb(response.result, this);
        }
      }
    }

    if (typeof all_done_cb === 'function') all_done_cb(result);
  };

})(jQuery);

/*
 * Verto HTML5/Javascript Telephony Signaling and Control Protocol Stack for FreeSWITCH
 * Copyright (C) 2005-2014, Anthony Minessale II <anthm@freeswitch.org>
 *
 * Version: MPL 1.1
 *
 * The contents of this file are subject to the Mozilla Public License Version
 * 1.1 (the "License"); you may not use this file except in compliance with
 * the License. You may obtain a copy of the License at
 * http://www.mozilla.org/MPL/
 *
 * Software distributed under the License is distributed on an "AS IS" basis,
 * WITHOUT WARRANTY OF ANY KIND, either express or implied. See the License
 * for the specific language governing rights and limitations under the
 * License.
 *
 * The Original Code is Verto HTML5/Javascript Telephony Signaling and Control Protocol Stack for FreeSWITCH
 *
 * The Initial Developer of the Original Code is
 * Anthony Minessale II <anthm@freeswitch.org>
 * Portions created by the Initial Developer are Copyright (C)
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *
 * Anthony Minessale II <anthm@freeswitch.org>
 *
 * jquery.FSRTC.js - WebRTC Glue code
 *
 */

(function ($) {

  // Find the line in sdpLines that starts with |prefix|, and, if specified,
  // contains |substr| (case-insensitive search).
  function findLine(sdpLines, prefix, substr) {
    return findLineInRange(sdpLines, 0, -1, prefix, substr);
  }

  // Find the line in sdpLines[startLine...endLine - 1] that starts with |prefix|
  // and, if specified, contains |substr| (case-insensitive search).
  function findLineInRange(sdpLines, startLine, endLine, prefix, substr) {
    var realEndLine = (endLine != -1) ? endLine : sdpLines.length;
    for (var i = startLine; i < realEndLine; ++i) {
      if (sdpLines[i].indexOf(prefix) === 0) {
        if (!substr || sdpLines[i].toLowerCase().indexOf(substr.toLowerCase()) !== -1) {
          return i;
        }
      }
    }
    return null;
  }

  // Gets the codec payload type from an a=rtpmap:X line.
  function getCodecPayloadType(sdpLine) {
    var pattern = new RegExp('a=rtpmap:(\\d+) \\w+\\/\\d+');
    var result = sdpLine.match(pattern);
    return (result && result.length === 2) ? result[1] : null;
  }

  // Returns a new m= line with the specified codec as the first one.
  function setDefaultCodec(mLine, payload) {
    var elements = mLine.split(' ');
    var newLine = [];
    var index = 0;
    for (var i = 0; i < elements.length; i++) {
      if (index === 3) { // Format of media starts from the fourth.
        newLine[index++] = payload; // Put target payload to the first.
      }
      if (elements[i] !== payload) newLine[index++] = elements[i];
    }
    return newLine.join(' ');
  }

  $.FSRTC = function (options) {
    this.options = $.extend({
      useVideo: null,
      useStereo: false,
      userData: null,
      localVideo: null,
      screenShare: false,
      useCamera: "any",
      iceServers: false,
      videoParams: {},
      audioParams: {},
      callbacks: {
        onICEComplete: function () {
        },
        onICE: function () {
        },
        onOfferSDP: function () {
        }
      },
      useStream: null,
    }, options);

    this.audioEnabled = true;
    this.videoEnabled = true;


    this.mediaData = {
      SDP: null,
      profile: {},
      candidateList: []
    };

    this.constraints = {
      offerToReceiveAudio: this.options.useSpeak !== "none",
      offerToReceiveVideo: !!this.options.useVideo,
    };

    if (self.options.useVideo) {
      self.options.useVideo.style.display = 'none';
    }

    setCompat();
    checkCompat();
  };

  $.FSRTC.validRes = [];

  $.FSRTC.prototype.useVideo = function (obj, local) {
    var self = this;

    if (obj) {
      self.options.useVideo = obj;
      self.options.localVideo = local;
      self.constraints.offerToReceiveVideo = true;
    } else {
      self.options.useVideo = null;
      self.options.localVideo = null;
      self.constraints.offerToReceiveVideo = false;
    }

    if (self.options.useVideo) {
      self.options.useVideo.style.display = 'none';
    }
  };

  $.FSRTC.prototype.useStereo = function (on) {
    var self = this;
    self.options.useStereo = on;
  };

  // Sets Opus in stereo if stereo is enabled, by adding the stereo=1 fmtp param.
  $.FSRTC.prototype.stereoHack = function (sdp) {
    var self = this;

    if (!self.options.useStereo) {
      return sdp;
    }

    var sdpLines = sdp.split('\r\n');

    // Find opus payload.
    var opusIndex = findLine(sdpLines, 'a=rtpmap', 'opus/48000'), opusPayload;

    if (!opusIndex) {
      return sdp;
    } else {
      opusPayload = getCodecPayloadType(sdpLines[opusIndex]);
    }

    // Find the payload in fmtp line.
    var fmtpLineIndex = findLine(sdpLines, 'a=fmtp:' + opusPayload.toString());

    if (fmtpLineIndex === null) {
      // create an fmtp line
      sdpLines[opusIndex] = sdpLines[opusIndex] + '\r\na=fmtp:' + opusPayload.toString() + " stereo=1; sprop-stereo=1"
    } else {
      // Append stereo=1 to fmtp line.
      sdpLines[fmtpLineIndex] = sdpLines[fmtpLineIndex].concat('; stereo=1; sprop-stereo=1');
    }

    sdp = sdpLines.join('\r\n');
    return sdp;
  };

  function setCompat() {
  }

  function checkCompat() {
    return true;
  }

  function onStreamError(self, e) {
    console.error('There has been a problem retrieving the streams - did you allow access? Check Device Resolution', e);
    doCallback(self, "onError", e);
  }

  function onStreamSuccess(self, stream) {
    console.log("Stream Success");
    doCallback(self, "onStream", stream);
  }

  function onRemoteStreamSuccess(self, stream) {
    console.log("Remote Stream Success");
    doCallback(self, "onRemoteStream", stream);
  }

  function onICE(self, candidate) {
    self.mediaData.candidate = candidate;
    self.mediaData.candidateList.push(self.mediaData.candidate);

    doCallback(self, "onICE");
  }

  function doCallback(self, func, arg) {
    if (func in self.options.callbacks) {
      self.options.callbacks[func](self, arg);
    }
  }

  function onICEComplete(self, candidate) {
    console.log("ICE Complete");
    doCallback(self, "onICEComplete");
  }

  function onChannelError(self, e) {
    console.error("Channel Error", e);
    doCallback(self, "onError", e);
  }

  function onICESDP(self, sdp) {
    self.mediaData.SDP = self.stereoHack(sdp.sdp);
    console.log("ICE SDP");
    doCallback(self, "onICESDP");
  }

  function onAnswerSDP(self, sdp) {
    self.answer.SDP = self.stereoHack(sdp.sdp);
    console.log("ICE ANSWER SDP");
    doCallback(self, "onAnswerSDP", self.answer.SDP);
  }

  function onMessage(self, msg) {
    console.log("Message");
    doCallback(self, "onICESDP", msg);
  }

  FSRTCattachMediaStream = function (element, stream) {
    if (typeof element.srcObject !== 'undefined') {
      element.srcObject = stream;
    } else {
      console.error('Error attaching stream to element.');
    }
  }

  function onRemoteStream(self, stream) {
    if (self.options.useVideo) {
      self.options.useVideo.style.display = 'block';

      // Hacks for Mobile Safari
      var iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;

      if (iOS) {
        self.options.useVideo.setAttribute("playsinline", true);
      }
    }

    var element = self.options.useAudio;
    console.log("REMOTE STREAM", stream, element);

    FSRTCattachMediaStream(element, stream);


    //self.options.useAudio.play();
    self.remoteStream = stream;
    onRemoteStreamSuccess(self, stream);
  }

  function onOfferSDP(self, sdp) {
    self.mediaData.SDP = self.stereoHack(sdp.sdp);
    console.log("Offer SDP");
    doCallback(self, "onOfferSDP");
  }

  $.FSRTC.prototype.answer = function (sdp, onSuccess, onError) {
    this.peer.addAnswerSDP({
        type: "answer",
        sdp: sdp
      },
      onSuccess, onError);
  };

  $.FSRTC.prototype.stopPeer = function () {
    if (self.peer) {
      console.log("stopping peer");
      self.peer.stop();
    }
  }

  $.FSRTC.prototype.stop = function () {
    var self = this;

    if (self.options.useVideo) {
      self.options.useVideo.style.display = 'none';
      self.options.useVideo['src'] = '';
    }

    if (self.localStream && !self.options.useStream) {
      if (typeof self.localStream.stop == 'function') {
        self.localStream.stop();
      } else {
        if (self.localStream.active) {
          var tracks = self.localStream.getTracks();
          console.log(tracks);
          tracks.forEach(function (track, index) {
            console.log(track);
            track.stop();
          })
        }
      }
      self.localStream = null;
    }

    if (self.options.localVideo) {
      deactivateLocalVideo(self.options.localVideo);
    }

    if (self.options.localVideoStream && !self.options.useStream) {
      if (typeof self.options.localVideoStream.stop == 'function') {
        self.options.localVideoStream.stop();
      } else {
        if (self.options.localVideoStream.active) {
          var tracks = self.options.localVideoStream.getTracks();
          console.log(tracks);
          tracks.forEach(function (track, index) {
            console.log(track);
            track.stop();
          })
        }
      }
    }

    if (self.peer) {
      console.log("stopping peer");
      self.peer.stop();
    }
  };

  $.FSRTC.prototype.getMute = function () {
    var self = this;
    return self.audioEnabled;
  }

  $.FSRTC.prototype.setMute = function (what) {
    var self = this;
    if (!self.localStream) {
      return false;
    }
    var audioTracks = self.localStream.getAudioTracks();

    for (var i = 0, len = audioTracks.length; i < len; i++) {
      switch (what) {
        case "on":
          audioTracks[i].enabled = true;
          break;
        case "off":
          audioTracks[i].enabled = false;
          break;
        case "toggle":
          audioTracks[i].enabled = !audioTracks[i].enabled;
        default:
          break;
      }

      self.audioEnabled = audioTracks[i].enabled;
    }

    return !self.audioEnabled;
  }

  $.FSRTC.prototype.getVideoMute = function () {
    var self = this;
    return self.videoEnabled;
  }

  $.FSRTC.prototype.setVideoMute = function (what) {
    var self = this;
    if (!self.localStream) {
      return false;
    }
    var videoTracks = self.localStream.getVideoTracks();

    for (var i = 0, len = videoTracks.length; i < len; i++) {
      switch (what) {
        case "on":
          videoTracks[i].enabled = true;
          break;
        case "off":
          videoTracks[i].enabled = false;
          break;
        case "toggle":
          videoTracks[i].enabled = !videoTracks[i].enabled;
        default:
          break;
      }

      self.videoEnabled = videoTracks[i].enabled;
    }

    return !self.videoEnabled;
  }

  $.FSRTC.prototype.createAnswer = function (params) {
    var self = this;
    self.type = "answer";
    self.remoteSDP = params.sdp;
    console.debug("inbound sdp: ", params.sdp);

    function onSuccess(stream) {
      self.localStream = stream;

      self.peer = FSRTCPeerConnection({
        type: self.type,
        attachStream: self.localStream,
        onICE: function (candidate) {
          return onICE(self, candidate);
        },
        onICEComplete: function () {
          return onICEComplete(self);
        },
        onRemoteStream: function (stream) {
          return onRemoteStream(self, stream);
        },
        onICESDP: function (sdp) {
          return onICESDP(self, sdp);
        },
        onChannelError: function (e) {
          return onChannelError(self, e);
        },
        constraints: self.constraints,
        iceServers: self.options.iceServers,
        offerSDP: {
          type: "offer",
          sdp: self.remoteSDP
        },
        turnServer: self.options.turnServer
      });

      onStreamSuccess(self, stream);
    }

    function onError(e) {
      onStreamError(self, e);
    }

    var mediaParams = getMediaParams(self);

    console.log("Audio constraints", mediaParams.audio);
    console.log("Video constraints", mediaParams.video);

    if (self.options.useVideo && self.options.localVideo && !self.options.useStream) {
      getUserMedia({
        constraints: {
          audio: false,
          video: {deviceId: params.useCamera},
        },
        localVideo: self.options.localVideo,
        onsuccess: function (e) {
          self.options.localVideoStream = e;
          console.log("local video ready");
        },
        onerror: function (e) {
          console.error("local video error!");
        }
      });
    }

    if (self.options.useStream) {
      if (self.options.useVideo) {
        self.options.localVideoStream = self.options.useStream;
        if (self.options.localVideo) {
          activateLocalVideo(self.options.localVideo, self.options.useStream);
        }
      }
      onSuccess(self.options.useStream);
    } else {
      getUserMedia({
        constraints: {
          audio: mediaParams.audio,
          video: mediaParams.video
        },
        video: mediaParams.useVideo,
        onsuccess: onSuccess,
        onerror: onError
      });
    }

  };

  function getMediaParams(obj) {
    var audio;

    if (obj.options.useMic && obj.options.useMic === "none") {
      console.log("Microphone Disabled");
      audio = false;
    } else if (obj.options.screenShare) {//obj.options.videoParams.chromeMediaSource == 'desktop') {
      obj.options.useMic = 'none';
      audio = false;
    } else {
      audio = {};

      if (obj.options.audioParams) {
        audio = obj.options.audioParams;
      }

      if (obj.options.useMic !== "any") {
        //audio.optional = [{sourceId: obj.options.useMic}];
        audio.deviceId = {exact: obj.options.useMic};
      }
    }

    if (obj.options.useVideo && obj.options.localVideo && !obj.options.useStream) {
      getUserMedia({
        constraints: {
          audio: false,
          video: {deviceId: obj.options.useCamera},
        },
        localVideo: obj.options.localVideo,
        onsuccess: function (e) {
          obj.options.localVideoStream = e;
          console.log("local video ready");
        },
        onerror: function (e) {
          console.error("local video error!");
        }
      });
    }

    var video;
    var bestFrameRate = obj.options.videoParams.vertoBestFrameRate;
    var minFrameRate = obj.options.videoParams.minFrameRate || 15;
    delete obj.options.videoParams.vertoBestFrameRate;

    if (obj.options.screenShare) {
      if (!obj.options.useCamera && !!navigator.mozGetUserMedia) {
        //This is an issue, only FireFox needs to ask this additional question if its screen or window we need a better way
        var dowin = window.confirm("Do you want to share an application window?  If not you can share an entire screen.");

        video = {
          width: obj.options.videoParams.width,
          height: obj.options.videoParams.height,
          aspectRatio: obj.options.videoParams.aspectRatio,
          mediaSource: dowin ? "window" : "screen"
        }
      } else {
        var opt = [];
        if (obj.options.useCamera) {
          opt.push({sourceId: obj.options.useCamera});
        }

        if (bestFrameRate) {
          opt.push({minFrameRate: bestFrameRate});
          opt.push({maxFrameRate: bestFrameRate});
        }

        video = {
          mandatory: obj.options.videoParams,
          optional: opt
        };
      }
    } else {
      video = {
        //mandatory: obj.options.videoParams,
        width: obj.options.videoParams.width,
        height: obj.options.videoParams.height,
        aspectRatio: obj.options.videoParams.aspectRatio
      };


      var useVideo = obj.options.useVideo;

      if (useVideo && obj.options.useCamera && obj.options.useCamera !== "none") {
        //if (!video.optional) {
        //video.optional = [];
        //}


        if (obj.options.useCamera !== "any") {
          //video.optional.push({sourceId: obj.options.useCamera});
          video.deviceId = {
            exact: obj.options.useCamera,
          };
        }

        if (bestFrameRate) {
          //video.optional.push({minFrameRate: bestFrameRate});
          //video.optional.push({maxFrameRate: bestFrameRate});
          video.frameRate = {ideal: bestFrameRate, min: minFrameRate, max: 30};
        }

      } else {
        console.log("Camera Disabled");
        video = false;
        useVideo = false;
      }
    }

    return {audio: audio, video: video, useVideo: useVideo};
  }

  $.FSRTC.prototype.call = function (profile) {
    checkCompat();

    var self = this;
    var screen = false;

    self.type = "offer";

    if (self.options.videoParams && self.options.screenShare) { //self.options.videoParams.chromeMediaSource == 'desktop') {
      screen = true;
    }

    function onSuccess(stream) {
      self.localStream = stream;

      if (screen) {
        var screenAudio = !!stream.getAudioTracks().length;
        self.constraints.offerToReceiveVideo = false;
        self.constraints.offerToReceiveAudio = screenAudio;
        self.constraints.offerToSendAudio = screenAudio;
      }

      self.peer = FSRTCPeerConnection({
        type: self.type,
        attachStream: self.localStream,
        onICE: function (candidate) {
          return onICE(self, candidate);
        },
        onICEComplete: function () {
          return onICEComplete(self);
        },
        onRemoteStream: screen ? function (stream) {
        } : function (stream) {
          return onRemoteStream(self, stream);
        },
        onOfferSDP: function (sdp) {
          return onOfferSDP(self, sdp);
        },
        onICESDP: function (sdp) {
          return onICESDP(self, sdp);
        },
        onChannelError: function (e) {
          return onChannelError(self, e);
        },
        constraints: self.constraints,
        iceServers: self.options.iceServers,
        turnServer: self.options.turnServer
      });

      onStreamSuccess(self, stream);
    }

    function onError(e) {
      onStreamError(self, e);
    }

    var mediaParams = getMediaParams(self);

    console.log("Audio constraints", mediaParams.audio);
    console.log("Video constraints", mediaParams.video);

    if (self.options.useStream) {
      if (self.options.useVideo) {
        self.options.localVideoStream = self.options.useStream;
        if (self.options.localVideo) {
          activateLocalVideo(self.options.localVideo, self.options.useStream);
        }
      }
      onSuccess(self.options.useStream);
    } else if (mediaParams.audio || mediaParams.video) {

      getUserMedia({
        constraints: {
          audio: mediaParams.audio,
          video: mediaParams.video
        },
        video: mediaParams.useVideo,
        onsuccess: onSuccess,
        onerror: onError
      });

    } else {
      onSuccess(null);
    }


    /*
    navigator.getUserMedia({
        video: self.options.useVideo,
        audio: true
    }, onSuccess, onError);
    */

  };

  // DERIVED from RTCPeerConnection-v1.5
  // 2013, @muazkh - github.com/muaz-khan
  // MIT License - https://www.webrtc-experiment.com/licence/
  // Documentation - https://github.com/muaz-khan/WebRTC-Experiment/tree/master/RTCPeerConnection

  function FSRTCPeerConnection(options) {
    var gathering = false, done = false;
    var config = {};
    var defaultIce = [{urls: ['stun:stun.l.google.com:19302']}];

    if (self.options.turnServer) {
      defaultIce.push(self.options.turnServer)
    }

    if (options.iceServers) {
      if (typeof (options.iceServers) === 'boolean') {
        config.iceServers = defaultIce;
      } else {
        config.iceServers = options.iceServers;
      }
    }

    config.bundlePolicy = 'max-compat';
    // config.sdpSemantics = 'plan-b';

    var peerConnection = new RTCPeerConnection(config);

    openOffererChannel();
    var x = 0;

    function iceHandler() {

      done = true;
      gathering = null;

      if (options.onICEComplete) {
        options.onICEComplete();
      }

      if (options.type === "offer") {
        options.onICESDP(peerConnection.localDescription);
      } else if (!x && options.onICESDP) {
        options.onICESDP(peerConnection.localDescription);
      }
    }

    peerConnection.onicecandidate = function (event) {
      if (done) {
        return;
      }

      if (!gathering) {
        gathering = setTimeout(iceHandler, 1000);
      }

      if (event) {
        if (event.candidate) {
          options.onICE(event.candidate);
        }
      } else {
        done = true;

        if (gathering) {
          clearTimeout(gathering);
          gathering = null;
        }

        iceHandler();
      }
    };

    if (options.attachStream) {
      options.attachStream.getTracks().forEach(function (track) {
        peerConnection.addTrack(track, options.attachStream);
      });
    }

    peerConnection.ontrack = function (event) {
      var remoteMediaStream = event.streams[0];

      // onRemoteStreamEnded(MediaStream)
      remoteMediaStream.oninactive = function () {
        if (options.onRemoteStreamEnded) options.onRemoteStreamEnded(remoteMediaStream);
      };

      // onRemoteStream(MediaStream)
      if (options.onRemoteStream) options.onRemoteStream(remoteMediaStream);
    };

    //var constraints = options.constraints || {
    //  offerToReceiveAudio: true,
    //offerToReceiveVideo: true
    //};

    // onOfferSDP(RTCSessionDescription)
    function createOffer() {
      if (!options.onOfferSDP) return;

      peerConnection.createOffer(options.constraints)
        .then(function (sessionDescription) {
            sessionDescription.sdp = serializeSdp(sessionDescription.sdp);
            peerConnection.setLocalDescription(sessionDescription)
            options.onOfferSDP(sessionDescription);
            createAnswer();
          },
          onSdpError);
    }

    // onAnswerSDP(RTCSessionDescription)
    function createAnswer() {
      if (options.type !== 'answer') return;

      //options.offerSDP.sdp = addStereo(options.offerSDP.sdp);
      //peer.setRemoteDescription(sessionDescription).then(onSdpSuccess, onSdpError);
      peerConnection.createAnswer()
        .then(function (sessionDescription2) {
            sessionDescription2.sdp = serializeSdp(sessionDescription2.sdp);
            peerConnection.setLocalDescription(sessionDescription2);
            if (options.onAnswerSDP) {
              options.onAnswerSDP(sessionDescription2);
            }
          },
          onSdpError);
    }

    if ((options.onChannelMessage) || !options.onChannelMessage) {
      createOffer();
    }

    // DataChannel Bandwidth
    function setBandwidth(sdp) {
      // remove existing bandwidth lines
      sdp = sdp.replace(/b=AS([^\r\n]+\r\n)/g, '');
      sdp = sdp.replace(/a=mid:data\r\n/g, 'a=mid:data\r\nb=AS:1638400\r\n');

      return sdp;
    }

    // old: FF<>Chrome interoperability management
    function getInteropSDP(sdp) {
      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
        extractedChars = '';

      function getChars() {
        extractedChars += chars[parseInt(Math.random() * 40)] || '';
        if (extractedChars.length < 40) getChars();

        return extractedChars;
      }

      // usually audio-only streaming failure occurs out of audio-specific crypto line
      // a=crypto:1 AES_CM_128_HMAC_SHA1_32 --------- kAttributeCryptoVoice
      if (options.onAnswerSDP) sdp = sdp.replace(/(a=crypto:0 AES_CM_128_HMAC_SHA1_32)(.*?)(\r\n)/g, '');

      // video-specific crypto line i.e. SHA1_80
      // a=crypto:1 AES_CM_128_HMAC_SHA1_80 --------- kAttributeCryptoVideo
      var inline = getChars() + '\r\n' + (extractedChars = '');
      sdp = sdp.indexOf('a=crypto') == -1 ? sdp.replace(/c=IN/g, 'a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:' + inline + 'c=IN') : sdp;

      return sdp;
    }

    function serializeSdp(sdp) {
      return sdp;
    }

    // DataChannel management
    var channel;

    function openOffererChannel() {
      if (!options.onChannelMessage) return;

      _openOffererChannel();
    }

    function _openOffererChannel() {
      channel = peerConnection.createDataChannel(options.channel || 'RTCDataChannel', {
        reliable: false
      });

      setChannelEvents();
    }

    function setChannelEvents() {
      channel.onmessage = function (event) {
        if (options.onChannelMessage) options.onChannelMessage(event);
      };

      channel.onopen = function () {
        if (options.onChannelOpened) options.onChannelOpened(channel);
      };
      channel.onclose = function (event) {
        if (options.onChannelClosed) options.onChannelClosed(event);

        console.warn('WebRTC DataChannel closed', event);
      };
      channel.onerror = function (event) {
        if (options.onChannelError) options.onChannelError(event);

        console.error('WebRTC DataChannel error', event);
      };
    }

    function openAnswererChannel() {
      peerConnection.ondatachannel = function (event) {
        channel = event.channel;
        channel.binaryType = 'blob';
        setChannelEvents();
      };


    }

    // fake:true is also available on chrome under a flag!
    function useless() {
      log('Error in fake:true');
    }

    function onSdpSuccess() {
    }

    function onSdpError(e) {
      if (options.onChannelError) {
        options.onChannelError(e);
      }
      console.error('sdp error:', e);
    }

    return {
      addAnswerSDP: function (sdp, cbSuccess, cbError) {

        peerConnection.setRemoteDescription(new window.RTCSessionDescription(sdp), cbSuccess ? cbSuccess : onSdpSuccess, cbError ? cbError : onSdpError);
      },
      addICE: function (candidate) {
        peerConnection.addIceCandidate(new RTCIceCandidate({
          sdpMLineIndex: candidate.sdpMLineIndex,
          candidate: candidate.candidate
        }));
      },

      peer: peerConnection,
      channel: channel,
      sendData: function (message) {
        if (channel) {
          channel.send(message);
        }
      },

      stop: function () {
        peerConnection.close();
        if (options.attachStream) {
          if (typeof options.attachStream.stop == 'function') {
            options.attachStream.stop();
          } else {
            options.attachStream.active = false;
          }
        }
      }

    };
  }

  // getUserMedia
  var video_constraints = {
    //mandatory: {},
    //optional: []
  };

  function activateLocalVideo(el, stream) {
    el.srcObject = stream;
    el.style.display = 'block';
  }

  function deactivateLocalVideo(el) {
    el.srcObject = null;
    el.style.display = 'none';
  }

  function getUserMedia(options) {
    var constrains = options.constraints || {audio: true, video: video_constraints};
    navigator.mediaDevices.getUserMedia(constrains)
      .then(
        function (stream) {
          if (options.localVideo) {
            activateLocalVideo(options.localVideo, stream);
          }

          if (options.onsuccess) {
            options.onsuccess(stream);
          }
        },
        options.onerror ||
        function (e) {
          console.error(e);
        }
      );
  }

  $.FSRTC.resSupported = function (w, h) {
    for (var i in $.FSRTC.validRes) {
      if ($.FSRTC.validRes[i][0] == w && $.FSRTC.validRes[i][1] == h) {
        return true;
      }
    }

    return false;
  }

  $.FSRTC.bestResSupported = function () {
    var w = 0, h = 0;

    for (var i in $.FSRTC.validRes) {
      if ($.FSRTC.validRes[i][0] >= w && $.FSRTC.validRes[i][1] >= h) {
        w = $.FSRTC.validRes[i][0];
        h = $.FSRTC.validRes[i][1];
      }
    }

    return [w, h];
  }

  var resList = [[160, 120], [320, 180], [320, 240], [640, 360], [640, 480], [1280, 720], [1920, 1080]];
  var resI = 0;
  var ttl = 0;

  var checkRes = function (cam, func) {

    if (resI >= resList.length) {
      var res = {
        'validRes': $.FSRTC.validRes,
        'bestResSupported': $.FSRTC.bestResSupported()
      };

      localStorage.setItem("res_" + cam, $.toJSON(res));

      if (func) return func(res);
      return;
    }

    w = resList[resI][0];
    h = resList[resI][1];
    resI++;

    var video = {
      width: {exact: w},
      height: {exact: h}
    };

    if (cam !== "any") {
      video.deviceId = {
        exact: cam,
      };
    }

    getUserMedia({
      constraints: {
        audio: ttl++ == 0,
        video: video
      },
      onsuccess: function (e) {
        e.getTracks().forEach(function (track) {
          track.stop();
        });
        console.info(w + "x" + h + " supported.");
        $.FSRTC.validRes.push([w, h]);
        checkRes(cam, func);
      },
      onerror: function (e) {
        console.warn(w + "x" + h + " not supported.");
        checkRes(cam, func);
      }
    });
  }


  $.FSRTC.getValidRes = function (cam, func) {
    var cached = localStorage.getItem("res_" + cam);

    if (cached) {
      var cache = $.parseJSON(cached);

      if (cache) {
        $.FSRTC.validRes = cache.validRes;
        console.log("CACHED RES FOR CAM " + cam, cache);
      } else {
        console.error("INVALID CACHE");
      }
      return func ? func(cache) : null;
    }


    $.FSRTC.validRes = [];
    resI = 0;

    checkRes(cam, func);
  }

  $.FSRTC.checkPerms = function (runtime, check_audio, check_video) {
    getUserMedia({
      constraints: {
        audio: check_audio,
        video: check_video,
      },
      onsuccess: function (response) {
        response.getTracks().forEach(function (track) {
          track.stop();
        });

        console.debug('Media perm init complete');

        if (runtime) {
          setTimeout(runtime, 100, true);
        }
      },
      onerror: function (error) {
        if (check_video && check_audio) {
          console.debug('Error, retesting with audio params only');
          return $.FSRTC.checkPerms(runtime, check_audio, false);
        }

        console.error('Мedia perm init error', error);

        if (runtime) {
          runtime(false)
        }
      }
    });
  }

})(jQuery);

/*
 * Verto HTML5/Javascript Telephony Signaling and Control Protocol Stack for FreeSWITCH
 * Copyright (C) 2005-2014, Anthony Minessale II <anthm@freeswitch.org>
 *
 * Version: MPL 1.1
 *
 * The contents of this file are subject to the Mozilla Public License Version
 * 1.1 (the "License"); you may not use this file except in compliance with
 * the License. You may obtain a copy of the License at
 * http://www.mozilla.org/MPL/
 *
 * Software distributed under the License is distributed on an "AS IS" basis,
 * WITHOUT WARRANTY OF ANY KIND, either express or implied. See the License
 * for the specific language governing rights and limitations under the
 * License.
 *
 * The Original Code is Verto HTML5/Javascript Telephony Signaling and Control Protocol Stack for FreeSWITCH
 *
 * The Initial Developer of the Original Code is
 * Anthony Minessale II <anthm@freeswitch.org>
 * Portions created by the Initial Developer are Copyright (C)
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *
 * Anthony Minessale II <anthm@freeswitch.org>
 *
 * jquery.verto.js - Main interface
 *
 */

(function ($) {
  var sources = [];

  var generateGUID = (typeof (window.crypto) !== 'undefined' && typeof (window.crypto.getRandomValues) !== 'undefined') ?
    function () {
      // If we have a cryptographically secure PRNG, use that
      // http://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
      var buf = new Uint16Array(8);
      window.crypto.getRandomValues(buf);
      var S4 = function (num) {
        var ret = num.toString(16);
        while (ret.length < 4) {
          ret = "0" + ret;
        }
        return ret;
      };
      return (S4(buf[0]) + S4(buf[1]) + "-" + S4(buf[2]) + "-" + S4(buf[3]) + "-" + S4(buf[4]) + "-" + S4(buf[5]) + S4(buf[6]) + S4(buf[7]));
    }

    :

    function () {
      // Otherwise, just use Math.random
      // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    };

  /// MASTER OBJ
  $.verto = function (options, callbacks) {
    var verto = this;

    $.verto.saved.push(verto);

    verto.options = $.extend({
      login: null,
      passwd: null,
      socketUrl: null,
      tag: null,
      localTag: null,
      videoParams: {},
      audioParams: {},
      loginParams: {},
      deviceParams: {onResCheck: null},
      userVariables: {},
      iceServers: false,
      ringSleep: 6000,
      sessid: null,
      useStream: null
    }, options);

    if (verto.options.deviceParams.useCamera) {
      $.FSRTC.getValidRes(verto.options.deviceParams.useCamera, verto.options.deviceParams.onResCheck);
    }

    if (!verto.options.deviceParams.useMic) {
      verto.options.deviceParams.useMic = "any";
    }

    if (!verto.options.deviceParams.useSpeak) {
      verto.options.deviceParams.useSpeak = "any";
    }

    if (verto.options.sessid) {
      verto.sessid = verto.options.sessid;
    } else {
      verto.sessid = localStorage.getItem("verto_session_uuid") || generateGUID();
      localStorage.setItem("verto_session_uuid", verto.sessid);
    }

    verto.dialogs = {};
    verto.callbacks = callbacks || {};
    verto.eventSUBS = {};

    verto.rpcClient = new $.JsonRpcClient({
      login: verto.options.login,
      passwd: verto.options.passwd,
      socketUrl: verto.options.socketUrl,
      wsFallbackURL: verto.options.wsFallbackURL,
      turnServer: verto.options.turnServer,
      loginParams: verto.options.loginParams,
      userVariables: verto.options.userVariables,
      sessid: verto.sessid,
      onmessage: function (e) {
        return verto.handleMessage(e.eventData);
      },
      onWSConnect: function (o) {
        o.call('login', {});
      },
      onWSLogin: function (success) {
        if (verto.callbacks.onWSLogin) {
          verto.callbacks.onWSLogin(verto, success);
        }
      },
      onWSClose: function (success) {
        if (verto.callbacks.onWSClose) {
          verto.callbacks.onWSClose(verto, success);
        }
        verto.purge();
      }
    });

    var tag = verto.options.tag;
    if (typeof (tag) === "function") {
      tag = tag();
    }

    if (verto.options.ringFile && verto.options.tag) {
      verto.ringer = $("#" + tag);
    }

    verto.rpcClient.call('login', {});

  };


  $.verto.prototype.deviceParams = function (obj) {
    var verto = this;

    for (var i in obj) {
      verto.options.deviceParams[i] = obj[i];
    }

    if (obj.useCamera) {
      $.FSRTC.getValidRes(verto.options.deviceParams.useCamera, obj ? obj.onResCheck : undefined);
    }
  };

  $.verto.prototype.videoParams = function (obj) {
    var verto = this;

    for (var i in obj) {
      verto.options.videoParams[i] = obj[i];
    }
  };

  $.verto.prototype.iceServers = function (obj) {
    var verto = this;
    verto.options.iceServers = obj;
  };

  $.verto.prototype.loginData = function (params) {
    var verto = this;
    verto.options.login = params.login;
    verto.options.passwd = params.passwd;
    verto.rpcClient.loginData(params);
  };

  $.verto.prototype.logout = function (msg) {
    var verto = this;
    verto.rpcClient.closeSocket();
    if (verto.callbacks.onWSClose) {
      verto.callbacks.onWSClose(verto, false);
    }
    verto.purge();
  };

  $.verto.prototype.login = function (msg) {
    var verto = this;
    verto.logout();
    verto.rpcClient.call('login', {});
  };

  $.verto.prototype.message = function (msg) {
    var verto = this;
    var err = 0;

    if (!msg.to) {
      console.error("Missing To");
      err++;
    }

    if (!msg.body) {
      console.error("Missing Body");
      err++;
    }

    if (err) {
      return false;
    }

    verto.sendMethod("verto.info", {
      msg: msg
    });

    return true;
  };

  $.verto.prototype.processReply = function (method, success, e) {
    var verto = this;
    var i;

    //console.log("Response: " + method, success, e);

    switch (method) {
      case "verto.subscribe":
        for (i in e.unauthorizedChannels) {
          drop_bad(verto, e.unauthorizedChannels[i]);
        }
        for (i in e.subscribedChannels) {
          mark_ready(verto, e.subscribedChannels[i]);
        }

        break;
      case "verto.unsubscribe":
        //console.error(e);
        break;
    }
  };

  $.verto.prototype.sendMethod = function (method, params) {
    var verto = this;

    verto.rpcClient.call(method, params,

      function (e) {
        /* Success */
        verto.processReply(method, true, e);
      },

      function (e) {
        /* Error */
        verto.processReply(method, false, e);
      });
  };

  function do_sub(verto, channel, obj) {

  }

  function drop_bad(verto, channel) {
    console.error("drop unauthorized channel: " + channel);
    delete verto.eventSUBS[channel];
  }

  function mark_ready(verto, channel) {
    for (var j in verto.eventSUBS[channel]) {
      verto.eventSUBS[channel][j].ready = true;
      console.log("subscribed to channel: " + channel);
      if (verto.eventSUBS[channel][j].readyHandler) {
        verto.eventSUBS[channel][j].readyHandler(verto, channel);
      }
    }
  }

  var SERNO = 1;

  function do_subscribe(verto, channel, subChannels, sparams) {
    var params = sparams || {};

    var local = params.local;

    var obj = {
      eventChannel: channel,
      userData: params.userData,
      handler: params.handler,
      ready: false,
      readyHandler: params.readyHandler,
      serno: SERNO++
    };

    var isnew = false;

    if (!verto.eventSUBS[channel]) {
      verto.eventSUBS[channel] = [];
      subChannels.push(channel);
      isnew = true;
    }

    verto.eventSUBS[channel].push(obj);

    if (local) {
      obj.ready = true;
      obj.local = true;
    }

    if (!isnew && verto.eventSUBS[channel][0].ready) {
      obj.ready = true;
      if (obj.readyHandler) {
        obj.readyHandler(verto, channel);
      }
    }

    return {
      serno: obj.serno,
      eventChannel: channel
    };

  }

  $.verto.prototype.subscribe = function (channel, sparams) {
    var verto = this;
    var r = [];
    var subChannels = [];
    var params = sparams || {};

    if (typeof (channel) === "string") {
      r.push(do_subscribe(verto, channel, subChannels, params));
    } else {
      for (var i in channel) {
        r.push(do_subscribe(verto, channel, subChannels, params));
      }
    }

    if (subChannels.length) {
      verto.sendMethod("verto.subscribe", {
        eventChannel: subChannels.length == 1 ? subChannels[0] : subChannels,
        subParams: params.subParams
      });
    }

    return r;
  };

  $.verto.prototype.unsubscribe = function (handle) {
    var verto = this;
    var i;

    if (!handle) {
      for (i in verto.eventSUBS) {
        if (verto.eventSUBS[i]) {
          verto.unsubscribe(verto.eventSUBS[i]);
        }
      }
    } else {
      var unsubChannels = {};
      var sendChannels = [];
      var channel;

      if (typeof (handle) == "string") {
        delete verto.eventSUBS[handle];
        unsubChannels[handle]++;
      } else {
        for (i in handle) {
          if (typeof (handle[i]) == "string") {
            channel = handle[i];
            delete verto.eventSUBS[channel];
            unsubChannels[channel]++;
          } else {
            var repl = [];
            channel = handle[i].eventChannel;

            for (var j in verto.eventSUBS[channel]) {
              if (verto.eventSUBS[channel][j].serno == handle[i].serno) {
              } else {
                repl.push(verto.eventSUBS[channel][j]);
              }
            }

            verto.eventSUBS[channel] = repl;

            if (verto.eventSUBS[channel].length === 0) {
              delete verto.eventSUBS[channel];
              unsubChannels[channel]++;
            }
          }
        }
      }

      for (var u in unsubChannels) {
        console.log("Sending Unsubscribe for: ", u);
        sendChannels.push(u);
      }

      if (sendChannels.length) {
        verto.sendMethod("verto.unsubscribe", {
          eventChannel: sendChannels.length == 1 ? sendChannels[0] : sendChannels
        });
      }
    }
  };

  $.verto.prototype.broadcast = function (channel, params) {
    var verto = this;
    var msg = {
      eventChannel: channel,
      data: {}
    };
    for (var i in params) {
      msg.data[i] = params[i];
    }
    verto.sendMethod("verto.broadcast", msg);
  };

  $.verto.prototype.purge = function (callID) {
    var verto = this;
    var x = 0;
    var i;

    for (i in verto.dialogs) {
      if (!x) {
        console.log("purging dialogs");
      }
      x++;
      verto.dialogs[i].setState($.verto.enum.state.purge);
    }

    for (i in verto.eventSUBS) {
      if (verto.eventSUBS[i]) {
        console.log("purging subscription: " + i);
        delete verto.eventSUBS[i];
      }
    }
  };

  $.verto.prototype.hangup = function (callID) {
    var verto = this;
    if (callID) {
      var dialog = verto.dialogs[callID];

      if (dialog) {
        dialog.hangup();
      }
    } else {
      for (var i in verto.dialogs) {
        verto.dialogs[i].hangup();
      }
    }
  };

  $.verto.prototype.newCall = function (args, callbacks) {
    var verto = this;

    if (!verto.rpcClient.socketReady()) {
      console.error("Not Connected...");
      return;
    }

    if (args["useCamera"]) {
      verto.options.deviceParams["useCamera"] = args["useCamera"];
    }

    var dialog = new $.verto.dialog($.verto.enum.direction.outbound, this, args);

    if (callbacks) {
      dialog.callbacks = callbacks;
    }

    dialog.invite();

    return dialog;
  };

  $.verto.prototype.handleMessage = function (data) {
    var verto = this;

    if (!(data && data.method)) {
      console.error("Invalid Data", data);
      return;
    }

    if (data.params.callID) {
      var dialog = verto.dialogs[data.params.callID];

      if (data.method === "verto.attach" && dialog) {
        delete dialog.verto.dialogs[dialog.callID];
        dialog.rtc.stop();
        dialog = null;
      }

      if (dialog) {

        switch (data.method) {
          case 'verto.bye':
            dialog.hangup(data.params);
            break;
          case 'verto.answer':
            dialog.handleAnswer(data.params);
            break;
          case 'verto.media':
            dialog.handleMedia(data.params);
            break;
          case 'verto.display':
            dialog.handleDisplay(data.params);
            break;
          case 'verto.info':
            dialog.handleInfo(data.params);
            break;
          default:
            console.debug("INVALID METHOD OR NON-EXISTANT CALL REFERENCE IGNORED", dialog, data.method);
            break;
        }
      } else {

        switch (data.method) {
          case 'verto.attach':
            data.params.attach = true;

            if (data.params.sdp && data.params.sdp.indexOf("m=video") > 0) {
              data.params.useVideo = true;
            }

            if (data.params.sdp && data.params.sdp.indexOf("stereo=1") > 0) {
              data.params.useStereo = true;
            }

            dialog = new $.verto.dialog($.verto.enum.direction.inbound, verto, data.params);
            dialog.setState($.verto.enum.state.recovering);

            break;
          case 'verto.invite':

            if (data.params.sdp && data.params.sdp.indexOf("m=video") > 0) {
              data.params.wantVideo = true;
            }

            if (data.params.sdp && data.params.sdp.indexOf("stereo=1") > 0) {
              data.params.useStereo = true;
            }

            dialog = new $.verto.dialog($.verto.enum.direction.inbound, verto, data.params);
            break;
          default:
            console.debug("INVALID METHOD OR NON-EXISTANT CALL REFERENCE IGNORED");
            break;
        }
      }

      return {
        method: data.method
      };
    } else {
      switch (data.method) {
        case 'verto.punt':
          verto.purge();
          verto.logout();
          break;
        case 'verto.event':
          var list = null;
          var key = null;

          if (data.params) {
            key = data.params.eventChannel;
          }

          if (key) {
            list = verto.eventSUBS[key];

            if (!list) {
              list = verto.eventSUBS[key.split(".")[0]];
            }
          }

          if (!list && key && key === verto.sessid) {
            if (verto.callbacks.onMessage) {
              verto.callbacks.onMessage(verto, null, $.verto.enum.message.pvtEvent, data.params);
            }
          } else if (!list && key && verto.dialogs[key]) {
            verto.dialogs[key].sendMessage($.verto.enum.message.pvtEvent, data.params);
          } else if (!list) {
            if (!key) {
              key = "UNDEFINED";
            }
            console.error("UNSUBBED or invalid EVENT " + key + " IGNORED");
          } else {
            for (var i in list) {
              var sub = list[i];

              if (!sub || !sub.ready) {
                console.error("invalid EVENT for " + key + " IGNORED");
              } else if (sub.handler) {
                sub.handler(verto, data.params, sub.userData);
              } else if (verto.callbacks.onEvent) {
                verto.callbacks.onEvent(verto, data.params, sub.userData);
              } else {
                console.log("EVENT:", data.params);
              }
            }
          }

          break;

        case "verto.info":
          if (verto.callbacks.onMessage) {
            verto.callbacks.onMessage(verto, null, $.verto.enum.message.info, data.params.msg);
          }
          //console.error(data);
          console.debug("MESSAGE from: " + data.params.msg.from, data.params.msg.body);

          break;

        case 'verto.clientReady':
          if (verto.callbacks.onMessage) {
            verto.callbacks.onMessage(verto, null, $.verto.enum.message.clientReady, data.params);
          }
          console.debug("CLIENT READY", data.params);
          break;

        default:
          console.error("INVALID METHOD OR NON-EXISTANT CALL REFERENCE IGNORED", data.method);
          break;
      }
    }
  };

  var del_array = function (array, name) {
    var r = [];
    var len = array.length;

    for (var i = 0; i < len; i++) {
      if (array[i] != name) {
        r.push(array[i]);
      }
    }

    return r;
  };

  var hashArray = function () {
    var vha = this;

    var hash = {};
    var array = [];

    vha.reorder = function (a) {
      array = a;
      var h = hash;
      hash = {};

      var len = array.length;

      for (var i = 0; i < len; i++) {
        var key = array[i];
        if (h[key]) {
          hash[key] = h[key];
          delete h[key];
        }
      }
      h = undefined;
    };

    vha.clear = function () {
      hash = undefined;
      array = undefined;
      hash = {};
      array = [];
    };

    vha.add = function (name, val, insertAt) {
      var redraw = false;

      if (!hash[name]) {
        if (insertAt === undefined || insertAt < 0 || insertAt >= array.length) {
          array.push(name);
        } else {
          var x = 0;
          var n = [];
          var len = array.length;

          for (var i = 0; i < len; i++) {
            if (x++ == insertAt) {
              n.push(name);
            }
            n.push(array[i]);
          }

          array = undefined;
          array = n;
          n = undefined;
          redraw = true;
        }
      }

      hash[name] = val;

      return redraw;
    };

    vha.del = function (name) {
      var r = false;

      if (hash[name]) {
        array = del_array(array, name);
        delete hash[name];
        r = true;
      } else {
        console.error("can't del nonexistant key " + name);
      }

      return r;
    };

    vha.get = function (name) {
      return hash[name];
    };

    vha.order = function () {
      return array;
    };

    vha.hash = function () {
      return hash;
    };

    vha.indexOf = function (name) {
      var len = array.length;

      for (var i = 0; i < len; i++) {
        if (array[i] == name) {
          return i;
        }
      }
    };

    vha.arrayLen = function () {
      return array.length;
    };

    vha.asArray = function () {
      var r = [];

      var len = array.length;

      for (var i = 0; i < len; i++) {
        var key = array[i];
        r.push(hash[key]);
      }

      return r;
    };

    vha.each = function (cb) {
      var len = array.length;

      for (var i = 0; i < len; i++) {
        cb(array[i], hash[array[i]]);
      }
    };

    vha.dump = function (html) {
      var str = "";

      vha.each(function (name, val) {
        str += "name: " + name + " val: " + JSON.stringify(val) + (html ? "<br>" : "\n");
      });

      return str;
    };

  };

  $.verto.liveArray = function (verto, context, name, config) {
    var la = this;
    var lastSerno = 0;
    var binding = null;
    var user_obj = config.userObj;
    var local = false;

    // Inherit methods of hashArray
    hashArray.call(la);

    // Save the hashArray add, del, reorder, clear methods so we can make our own.
    la._add = la.add;
    la._del = la.del;
    la._reorder = la.reorder;
    la._clear = la.clear;

    la.context = context;
    la.name = name;
    la.user_obj = user_obj;

    la.verto = verto;
    la.broadcast = function (channel, obj) {
      verto.broadcast(channel, obj);
    };
    la.errs = 0;

    la.clear = function () {
      la._clear();
      lastSerno = 0;

      if (la.onChange) {
        la.onChange(la, {
          action: "clear"
        });
      }
    };

    la.checkSerno = function (serno) {
      if (serno < 0) {
        return true;
      }

      if (lastSerno > 0 && serno != (lastSerno + 1)) {
        if (la.onErr) {
          la.onErr(la, {
            lastSerno: lastSerno,
            serno: serno
          });
        }
        la.errs++;
        console.debug(la.errs);
        if (la.errs < 3) {
          la.bootstrap(la.user_obj);
        }
        return false;
      } else {
        lastSerno = serno;
        return true;
      }
    };

    la.reorder = function (serno, a) {
      if (la.checkSerno(serno)) {
        la._reorder(a);
        if (la.onChange) {
          la.onChange(la, {
            serno: serno,
            action: "reorder"
          });
        }
      }
    };

    la.init = function (serno, val, key, index) {
      if (key === null || key === undefined) {
        key = serno;
      }
      if (la.checkSerno(serno)) {
        if (la.onChange) {
          la.onChange(la, {
            serno: serno,
            action: "init",
            index: index,
            key: key,
            data: val
          });
        }
      }
    };

    la.bootObj = function (serno, val) {
      if (la.checkSerno(serno)) {

        //la.clear();
        for (var i in val) {
          la._add(val[i][0], val[i][1]);
        }

        if (la.onChange) {
          la.onChange(la, {
            serno: serno,
            action: "bootObj",
            data: val,
            redraw: true
          });
        }
      }
    };

    // @param serno  La is the serial number for la particular request.
    // @param key    If looking at it as a hash table, la represents the key in the hashArray object where you want to store the val object.
    // @param index  If looking at it as an array, la represents the position in the array where you want to store the val object.
    // @param val    La is the object you want to store at the key or index location in the hash table / array.
    la.add = function (serno, val, key, index) {
      if (key === null || key === undefined) {
        key = serno;
      }
      if (la.checkSerno(serno)) {
        var redraw = la._add(key, val, index);
        if (la.onChange) {
          la.onChange(la, {
            serno: serno,
            action: "add",
            index: index,
            key: key,
            data: val,
            redraw: redraw
          });
        }
      }
    };

    la.modify = function (serno, val, key, index) {
      if (key === null || key === undefined) {
        key = serno;
      }
      if (la.checkSerno(serno)) {
        la._add(key, val, index);
        if (la.onChange) {
          la.onChange(la, {
            serno: serno,
            action: "modify",
            key: key,
            data: val,
            index: index
          });
        }
      }
    };

    la.del = function (serno, key, index) {
      if (key === null || key === undefined) {
        key = serno;
      }
      if (la.checkSerno(serno)) {
        if (index === null || index < 0 || index === undefined) {
          index = la.indexOf(key);
        }
        var ok = la._del(key);

        if (ok && la.onChange) {
          la.onChange(la, {
            serno: serno,
            action: "del",
            key: key,
            index: index
          });
        }
      }
    };

    var eventHandler = function (v, e, la) {
      var packet = e.data;

      //console.error("READ:", packet);

      if (packet.name != la.name) {
        return;
      }

      switch (packet.action) {

        case "init":
          la.init(packet.wireSerno, packet.data, packet.hashKey, packet.arrIndex);
          break;

        case "bootObj":
          la.bootObj(packet.wireSerno, packet.data);
          break;
        case "add":
          la.add(packet.wireSerno, packet.data, packet.hashKey, packet.arrIndex);
          break;

        case "modify":
          if (!(packet.arrIndex || packet.hashKey)) {
            console.error("Invalid Packet", packet);
          } else {
            la.modify(packet.wireSerno, packet.data, packet.hashKey, packet.arrIndex);
          }
          break;
        case "del":
          if (!(packet.arrIndex || packet.hashKey)) {
            console.error("Invalid Packet", packet);
          } else {
            la.del(packet.wireSerno, packet.hashKey, packet.arrIndex);
          }
          break;

        case "clear":
          la.clear();
          break;

        case "reorder":
          la.reorder(packet.wireSerno, packet.order);
          break;

        default:
          if (la.checkSerno(packet.wireSerno)) {
            if (la.onChange) {
              la.onChange(la, {
                serno: packet.wireSerno,
                action: packet.action,
                data: packet.data
              });
            }
          }
          break;
      }
    };

    if (la.context) {
      binding = la.verto.subscribe(la.context, {
        handler: eventHandler,
        userData: la,
        subParams: config.subParams
      });
    }

    la.destroy = function () {
      la._clear();
      la.verto.unsubscribe(binding);
    };

    la.sendCommand = function (cmd, obj) {
      var self = la;
      self.broadcast(self.context, {
        liveArray: {
          command: cmd,
          context: self.context,
          name: self.name,
          obj: obj
        }
      });
    };

    la.bootstrap = function (obj) {
      var self = la;
      la.sendCommand("bootstrap", obj);
      //self.heartbeat();
    };

    la.changepage = function (obj) {
      var self = la;
      self.clear();
      self.broadcast(self.context, {
        liveArray: {
          command: "changepage",
          context: la.context,
          name: la.name,
          obj: obj
        }
      });
    };

    la.heartbeat = function (obj) {
      var self = la;

      var callback = function () {
        self.heartbeat.call(self, obj);
      };
      self.broadcast(self.context, {
        liveArray: {
          command: "heartbeat",
          context: self.context,
          name: self.name,
          obj: obj
        }
      });
      self.hb_pid = setTimeout(callback, 30000);
    };

    la.bootstrap(la.user_obj);
  };

  $.verto.liveTable = function (verto, context, name, jq, config) {
    var dt;
    var la = new $.verto.liveArray(verto, context, name, {
      subParams: config.subParams
    });
    var lt = this;

    lt.liveArray = la;
    lt.dataTable = dt;
    lt.verto = verto;

    lt.destroy = function () {
      if (dt) {
        dt.fnDestroy();
      }
      if (la) {
        la.destroy();
      }

      dt = null;
      la = null;
    };

    la.onErr = function (obj, args) {
      console.error("Error: ", obj, args);
    };

    /* back compat so jsonstatus can always be enabled */
    function genRow(data) {
      if (typeof (data[4]) === "string" && data[4].indexOf("{") > -1) {
        var tmp = $.parseJSON(data[4]);
        data[4] = tmp.oldStatus;
        data[5] = null;
      }
      return data;
    }

    function genArray(obj) {
      var data = obj.asArray();

      for (var i in data) {
        data[i] = genRow(data[i]);
      }

      return data;
    }


    la.onChange = function (obj, args) {
      var index = 0;
      var iserr = 0;

      if (!dt) {
        if (!config.aoColumns) {
          if (args.action != "init") {
            return;
          }

          config.aoColumns = [];

          for (var i in args.data) {
            config.aoColumns.push({
              "sTitle": args.data[i]
            });
          }
        }

        dt = jq.dataTable(config);
      }

      if (dt && (args.action == "del" || args.action == "modify")) {
        index = args.index;

        if (index === undefined && args.key) {
          index = la.indexOf(args.key);
        }

        if (index === undefined) {
          console.error("INVALID PACKET Missing INDEX\n", args);
          return;
        }
      }

      if (config.onChange) {
        config.onChange(obj, args);
      }

      try {
        switch (args.action) {
          case "bootObj":
            if (!args.data) {
              console.error("missing data");
              return;
            }
            dt.fnClearTable();
            dt.fnAddData(genArray(obj));
            dt.fnAdjustColumnSizing();
            break;
          case "add":
            if (!args.data) {
              console.error("missing data");
              return;
            }
            if (args.redraw > -1) {
              // specific position, more costly
              dt.fnClearTable();
              dt.fnAddData(genArray(obj));
            } else {
              dt.fnAddData(genRow(args.data));
            }
            dt.fnAdjustColumnSizing();
            break;
          case "modify":
            if (!args.data) {
              return;
            }
            //console.debug(args, index);
            dt.fnUpdate(genRow(args.data), index);
            dt.fnAdjustColumnSizing();
            break;
          case "del":
            dt.fnDeleteRow(index);
            dt.fnAdjustColumnSizing();
            break;
          case "clear":
            dt.fnClearTable();
            break;
          case "reorder":
            // specific position, more costly
            dt.fnClearTable();
            dt.fnAddData(genArray(obj));
            break;
          case "hide":
            jq.hide();
            break;

          case "show":
            jq.show();
            break;

        }
      } catch (err) {
        console.error("ERROR: " + err);
        iserr++;
      }

      if (iserr) {
        obj.errs++;
        if (obj.errs < 3) {
          obj.bootstrap(obj.user_obj);
        }
      } else {
        obj.errs = 0;
      }

    };

    la.onChange(la, {
      action: "init"
    });

  };

  var CONFMAN_SERNO = 1;

  /*
      Conference Manager without jQuery table.
   */

  $.verto.conf = function (verto, params) {
    var conf = this;

    conf.params = $.extend({
      dialog: null,
      hasVid: false,
      laData: null,
      onBroadcast: null,
      onLaChange: null,
      onLaRow: null
    }, params);

    conf.verto = verto;
    conf.serno = CONFMAN_SERNO++;

    createMainModeratorMethods();

    verto.subscribe(conf.params.laData.modChannel, {
      handler: function (v, e) {
        if (conf.params.onBroadcast) {
          conf.params.onBroadcast(verto, conf, e.data);
        }
      }
    });

    verto.subscribe(conf.params.laData.infoChannel, {
      handler: function (v, e) {
        if (typeof (conf.params.infoCallback) === "function") {
          conf.params.infoCallback(v, e);
        }
      }
    });

    verto.subscribe(conf.params.laData.chatChannel, {
      handler: function (v, e) {
        if (typeof (conf.params.chatCallback) === "function") {
          conf.params.chatCallback(v, e);
        }
      }
    });
  };

  $.verto.conf.prototype.modCommand = function (cmd, id, value) {
    var conf = this;

    conf.verto.rpcClient.call("verto.broadcast", {
      "eventChannel": conf.params.laData.modChannel,
      "data": {
        "application": "conf-control",
        "command": cmd,
        "id": id,
        "value": value
      }
    });
  };

  $.verto.conf.prototype.destroy = function () {
    var conf = this;

    conf.destroyed = true;
    conf.params.onBroadcast(conf.verto, conf, 'destroy');

    if (conf.params.laData.modChannel) {
      conf.verto.unsubscribe(conf.params.laData.modChannel);
    }

    if (conf.params.laData.chatChannel) {
      conf.verto.unsubscribe(conf.params.laData.chatChannel);
    }

    if (conf.params.laData.infoChannel) {
      conf.verto.unsubscribe(conf.params.laData.infoChannel);
    }
  };

  function createMainModeratorMethods() {
    $.verto.conf.prototype.listVideoLayouts = function () {
      this.modCommand("list-videoLayouts", null, null);
    };

    $.verto.conf.prototype.play = function (file) {
      this.modCommand("play", null, file);
    };

    $.verto.conf.prototype.stop = function () {
      this.modCommand("stop", null, "all");
    };

    $.verto.conf.prototype.deaf = function (memberID) {
      this.modCommand("deaf", parseInt(memberID));
    };

    $.verto.conf.prototype.undeaf = function (memberID) {
      this.modCommand("undeaf", parseInt(memberID));
    };

    $.verto.conf.prototype.record = function (file) {
      this.modCommand("recording", null, ["start", file]);
    };

    $.verto.conf.prototype.stopRecord = function () {
      this.modCommand("recording", null, ["stop", "all"]);
    };

    $.verto.conf.prototype.snapshot = function (file) {
      if (!this.params.hasVid) {
        throw 'Conference has no video';
      }
      this.modCommand("vid-write-png", null, file);
    };

    $.verto.conf.prototype.setVideoLayout = function (layout, canvasID) {
      if (!this.params.hasVid) {
        throw 'Conference has no video';
      }
      if (canvasID) {
        this.modCommand("vid-layout", null, [layout, canvasID]);
      } else {
        this.modCommand("vid-layout", null, layout);
      }
    };

    $.verto.conf.prototype.kick = function (memberID) {
      this.modCommand("kick", parseInt(memberID));
    };

    $.verto.conf.prototype.muteMic = function (memberID) {
      this.modCommand("tmute", parseInt(memberID));
    };

    $.verto.conf.prototype.muteVideo = function (memberID) {
      if (!this.params.hasVid) {
        throw 'Conference has no video';
      }
      this.modCommand("tvmute", parseInt(memberID));
    };

    $.verto.conf.prototype.presenter = function (memberID) {
      if (!this.params.hasVid) {
        throw 'Conference has no video';
      }
      this.modCommand("vid-res-id", parseInt(memberID), "presenter");
    };

    $.verto.conf.prototype.videoFloor = function (memberID) {
      if (!this.params.hasVid) {
        throw 'Conference has no video';
      }
      this.modCommand("vid-floor", parseInt(memberID), "force");
    };

    $.verto.conf.prototype.banner = function (memberID, text) {
      if (!this.params.hasVid) {
        throw 'Conference has no video';
      }
      this.modCommand("vid-banner", parseInt(memberID), escape(text));
    };

    $.verto.conf.prototype.volumeDown = function (memberID) {
      this.modCommand("volume_out", parseInt(memberID), "down");
    };

    $.verto.conf.prototype.volumeUp = function (memberID) {
      this.modCommand("volume_out", parseInt(memberID), "up");
    };

    $.verto.conf.prototype.gainDown = function (memberID) {
      this.modCommand("volume_in", parseInt(memberID), "down");
    };

    $.verto.conf.prototype.gainUp = function (memberID) {
      this.modCommand("volume_in", parseInt(memberID), "up");
    };

    $.verto.conf.prototype.transfer = function (memberID, exten) {
      this.modCommand("transfer", parseInt(memberID), exten);
    };

    $.verto.conf.prototype.sendChat = function (message, type) {
      var conf = this;
      conf.verto.rpcClient.call("verto.broadcast", {
        "eventChannel": conf.params.laData.chatChannel,
        "data": {
          "action": "send",
          "message": message,
          "type": type
        }
      });
    };

  }

  $.verto.modfuncs = {};

  $.verto.confMan = function (verto, params) {
    var confMan = this;

    confMan.params = $.extend({
      tableID: null,
      statusID: null,
      mainModID: null,
      dialog: null,
      hasVid: false,
      laData: null,
      onBroadcast: null,
      onLaChange: null,
      onLaRow: null
    }, params);

    confMan.verto = verto;
    confMan.serno = CONFMAN_SERNO++;
    confMan.canvasCount = confMan.params.laData.canvasCount;

    function genMainMod(jq) {
      var play_id = "play_" + confMan.serno;
      var stop_id = "stop_" + confMan.serno;
      var recording_id = "recording_" + confMan.serno;
      var snapshot_id = "snapshot_" + confMan.serno;
      var rec_stop_id = "recording_stop" + confMan.serno;
      var div_id = "confman_" + confMan.serno;

      var html = "<div id='" + div_id + "'><br>" +
        "<button class='ctlbtn' id='" + play_id + "'>Play</button>" +
        "<button class='ctlbtn' id='" + stop_id + "'>Stop</button>" +
        "<button class='ctlbtn' id='" + recording_id + "'>Record</button>" +
        "<button class='ctlbtn' id='" + rec_stop_id + "'>Record Stop</button>" +
        (confMan.params.hasVid ? "<button class='ctlbtn' id='" + snapshot_id + "'>PNG Snapshot</button>" : "") +
        "<br><br></div>";

      jq.html(html);

      $.verto.modfuncs.change_video_layout = function (id, canvas_id) {
        var val = $("#" + id + " option:selected").text();
        if (val !== "none") {
          confMan.modCommand("vid-layout", null, [val, canvas_id]);
        }
      };

      if (confMan.params.hasVid) {
        for (var j = 0; j < confMan.canvasCount; j++) {
          var vlayout_id = "confman_vid_layout_" + j + "_" + confMan.serno;
          var vlselect_id = "confman_vl_select_" + j + "_" + confMan.serno;


          var vlhtml = "<div id='" + vlayout_id + "'><br>" +
            "<b>Video Layout Canvas " + (j + 1) +
            "</b> <select onChange='$.verto.modfuncs.change_video_layout(\"" + vlayout_id + "\", \"" + (j + 1) + "\")' id='" + vlselect_id + "'></select> " +
            "<br><br></div>";
          jq.append(vlhtml);
        }

        $("#" + snapshot_id).click(function () {
          var file = prompt("Please enter file name", "");
          if (file) {
            confMan.modCommand("vid-write-png", null, file);
          }
        });
      }

      $("#" + play_id).click(function () {
        var file = prompt("Please enter file name", "");
        if (file) {
          confMan.modCommand("play", null, file);
        }
      });

      $("#" + stop_id).click(function () {
        confMan.modCommand("stop", null, "all");
      });

      $("#" + recording_id).click(function () {
        var file = prompt("Please enter file name", "");
        if (file) {
          confMan.modCommand("recording", null, ["start", file]);
        }
      });

      $("#" + rec_stop_id).click(function () {
        confMan.modCommand("recording", null, ["stop", "all"]);
      });

    }

    function genControls(jq, rowid) {
      var x = parseInt(rowid);
      var kick_id = "kick_" + x;
      var canvas_in_next_id = "canvas_in_next_" + x;
      var canvas_in_prev_id = "canvas_in_prev_" + x;
      var canvas_out_next_id = "canvas_out_next_" + x;
      var canvas_out_prev_id = "canvas_out_prev_" + x;

      var canvas_in_set_id = "canvas_in_set_" + x;
      var canvas_out_set_id = "canvas_out_set_" + x;

      var layer_set_id = "layer_set_" + x;
      var layer_next_id = "layer_next_" + x;
      var layer_prev_id = "layer_prev_" + x;

      var tmute_id = "tmute_" + x;
      var tvmute_id = "tvmute_" + x;
      var vbanner_id = "vbanner_" + x;
      var tvpresenter_id = "tvpresenter_" + x;
      var tvfloor_id = "tvfloor_" + x;
      var box_id = "box_" + x;
      var gainup_id = "gain_in_up" + x;
      var gaindn_id = "gain_in_dn" + x;
      var volup_id = "vol_in_up" + x;
      var voldn_id = "vol_in_dn" + x;
      var transfer_id = "transfer" + x;


      var html = "<div id='" + box_id + "'>";

      html += "<b>General Controls</b><hr noshade>";

      html += "<button class='ctlbtn' id='" + kick_id + "'>Kick</button>" +
        "<button class='ctlbtn' id='" + tmute_id + "'>Mute</button>" +
        "<button class='ctlbtn' id='" + gainup_id + "'>Gain -</button>" +
        "<button class='ctlbtn' id='" + gaindn_id + "'>Gain +</button>" +
        "<button class='ctlbtn' id='" + voldn_id + "'>Vol -</button>" +
        "<button class='ctlbtn' id='" + volup_id + "'>Vol +</button>" +
        "<button class='ctlbtn' id='" + transfer_id + "'>Transfer</button>";

      if (confMan.params.hasVid) {
        html += "<br><br><b>Video Controls</b><hr noshade>";


        html += "<button class='ctlbtn' id='" + tvmute_id + "'>VMute</button>" +
          "<button class='ctlbtn' id='" + tvpresenter_id + "'>Presenter</button>" +
          "<button class='ctlbtn' id='" + tvfloor_id + "'>Vid Floor</button>" +
          "<button class='ctlbtn' id='" + vbanner_id + "'>Banner</button>";

        if (confMan.canvasCount > 1) {
          html += "<br><br><b>Canvas Controls</b><hr noshade>" +
            "<button class='ctlbtn' id='" + canvas_in_set_id + "'>Set Input Canvas</button>" +
            "<button class='ctlbtn' id='" + canvas_in_prev_id + "'>Prev Input Canvas</button>" +
            "<button class='ctlbtn' id='" + canvas_in_next_id + "'>Next Input Canvas</button>" +

            "<br>" +

            "<button class='ctlbtn' id='" + canvas_out_set_id + "'>Set Watching Canvas</button>" +
            "<button class='ctlbtn' id='" + canvas_out_prev_id + "'>Prev Watching Canvas</button>" +
            "<button class='ctlbtn' id='" + canvas_out_next_id + "'>Next Watching Canvas</button>";
        }

        html += "<br>" +

          "<button class='ctlbtn' id='" + layer_set_id + "'>Set Layer</button>" +
          "<button class='ctlbtn' id='" + layer_prev_id + "'>Prev Layer</button>" +
          "<button class='ctlbtn' id='" + layer_next_id + "'>Next Layer</button>" +


          "</div>";
      }

      jq.html(html);


      if (!jq.data("mouse")) {
        $("#" + box_id).hide();
      }

      jq.mouseover(function (e) {
        jq.data({"mouse": true});
        $("#" + box_id).show();
      });

      jq.mouseout(function (e) {
        jq.data({"mouse": false});
        $("#" + box_id).hide();
      });

      $("#" + transfer_id).click(function () {
        var xten = prompt("Enter Extension");
        if (xten) {
          confMan.modCommand("transfer", x, xten);
        }
      });

      $("#" + kick_id).click(function () {
        confMan.modCommand("kick", x);
      });


      $("#" + layer_set_id).click(function () {
        var cid = prompt("Please enter layer ID", "");
        if (cid) {
          confMan.modCommand("vid-layer", x, cid);
        }
      });

      $("#" + layer_next_id).click(function () {
        confMan.modCommand("vid-layer", x, "next");
      });
      $("#" + layer_prev_id).click(function () {
        confMan.modCommand("vid-layer", x, "prev");
      });

      $("#" + canvas_in_set_id).click(function () {
        var cid = prompt("Please enter canvas ID", "");
        if (cid) {
          confMan.modCommand("vid-canvas", x, cid);
        }
      });

      $("#" + canvas_out_set_id).click(function () {
        var cid = prompt("Please enter canvas ID", "");
        if (cid) {
          confMan.modCommand("vid-watching-canvas", x, cid);
        }
      });

      $("#" + canvas_in_next_id).click(function () {
        confMan.modCommand("vid-canvas", x, "next");
      });
      $("#" + canvas_in_prev_id).click(function () {
        confMan.modCommand("vid-canvas", x, "prev");
      });


      $("#" + canvas_out_next_id).click(function () {
        confMan.modCommand("vid-watching-canvas", x, "next");
      });
      $("#" + canvas_out_prev_id).click(function () {
        confMan.modCommand("vid-watching-canvas", x, "prev");
      });

      $("#" + tmute_id).click(function () {
        confMan.modCommand("tmute", x);
      });

      if (confMan.params.hasVid) {
        $("#" + tvmute_id).click(function () {
          confMan.modCommand("tvmute", x);
        });
        $("#" + tvpresenter_id).click(function () {
          confMan.modCommand("vid-res-id", x, "presenter");
        });
        $("#" + tvfloor_id).click(function () {
          confMan.modCommand("vid-floor", x, "force");
        });
        $("#" + vbanner_id).click(function () {
          var text = prompt("Please enter text", "");
          if (text) {
            confMan.modCommand("vid-banner", x, escape(text));
          }
        });
      }

      $("#" + gainup_id).click(function () {
        confMan.modCommand("volume_in", x, "up");
      });

      $("#" + gaindn_id).click(function () {
        confMan.modCommand("volume_in", x, "down");
      });

      $("#" + volup_id).click(function () {
        confMan.modCommand("volume_out", x, "up");
      });

      $("#" + voldn_id).click(function () {
        confMan.modCommand("volume_out", x, "down");
      });

      return html;
    }

    var atitle = "";
    var awidth = 0;

    //$(".jsDataTable").width(confMan.params.hasVid ? "900px" : "800px");

    verto.subscribe(confMan.params.laData.infoChannel, {
      handler: function (v, e) {
        if (typeof (confMan.params.infoCallback) === "function") {
          confMan.params.infoCallback(v, e);
        }
      }
    });

    verto.subscribe(confMan.params.laData.chatChannel, {
      handler: function (v, e) {
        if (typeof (confMan.params.chatCallback) === "function") {
          confMan.params.chatCallback(v, e);
        }
      }
    });

    if (confMan.params.laData.role === "moderator") {
      atitle = "Action";
      awidth = 600;

      if (confMan.params.mainModID) {
        genMainMod($(confMan.params.mainModID));
        $(confMan.params.displayID).html("Moderator Controls Ready<br><br>");
      } else {
        $(confMan.params.mainModID).html("");
      }

      verto.subscribe(confMan.params.laData.modChannel, {
        handler: function (v, e) {
          //console.error("MODDATA:", e.data);
          if (confMan.params.onBroadcast) {
            confMan.params.onBroadcast(verto, confMan, e.data);
          }

          if (e.data["conf-command"] === "list-videoLayouts") {
            for (var j = 0; j < confMan.canvasCount; j++) {
              var vlselect_id = "#confman_vl_select_" + j + "_" + confMan.serno;
              var vlayout_id = "#confman_vid_layout_" + j + "_" + confMan.serno;

              var x = 0;
              var options;

              $(vlselect_id).selectmenu({});
              $(vlselect_id).selectmenu("enable");
              $(vlselect_id).empty();

              $(vlselect_id).append(new Option("Choose a Layout", "none"));

              if (e.data.responseData) {
                var rdata = [];

                for (var i in e.data.responseData) {
                  rdata.push(e.data.responseData[i].name);
                }

                options = rdata.sort(function (a, b) {
                  var ga = a.substring(0, 6) == "group:" ? true : false;
                  var gb = b.substring(0, 6) == "group:" ? true : false;

                  if ((ga || gb) && ga != gb) {
                    return ga ? -1 : 1;
                  }

                  return ((a == b) ? 0 : ((a > b) ? 1 : -1));
                });

                for (var i in options) {
                  $(vlselect_id).append(new Option(options[i], options[i]));
                  x++;
                }
              }

              if (x) {
                $(vlselect_id).selectmenu('refresh', true);
              } else {
                $(vlayout_id).hide();
              }
            }
          } else {

            if (!confMan.destroyed && confMan.params.displayID) {
              $(confMan.params.displayID).html(e.data.response + "<br><br>");
              if (confMan.lastTimeout) {
                clearTimeout(confMan.lastTimeout);
                confMan.lastTimeout = 0;
              }
              confMan.lastTimeout = setTimeout(function () {
                $(confMan.params.displayID).html(confMan.destroyed ? "" : "Moderator Controls Ready<br><br>");
              }, 4000);
            }
          }
        }
      });


      if (confMan.params.hasVid) {
        confMan.modCommand("list-videoLayouts", null, null);
      }
    }

    var row_callback = null;

    if (confMan.params.laData.role === "moderator") {
      row_callback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        if (!aData[5]) {
          var $row = $('td:eq(5)', nRow);
          genControls($row, aData);

          if (confMan.params.onLaRow) {
            confMan.params.onLaRow(verto, confMan, $row, aData);
          }
        }
      };
    }

    confMan.lt = new $.verto.liveTable(verto, confMan.params.laData.laChannel, confMan.params.laData.laName, $(confMan.params.tableID), {
      subParams: {
        callID: confMan.params.dialog ? confMan.params.dialog.callID : null
      },

      "onChange": function (obj, args) {
        $(confMan.params.statusID).text("Conference Members: " + " (" + obj.arrayLen() + " Total)");
        if (confMan.params.onLaChange) {
          confMan.params.onLaChange(verto, confMan, $.verto.enum.confEvent.laChange, obj, args);
        }
      },

      "aaData": [],
      "aoColumns": [
        {
          "sTitle": "ID",
          "sWidth": "50"
        },
        {
          "sTitle": "Number",
          "sWidth": "250"
        },
        {
          "sTitle": "Name",
          "sWidth": "250"
        },
        {
          "sTitle": "Codec",
          "sWidth": "100"
        },
        {
          "sTitle": "Status",
          "sWidth": confMan.params.hasVid ? "200px" : "150px"
        },
        {
          "sTitle": atitle,
          "sWidth": awidth,
        }
      ],
      "bAutoWidth": true,
      "bDestroy": true,
      "bSort": false,
      "bInfo": false,
      "bFilter": false,
      "bLengthChange": false,
      "bPaginate": false,
      "iDisplayLength": 1400,

      "oLanguage": {
        "sEmptyTable": "The Conference is Empty....."
      },

      "fnRowCallback": row_callback

    });
  };

  $.verto.confMan.prototype.modCommand = function (cmd, id, value) {
    var confMan = this;

    confMan.verto.rpcClient.call("verto.broadcast", {
      "eventChannel": confMan.params.laData.modChannel,
      "data": {
        "application": "conf-control",
        "command": cmd,
        "id": id,
        "value": value
      }
    });
  };

  $.verto.confMan.prototype.sendChat = function (message, type) {
    var confMan = this;
    confMan.verto.rpcClient.call("verto.broadcast", {
      "eventChannel": confMan.params.laData.chatChannel,
      "data": {
        "action": "send",
        "message": message,
        "type": type
      }
    });
  };


  $.verto.confMan.prototype.destroy = function () {
    var confMan = this;

    confMan.destroyed = true;

    if (confMan.lt) {
      confMan.lt.destroy();
    }

    if (confMan.params.laData.chatChannel) {
      confMan.verto.unsubscribe(confMan.params.laData.chatChannel);
    }

    if (confMan.params.laData.modChannel) {
      confMan.verto.unsubscribe(confMan.params.laData.modChannel);
    }

    if (confMan.params.mainModID) {
      $(confMan.params.mainModID).html("");
    }
  };

  $.verto.dialog = function (direction, verto, params) {
    var dialog = this;

    dialog.params = $.extend({
      useVideo: verto.options.useVideo,
      useStereo: verto.options.useStereo,
      screenShare: false,
      useCamera: false,
      useMic: verto.options.deviceParams.useMic,
      useSpeak: verto.options.deviceParams.useSpeak,
      tag: verto.options.tag,
      localTag: verto.options.localTag,
      login: verto.options.login,
      videoParams: verto.options.videoParams,
      useStream: verto.options.useStream,
    }, params);


    if (!dialog.params.screenShare) {
      dialog.params.useCamera = verto.options.deviceParams.useCamera;
    }

    dialog.verto = verto;
    dialog.direction = direction;
    dialog.lastState = null;
    dialog.state = dialog.lastState = $.verto.enum.state.new;
    dialog.callbacks = verto.callbacks;
    dialog.answered = false;
    dialog.attach = params.attach || false;
    dialog.screenShare = params.screenShare || false;
    dialog.useCamera = dialog.params.useCamera;
    dialog.useMic = dialog.params.useMic;
    dialog.useSpeak = dialog.params.useSpeak;

    if (dialog.params.callID) {
      dialog.callID = dialog.params.callID;
    } else {
      dialog.callID = dialog.params.callID = generateGUID();
    }

    if (typeof (dialog.params.tag) === "function") {
      dialog.params.tag = dialog.params.tag();
    }

    if (dialog.params.tag) {
      dialog.audioStream = document.getElementById(dialog.params.tag);

      if (dialog.params.useVideo) {
        dialog.videoStream = dialog.audioStream;
      }
    } //else conjure one TBD

    if (dialog.params.localTag) {
      dialog.localVideo = document.getElementById(dialog.params.localTag);
    }

    dialog.verto.dialogs[dialog.callID] = dialog;

    var RTCcallbacks = {};

    if (dialog.direction == $.verto.enum.direction.inbound) {
      if (dialog.params.display_direction === "outbound") {
        dialog.params.remote_caller_id_name = dialog.params.caller_id_name;
        dialog.params.remote_caller_id_number = dialog.params.caller_id_number;
      } else {
        dialog.params.remote_caller_id_name = dialog.params.callee_id_name;
        dialog.params.remote_caller_id_number = dialog.params.callee_id_number;
      }

      if (!dialog.params.remote_caller_id_name) {
        dialog.params.remote_caller_id_name = "Nobody";
      }

      if (!dialog.params.remote_caller_id_number) {
        dialog.params.remote_caller_id_number = "UNKNOWN";
      }

      RTCcallbacks.onMessage = function (rtc, msg) {
        console.debug(msg);
      };

      RTCcallbacks.onAnswerSDP = function (rtc, sdp) {
        console.error("answer sdp", sdp);
      };
    } else {
      dialog.params.remote_caller_id_name = "Outbound Call";
      dialog.params.remote_caller_id_number = dialog.params.destination_number;
    }

    RTCcallbacks.onICESDP = function (rtc) {
      console.debug("RECV " + rtc.type + " SDP", rtc.mediaData.SDP);

      if (dialog.state == $.verto.enum.state.requesting || dialog.state == $.verto.enum.state.answering || dialog.state == $.verto.enum.state.active) {
        location.reload();
        return;
      }

      if (rtc.type == "offer") {
        if (dialog.state == $.verto.enum.state.active) {
          dialog.setState($.verto.enum.state.requesting);
          dialog.sendMethod("verto.attach", {
            sdp: rtc.mediaData.SDP
          });
        } else {
          dialog.setState($.verto.enum.state.requesting);

          dialog.sendMethod("verto.invite", {
            sdp: rtc.mediaData.SDP
          });
        }
      } else { //answer
        dialog.setState($.verto.enum.state.answering);

        dialog.sendMethod(dialog.attach ? "verto.attach" : "verto.answer", {
          sdp: dialog.rtc.mediaData.SDP
        });
      }
    };

    RTCcallbacks.onICE = function (rtc) {
      //console.log("cand", rtc.mediaData.candidate);
      if (rtc.type === "offer") {
        console.debug("offer", rtc.mediaData.candidate);

      }
    };

    RTCcallbacks.onStream = function (rtc, stream) {
      if (dialog.callbacks.permissionCallback &&
        typeof dialog.callbacks.permissionCallback.onGranted === 'function') {
        dialog.callbacks.permissionCallback.onGranted(stream);
      } else if (dialog.verto.options.permissionCallback &&
        typeof dialog.verto.options.permissionCallback.onGranted === 'function') {
        dialog.verto.options.permissionCallback.onGranted(stream);
      }
      console.log("stream started");
    };

    RTCcallbacks.onRemoteStream = function (rtc, stream) {
      if (typeof dialog.callbacks.onRemoteStream === 'function') {
        dialog.callbacks.onRemoteStream(stream, dialog);
      }
      console.log("remote stream started");
    };

    RTCcallbacks.onError = function (e) {
      if (dialog.callbacks.permissionCallback &&
        typeof dialog.callbacks.permissionCallback.onDenied === 'function') {
        dialog.callbacks.permissionCallback.onDenied();
      } else if (dialog.verto.options.permissionCallback &&
        typeof dialog.verto.options.permissionCallback.onDenied === 'function') {
        dialog.verto.options.permissionCallback.onDenied();
      }
      console.error("ERROR:", e);
      dialog.hangup({cause: "Device or Permission Error"});
    };

    dialog.rtc = new $.FSRTC({
      callbacks: RTCcallbacks,
      localVideo: dialog.screenShare ? null : dialog.localVideo,
      useVideo: dialog.params.useVideo ? dialog.videoStream : null,
      useAudio: dialog.audioStream,
      useStereo: dialog.params.useStereo,
      videoParams: dialog.params.videoParams,
      audioParams: verto.options.audioParams,
      iceServers: verto.options.iceServers,
      screenShare: dialog.screenShare,
      useCamera: dialog.useCamera,
      useMic: dialog.useMic,
      useSpeak: dialog.useSpeak,
      turnServer: verto.options.turnServer,
      useStream: dialog.params.useStream
    });

    dialog.rtc.verto = dialog.verto;

    if (dialog.direction == $.verto.enum.direction.inbound) {
      if (dialog.attach) {
        dialog.answer();
      } else {
        dialog.ring();
      }
    }
  };

  $.verto.dialog.prototype.invite = function () {
    var dialog = this;
    dialog.rtc.call();
  };

  $.verto.dialog.prototype.sendMethod = function (method, obj) {
    var dialog = this;
    obj.dialogParams = {};

    for (var i in dialog.params) {
      if (i == "sdp" && method != "verto.invite" && method != "verto.attach") {
        continue;
      }

      if ((obj.noDialogParams && i != "callID")) {
        continue;
      }

      obj.dialogParams[i] = dialog.params[i];
    }

    delete obj.noDialogParams;

    dialog.verto.rpcClient.call(method, obj,

      function (e) {
        /* Success */
        dialog.processReply(method, true, e);
      },

      function (e) {
        /* Error */
        dialog.processReply(method, false, e);
      });
  };

  function checkStateChange(oldS, newS) {

    if (newS == $.verto.enum.state.purge || $.verto.enum.states[oldS.name][newS.name]) {
      return true;
    }

    return false;
  }


  // Attach audio output device to video element using device/sink ID.
  function find_name(id) {
    for (var i in $.verto.audioOutDevices) {
      var source = $.verto.audioOutDevices[i];
      if (source.id === id) {
        return (source.label);
      }
    }

    return id;
  }

  $.verto.dialog.prototype.setAudioPlaybackDevice = function (sinkId, callback, arg) {
    var dialog = this;
    var element = dialog.audioStream;

    if (typeof element.sinkId !== 'undefined') {
      var devname = find_name(sinkId);
      console.info("Dialog: " + dialog.callID + " Setting speaker:", element, devname);

      element.setSinkId(sinkId)
        .then(function () {
          console.log("Dialog: " + dialog.callID + ' Success, audio output device attached: ' + sinkId);
          if (callback) {
            callback(true, devname, arg);
          }
        })
        .catch(function (error) {
          var errorMessage = error;
          if (error.name === 'SecurityError') {
            errorMessage = "Dialog: " + dialog.callID + ' You need to use HTTPS for selecting audio output ' +
              'device: ' + error;
          }
          if (callback) {
            callback(false, null, arg);
          }
          console.error(errorMessage);
        });
    } else {
      console.warn("Dialog: " + dialog.callID + ' Browser does not support output device selection.');
      if (callback) {
        callback(false, null, arg);
      }
    }
  }

  $.verto.dialog.prototype.setState = function (state) {
    var dialog = this;

    if (dialog.state == $.verto.enum.state.ringing) {
      dialog.stopRinging();
    }

    if (dialog.state == state || !checkStateChange(dialog.state, state)) {
      console.error("Dialog " + dialog.callID + ": INVALID state change from " + dialog.state.name + " to " + state.name);
      dialog.hangup();
      return false;
    }

    console.log("Dialog " + dialog.callID + ": state change from " + dialog.state.name + " to " + state.name);

    dialog.lastState = dialog.state;
    dialog.state = state;

    if (dialog.callbacks.onDialogState) {
      dialog.callbacks.onDialogState(this);
    }

    switch (dialog.state) {

      case $.verto.enum.state.early:
      case $.verto.enum.state.active:

        var speaker = dialog.useSpeak;
        console.info("Using Speaker: ", speaker);

        if (speaker && speaker !== "any" && speaker !== "none") {
          setTimeout(function () {
            dialog.setAudioPlaybackDevice(speaker);
          }, 500);
        }

        break;

      case $.verto.enum.state.trying:
        setTimeout(function () {
          if (dialog.state == $.verto.enum.state.trying) {
            dialog.setState($.verto.enum.state.hangup);
          }
        }, 30000);
        break;
      case $.verto.enum.state.purge:
        dialog.setState($.verto.enum.state.destroy);
        break;
      case $.verto.enum.state.hangup:

        if (dialog.lastState.val > $.verto.enum.state.requesting.val && dialog.lastState.val < $.verto.enum.state.hangup.val) {
          dialog.sendMethod("verto.bye", {});
        }

        dialog.setState($.verto.enum.state.destroy);
        break;
      case $.verto.enum.state.destroy:

        if (typeof (dialog.verto.options.tag) === "function") {
          $('#' + dialog.params.tag).remove();
        }

        delete dialog.verto.dialogs[dialog.callID];
        if (dialog.params.screenShare) {
          dialog.rtc.stopPeer();
        } else {
          dialog.rtc.stop();
        }
        break;
    }

    return true;
  };

  $.verto.dialog.prototype.processReply = function (method, success, e) {
    var dialog = this;

    //console.log("Response: " + method + " State:" + dialog.state.name, success, e);

    switch (method) {

      case "verto.answer":
      case "verto.attach":
        if (success) {
          dialog.setState($.verto.enum.state.active);
        } else {
          dialog.hangup();
        }
        break;
      case "verto.invite":
        if (success) {
          dialog.setState($.verto.enum.state.trying);
        } else {
          dialog.setState($.verto.enum.state.destroy);
        }
        break;

      case "verto.bye":
        dialog.hangup();
        break;

      case "verto.modify":
        if (e.holdState) {
          if (e.holdState == "held") {
            if (dialog.state != $.verto.enum.state.held) {
              dialog.setState($.verto.enum.state.held);
            }
          } else if (e.holdState == "active") {
            if (dialog.state != $.verto.enum.state.active) {
              dialog.setState($.verto.enum.state.active);
            }
          }
        }

        if (success) {
        }

        break;

      default:
        break;
    }

  };

  $.verto.dialog.prototype.hangup = function (params) {
    var dialog = this;

    if (params) {
      if (params.causeCode) {
        dialog.causeCode = params.causeCode;
      }

      if (params.cause) {
        dialog.cause = params.cause;
      }
    }

    if (!dialog.cause && !dialog.causeCode) {
      dialog.cause = "NORMAL_CLEARING";
    }

    if (dialog.state.val >= $.verto.enum.state.new.val && dialog.state.val < $.verto.enum.state.hangup.val) {
      dialog.setState($.verto.enum.state.hangup);
    } else if (dialog.state.val < $.verto.enum.state.destroy) {
      dialog.setState($.verto.enum.state.destroy);
    }
  };

  $.verto.dialog.prototype.stopRinging = function () {
    var dialog = this;
    if (dialog.verto.ringer) {
      dialog.verto.ringer.stop();
    }
  };

  $.verto.dialog.prototype.indicateRing = function () {
    var dialog = this;

    if (dialog.verto.ringer) {
      dialog.verto.ringer.attr("src", dialog.verto.options.ringFile)[0].play();

      setTimeout(function () {
          dialog.stopRinging();
          if (dialog.state == $.verto.enum.state.ringing) {
            dialog.indicateRing();
          }
        },
        dialog.verto.options.ringSleep);
    }
  };

  $.verto.dialog.prototype.ring = function () {
    var dialog = this;

    dialog.setState($.verto.enum.state.ringing);
    dialog.indicateRing();
  };

  $.verto.dialog.prototype.useVideo = function (on) {
    var dialog = this;

    dialog.params.useVideo = on;

    if (on) {
      dialog.videoStream = dialog.audioStream;
    } else {
      dialog.videoStream = null;
    }

    dialog.rtc.useVideo(dialog.videoStream, dialog.localVideo);

  };

  $.verto.dialog.prototype.setMute = function (what) {
    var dialog = this;
    return dialog.rtc.setMute(what);
  };

  $.verto.dialog.prototype.getMute = function () {
    var dialog = this;
    return dialog.rtc.getMute();
  };

  $.verto.dialog.prototype.setVideoMute = function (what) {
    var dialog = this;
    return dialog.rtc.setVideoMute(what);
  };

  $.verto.dialog.prototype.getVideoMute = function () {
    var dialog = this;
    return dialog.rtc.getVideoMute();
  };

  $.verto.dialog.prototype.useStereo = function (on) {
    var dialog = this;

    dialog.params.useStereo = on;
    dialog.rtc.useStereo(on);
  };

  $.verto.dialog.prototype.dtmf = function (digits) {
    var dialog = this;
    if (digits) {
      dialog.sendMethod("verto.info", {
        dtmf: digits
      });
    }
  };

  $.verto.dialog.prototype.rtt = function (obj) {
    var dialog = this;
    var pobj = {};

    if (!obj) {
      return false;
    }

    pobj.code = obj.code;
    pobj.chars = obj.chars;


    if (pobj.chars || pobj.code) {
      dialog.sendMethod("verto.info", {
        txt: obj,
        noDialogParams: true
      });
    }
  };

  $.verto.dialog.prototype.transfer = function (dest, params) {
    var dialog = this;
    if (dest) {
      dialog.sendMethod("verto.modify", {
        action: "transfer",
        destination: dest,
        params: params
      });
    }
  };

  $.verto.dialog.prototype.replace = function (replaceCallID, params) {
    var dialog = this;
    if (replaceCallID) {
      dialog.sendMethod("verto.modify", {
        action: "replace",
        replaceCallID: replaceCallID,
        params: params
      });
    }
  };

  $.verto.dialog.prototype.hold = function (params) {
    var dialog = this;

    dialog.sendMethod("verto.modify", {
      action: "hold",
      params: params
    });
  };

  $.verto.dialog.prototype.unhold = function (params) {
    var dialog = this;

    dialog.sendMethod("verto.modify", {
      action: "unhold",
      params: params
    });
  };

  $.verto.dialog.prototype.toggleHold = function (params) {
    var dialog = this;

    dialog.sendMethod("verto.modify", {
      action: "toggleHold",
      params: params
    });
  };

  $.verto.dialog.prototype.message = function (msg) {
    var dialog = this;
    var err = 0;

    msg.from = dialog.params.login;

    if (!msg.to) {
      console.error("Missing To");
      err++;
    }

    if (!msg.body) {
      console.error("Missing Body");
      err++;
    }

    if (err) {
      return false;
    }

    dialog.sendMethod("verto.info", {
      msg: msg
    });

    return true;
  };

  $.verto.dialog.prototype.answer = function (params) {
    var dialog = this;

    if (!dialog.answered) {
      if (!params) {
        params = {};
      }

      params.sdp = dialog.params.sdp;

      if (params) {
        if (params.useVideo) {
          dialog.useVideo(true);
        }
        dialog.params.callee_id_name = params.callee_id_name;
        dialog.params.callee_id_number = params.callee_id_number;

        if (params.useCamera) {
          dialog.useCamera = params.useCamera;
        }

        if (params.useMic) {
          dialog.useMic = params.useMic;
        }

        if (params.useSpeak) {
          dialog.useSpeak = params.useSpeak;
        }
      }

      dialog.rtc.createAnswer(params);
      dialog.answered = true;
    }
  };

  $.verto.dialog.prototype.handleAnswer = function (params) {
    var dialog = this;

    dialog.gotAnswer = true;

    if (dialog.state.val >= $.verto.enum.state.active.val) {
      return;
    }

    if (dialog.state.val >= $.verto.enum.state.early.val) {
      dialog.setState($.verto.enum.state.active);
    } else {
      if (dialog.gotEarly) {
        console.log("Dialog " + dialog.callID + " Got answer while still establishing early media, delaying...");
      } else {
        console.log("Dialog " + dialog.callID + " Answering Channel");
        dialog.rtc.answer(params.sdp, function () {
          dialog.setState($.verto.enum.state.active);
        }, function (e) {
          console.error(e);
          dialog.hangup();
        });
        console.log("Dialog " + dialog.callID + "ANSWER SDP", params.sdp);
      }
    }


  };

  $.verto.dialog.prototype.cidString = function (enc) {
    var dialog = this;
    var party = dialog.params.remote_caller_id_name + (enc ? " &lt;" : " <") + dialog.params.remote_caller_id_number + (enc ? "&gt;" : ">");
    return party;
  };

  $.verto.dialog.prototype.sendMessage = function (msg, params) {
    var dialog = this;

    if (dialog.callbacks.onMessage) {
      dialog.callbacks.onMessage(dialog.verto, dialog, msg, params);
    }
  };

  $.verto.dialog.prototype.handleInfo = function (params) {
    var dialog = this;

    dialog.sendMessage($.verto.enum.message.info, params);

  };

  $.verto.dialog.prototype.handleDisplay = function (params) {
    var dialog = this;

    if (params.display_name) {
      dialog.params.remote_caller_id_name = params.display_name;
    }
    if (params.display_number) {
      dialog.params.remote_caller_id_number = params.display_number;
    }

    dialog.sendMessage($.verto.enum.message.display, {});
  };

  $.verto.dialog.prototype.handleMedia = function (params) {
    var dialog = this;

    if (dialog.state.val >= $.verto.enum.state.early.val) {
      return;
    }

    dialog.gotEarly = true;

    dialog.rtc.answer(params.sdp, function () {
      console.log("Dialog " + dialog.callID + "Establishing early media");
      dialog.setState($.verto.enum.state.early);

      if (dialog.gotAnswer) {
        console.log("Dialog " + dialog.callID + "Answering Channel");
        dialog.setState($.verto.enum.state.active);
      }
    }, function (e) {
      console.error(e);
      dialog.hangup();
    });
    console.debug("Dialog " + dialog.callID + "EARLY SDP", params.sdp);
  };

  $.verto.ENUM = function (s) {
    var i = 0,
      o = {};
    s.split(" ").map(function (x) {
      o[x] = {
        name: x,
        val: i++
      };
    });
    return Object.freeze(o);
  };

  $.verto.enum = {};

  $.verto.enum.states = Object.freeze({
    new: {
      requesting: 1,
      recovering: 1,
      ringing: 1,
      destroy: 1,
      answering: 1,
      hangup: 1
    },
    requesting: {
      trying: 1,
      hangup: 1,
      active: 1
    },
    recovering: {
      answering: 1,
      hangup: 1
    },
    trying: {
      active: 1,
      early: 1,
      hangup: 1
    },
    ringing: {
      answering: 1,
      hangup: 1
    },
    answering: {
      active: 1,
      hangup: 1
    },
    active: {
      answering: 1,
      requesting: 1,
      hangup: 1,
      held: 1
    },
    held: {
      hangup: 1,
      active: 1
    },
    early: {
      hangup: 1,
      active: 1
    },
    hangup: {
      destroy: 1
    },
    destroy: {},
    purge: {
      destroy: 1
    }
  });

  $.verto.enum.state = $.verto.ENUM("new requesting trying recovering ringing answering early active held hangup destroy purge");
  $.verto.enum.direction = $.verto.ENUM("inbound outbound");
  $.verto.enum.message = $.verto.ENUM("display info pvtEvent clientReady");

  $.verto.enum = Object.freeze($.verto.enum);

  $.verto.saved = [];

  $.verto.unloadJobs = [];

  var unloadEventName = 'beforeunload';
  // Hacks for Mobile Safari
  var iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
  if (iOS) {
    unloadEventName = 'pagehide';
  }

  $(window).bind(unloadEventName, function () {
    for (var f in $.verto.unloadJobs) {
      $.verto.unloadJobs[f]();
    }

    if ($.verto.haltClosure)
      return $.verto.haltClosure();

    for (var i in $.verto.saved) {
      var verto = $.verto.saved[i];
      if (verto) {
        verto.purge();
        verto.logout();
      }
    }

    return $.verto.warnOnUnload;
  });

  $.verto.videoDevices = [];
  $.verto.audioInDevices = [];
  $.verto.audioOutDevices = [];

  var checkDevices = function (runtime) {
    console.debug('Enumerating devices');

    var aud_in = [], aud_out = [], vid = [];
    var has_video = 0, has_audio = 0;
    var Xstream;

    function gotDevices(deviceInfos) {
      // Handles being called several times to update labels. Preserve values.
      deviceInfos.forEach(function (dev) {
        var text = "";

        console.debug(dev);
        console.debug(dev.kind + ": " + dev.label + " id = " + dev.deviceId);

        if (dev.deviceId !== '') {
          switch (dev.kind) {
            case 'audioinput':
              text = dev.label || 'microphone ' + (aud_in.length + 1);
              aud_in.push({id: dev.deviceId, kind: "audio_in", label: text});
              break;
            case 'audiooutput':
              text = dev.label || 'speaker ' + (aud_out.length + 1);
              aud_out.push({id: dev.deviceId, kind: "audio_out", label: text});
              break;
            case 'videoinput':
              text = dev.label || 'camera ' + (vid.length + 1);
              vid.push({id: dev.deviceId, kind: "video", label: text});
              break;
            default:
              console.log('Some other kind of source/device: ', dev);
              break;
          }
        }

      });

      $.verto.videoDevices = vid;
      $.verto.audioInDevices = aud_in;
      $.verto.audioOutDevices = aud_out;

      console.debug("Audio IN Devices", $.verto.audioInDevices);
      console.debug("Audio Out Devices", $.verto.audioOutDevices);
      console.debug("Video Devices", $.verto.videoDevices);

      if (Xstream) {
        Xstream.getTracks().forEach(function (track) {
          track.stop();
        });
      }

      if (runtime) {
        runtime(true);
      }
    }


    function handleError(error) {
      console.error('device enumeration error: ', error);
      if (runtime) runtime(false);
    }


    function checkTypes(devs) {
      devs.forEach(function (dev) {
        if (dev.deviceId !== '') {
          if (dev.kind === 'audioinput') {
            has_audio++;
          } else if (dev.kind === 'videoinput') {
            has_video++;
          }
        }
      });

      navigator.mediaDevices.getUserMedia({audio: (has_audio > 0), video: (has_video > 0)}
      ).then(
        function (stream) {
          Xstream = stream;
          navigator.mediaDevices.enumerateDevices().then(gotDevices).catch(handleError);
        },
        function (err) {
          console.error('The following error occurred: ' + err.name);
        }
      );
    }

    navigator.mediaDevices.enumerateDevices().then(checkTypes).catch(handleError);

  };

  $.verto.refreshDevices = function (runtime) {
    checkDevices(runtime);
  }

  $.verto.init = function (obj, runtime) {
    if (!obj) {
      obj = {};
    }

    if (!obj.skipPermCheck && !obj.skipDeviceCheck) {
      $.FSRTC.checkPerms(function (status) {
        checkDevices(runtime);
      }, true, true);
    } else if (obj.skipPermCheck && !obj.skipDeviceCheck) {
      checkDevices(runtime);
    } else if (!obj.skipPermCheck && obj.skipDeviceCheck) {
      $.FSRTC.checkPerms(function (status) {
        runtime(status);
      }, true, true);
    } else {
      runtime(null);
    }

  }

  $.verto.genUUID = function () {
    return generateGUID();
  }


})(jQuery);

(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.adapter = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */

'use strict';

var _adapter_factory = require('./adapter_factory.js');

var adapter = (0, _adapter_factory.adapterFactory)({ window: window });
module.exports = adapter; // this is the difference from adapter_core.

},{"./adapter_factory.js":2}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adapterFactory = adapterFactory;

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

var _chrome_shim = require('./chrome/chrome_shim');

var chromeShim = _interopRequireWildcard(_chrome_shim);

var _edge_shim = require('./edge/edge_shim');

var edgeShim = _interopRequireWildcard(_edge_shim);

var _firefox_shim = require('./firefox/firefox_shim');

var firefoxShim = _interopRequireWildcard(_firefox_shim);

var _safari_shim = require('./safari/safari_shim');

var safariShim = _interopRequireWildcard(_safari_shim);

var _common_shim = require('./common_shim');

var commonShim = _interopRequireWildcard(_common_shim);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Shimming starts here.
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
function adapterFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      window = _ref.window;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    shimChrome: true,
    shimFirefox: true,
    shimEdge: true,
    shimSafari: true
  };

  // Utils.
  var logging = utils.log;
  var browserDetails = utils.detectBrowser(window);

  var adapter = {
    browserDetails: browserDetails,
    commonShim: commonShim,
    extractVersion: utils.extractVersion,
    disableLog: utils.disableLog,
    disableWarnings: utils.disableWarnings
  };

  // Shim browser if found.
  switch (browserDetails.browser) {
    case 'chrome':
      if (!chromeShim || !chromeShim.shimPeerConnection || !options.shimChrome) {
        logging('Chrome shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming chrome.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = chromeShim;

      chromeShim.shimGetUserMedia(window);
      chromeShim.shimMediaStream(window);
      chromeShim.shimPeerConnection(window);
      chromeShim.shimOnTrack(window);
      chromeShim.shimAddTrackRemoveTrack(window);
      chromeShim.shimGetSendersWithDtmf(window);
      chromeShim.shimGetStats(window);
      chromeShim.shimSenderReceiverGetStats(window);
      chromeShim.fixNegotiationNeeded(window);

      commonShim.shimRTCIceCandidate(window);
      commonShim.shimConnectionState(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      commonShim.removeAllowExtmapMixed(window);
      break;
    case 'firefox':
      if (!firefoxShim || !firefoxShim.shimPeerConnection || !options.shimFirefox) {
        logging('Firefox shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming firefox.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = firefoxShim;

      firefoxShim.shimGetUserMedia(window);
      firefoxShim.shimPeerConnection(window);
      firefoxShim.shimOnTrack(window);
      firefoxShim.shimRemoveStream(window);
      firefoxShim.shimSenderGetStats(window);
      firefoxShim.shimReceiverGetStats(window);
      firefoxShim.shimRTCDataChannel(window);

      commonShim.shimRTCIceCandidate(window);
      commonShim.shimConnectionState(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'edge':
      if (!edgeShim || !edgeShim.shimPeerConnection || !options.shimEdge) {
        logging('MS edge shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming edge.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = edgeShim;

      edgeShim.shimGetUserMedia(window);
      edgeShim.shimGetDisplayMedia(window);
      edgeShim.shimPeerConnection(window);
      edgeShim.shimReplaceTrack(window);

      // the edge shim implements the full RTCIceCandidate object.

      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'safari':
      if (!safariShim || !options.shimSafari) {
        logging('Safari shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming safari.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = safariShim;

      safariShim.shimRTCIceServerUrls(window);
      safariShim.shimCreateOfferLegacy(window);
      safariShim.shimCallbacksAPI(window);
      safariShim.shimLocalStreamsAPI(window);
      safariShim.shimRemoteStreamsAPI(window);
      safariShim.shimTrackEventTransceiver(window);
      safariShim.shimGetUserMedia(window);

      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      commonShim.removeAllowExtmapMixed(window);
      break;
    default:
      logging('Unsupported browser!');
      break;
  }

  return adapter;
}

// Browser shims.

},{"./chrome/chrome_shim":3,"./common_shim":6,"./edge/edge_shim":7,"./firefox/firefox_shim":11,"./safari/safari_shim":14,"./utils":15}],3:[function(require,module,exports){

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shimGetDisplayMedia = exports.shimGetUserMedia = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _getusermedia = require('./getusermedia');

Object.defineProperty(exports, 'shimGetUserMedia', {
  enumerable: true,
  get: function get() {
    return _getusermedia.shimGetUserMedia;
  }
});

var _getdisplaymedia = require('./getdisplaymedia');

Object.defineProperty(exports, 'shimGetDisplayMedia', {
  enumerable: true,
  get: function get() {
    return _getdisplaymedia.shimGetDisplayMedia;
  }
});
exports.shimMediaStream = shimMediaStream;
exports.shimOnTrack = shimOnTrack;
exports.shimGetSendersWithDtmf = shimGetSendersWithDtmf;
exports.shimGetStats = shimGetStats;
exports.shimSenderReceiverGetStats = shimSenderReceiverGetStats;
exports.shimAddTrackRemoveTrackWithNative = shimAddTrackRemoveTrackWithNative;
exports.shimAddTrackRemoveTrack = shimAddTrackRemoveTrack;
exports.shimPeerConnection = shimPeerConnection;
exports.fixNegotiationNeeded = fixNegotiationNeeded;

var _utils = require('../utils.js');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function shimMediaStream(window) {
  window.MediaStream = window.MediaStream || window.webkitMediaStream;
}

function shimOnTrack(window) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && !('ontrack' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
      get: function get() {
        return this._ontrack;
      },
      set: function set(f) {
        if (this._ontrack) {
          this.removeEventListener('track', this._ontrack);
        }
        this.addEventListener('track', this._ontrack = f);
      },

      enumerable: true,
      configurable: true
    });
    var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function () {
      var _this = this;

      if (!this._ontrackpoly) {
        this._ontrackpoly = function (e) {
          // onaddstream does not fire when a track is added to an existing
          // stream. But stream.onaddtrack is implemented so we use that.
          e.stream.addEventListener('addtrack', function (te) {
            var receiver = void 0;
            if (window.RTCPeerConnection.prototype.getReceivers) {
              receiver = _this.getReceivers().find(function (r) {
                return r.track && r.track.id === te.track.id;
              });
            } else {
              receiver = { track: te.track };
            }

            var event = new Event('track');
            event.track = te.track;
            event.receiver = receiver;
            event.transceiver = { receiver: receiver };
            event.streams = [e.stream];
            _this.dispatchEvent(event);
          });
          e.stream.getTracks().forEach(function (track) {
            var receiver = void 0;
            if (window.RTCPeerConnection.prototype.getReceivers) {
              receiver = _this.getReceivers().find(function (r) {
                return r.track && r.track.id === track.id;
              });
            } else {
              receiver = { track: track };
            }
            var event = new Event('track');
            event.track = track;
            event.receiver = receiver;
            event.transceiver = { receiver: receiver };
            event.streams = [e.stream];
            _this.dispatchEvent(event);
          });
        };
        this.addEventListener('addstream', this._ontrackpoly);
      }
      return origSetRemoteDescription.apply(this, arguments);
    };
  } else {
    // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    utils.wrapPeerConnectionEvent(window, 'track', function (e) {
      if (!e.transceiver) {
        Object.defineProperty(e, 'transceiver', { value: { receiver: e.receiver } });
      }
      return e;
    });
  }
}

function shimGetSendersWithDtmf(window) {
  // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && !('getSenders' in window.RTCPeerConnection.prototype) && 'createDTMFSender' in window.RTCPeerConnection.prototype) {
    var shimSenderWithDtmf = function shimSenderWithDtmf(pc, track) {
      return {
        track: track,
        get dtmf() {
          if (this._dtmf === undefined) {
            if (track.kind === 'audio') {
              this._dtmf = pc.createDTMFSender(track);
            } else {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        },
        _pc: pc
      };
    };

    // augment addTrack when getSenders is not available.
    if (!window.RTCPeerConnection.prototype.getSenders) {
      window.RTCPeerConnection.prototype.getSenders = function () {
        this._senders = this._senders || [];
        return this._senders.slice(); // return a copy of the internal state.
      };
      var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
      window.RTCPeerConnection.prototype.addTrack = function (track, stream) {
        var sender = origAddTrack.apply(this, arguments);
        if (!sender) {
          sender = shimSenderWithDtmf(this, track);
          this._senders.push(sender);
        }
        return sender;
      };

      var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
      window.RTCPeerConnection.prototype.removeTrack = function (sender) {
        origRemoveTrack.apply(this, arguments);
        var idx = this._senders.indexOf(sender);
        if (idx !== -1) {
          this._senders.splice(idx, 1);
        }
      };
    }
    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function (stream) {
      var _this2 = this;

      this._senders = this._senders || [];
      origAddStream.apply(this, [stream]);
      stream.getTracks().forEach(function (track) {
        _this2._senders.push(shimSenderWithDtmf(_this2, track));
      });
    };

    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function (stream) {
      var _this3 = this;

      this._senders = this._senders || [];
      origRemoveStream.apply(this, [stream]);

      stream.getTracks().forEach(function (track) {
        var sender = _this3._senders.find(function (s) {
          return s.track === track;
        });
        if (sender) {
          // remove sender
          _this3._senders.splice(_this3._senders.indexOf(sender), 1);
        }
      });
    };
  } else if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && 'getSenders' in window.RTCPeerConnection.prototype && 'createDTMFSender' in window.RTCPeerConnection.prototype && window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    window.RTCPeerConnection.prototype.getSenders = function () {
      var _this4 = this;

      var senders = origGetSenders.apply(this, []);
      senders.forEach(function (sender) {
        return sender._pc = _this4;
      });
      return senders;
    };

    Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
      get: function get() {
        if (this._dtmf === undefined) {
          if (this.track.kind === 'audio') {
            this._dtmf = this._pc.createDTMFSender(this.track);
          } else {
            this._dtmf = null;
          }
        }
        return this._dtmf;
      }
    });
  }
}

function shimGetStats(window) {
  if (!window.RTCPeerConnection) {
    return;
  }

  var origGetStats = window.RTCPeerConnection.prototype.getStats;
  window.RTCPeerConnection.prototype.getStats = function (selector, successCallback, errorCallback) {
    var _this5 = this;

    var args = arguments;

    // If selector is a function then we are in the old style stats so just
    // pass back the original getStats format to avoid breaking old users.
    if (arguments.length > 0 && typeof selector === 'function') {
      return origGetStats.apply(this, arguments);
    }

    // When spec-style getStats is supported, return those when called with
    // either no arguments or the selector argument is null.
    if (origGetStats.length === 0 && (arguments.length === 0 || typeof arguments[0] !== 'function')) {
      return origGetStats.apply(this, []);
    }

    var fixChromeStats_ = function fixChromeStats_(response) {
      var standardReport = {};
      var reports = response.result();
      reports.forEach(function (report) {
        var standardStats = {
          id: report.id,
          timestamp: report.timestamp,
          type: {
            localcandidate: 'local-candidate',
            remotecandidate: 'remote-candidate'
          }[report.type] || report.type
        };
        report.names().forEach(function (name) {
          standardStats[name] = report.stat(name);
        });
        standardReport[standardStats.id] = standardStats;
      });

      return standardReport;
    };

    // shim getStats with maplike support
    var makeMapStats = function makeMapStats(stats) {
      return new Map(Object.keys(stats).map(function (key) {
        return [key, stats[key]];
      }));
    };

    if (arguments.length >= 2) {
      var successCallbackWrapper_ = function successCallbackWrapper_(response) {
        args[1](makeMapStats(fixChromeStats_(response)));
      };

      return origGetStats.apply(this, [successCallbackWrapper_, arguments[0]]);
    }

    // promise-support
    return new Promise(function (resolve, reject) {
      origGetStats.apply(_this5, [function (response) {
        resolve(makeMapStats(fixChromeStats_(response)));
      }, reject]);
    }).then(successCallback, errorCallback);
  };
}

function shimSenderReceiverGetStats(window) {
  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) {
    return;
  }

  // shim sender stats.
  if (!('getStats' in window.RTCRtpSender.prototype)) {
    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) {
      window.RTCPeerConnection.prototype.getSenders = function () {
        var _this6 = this;

        var senders = origGetSenders.apply(this, []);
        senders.forEach(function (sender) {
          return sender._pc = _this6;
        });
        return senders;
      };
    }

    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) {
      window.RTCPeerConnection.prototype.addTrack = function () {
        var sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
      };
    }
    window.RTCRtpSender.prototype.getStats = function () {
      var sender = this;
      return this._pc.getStats().then(function (result) {
        return (
          /* Note: this will include stats of all senders that
           *   send a track with the same id as sender.track as
           *   it is not possible to identify the RTCRtpSender.
           */
          utils.filterStats(result, sender.track, true)
        );
      });
    };
  }

  // shim receiver stats.
  if (!('getStats' in window.RTCRtpReceiver.prototype)) {
    var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) {
      window.RTCPeerConnection.prototype.getReceivers = function () {
        var _this7 = this;

        var receivers = origGetReceivers.apply(this, []);
        receivers.forEach(function (receiver) {
          return receiver._pc = _this7;
        });
        return receivers;
      };
    }
    utils.wrapPeerConnectionEvent(window, 'track', function (e) {
      e.receiver._pc = e.srcElement;
      return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function () {
      var receiver = this;
      return this._pc.getStats().then(function (result) {
        return utils.filterStats(result, receiver.track, false);
      });
    };
  }

  if (!('getStats' in window.RTCRtpSender.prototype && 'getStats' in window.RTCRtpReceiver.prototype)) {
    return;
  }

  // shim RTCPeerConnection.getStats(track).
  var origGetStats = window.RTCPeerConnection.prototype.getStats;
  window.RTCPeerConnection.prototype.getStats = function () {
    if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
      var track = arguments[0];
      var sender = void 0;
      var receiver = void 0;
      var err = void 0;
      this.getSenders().forEach(function (s) {
        if (s.track === track) {
          if (sender) {
            err = true;
          } else {
            sender = s;
          }
        }
      });
      this.getReceivers().forEach(function (r) {
        if (r.track === track) {
          if (receiver) {
            err = true;
          } else {
            receiver = r;
          }
        }
        return r.track === track;
      });
      if (err || sender && receiver) {
        return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
      } else if (sender) {
        return sender.getStats();
      } else if (receiver) {
        return receiver.getStats();
      }
      return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
    }
    return origGetStats.apply(this, arguments);
  };
}

function shimAddTrackRemoveTrackWithNative(window) {
  // shim addTrack/removeTrack with native variants in order to make
  // the interactions with legacy getLocalStreams behave as in other browsers.
  // Keeps a mapping stream.id => [stream, rtpsenders...]
  window.RTCPeerConnection.prototype.getLocalStreams = function () {
    var _this8 = this;

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    return Object.keys(this._shimmedLocalStreams).map(function (streamId) {
      return _this8._shimmedLocalStreams[streamId][0];
    });
  };

  var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
  window.RTCPeerConnection.prototype.addTrack = function (track, stream) {
    if (!stream) {
      return origAddTrack.apply(this, arguments);
    }
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};

    var sender = origAddTrack.apply(this, arguments);
    if (!this._shimmedLocalStreams[stream.id]) {
      this._shimmedLocalStreams[stream.id] = [stream, sender];
    } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
      this._shimmedLocalStreams[stream.id].push(sender);
    }
    return sender;
  };

  var origAddStream = window.RTCPeerConnection.prototype.addStream;
  window.RTCPeerConnection.prototype.addStream = function (stream) {
    var _this9 = this;

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};

    stream.getTracks().forEach(function (track) {
      var alreadyExists = _this9.getSenders().find(function (s) {
        return s.track === track;
      });
      if (alreadyExists) {
        throw new DOMException('Track already exists.', 'InvalidAccessError');
      }
    });
    var existingSenders = this.getSenders();
    origAddStream.apply(this, arguments);
    var newSenders = this.getSenders().filter(function (newSender) {
      return existingSenders.indexOf(newSender) === -1;
    });
    this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
  };

  var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
  window.RTCPeerConnection.prototype.removeStream = function (stream) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    delete this._shimmedLocalStreams[stream.id];
    return origRemoveStream.apply(this, arguments);
  };

  var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
  window.RTCPeerConnection.prototype.removeTrack = function (sender) {
    var _this10 = this;

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    if (sender) {
      Object.keys(this._shimmedLocalStreams).forEach(function (streamId) {
        var idx = _this10._shimmedLocalStreams[streamId].indexOf(sender);
        if (idx !== -1) {
          _this10._shimmedLocalStreams[streamId].splice(idx, 1);
        }
        if (_this10._shimmedLocalStreams[streamId].length === 1) {
          delete _this10._shimmedLocalStreams[streamId];
        }
      });
    }
    return origRemoveTrack.apply(this, arguments);
  };
}

function shimAddTrackRemoveTrack(window) {
  if (!window.RTCPeerConnection) {
    return;
  }
  var browserDetails = utils.detectBrowser(window);
  // shim addTrack and removeTrack.
  if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) {
    return shimAddTrackRemoveTrackWithNative(window);
  }

  // also shim pc.getLocalStreams when addTrack is shimmed
  // to return the original streams.
  var origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
  window.RTCPeerConnection.prototype.getLocalStreams = function () {
    var _this11 = this;

    var nativeStreams = origGetLocalStreams.apply(this);
    this._reverseStreams = this._reverseStreams || {};
    return nativeStreams.map(function (stream) {
      return _this11._reverseStreams[stream.id];
    });
  };

  var origAddStream = window.RTCPeerConnection.prototype.addStream;
  window.RTCPeerConnection.prototype.addStream = function (stream) {
    var _this12 = this;

    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};

    stream.getTracks().forEach(function (track) {
      var alreadyExists = _this12.getSenders().find(function (s) {
        return s.track === track;
      });
      if (alreadyExists) {
        throw new DOMException('Track already exists.', 'InvalidAccessError');
      }
    });
    // Add identity mapping for consistency with addTrack.
    // Unless this is being used with a stream from addTrack.
    if (!this._reverseStreams[stream.id]) {
      var newStream = new window.MediaStream(stream.getTracks());
      this._streams[stream.id] = newStream;
      this._reverseStreams[newStream.id] = stream;
      stream = newStream;
    }
    origAddStream.apply(this, [stream]);
  };

  var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
  window.RTCPeerConnection.prototype.removeStream = function (stream) {
    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};

    origRemoveStream.apply(this, [this._streams[stream.id] || stream]);
    delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
    delete this._streams[stream.id];
  };

  window.RTCPeerConnection.prototype.addTrack = function (track, stream) {
    var _this13 = this;

    if (this.signalingState === 'closed') {
      throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
    }
    var streams = [].slice.call(arguments, 1);
    if (streams.length !== 1 || !streams[0].getTracks().find(function (t) {
      return t === track;
    })) {
      // this is not fully correct but all we can manage without
      // [[associated MediaStreams]] internal slot.
      throw new DOMException('The adapter.js addTrack polyfill only supports a single ' + ' stream which is associated with the specified track.', 'NotSupportedError');
    }

    var alreadyExists = this.getSenders().find(function (s) {
      return s.track === track;
    });
    if (alreadyExists) {
      throw new DOMException('Track already exists.', 'InvalidAccessError');
    }

    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};
    var oldStream = this._streams[stream.id];
    if (oldStream) {
      // this is using odd Chrome behaviour, use with caution:
      // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
      // Note: we rely on the high-level addTrack/dtmf shim to
      // create the sender with a dtmf sender.
      oldStream.addTrack(track);

      // Trigger ONN async.
      Promise.resolve().then(function () {
        _this13.dispatchEvent(new Event('negotiationneeded'));
      });
    } else {
      var newStream = new window.MediaStream([track]);
      this._streams[stream.id] = newStream;
      this._reverseStreams[newStream.id] = stream;
      this.addStream(newStream);
    }
    return this.getSenders().find(function (s) {
      return s.track === track;
    });
  };

  // replace the internal stream id with the external one and
  // vice versa.
  function replaceInternalStreamId(pc, description) {
    var sdp = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
      var externalStream = pc._reverseStreams[internalId];
      var internalStream = pc._streams[externalStream.id];
      sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp: sdp
    });
  }
  function replaceExternalStreamId(pc, description) {
    var sdp = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
      var externalStream = pc._reverseStreams[internalId];
      var internalStream = pc._streams[externalStream.id];
      sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp: sdp
    });
  }
  ['createOffer', 'createAnswer'].forEach(function (method) {
    var nativeMethod = window.RTCPeerConnection.prototype[method];
    window.RTCPeerConnection.prototype[method] = function () {
      var _this14 = this;

      var args = arguments;
      var isLegacyCall = arguments.length && typeof arguments[0] === 'function';
      if (isLegacyCall) {
        return nativeMethod.apply(this, [function (description) {
          var desc = replaceInternalStreamId(_this14, description);
          args[0].apply(null, [desc]);
        }, function (err) {
          if (args[1]) {
            args[1].apply(null, err);
          }
        }, arguments[2]]);
      }
      return nativeMethod.apply(this, arguments).then(function (description) {
        return replaceInternalStreamId(_this14, description);
      });
    };
  });

  var origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
  window.RTCPeerConnection.prototype.setLocalDescription = function () {
    if (!arguments.length || !arguments[0].type) {
      return origSetLocalDescription.apply(this, arguments);
    }
    arguments[0] = replaceExternalStreamId(this, arguments[0]);
    return origSetLocalDescription.apply(this, arguments);
  };

  // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier

  var origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, 'localDescription');
  Object.defineProperty(window.RTCPeerConnection.prototype, 'localDescription', {
    get: function get() {
      var description = origLocalDescription.get.apply(this);
      if (description.type === '') {
        return description;
      }
      return replaceInternalStreamId(this, description);
    }
  });

  window.RTCPeerConnection.prototype.removeTrack = function (sender) {
    var _this15 = this;

    if (this.signalingState === 'closed') {
      throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
    }
    // We can not yet check for sender instanceof RTCRtpSender
    // since we shim RTPSender. So we check if sender._pc is set.
    if (!sender._pc) {
      throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' + 'does not implement interface RTCRtpSender.', 'TypeError');
    }
    var isLocal = sender._pc === this;
    if (!isLocal) {
      throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
    }

    // Search for the native stream the senders track belongs to.
    this._streams = this._streams || {};
    var stream = void 0;
    Object.keys(this._streams).forEach(function (streamid) {
      var hasTrack = _this15._streams[streamid].getTracks().find(function (track) {
        return sender.track === track;
      });
      if (hasTrack) {
        stream = _this15._streams[streamid];
      }
    });

    if (stream) {
      if (stream.getTracks().length === 1) {
        // if this is the last track of the stream, remove the stream. This
        // takes care of any shimmed _senders.
        this.removeStream(this._reverseStreams[stream.id]);
      } else {
        // relying on the same odd chrome behaviour as above.
        stream.removeTrack(sender.track);
      }
      this.dispatchEvent(new Event('negotiationneeded'));
    }
  };
}

function shimPeerConnection(window) {
  if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) {
    // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
  }
  if (!window.RTCPeerConnection) {
    return;
  }

  // shim implicit creation of RTCSessionDescription/RTCIceCandidate
  ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
    var nativeMethod = window.RTCPeerConnection.prototype[method];
    window.RTCPeerConnection.prototype[method] = function () {
      arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
      return nativeMethod.apply(this, arguments);
    };
  });

  // support for addIceCandidate(null or undefined)
  var nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
  window.RTCPeerConnection.prototype.addIceCandidate = function () {
    if (!arguments[0]) {
      if (arguments[1]) {
        arguments[1].apply(null);
      }
      return Promise.resolve();
    }
    return nativeAddIceCandidate.apply(this, arguments);
  };
}

function fixNegotiationNeeded(window) {
  utils.wrapPeerConnectionEvent(window, 'negotiationneeded', function (e) {
    var pc = e.target;
    if (pc.signalingState !== 'stable') {
      return;
    }
    return e;
  });
}

},{"../utils.js":15,"./getdisplaymedia":4,"./getusermedia":5}],4:[function(require,module,exports){
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shimGetDisplayMedia = shimGetDisplayMedia;
function shimGetDisplayMedia(window, getSourceId) {
  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }
  if (!window.navigator.mediaDevices) {
    return;
  }
  // getSourceId is a function that returns a promise resolving with
  // the sourceId of the screen/window/tab to be shared.
  if (typeof getSourceId !== 'function') {
    console.error('shimGetDisplayMedia: getSourceId argument is not ' + 'a function');
    return;
  }
  window.navigator.mediaDevices.getDisplayMedia = function (constraints) {
    return getSourceId(constraints).then(function (sourceId) {
      var widthSpecified = constraints.video && constraints.video.width;
      var heightSpecified = constraints.video && constraints.video.height;
      var frameRateSpecified = constraints.video && constraints.video.frameRate;
      constraints.video = {
        mandatory: {
          chromeMediaSource: 'desktop',
          chromeMediaSourceId: sourceId,
          maxFrameRate: frameRateSpecified || 3
        }
      };
      if (widthSpecified) {
        constraints.video.mandatory.maxWidth = widthSpecified;
      }
      if (heightSpecified) {
        constraints.video.mandatory.maxHeight = heightSpecified;
      }
      return window.navigator.mediaDevices.getUserMedia(constraints);
    });
  };
}

},{}],5:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.shimGetUserMedia = shimGetUserMedia;

var _utils = require('../utils.js');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var logging = utils.log;

function shimGetUserMedia(window) {
  var navigator = window && window.navigator;

  if (!navigator.mediaDevices) {
    return;
  }

  var browserDetails = utils.detectBrowser(window);

  var constraintsToChrome_ = function constraintsToChrome_(c) {
    if ((typeof c === 'undefined' ? 'undefined' : _typeof(c)) !== 'object' || c.mandatory || c.optional) {
      return c;
    }
    var cc = {};
    Object.keys(c).forEach(function (key) {
      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
        return;
      }
      var r = _typeof(c[key]) === 'object' ? c[key] : { ideal: c[key] };
      if (r.exact !== undefined && typeof r.exact === 'number') {
        r.min = r.max = r.exact;
      }
      var oldname_ = function oldname_(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }
        return name === 'deviceId' ? 'sourceId' : name;
      };
      if (r.ideal !== undefined) {
        cc.optional = cc.optional || [];
        var oc = {};
        if (typeof r.ideal === 'number') {
          oc[oldname_('min', key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_('max', key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_('', key)] = r.ideal;
          cc.optional.push(oc);
        }
      }
      if (r.exact !== undefined && typeof r.exact !== 'number') {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_('', key)] = r.exact;
      } else {
        ['min', 'max'].forEach(function (mix) {
          if (r[mix] !== undefined) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });
    if (c.advanced) {
      cc.optional = (cc.optional || []).concat(c.advanced);
    }
    return cc;
  };

  var shimConstraints_ = function shimConstraints_(constraints, func) {
    if (browserDetails.version >= 61) {
      return func(constraints);
    }
    constraints = JSON.parse(JSON.stringify(constraints));
    if (constraints && _typeof(constraints.audio) === 'object') {
      var remap = function remap(obj, a, b) {
        if (a in obj && !(b in obj)) {
          obj[b] = obj[a];
          delete obj[a];
        }
      };
      constraints = JSON.parse(JSON.stringify(constraints));
      remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
      remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
      constraints.audio = constraintsToChrome_(constraints.audio);
    }
    if (constraints && _typeof(constraints.video) === 'object') {
      // Shim facingMode for mobile & surface pro.
      var face = constraints.video.facingMode;
      face = face && ((typeof face === 'undefined' ? 'undefined' : _typeof(face)) === 'object' ? face : { ideal: face });
      var getSupportedFacingModeLies = browserDetails.version < 66;

      if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
        delete constraints.video.facingMode;
        var matches = void 0;
        if (face.exact === 'environment' || face.ideal === 'environment') {
          matches = ['back', 'rear'];
        } else if (face.exact === 'user' || face.ideal === 'user') {
          matches = ['front'];
        }
        if (matches) {
          // Look for matches in label, or use last cam for back (typical).
          return navigator.mediaDevices.enumerateDevices().then(function (devices) {
            devices = devices.filter(function (d) {
              return d.kind === 'videoinput';
            });
            var dev = devices.find(function (d) {
              return matches.some(function (match) {
                return d.label.toLowerCase().includes(match);
              });
            });
            if (!dev && devices.length && matches.includes('back')) {
              dev = devices[devices.length - 1]; // more likely the back cam
            }
            if (dev) {
              constraints.video.deviceId = face.exact ? { exact: dev.deviceId } : { ideal: dev.deviceId };
            }
            constraints.video = constraintsToChrome_(constraints.video);
            logging('chrome: ' + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }
      constraints.video = constraintsToChrome_(constraints.video);
    }
    logging('chrome: ' + JSON.stringify(constraints));
    return func(constraints);
  };

  var shimError_ = function shimError_(e) {
    if (browserDetails.version >= 64) {
      return e;
    }
    return {
      name: {
        PermissionDeniedError: 'NotAllowedError',
        PermissionDismissedError: 'NotAllowedError',
        InvalidStateError: 'NotAllowedError',
        DevicesNotFoundError: 'NotFoundError',
        ConstraintNotSatisfiedError: 'OverconstrainedError',
        TrackStartError: 'NotReadableError',
        MediaDeviceFailedDueToShutdown: 'NotAllowedError',
        MediaDeviceKillSwitchOn: 'NotAllowedError',
        TabCaptureError: 'AbortError',
        ScreenCaptureError: 'AbortError',
        DeviceCaptureError: 'AbortError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint || e.constraintName,
      toString: function toString() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  var getUserMedia_ = function getUserMedia_(constraints, onSuccess, onError) {
    shimConstraints_(constraints, function (c) {
      navigator.webkitGetUserMedia(c, onSuccess, function (e) {
        if (onError) {
          onError(shimError_(e));
        }
      });
    });
  };
  navigator.getUserMedia = getUserMedia_.bind(navigator);

  // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
  // function which returns a Promise, it does not accept spec-style
  // constraints.
  if (navigator.mediaDevices.getUserMedia) {
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function (cs) {
      return shimConstraints_(cs, function (c) {
        return origGetUserMedia(c).then(function (stream) {
          if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
            stream.getTracks().forEach(function (track) {
              track.stop();
            });
            throw new DOMException('', 'NotFoundError');
          }
          return stream;
        }, function (e) {
          return Promise.reject(shimError_(e));
        });
      });
    };
  }
}

},{"../utils.js":15}],6:[function(require,module,exports){
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.shimRTCIceCandidate = shimRTCIceCandidate;
exports.shimMaxMessageSize = shimMaxMessageSize;
exports.shimSendThrowTypeError = shimSendThrowTypeError;
exports.shimConnectionState = shimConnectionState;
exports.removeAllowExtmapMixed = removeAllowExtmapMixed;

var _sdp = require('sdp');

var _sdp2 = _interopRequireDefault(_sdp);

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shimRTCIceCandidate(window) {
  // foundation is arbitrarily chosen as an indicator for full support for
  // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
  if (!window.RTCIceCandidate || window.RTCIceCandidate && 'foundation' in window.RTCIceCandidate.prototype) {
    return;
  }

  var NativeRTCIceCandidate = window.RTCIceCandidate;
  window.RTCIceCandidate = function (args) {
    // Remove the a= which shouldn't be part of the candidate string.
    if ((typeof args === 'undefined' ? 'undefined' : _typeof(args)) === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
      args = JSON.parse(JSON.stringify(args));
      args.candidate = args.candidate.substr(2);
    }

    if (args.candidate && args.candidate.length) {
      // Augment the native candidate with the parsed fields.
      var nativeCandidate = new NativeRTCIceCandidate(args);
      var parsedCandidate = _sdp2.default.parseCandidate(args.candidate);
      var augmentedCandidate = Object.assign(nativeCandidate, parsedCandidate);

      // Add a serializer that does not serialize the extra attributes.
      augmentedCandidate.toJSON = function () {
        return {
          candidate: augmentedCandidate.candidate,
          sdpMid: augmentedCandidate.sdpMid,
          sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
          usernameFragment: augmentedCandidate.usernameFragment
        };
      };
      return augmentedCandidate;
    }
    return new NativeRTCIceCandidate(args);
  };
  window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;

  // Hook up the augmented candidate in onicecandidate and
  // addEventListener('icecandidate', ...)
  utils.wrapPeerConnectionEvent(window, 'icecandidate', function (e) {
    if (e.candidate) {
      Object.defineProperty(e, 'candidate', {
        value: new window.RTCIceCandidate(e.candidate),
        writable: 'false'
      });
    }
    return e;
  });
}

function shimMaxMessageSize(window) {
  if (window.RTCSctpTransport || !window.RTCPeerConnection) {
    return;
  }
  var browserDetails = utils.detectBrowser(window);

  if (!('sctp' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
      get: function get() {
        return typeof this._sctp === 'undefined' ? null : this._sctp;
      }
    });
  }

  var sctpInDescription = function sctpInDescription(description) {
    if (!description || !description.sdp) {
      return false;
    }
    var sections = _sdp2.default.splitSections(description.sdp);
    sections.shift();
    return sections.some(function (mediaSection) {
      var mLine = _sdp2.default.parseMLine(mediaSection);
      return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
    });
  };

  var getRemoteFirefoxVersion = function getRemoteFirefoxVersion(description) {
    // TODO: Is there a better solution for detecting Firefox?
    var match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
    if (match === null || match.length < 2) {
      return -1;
    }
    var version = parseInt(match[1], 10);
    // Test for NaN (yes, this is ugly)
    return version !== version ? -1 : version;
  };

  var getCanSendMaxMessageSize = function getCanSendMaxMessageSize(remoteIsFirefox) {
    // Every implementation we know can send at least 64 KiB.
    // Note: Although Chrome is technically able to send up to 256 KiB, the
    //       data does not reach the other peer reliably.
    //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
    var canSendMaxMessageSize = 65536;
    if (browserDetails.browser === 'firefox') {
      if (browserDetails.version < 57) {
        if (remoteIsFirefox === -1) {
          // FF < 57 will send in 16 KiB chunks using the deprecated PPID
          // fragmentation.
          canSendMaxMessageSize = 16384;
        } else {
          // However, other FF (and RAWRTC) can reassemble PPID-fragmented
          // messages. Thus, supporting ~2 GiB when sending.
          canSendMaxMessageSize = 2147483637;
        }
      } else if (browserDetails.version < 60) {
        // Currently, all FF >= 57 will reset the remote maximum message size
        // to the default value when a data channel is created at a later
        // stage. :(
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
        canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
      } else {
        // FF >= 60 supports sending ~2 GiB
        canSendMaxMessageSize = 2147483637;
      }
    }
    return canSendMaxMessageSize;
  };

  var getMaxMessageSize = function getMaxMessageSize(description, remoteIsFirefox) {
    // Note: 65536 bytes is the default value from the SDP spec. Also,
    //       every implementation we know supports receiving 65536 bytes.
    var maxMessageSize = 65536;

    // FF 57 has a slightly incorrect default remote max message size, so
    // we need to adjust it here to avoid a failure when sending.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
    if (browserDetails.browser === 'firefox' && browserDetails.version === 57) {
      maxMessageSize = 65535;
    }

    var match = _sdp2.default.matchPrefix(description.sdp, 'a=max-message-size:');
    if (match.length > 0) {
      maxMessageSize = parseInt(match[0].substr(19), 10);
    } else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) {
      // If the maximum message size is not present in the remote SDP and
      // both local and remote are Firefox, the remote peer can receive
      // ~2 GiB.
      maxMessageSize = 2147483637;
    }
    return maxMessageSize;
  };

  var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
  window.RTCPeerConnection.prototype.setRemoteDescription = function () {
    this._sctp = null;

    if (sctpInDescription(arguments[0])) {
      // Check if the remote is FF.
      var isFirefox = getRemoteFirefoxVersion(arguments[0]);

      // Get the maximum message size the local peer is capable of sending
      var canSendMMS = getCanSendMaxMessageSize(isFirefox);

      // Get the maximum message size of the remote peer.
      var remoteMMS = getMaxMessageSize(arguments[0], isFirefox);

      // Determine final maximum message size
      var maxMessageSize = void 0;
      if (canSendMMS === 0 && remoteMMS === 0) {
        maxMessageSize = Number.POSITIVE_INFINITY;
      } else if (canSendMMS === 0 || remoteMMS === 0) {
        maxMessageSize = Math.max(canSendMMS, remoteMMS);
      } else {
        maxMessageSize = Math.min(canSendMMS, remoteMMS);
      }

      // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
      // attribute.
      var sctp = {};
      Object.defineProperty(sctp, 'maxMessageSize', {
        get: function get() {
          return maxMessageSize;
        }
      });
      this._sctp = sctp;
    }

    return origSetRemoteDescription.apply(this, arguments);
  };
}

function shimSendThrowTypeError(window) {
  if (!(window.RTCPeerConnection && 'createDataChannel' in window.RTCPeerConnection.prototype)) {
    return;
  }

  // Note: Although Firefox >= 57 has a native implementation, the maximum
  //       message size can be reset for all data channels at a later stage.
  //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831

  function wrapDcSend(dc, pc) {
    var origDataChannelSend = dc.send;
    dc.send = function () {
      var data = arguments[0];
      var length = data.length || data.size || data.byteLength;
      if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) {
        throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
      }
      return origDataChannelSend.apply(dc, arguments);
    };
  }
  var origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
  window.RTCPeerConnection.prototype.createDataChannel = function () {
    var dataChannel = origCreateDataChannel.apply(this, arguments);
    wrapDcSend(dataChannel, this);
    return dataChannel;
  };
  utils.wrapPeerConnectionEvent(window, 'datachannel', function (e) {
    wrapDcSend(e.channel, e.target);
    return e;
  });
}

/* shims RTCConnectionState by pretending it is the same as iceConnectionState.
 * See https://bugs.chromium.org/p/webrtc/issues/detail?id=6145#c12
 * for why this is a valid hack in Chrome. In Firefox it is slightly incorrect
 * since DTLS failures would be hidden. See
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1265827
 * for the Firefox tracking bug.
 */
function shimConnectionState(window) {
  if (!window.RTCPeerConnection || 'connectionState' in window.RTCPeerConnection.prototype) {
    return;
  }
  var proto = window.RTCPeerConnection.prototype;
  Object.defineProperty(proto, 'connectionState', {
    get: function get() {
      return {
        completed: 'connected',
        checking: 'connecting'
      }[this.iceConnectionState] || this.iceConnectionState;
    },

    enumerable: true,
    configurable: true
  });
  Object.defineProperty(proto, 'onconnectionstatechange', {
    get: function get() {
      return this._onconnectionstatechange || null;
    },
    set: function set(cb) {
      if (this._onconnectionstatechange) {
        this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
        delete this._onconnectionstatechange;
      }
      if (cb) {
        this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
      }
    },

    enumerable: true,
    configurable: true
  });

  ['setLocalDescription', 'setRemoteDescription'].forEach(function (method) {
    var origMethod = proto[method];
    proto[method] = function () {
      if (!this._connectionstatechangepoly) {
        this._connectionstatechangepoly = function (e) {
          var pc = e.target;
          if (pc._lastConnectionState !== pc.connectionState) {
            pc._lastConnectionState = pc.connectionState;
            var newEvent = new Event('connectionstatechange', e);
            pc.dispatchEvent(newEvent);
          }
          return e;
        };
        this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
      }
      return origMethod.apply(this, arguments);
    };
  });
}

function removeAllowExtmapMixed(window) {
  /* remove a=extmap-allow-mixed for Chrome < M71 */
  if (!window.RTCPeerConnection) {
    return;
  }
  var browserDetails = utils.detectBrowser(window);
  if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) {
    return;
  }
  var nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
  window.RTCPeerConnection.prototype.setRemoteDescription = function (desc) {
    if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
      desc.sdp = desc.sdp.split('\n').filter(function (line) {
        return line.trim() !== 'a=extmap-allow-mixed';
      }).join('\n');
    }
    return nativeSRD.apply(this, arguments);
  };
}

},{"./utils":15,"sdp":17}],7:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shimGetDisplayMedia = exports.shimGetUserMedia = undefined;

var _getusermedia = require('./getusermedia');

Object.defineProperty(exports, 'shimGetUserMedia', {
  enumerable: true,
  get: function get() {
    return _getusermedia.shimGetUserMedia;
  }
});

var _getdisplaymedia = require('./getdisplaymedia');

Object.defineProperty(exports, 'shimGetDisplayMedia', {
  enumerable: true,
  get: function get() {
    return _getdisplaymedia.shimGetDisplayMedia;
  }
});
exports.shimPeerConnection = shimPeerConnection;
exports.shimReplaceTrack = shimReplaceTrack;

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

var _filtericeservers = require('./filtericeservers');

var _rtcpeerconnectionShim = require('rtcpeerconnection-shim');

var _rtcpeerconnectionShim2 = _interopRequireDefault(_rtcpeerconnectionShim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function shimPeerConnection(window) {
  var browserDetails = utils.detectBrowser(window);

  if (window.RTCIceGatherer) {
    if (!window.RTCIceCandidate) {
      window.RTCIceCandidate = function (args) {
        return args;
      };
    }
    if (!window.RTCSessionDescription) {
      window.RTCSessionDescription = function (args) {
        return args;
      };
    }
    // this adds an additional event listener to MediaStrackTrack that signals
    // when a tracks enabled property was changed. Workaround for a bug in
    // addStream, see below. No longer required in 15025+
    if (browserDetails.version < 15025) {
      var origMSTEnabled = Object.getOwnPropertyDescriptor(window.MediaStreamTrack.prototype, 'enabled');
      Object.defineProperty(window.MediaStreamTrack.prototype, 'enabled', {
        set: function set(value) {
          origMSTEnabled.set.call(this, value);
          var ev = new Event('enabled');
          ev.enabled = value;
          this.dispatchEvent(ev);
        }
      });
    }
  }

  // ORTC defines the DTMF sender a bit different.
  // https://github.com/w3c/ortc/issues/714
  if (window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
    Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
      get: function get() {
        if (this._dtmf === undefined) {
          if (this.track.kind === 'audio') {
            this._dtmf = new window.RTCDtmfSender(this);
          } else if (this.track.kind === 'video') {
            this._dtmf = null;
          }
        }
        return this._dtmf;
      }
    });
  }
  // Edge currently only implements the RTCDtmfSender, not the
  // RTCDTMFSender alias. See http://draft.ortc.org/#rtcdtmfsender2*
  if (window.RTCDtmfSender && !window.RTCDTMFSender) {
    window.RTCDTMFSender = window.RTCDtmfSender;
  }

  var RTCPeerConnectionShim = (0, _rtcpeerconnectionShim2.default)(window, browserDetails.version);
  window.RTCPeerConnection = function (config) {
    if (config && config.iceServers) {
      config.iceServers = (0, _filtericeservers.filterIceServers)(config.iceServers, browserDetails.version);
      utils.log('ICE servers after filtering:', config.iceServers);
    }
    return new RTCPeerConnectionShim(config);
  };
  window.RTCPeerConnection.prototype = RTCPeerConnectionShim.prototype;
}

function shimReplaceTrack(window) {
  // ORTC has replaceTrack -- https://github.com/w3c/ortc/issues/614
  if (window.RTCRtpSender && !('replaceTrack' in window.RTCRtpSender.prototype)) {
    window.RTCRtpSender.prototype.replaceTrack = window.RTCRtpSender.prototype.setTrack;
  }
}

},{"../utils":15,"./filtericeservers":8,"./getdisplaymedia":9,"./getusermedia":10,"rtcpeerconnection-shim":16}],8:[function(require,module,exports){
/*
 *  Copyright (c) 2018 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterIceServers = filterIceServers;

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
function filterIceServers(iceServers, edgeVersion) {
  var hasTurn = false;
  iceServers = JSON.parse(JSON.stringify(iceServers));
  return iceServers.filter(function (server) {
    if (server && (server.urls || server.url)) {
      var urls = server.urls || server.url;
      if (server.url && !server.urls) {
        utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
      }
      var isString = typeof urls === 'string';
      if (isString) {
        urls = [urls];
      }
      urls = urls.filter(function (url) {
        // filter STUN unconditionally.
        if (url.indexOf('stun:') === 0) {
          return false;
        }

        var validTurn = url.startsWith('turn') && !url.startsWith('turn:[') && url.includes('transport=udp');
        if (validTurn && !hasTurn) {
          hasTurn = true;
          return true;
        }
        return validTurn && !hasTurn;
      });

      delete server.url;
      server.urls = isString ? urls[0] : urls;
      return !!urls.length;
    }
  });
}

},{"../utils":15}],9:[function(require,module,exports){
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shimGetDisplayMedia = shimGetDisplayMedia;
function shimGetDisplayMedia(window) {
  if (!('getDisplayMedia' in window.navigator)) {
    return;
  }
  if (!window.navigator.mediaDevices) {
    return;
  }
  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }
  window.navigator.mediaDevices.getDisplayMedia = window.navigator.getDisplayMedia.bind(window.navigator);
}

},{}],10:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shimGetUserMedia = shimGetUserMedia;
function shimGetUserMedia(window) {
  var navigator = window && window.navigator;

  var shimError_ = function shimError_(e) {
    return {
      name: { PermissionDeniedError: 'NotAllowedError' }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint,
      toString: function toString() {
        return this.name;
      }
    };
  };

  // getUserMedia error shim.
  var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
  navigator.mediaDevices.getUserMedia = function (c) {
    return origGetUserMedia(c).catch(function (e) {
      return Promise.reject(shimError_(e));
    });
  };
}

},{}],11:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shimGetDisplayMedia = exports.shimGetUserMedia = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _getusermedia = require('./getusermedia');

Object.defineProperty(exports, 'shimGetUserMedia', {
  enumerable: true,
  get: function get() {
    return _getusermedia.shimGetUserMedia;
  }
});

var _getdisplaymedia = require('./getdisplaymedia');

Object.defineProperty(exports, 'shimGetDisplayMedia', {
  enumerable: true,
  get: function get() {
    return _getdisplaymedia.shimGetDisplayMedia;
  }
});
exports.shimOnTrack = shimOnTrack;
exports.shimPeerConnection = shimPeerConnection;
exports.shimSenderGetStats = shimSenderGetStats;
exports.shimReceiverGetStats = shimReceiverGetStats;
exports.shimRemoveStream = shimRemoveStream;
exports.shimRTCDataChannel = shimRTCDataChannel;

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function shimOnTrack(window) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
      get: function get() {
        return { receiver: this.receiver };
      }
    });
  }
}

function shimPeerConnection(window) {
  var browserDetails = utils.detectBrowser(window);

  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) {
    return; // probably media.peerconnection.enabled=false in about:config
  }
  if (!window.RTCPeerConnection && window.mozRTCPeerConnection) {
    // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
  }

  // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
  ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
    var nativeMethod = window.RTCPeerConnection.prototype[method];
    window.RTCPeerConnection.prototype[method] = function () {
      arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
      return nativeMethod.apply(this, arguments);
    };
  });

  // support for addIceCandidate(null or undefined)
  var nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
  window.RTCPeerConnection.prototype.addIceCandidate = function () {
    if (!arguments[0]) {
      if (arguments[1]) {
        arguments[1].apply(null);
      }
      return Promise.resolve();
    }
    return nativeAddIceCandidate.apply(this, arguments);
  };

  var modernStatsTypes = {
    inboundrtp: 'inbound-rtp',
    outboundrtp: 'outbound-rtp',
    candidatepair: 'candidate-pair',
    localcandidate: 'local-candidate',
    remotecandidate: 'remote-candidate'
  };

  var nativeGetStats = window.RTCPeerConnection.prototype.getStats;
  window.RTCPeerConnection.prototype.getStats = function (selector, onSucc, onErr) {
    return nativeGetStats.apply(this, [selector || null]).then(function (stats) {
      if (browserDetails.version < 53 && !onSucc) {
        // Shim only promise getStats with spec-hyphens in type names
        // Leave callback version alone; misc old uses of forEach before Map
        try {
          stats.forEach(function (stat) {
            stat.type = modernStatsTypes[stat.type] || stat.type;
          });
        } catch (e) {
          if (e.name !== 'TypeError') {
            throw e;
          }
          // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
          stats.forEach(function (stat, i) {
            stats.set(i, Object.assign({}, stat, {
              type: modernStatsTypes[stat.type] || stat.type
            }));
          });
        }
      }
      return stats;
    }).then(onSucc, onErr);
  };
}

function shimSenderGetStats(window) {
  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
    return;
  }
  if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) {
    return;
  }
  var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
  if (origGetSenders) {
    window.RTCPeerConnection.prototype.getSenders = function () {
      var _this = this;

      var senders = origGetSenders.apply(this, []);
      senders.forEach(function (sender) {
        return sender._pc = _this;
      });
      return senders;
    };
  }

  var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
  if (origAddTrack) {
    window.RTCPeerConnection.prototype.addTrack = function () {
      var sender = origAddTrack.apply(this, arguments);
      sender._pc = this;
      return sender;
    };
  }
  window.RTCRtpSender.prototype.getStats = function () {
    return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
  };
}

function shimReceiverGetStats(window) {
  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
    return;
  }
  if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) {
    return;
  }
  var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
  if (origGetReceivers) {
    window.RTCPeerConnection.prototype.getReceivers = function () {
      var _this2 = this;

      var receivers = origGetReceivers.apply(this, []);
      receivers.forEach(function (receiver) {
        return receiver._pc = _this2;
      });
      return receivers;
    };
  }
  utils.wrapPeerConnectionEvent(window, 'track', function (e) {
    e.receiver._pc = e.srcElement;
    return e;
  });
  window.RTCRtpReceiver.prototype.getStats = function () {
    return this._pc.getStats(this.track);
  };
}

function shimRemoveStream(window) {
  if (!window.RTCPeerConnection || 'removeStream' in window.RTCPeerConnection.prototype) {
    return;
  }
  window.RTCPeerConnection.prototype.removeStream = function (stream) {
    var _this3 = this;

    utils.deprecated('removeStream', 'removeTrack');
    this.getSenders().forEach(function (sender) {
      if (sender.track && stream.getTracks().includes(sender.track)) {
        _this3.removeTrack(sender);
      }
    });
  };
}

function shimRTCDataChannel(window) {
  // rename DataChannel to RTCDataChannel (native fix in FF60):
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
  if (window.DataChannel && !window.RTCDataChannel) {
    window.RTCDataChannel = window.DataChannel;
  }
}

},{"../utils":15,"./getdisplaymedia":12,"./getusermedia":13}],12:[function(require,module,exports){
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shimGetDisplayMedia = shimGetDisplayMedia;
function shimGetDisplayMedia(window, preferredMediaSource) {
  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }
  if (!window.navigator.mediaDevices) {
    return;
  }
  window.navigator.mediaDevices.getDisplayMedia = function (constraints) {
    if (!(constraints && constraints.video)) {
      var err = new DOMException('getDisplayMedia without video ' + 'constraints is undefined');
      err.name = 'NotFoundError';
      // from https://heycam.github.io/webidl/#idl-DOMException-error-names
      err.code = 8;
      return Promise.reject(err);
    }
    if (constraints.video === true) {
      constraints.video = { mediaSource: preferredMediaSource };
    } else {
      constraints.video.mediaSource = preferredMediaSource;
    }
    return window.navigator.mediaDevices.getUserMedia(constraints);
  };
}

},{}],13:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.shimGetUserMedia = shimGetUserMedia;

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function shimGetUserMedia(window) {
  var browserDetails = utils.detectBrowser(window);
  var navigator = window && window.navigator;
  var MediaStreamTrack = window && window.MediaStreamTrack;

  navigator.getUserMedia = function (constraints, onSuccess, onError) {
    // Replace Firefox 44+'s deprecation warning with unprefixed version.
    utils.deprecated('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };

  if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
    var remap = function remap(obj, a, b) {
      if (a in obj && !(b in obj)) {
        obj[b] = obj[a];
        delete obj[a];
      }
    };

    var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function (c) {
      if ((typeof c === 'undefined' ? 'undefined' : _typeof(c)) === 'object' && _typeof(c.audio) === 'object') {
        c = JSON.parse(JSON.stringify(c));
        remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
        remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
      }
      return nativeGetUserMedia(c);
    };

    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
      var nativeGetSettings = MediaStreamTrack.prototype.getSettings;
      MediaStreamTrack.prototype.getSettings = function () {
        var obj = nativeGetSettings.apply(this, arguments);
        remap(obj, 'mozAutoGainControl', 'autoGainControl');
        remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
        return obj;
      };
    }

    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
      var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
      MediaStreamTrack.prototype.applyConstraints = function (c) {
        if (this.kind === 'audio' && (typeof c === 'undefined' ? 'undefined' : _typeof(c)) === 'object') {
          c = JSON.parse(JSON.stringify(c));
          remap(c, 'autoGainControl', 'mozAutoGainControl');
          remap(c, 'noiseSuppression', 'mozNoiseSuppression');
        }
        return nativeApplyConstraints.apply(this, [c]);
      };
    }
  }
}

},{"../utils":15}],14:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.shimLocalStreamsAPI = shimLocalStreamsAPI;
exports.shimRemoteStreamsAPI = shimRemoteStreamsAPI;
exports.shimCallbacksAPI = shimCallbacksAPI;
exports.shimGetUserMedia = shimGetUserMedia;
exports.shimConstraints = shimConstraints;
exports.shimRTCIceServerUrls = shimRTCIceServerUrls;
exports.shimTrackEventTransceiver = shimTrackEventTransceiver;
exports.shimCreateOfferLegacy = shimCreateOfferLegacy;

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function shimLocalStreamsAPI(window) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !window.RTCPeerConnection) {
    return;
  }
  if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.getLocalStreams = function () {
      if (!this._localStreams) {
        this._localStreams = [];
      }
      return this._localStreams;
    };
  }
  if (!('addStream' in window.RTCPeerConnection.prototype)) {
    var _addTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addStream = function (stream) {
      var _this = this;

      if (!this._localStreams) {
        this._localStreams = [];
      }
      if (!this._localStreams.includes(stream)) {
        this._localStreams.push(stream);
      }
      stream.getTracks().forEach(function (track) {
        return _addTrack.call(_this, track, stream);
      });
    };

    window.RTCPeerConnection.prototype.addTrack = function (track, stream) {
      if (stream) {
        if (!this._localStreams) {
          this._localStreams = [stream];
        } else if (!this._localStreams.includes(stream)) {
          this._localStreams.push(stream);
        }
      }
      return _addTrack.call(this, track, stream);
    };
  }
  if (!('removeStream' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.removeStream = function (stream) {
      var _this2 = this;

      if (!this._localStreams) {
        this._localStreams = [];
      }
      var index = this._localStreams.indexOf(stream);
      if (index === -1) {
        return;
      }
      this._localStreams.splice(index, 1);
      var tracks = stream.getTracks();
      this.getSenders().forEach(function (sender) {
        if (tracks.includes(sender.track)) {
          _this2.removeTrack(sender);
        }
      });
    };
  }
}

function shimRemoteStreamsAPI(window) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !window.RTCPeerConnection) {
    return;
  }
  if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.getRemoteStreams = function () {
      return this._remoteStreams ? this._remoteStreams : [];
    };
  }
  if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
      get: function get() {
        return this._onaddstream;
      },
      set: function set(f) {
        var _this3 = this;

        if (this._onaddstream) {
          this.removeEventListener('addstream', this._onaddstream);
          this.removeEventListener('track', this._onaddstreampoly);
        }
        this.addEventListener('addstream', this._onaddstream = f);
        this.addEventListener('track', this._onaddstreampoly = function (e) {
          e.streams.forEach(function (stream) {
            if (!_this3._remoteStreams) {
              _this3._remoteStreams = [];
            }
            if (_this3._remoteStreams.includes(stream)) {
              return;
            }
            _this3._remoteStreams.push(stream);
            var event = new Event('addstream');
            event.stream = stream;
            _this3.dispatchEvent(event);
          });
        });
      }
    });
    var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function () {
      var pc = this;
      if (!this._onaddstreampoly) {
        this.addEventListener('track', this._onaddstreampoly = function (e) {
          e.streams.forEach(function (stream) {
            if (!pc._remoteStreams) {
              pc._remoteStreams = [];
            }
            if (pc._remoteStreams.indexOf(stream) >= 0) {
              return;
            }
            pc._remoteStreams.push(stream);
            var event = new Event('addstream');
            event.stream = stream;
            pc.dispatchEvent(event);
          });
        });
      }
      return origSetRemoteDescription.apply(pc, arguments);
    };
  }
}

function shimCallbacksAPI(window) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !window.RTCPeerConnection) {
    return;
  }
  var prototype = window.RTCPeerConnection.prototype;
  var createOffer = prototype.createOffer;
  var createAnswer = prototype.createAnswer;
  var setLocalDescription = prototype.setLocalDescription;
  var setRemoteDescription = prototype.setRemoteDescription;
  var addIceCandidate = prototype.addIceCandidate;

  prototype.createOffer = function (successCallback, failureCallback) {
    var options = arguments.length >= 2 ? arguments[2] : arguments[0];
    var promise = createOffer.apply(this, [options]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };

  prototype.createAnswer = function (successCallback, failureCallback) {
    var options = arguments.length >= 2 ? arguments[2] : arguments[0];
    var promise = createAnswer.apply(this, [options]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };

  var withCallback = function withCallback(description, successCallback, failureCallback) {
    var promise = setLocalDescription.apply(this, [description]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.setLocalDescription = withCallback;

  withCallback = function withCallback(description, successCallback, failureCallback) {
    var promise = setRemoteDescription.apply(this, [description]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.setRemoteDescription = withCallback;

  withCallback = function withCallback(candidate, successCallback, failureCallback) {
    var promise = addIceCandidate.apply(this, [candidate]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.addIceCandidate = withCallback;
}

function shimGetUserMedia(window) {
  var navigator = window && window.navigator;

  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    // shim not needed in Safari 12.1
    var mediaDevices = navigator.mediaDevices;
    var _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
    navigator.mediaDevices.getUserMedia = function (constraints) {
      return _getUserMedia(shimConstraints(constraints));
    };
  }

  if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    navigator.getUserMedia = function (constraints, cb, errcb) {
      navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }.bind(navigator);
  }
}

function shimConstraints(constraints) {
  if (constraints && constraints.video !== undefined) {
    return Object.assign({}, constraints, { video: utils.compactObject(constraints.video) });
  }

  return constraints;
}

function shimRTCIceServerUrls(window) {
  // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
  var OrigPeerConnection = window.RTCPeerConnection;
  window.RTCPeerConnection = function (pcConfig, pcConstraints) {
    if (pcConfig && pcConfig.iceServers) {
      var newIceServers = [];
      for (var i = 0; i < pcConfig.iceServers.length; i++) {
        var server = pcConfig.iceServers[i];
        if (!server.hasOwnProperty('urls') && server.hasOwnProperty('url')) {
          utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
          server = JSON.parse(JSON.stringify(server));
          server.urls = server.url;
          delete server.url;
          newIceServers.push(server);
        } else {
          newIceServers.push(pcConfig.iceServers[i]);
        }
      }
      pcConfig.iceServers = newIceServers;
    }
    return new OrigPeerConnection(pcConfig, pcConstraints);
  };
  window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
  // wrap static methods. Currently just generateCertificate.
  if ('generateCertificate' in window.RTCPeerConnection) {
    Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
      get: function get() {
        return OrigPeerConnection.generateCertificate;
      }
    });
  }
}

function shimTrackEventTransceiver(window) {
  // Add event.transceiver member over deprecated event.receiver
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && 'receiver' in window.RTCTrackEvent.prototype &&
  // can't check 'transceiver' in window.RTCTrackEvent.prototype, as it is
  // defined for some reason even when window.RTCTransceiver is not.
  !window.RTCTransceiver) {
    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
      get: function get() {
        return { receiver: this.receiver };
      }
    });
  }
}

function shimCreateOfferLegacy(window) {
  var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
  window.RTCPeerConnection.prototype.createOffer = function (offerOptions) {
    if (offerOptions) {
      if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
        // support bit values
        offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
      }
      var audioTransceiver = this.getTransceivers().find(function (transceiver) {
        return transceiver.receiver.track.kind === 'audio';
      });
      if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
        if (audioTransceiver.direction === 'sendrecv') {
          if (audioTransceiver.setDirection) {
            audioTransceiver.setDirection('sendonly');
          } else {
            audioTransceiver.direction = 'sendonly';
          }
        } else if (audioTransceiver.direction === 'recvonly') {
          if (audioTransceiver.setDirection) {
            audioTransceiver.setDirection('inactive');
          } else {
            audioTransceiver.direction = 'inactive';
          }
        }
      } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) {
        this.addTransceiver('audio');
      }

      if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
        // support bit values
        offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
      }
      var videoTransceiver = this.getTransceivers().find(function (transceiver) {
        return transceiver.receiver.track.kind === 'video';
      });
      if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
        if (videoTransceiver.direction === 'sendrecv') {
          if (videoTransceiver.setDirection) {
            videoTransceiver.setDirection('sendonly');
          } else {
            videoTransceiver.direction = 'sendonly';
          }
        } else if (videoTransceiver.direction === 'recvonly') {
          if (videoTransceiver.setDirection) {
            videoTransceiver.setDirection('inactive');
          } else {
            videoTransceiver.direction = 'inactive';
          }
        }
      } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) {
        this.addTransceiver('video');
      }
    }
    return origCreateOffer.apply(this, arguments);
  };
}

},{"../utils":15}],15:[function(require,module,exports){
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.extractVersion = extractVersion;
exports.wrapPeerConnectionEvent = wrapPeerConnectionEvent;
exports.disableLog = disableLog;
exports.disableWarnings = disableWarnings;
exports.log = log;
exports.deprecated = deprecated;
exports.detectBrowser = detectBrowser;
exports.compactObject = compactObject;
exports.walkStats = walkStats;
exports.filterStats = filterStats;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var logDisabled_ = true;
var deprecationWarnings_ = true;

/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */
function extractVersion(uastring, expr, pos) {
  var match = uastring.match(expr);
  return match && match.length >= pos && parseInt(match[pos], 10);
}

// Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object (or false to prevent
// the event).
function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
  if (!window.RTCPeerConnection) {
    return;
  }
  var proto = window.RTCPeerConnection.prototype;
  var nativeAddEventListener = proto.addEventListener;
  proto.addEventListener = function (nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap) {
      return nativeAddEventListener.apply(this, arguments);
    }
    var wrappedCallback = function wrappedCallback(e) {
      var modifiedEvent = wrapper(e);
      if (modifiedEvent) {
        cb(modifiedEvent);
      }
    };
    this._eventMap = this._eventMap || {};
    this._eventMap[cb] = wrappedCallback;
    return nativeAddEventListener.apply(this, [nativeEventName, wrappedCallback]);
  };

  var nativeRemoveEventListener = proto.removeEventListener;
  proto.removeEventListener = function (nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[cb]) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    var unwrappedCb = this._eventMap[cb];
    delete this._eventMap[cb];
    return nativeRemoveEventListener.apply(this, [nativeEventName, unwrappedCb]);
  };

  Object.defineProperty(proto, 'on' + eventNameToWrap, {
    get: function get() {
      return this['_on' + eventNameToWrap];
    },
    set: function set(cb) {
      if (this['_on' + eventNameToWrap]) {
        this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
        delete this['_on' + eventNameToWrap];
      }
      if (cb) {
        this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
      }
    },

    enumerable: true,
    configurable: true
  });
}

function disableLog(bool) {
  if (typeof bool !== 'boolean') {
    return new Error('Argument type: ' + (typeof bool === 'undefined' ? 'undefined' : _typeof(bool)) + '. Please use a boolean.');
  }
  logDisabled_ = bool;
  return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
}

/**
 * Disable or enable deprecation warnings
 * @param {!boolean} bool set to true to disable warnings.
 */
function disableWarnings(bool) {
  if (typeof bool !== 'boolean') {
    return new Error('Argument type: ' + (typeof bool === 'undefined' ? 'undefined' : _typeof(bool)) + '. Please use a boolean.');
  }
  deprecationWarnings_ = !bool;
  return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
}

function log() {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
    if (logDisabled_) {
      return;
    }
    if (typeof console !== 'undefined' && typeof console.log === 'function') {
      console.log.apply(console, arguments);
    }
  }
}

/**
 * Shows a deprecation warning suggesting the modern and spec-compatible API.
 */
function deprecated(oldMethod, newMethod) {
  if (!deprecationWarnings_) {
    return;
  }
  console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
}

/**
 * Browser detector.
 *
 * @return {object} result containing browser and version
 *     properties.
 */
function detectBrowser(window) {
  var navigator = window.navigator;

  // Returned result object.

  var result = { browser: null, version: null };

  // Fail early if it's not a browser
  if (typeof window === 'undefined' || !window.navigator) {
    result.browser = 'Not a browser.';
    return result;
  }

  if (navigator.mozGetUserMedia) {
    // Firefox.
    result.browser = 'firefox';
    result.version = extractVersion(navigator.userAgent, /Firefox\/(\d+)\./, 1);
  } else if (navigator.webkitGetUserMedia || window.isSecureContext === false && window.webkitRTCPeerConnection && !window.RTCIceGatherer) {
    // Chrome, Chromium, Webview, Opera.
    // Version matches Chrome/WebRTC version.
    // Chrome 74 removed webkitGetUserMedia on http as well so we need the
    // more complicated fallback to webkitRTCPeerConnection.
    result.browser = 'chrome';
    result.version = extractVersion(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
  } else if (navigator.mediaDevices && navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
    // Edge.
    result.browser = 'edge';
    result.version = extractVersion(navigator.userAgent, /Edge\/(\d+).(\d+)$/, 2);
  } else if (window.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
    // Safari.
    result.browser = 'safari';
    result.version = extractVersion(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
  } else {
    // Default fallthrough: not supported.
    result.browser = 'Not a supported browser.';
    return result;
  }

  return result;
}

/**
 * Remove all empty objects and undefined values
 * from a nested object -- an enhanced and vanilla version
 * of Lodash's `compact`.
 */
function compactObject(data) {
  if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
    return data;
  }

  return Object.keys(data).reduce(function (accumulator, key) {
    var isObject = _typeof(data[key]) === 'object';
    var value = isObject ? compactObject(data[key]) : data[key];
    var isEmptyObject = isObject && !Object.keys(value).length;
    if (value === undefined || isEmptyObject) {
      return accumulator;
    }

    return Object.assign(accumulator, _defineProperty({}, key, value));
  }, {});
}

/* iterates the stats graph recursively. */
function walkStats(stats, base, resultSet) {
  if (!base || resultSet.has(base.id)) {
    return;
  }
  resultSet.set(base.id, base);
  Object.keys(base).forEach(function (name) {
    if (name.endsWith('Id')) {
      walkStats(stats, stats.get(base[name]), resultSet);
    } else if (name.endsWith('Ids')) {
      base[name].forEach(function (id) {
        walkStats(stats, stats.get(id), resultSet);
      });
    }
  });
}

/* filter getStats for a sender/receiver track. */
function filterStats(result, track, outbound) {
  var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
  var filteredResult = new Map();
  if (track === null) {
    return filteredResult;
  }
  var trackStats = [];
  result.forEach(function (value) {
    if (value.type === 'track' && value.trackIdentifier === track.id) {
      trackStats.push(value);
    }
  });
  trackStats.forEach(function (trackStat) {
    result.forEach(function (stats) {
      if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
        walkStats(result, stats, filteredResult);
      }
    });
  });
  return filteredResult;
}

},{}],16:[function(require,module,exports){
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */
'use strict';

var SDPUtils = require('sdp');

function fixStatsType(stat) {
  return {
    inboundrtp: 'inbound-rtp',
    outboundrtp: 'outbound-rtp',
    candidatepair: 'candidate-pair',
    localcandidate: 'local-candidate',
    remotecandidate: 'remote-candidate'
  }[stat.type] || stat.type;
}

function writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);

  // Map ICE parameters (ufrag, pwd) to SDP.
  sdp += SDPUtils.writeIceParameters(
      transceiver.iceGatherer.getLocalParameters());

  // Map DTLS parameters to SDP.
  sdp += SDPUtils.writeDtlsParameters(
      transceiver.dtlsTransport.getLocalParameters(),
      type === 'offer' ? 'actpass' : dtlsRole || 'active');

  sdp += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    var trackId = transceiver.rtpSender._initialTrackId ||
        transceiver.rtpSender.track.id;
    transceiver.rtpSender._initialTrackId = trackId;
    // spec.
    var msid = 'msid:' + (stream ? stream.id : '-') + ' ' +
        trackId + '\r\n';
    sdp += 'a=' + msid;
    // for Chrome. Legacy should no longer be required.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;

    // RTX
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  // FIXME: this should be written by writeRtpDescription.
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
}

// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
function filterIceServers(iceServers, edgeVersion) {
  var hasTurn = false;
  iceServers = JSON.parse(JSON.stringify(iceServers));
  return iceServers.filter(function(server) {
    if (server && (server.urls || server.url)) {
      var urls = server.urls || server.url;
      if (server.url && !server.urls) {
        console.warn('RTCIceServer.url is deprecated! Use urls instead.');
      }
      var isString = typeof urls === 'string';
      if (isString) {
        urls = [urls];
      }
      urls = urls.filter(function(url) {
        var validTurn = url.indexOf('turn:') === 0 &&
            url.indexOf('transport=udp') !== -1 &&
            url.indexOf('turn:[') === -1 &&
            !hasTurn;

        if (validTurn) {
          hasTurn = true;
          return true;
        }
        return url.indexOf('stun:') === 0 && edgeVersion >= 14393 &&
            url.indexOf('?transport=udp') === -1;
      });

      delete server.url;
      server.urls = isString ? urls[0] : urls;
      return !!urls.length;
    }
  });
}

// Determines the intersection of local and remote capabilities.
function getCommonCapabilities(localCapabilities, remoteCapabilities) {
  var commonCapabilities = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: []
  };

  var findCodecByPayloadType = function(pt, codecs) {
    pt = parseInt(pt, 10);
    for (var i = 0; i < codecs.length; i++) {
      if (codecs[i].payloadType === pt ||
          codecs[i].preferredPayloadType === pt) {
        return codecs[i];
      }
    }
  };

  var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
    var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
    var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
    return lCodec && rCodec &&
        lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
  };

  localCapabilities.codecs.forEach(function(lCodec) {
    for (var i = 0; i < remoteCapabilities.codecs.length; i++) {
      var rCodec = remoteCapabilities.codecs[i];
      if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() &&
          lCodec.clockRate === rCodec.clockRate) {
        if (lCodec.name.toLowerCase() === 'rtx' &&
            lCodec.parameters && rCodec.parameters.apt) {
          // for RTX we need to find the local rtx that has a apt
          // which points to the same local codec as the remote one.
          if (!rtxCapabilityMatches(lCodec, rCodec,
              localCapabilities.codecs, remoteCapabilities.codecs)) {
            continue;
          }
        }
        rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
        // number of channels is the highest common number of channels
        rCodec.numChannels = Math.min(lCodec.numChannels,
            rCodec.numChannels);
        // push rCodec so we reply with offerer payload type
        commonCapabilities.codecs.push(rCodec);

        // determine common feedback mechanisms
        rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
          for (var j = 0; j < lCodec.rtcpFeedback.length; j++) {
            if (lCodec.rtcpFeedback[j].type === fb.type &&
                lCodec.rtcpFeedback[j].parameter === fb.parameter) {
              return true;
            }
          }
          return false;
        });
        // FIXME: also need to determine .parameters
        //  see https://github.com/openpeer/ortc/issues/569
        break;
      }
    }
  });

  localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
    for (var i = 0; i < remoteCapabilities.headerExtensions.length;
         i++) {
      var rHeaderExtension = remoteCapabilities.headerExtensions[i];
      if (lHeaderExtension.uri === rHeaderExtension.uri) {
        commonCapabilities.headerExtensions.push(rHeaderExtension);
        break;
      }
    }
  });

  // FIXME: fecMechanisms
  return commonCapabilities;
}

// is action=setLocalDescription with type allowed in signalingState
function isActionAllowedInSignalingState(action, type, signalingState) {
  return {
    offer: {
      setLocalDescription: ['stable', 'have-local-offer'],
      setRemoteDescription: ['stable', 'have-remote-offer']
    },
    answer: {
      setLocalDescription: ['have-remote-offer', 'have-local-pranswer'],
      setRemoteDescription: ['have-local-offer', 'have-remote-pranswer']
    }
  }[type][action].indexOf(signalingState) !== -1;
}

function maybeAddCandidate(iceTransport, candidate) {
  // Edge's internal representation adds some fields therefore
  // not all fieldѕ are taken into account.
  var alreadyAdded = iceTransport.getRemoteCandidates()
      .find(function(remoteCandidate) {
        return candidate.foundation === remoteCandidate.foundation &&
            candidate.ip === remoteCandidate.ip &&
            candidate.port === remoteCandidate.port &&
            candidate.priority === remoteCandidate.priority &&
            candidate.protocol === remoteCandidate.protocol &&
            candidate.type === remoteCandidate.type;
      });
  if (!alreadyAdded) {
    iceTransport.addRemoteCandidate(candidate);
  }
  return !alreadyAdded;
}


function makeError(name, description) {
  var e = new Error(description);
  e.name = name;
  // legacy error codes from https://heycam.github.io/webidl/#idl-DOMException-error-names
  e.code = {
    NotSupportedError: 9,
    InvalidStateError: 11,
    InvalidAccessError: 15,
    TypeError: undefined,
    OperationError: undefined
  }[name];
  return e;
}

module.exports = function(window, edgeVersion) {
  // https://w3c.github.io/mediacapture-main/#mediastream
  // Helper function to add the track to the stream and
  // dispatch the event ourselves.
  function addTrackToStreamAndFireEvent(track, stream) {
    stream.addTrack(track);
    stream.dispatchEvent(new window.MediaStreamTrackEvent('addtrack',
        {track: track}));
  }

  function removeTrackFromStreamAndFireEvent(track, stream) {
    stream.removeTrack(track);
    stream.dispatchEvent(new window.MediaStreamTrackEvent('removetrack',
        {track: track}));
  }

  function fireAddTrack(pc, track, receiver, streams) {
    var trackEvent = new Event('track');
    trackEvent.track = track;
    trackEvent.receiver = receiver;
    trackEvent.transceiver = {receiver: receiver};
    trackEvent.streams = streams;
    window.setTimeout(function() {
      pc._dispatchEvent('track', trackEvent);
    });
  }

  var RTCPeerConnection = function(config) {
    var pc = this;

    var _eventTarget = document.createDocumentFragment();
    ['addEventListener', 'removeEventListener', 'dispatchEvent']
        .forEach(function(method) {
          pc[method] = _eventTarget[method].bind(_eventTarget);
        });

    this.canTrickleIceCandidates = null;

    this.needNegotiation = false;

    this.localStreams = [];
    this.remoteStreams = [];

    this._localDescription = null;
    this._remoteDescription = null;

    this.signalingState = 'stable';
    this.iceConnectionState = 'new';
    this.connectionState = 'new';
    this.iceGatheringState = 'new';

    config = JSON.parse(JSON.stringify(config || {}));

    this.usingBundle = config.bundlePolicy === 'max-bundle';
    if (config.rtcpMuxPolicy === 'negotiate') {
      throw(makeError('NotSupportedError',
          'rtcpMuxPolicy \'negotiate\' is not supported'));
    } else if (!config.rtcpMuxPolicy) {
      config.rtcpMuxPolicy = 'require';
    }

    switch (config.iceTransportPolicy) {
      case 'all':
      case 'relay':
        break;
      default:
        config.iceTransportPolicy = 'all';
        break;
    }

    switch (config.bundlePolicy) {
      case 'balanced':
      case 'max-compat':
      case 'max-bundle':
        break;
      default:
        config.bundlePolicy = 'balanced';
        break;
    }

    config.iceServers = filterIceServers(config.iceServers || [], edgeVersion);

    this._iceGatherers = [];
    if (config.iceCandidatePoolSize) {
      for (var i = config.iceCandidatePoolSize; i > 0; i--) {
        this._iceGatherers.push(new window.RTCIceGatherer({
          iceServers: config.iceServers,
          gatherPolicy: config.iceTransportPolicy
        }));
      }
    } else {
      config.iceCandidatePoolSize = 0;
    }

    this._config = config;

    // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
    // everything that is needed to describe a SDP m-line.
    this.transceivers = [];

    this._sdpSessionId = SDPUtils.generateSessionId();
    this._sdpSessionVersion = 0;

    this._dtlsRole = undefined; // role for a=setup to use in answers.

    this._isClosed = false;
  };

  Object.defineProperty(RTCPeerConnection.prototype, 'localDescription', {
    configurable: true,
    get: function() {
      return this._localDescription;
    }
  });
  Object.defineProperty(RTCPeerConnection.prototype, 'remoteDescription', {
    configurable: true,
    get: function() {
      return this._remoteDescription;
    }
  });

  // set up event handlers on prototype
  RTCPeerConnection.prototype.onicecandidate = null;
  RTCPeerConnection.prototype.onaddstream = null;
  RTCPeerConnection.prototype.ontrack = null;
  RTCPeerConnection.prototype.onremovestream = null;
  RTCPeerConnection.prototype.onsignalingstatechange = null;
  RTCPeerConnection.prototype.oniceconnectionstatechange = null;
  RTCPeerConnection.prototype.onconnectionstatechange = null;
  RTCPeerConnection.prototype.onicegatheringstatechange = null;
  RTCPeerConnection.prototype.onnegotiationneeded = null;
  RTCPeerConnection.prototype.ondatachannel = null;

  RTCPeerConnection.prototype._dispatchEvent = function(name, event) {
    if (this._isClosed) {
      return;
    }
    this.dispatchEvent(event);
    if (typeof this['on' + name] === 'function') {
      this['on' + name](event);
    }
  };

  RTCPeerConnection.prototype._emitGatheringStateChange = function() {
    var event = new Event('icegatheringstatechange');
    this._dispatchEvent('icegatheringstatechange', event);
  };

  RTCPeerConnection.prototype.getConfiguration = function() {
    return this._config;
  };

  RTCPeerConnection.prototype.getLocalStreams = function() {
    return this.localStreams;
  };

  RTCPeerConnection.prototype.getRemoteStreams = function() {
    return this.remoteStreams;
  };

  // internal helper to create a transceiver object.
  // (which is not yet the same as the WebRTC 1.0 transceiver)
  RTCPeerConnection.prototype._createTransceiver = function(kind, doNotAdd) {
    var hasBundleTransport = this.transceivers.length > 0;
    var transceiver = {
      track: null,
      iceGatherer: null,
      iceTransport: null,
      dtlsTransport: null,
      localCapabilities: null,
      remoteCapabilities: null,
      rtpSender: null,
      rtpReceiver: null,
      kind: kind,
      mid: null,
      sendEncodingParameters: null,
      recvEncodingParameters: null,
      stream: null,
      associatedRemoteMediaStreams: [],
      wantReceive: true
    };
    if (this.usingBundle && hasBundleTransport) {
      transceiver.iceTransport = this.transceivers[0].iceTransport;
      transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
    } else {
      var transports = this._createIceAndDtlsTransports();
      transceiver.iceTransport = transports.iceTransport;
      transceiver.dtlsTransport = transports.dtlsTransport;
    }
    if (!doNotAdd) {
      this.transceivers.push(transceiver);
    }
    return transceiver;
  };

  RTCPeerConnection.prototype.addTrack = function(track, stream) {
    if (this._isClosed) {
      throw makeError('InvalidStateError',
          'Attempted to call addTrack on a closed peerconnection.');
    }

    var alreadyExists = this.transceivers.find(function(s) {
      return s.track === track;
    });

    if (alreadyExists) {
      throw makeError('InvalidAccessError', 'Track already exists.');
    }

    var transceiver;
    for (var i = 0; i < this.transceivers.length; i++) {
      if (!this.transceivers[i].track &&
          this.transceivers[i].kind === track.kind) {
        transceiver = this.transceivers[i];
      }
    }
    if (!transceiver) {
      transceiver = this._createTransceiver(track.kind);
    }

    this._maybeFireNegotiationNeeded();

    if (this.localStreams.indexOf(stream) === -1) {
      this.localStreams.push(stream);
    }

    transceiver.track = track;
    transceiver.stream = stream;
    transceiver.rtpSender = new window.RTCRtpSender(track,
        transceiver.dtlsTransport);
    return transceiver.rtpSender;
  };

  RTCPeerConnection.prototype.addStream = function(stream) {
    var pc = this;
    if (edgeVersion >= 15025) {
      stream.getTracks().forEach(function(track) {
        pc.addTrack(track, stream);
      });
    } else {
      // Clone is necessary for local demos mostly, attaching directly
      // to two different senders does not work (build 10547).
      // Fixed in 15025 (or earlier)
      var clonedStream = stream.clone();
      stream.getTracks().forEach(function(track, idx) {
        var clonedTrack = clonedStream.getTracks()[idx];
        track.addEventListener('enabled', function(event) {
          clonedTrack.enabled = event.enabled;
        });
      });
      clonedStream.getTracks().forEach(function(track) {
        pc.addTrack(track, clonedStream);
      });
    }
  };

  RTCPeerConnection.prototype.removeTrack = function(sender) {
    if (this._isClosed) {
      throw makeError('InvalidStateError',
          'Attempted to call removeTrack on a closed peerconnection.');
    }

    if (!(sender instanceof window.RTCRtpSender)) {
      throw new TypeError('Argument 1 of RTCPeerConnection.removeTrack ' +
          'does not implement interface RTCRtpSender.');
    }

    var transceiver = this.transceivers.find(function(t) {
      return t.rtpSender === sender;
    });

    if (!transceiver) {
      throw makeError('InvalidAccessError',
          'Sender was not created by this connection.');
    }
    var stream = transceiver.stream;

    transceiver.rtpSender.stop();
    transceiver.rtpSender = null;
    transceiver.track = null;
    transceiver.stream = null;

    // remove the stream from the set of local streams
    var localStreams = this.transceivers.map(function(t) {
      return t.stream;
    });
    if (localStreams.indexOf(stream) === -1 &&
        this.localStreams.indexOf(stream) > -1) {
      this.localStreams.splice(this.localStreams.indexOf(stream), 1);
    }

    this._maybeFireNegotiationNeeded();
  };

  RTCPeerConnection.prototype.removeStream = function(stream) {
    var pc = this;
    stream.getTracks().forEach(function(track) {
      var sender = pc.getSenders().find(function(s) {
        return s.track === track;
      });
      if (sender) {
        pc.removeTrack(sender);
      }
    });
  };

  RTCPeerConnection.prototype.getSenders = function() {
    return this.transceivers.filter(function(transceiver) {
      return !!transceiver.rtpSender;
    })
    .map(function(transceiver) {
      return transceiver.rtpSender;
    });
  };

  RTCPeerConnection.prototype.getReceivers = function() {
    return this.transceivers.filter(function(transceiver) {
      return !!transceiver.rtpReceiver;
    })
    .map(function(transceiver) {
      return transceiver.rtpReceiver;
    });
  };


  RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex,
      usingBundle) {
    var pc = this;
    if (usingBundle && sdpMLineIndex > 0) {
      return this.transceivers[0].iceGatherer;
    } else if (this._iceGatherers.length) {
      return this._iceGatherers.shift();
    }
    var iceGatherer = new window.RTCIceGatherer({
      iceServers: this._config.iceServers,
      gatherPolicy: this._config.iceTransportPolicy
    });
    Object.defineProperty(iceGatherer, 'state',
        {value: 'new', writable: true}
    );

    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];
    this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
      var end = !event.candidate || Object.keys(event.candidate).length === 0;
      // polyfill since RTCIceGatherer.state is not implemented in
      // Edge 10547 yet.
      iceGatherer.state = end ? 'completed' : 'gathering';
      if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) {
        pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
      }
    };
    iceGatherer.addEventListener('localcandidate',
      this.transceivers[sdpMLineIndex].bufferCandidates);
    return iceGatherer;
  };

  // start gathering from an RTCIceGatherer.
  RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
    var pc = this;
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
    if (iceGatherer.onlocalcandidate) {
      return;
    }
    var bufferedCandidateEvents =
      this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
    iceGatherer.removeEventListener('localcandidate',
      this.transceivers[sdpMLineIndex].bufferCandidates);
    iceGatherer.onlocalcandidate = function(evt) {
      if (pc.usingBundle && sdpMLineIndex > 0) {
        // if we know that we use bundle we can drop candidates with
        // ѕdpMLineIndex > 0. If we don't do this then our state gets
        // confused since we dispose the extra ice gatherer.
        return;
      }
      var event = new Event('icecandidate');
      event.candidate = {sdpMid: mid, sdpMLineIndex: sdpMLineIndex};

      var cand = evt.candidate;
      // Edge emits an empty object for RTCIceCandidateComplete‥
      var end = !cand || Object.keys(cand).length === 0;
      if (end) {
        // polyfill since RTCIceGatherer.state is not implemented in
        // Edge 10547 yet.
        if (iceGatherer.state === 'new' || iceGatherer.state === 'gathering') {
          iceGatherer.state = 'completed';
        }
      } else {
        if (iceGatherer.state === 'new') {
          iceGatherer.state = 'gathering';
        }
        // RTCIceCandidate doesn't have a component, needs to be added
        cand.component = 1;
        // also the usernameFragment. TODO: update SDP to take both variants.
        cand.ufrag = iceGatherer.getLocalParameters().usernameFragment;

        var serializedCandidate = SDPUtils.writeCandidate(cand);
        event.candidate = Object.assign(event.candidate,
            SDPUtils.parseCandidate(serializedCandidate));

        event.candidate.candidate = serializedCandidate;
        event.candidate.toJSON = function() {
          return {
            candidate: event.candidate.candidate,
            sdpMid: event.candidate.sdpMid,
            sdpMLineIndex: event.candidate.sdpMLineIndex,
            usernameFragment: event.candidate.usernameFragment
          };
        };
      }

      // update local description.
      var sections = SDPUtils.getMediaSections(pc._localDescription.sdp);
      if (!end) {
        sections[event.candidate.sdpMLineIndex] +=
            'a=' + event.candidate.candidate + '\r\n';
      } else {
        sections[event.candidate.sdpMLineIndex] +=
            'a=end-of-candidates\r\n';
      }
      pc._localDescription.sdp =
          SDPUtils.getDescription(pc._localDescription.sdp) +
          sections.join('');
      var complete = pc.transceivers.every(function(transceiver) {
        return transceiver.iceGatherer &&
            transceiver.iceGatherer.state === 'completed';
      });

      if (pc.iceGatheringState !== 'gathering') {
        pc.iceGatheringState = 'gathering';
        pc._emitGatheringStateChange();
      }

      // Emit candidate. Also emit null candidate when all gatherers are
      // complete.
      if (!end) {
        pc._dispatchEvent('icecandidate', event);
      }
      if (complete) {
        pc._dispatchEvent('icecandidate', new Event('icecandidate'));
        pc.iceGatheringState = 'complete';
        pc._emitGatheringStateChange();
      }
    };

    // emit already gathered candidates.
    window.setTimeout(function() {
      bufferedCandidateEvents.forEach(function(e) {
        iceGatherer.onlocalcandidate(e);
      });
    }, 0);
  };

  // Create ICE transport and DTLS transport.
  RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
    var pc = this;
    var iceTransport = new window.RTCIceTransport(null);
    iceTransport.onicestatechange = function() {
      pc._updateIceConnectionState();
      pc._updateConnectionState();
    };

    var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
    dtlsTransport.ondtlsstatechange = function() {
      pc._updateConnectionState();
    };
    dtlsTransport.onerror = function() {
      // onerror does not set state to failed by itself.
      Object.defineProperty(dtlsTransport, 'state',
          {value: 'failed', writable: true});
      pc._updateConnectionState();
    };

    return {
      iceTransport: iceTransport,
      dtlsTransport: dtlsTransport
    };
  };

  // Destroy ICE gatherer, ICE transport and DTLS transport.
  // Without triggering the callbacks.
  RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(
      sdpMLineIndex) {
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
    if (iceGatherer) {
      delete iceGatherer.onlocalcandidate;
      delete this.transceivers[sdpMLineIndex].iceGatherer;
    }
    var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
    if (iceTransport) {
      delete iceTransport.onicestatechange;
      delete this.transceivers[sdpMLineIndex].iceTransport;
    }
    var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
    if (dtlsTransport) {
      delete dtlsTransport.ondtlsstatechange;
      delete dtlsTransport.onerror;
      delete this.transceivers[sdpMLineIndex].dtlsTransport;
    }
  };

  // Start the RTP Sender and Receiver for a transceiver.
  RTCPeerConnection.prototype._transceive = function(transceiver,
      send, recv) {
    var params = getCommonCapabilities(transceiver.localCapabilities,
        transceiver.remoteCapabilities);
    if (send && transceiver.rtpSender) {
      params.encodings = transceiver.sendEncodingParameters;
      params.rtcp = {
        cname: SDPUtils.localCName,
        compound: transceiver.rtcpParameters.compound
      };
      if (transceiver.recvEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
      }
      transceiver.rtpSender.send(params);
    }
    if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
      // remove RTX field in Edge 14942
      if (transceiver.kind === 'video'
          && transceiver.recvEncodingParameters
          && edgeVersion < 15019) {
        transceiver.recvEncodingParameters.forEach(function(p) {
          delete p.rtx;
        });
      }
      if (transceiver.recvEncodingParameters.length) {
        params.encodings = transceiver.recvEncodingParameters;
      } else {
        params.encodings = [{}];
      }
      params.rtcp = {
        compound: transceiver.rtcpParameters.compound
      };
      if (transceiver.rtcpParameters.cname) {
        params.rtcp.cname = transceiver.rtcpParameters.cname;
      }
      if (transceiver.sendEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
      }
      transceiver.rtpReceiver.receive(params);
    }
  };

  RTCPeerConnection.prototype.setLocalDescription = function(description) {
    var pc = this;

    // Note: pranswer is not supported.
    if (['offer', 'answer'].indexOf(description.type) === -1) {
      return Promise.reject(makeError('TypeError',
          'Unsupported type "' + description.type + '"'));
    }

    if (!isActionAllowedInSignalingState('setLocalDescription',
        description.type, pc.signalingState) || pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not set local ' + description.type +
          ' in state ' + pc.signalingState));
    }

    var sections;
    var sessionpart;
    if (description.type === 'offer') {
      // VERY limited support for SDP munging. Limited to:
      // * changing the order of codecs
      sections = SDPUtils.splitSections(description.sdp);
      sessionpart = sections.shift();
      sections.forEach(function(mediaSection, sdpMLineIndex) {
        var caps = SDPUtils.parseRtpParameters(mediaSection);
        pc.transceivers[sdpMLineIndex].localCapabilities = caps;
      });

      pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
        pc._gather(transceiver.mid, sdpMLineIndex);
      });
    } else if (description.type === 'answer') {
      sections = SDPUtils.splitSections(pc._remoteDescription.sdp);
      sessionpart = sections.shift();
      var isIceLite = SDPUtils.matchPrefix(sessionpart,
          'a=ice-lite').length > 0;
      sections.forEach(function(mediaSection, sdpMLineIndex) {
        var transceiver = pc.transceivers[sdpMLineIndex];
        var iceGatherer = transceiver.iceGatherer;
        var iceTransport = transceiver.iceTransport;
        var dtlsTransport = transceiver.dtlsTransport;
        var localCapabilities = transceiver.localCapabilities;
        var remoteCapabilities = transceiver.remoteCapabilities;

        // treat bundle-only as not-rejected.
        var rejected = SDPUtils.isRejected(mediaSection) &&
            SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;

        if (!rejected && !transceiver.rejected) {
          var remoteIceParameters = SDPUtils.getIceParameters(
              mediaSection, sessionpart);
          var remoteDtlsParameters = SDPUtils.getDtlsParameters(
              mediaSection, sessionpart);
          if (isIceLite) {
            remoteDtlsParameters.role = 'server';
          }

          if (!pc.usingBundle || sdpMLineIndex === 0) {
            pc._gather(transceiver.mid, sdpMLineIndex);
            if (iceTransport.state === 'new') {
              iceTransport.start(iceGatherer, remoteIceParameters,
                  isIceLite ? 'controlling' : 'controlled');
            }
            if (dtlsTransport.state === 'new') {
              dtlsTransport.start(remoteDtlsParameters);
            }
          }

          // Calculate intersection of capabilities.
          var params = getCommonCapabilities(localCapabilities,
              remoteCapabilities);

          // Start the RTCRtpSender. The RTCRtpReceiver for this
          // transceiver has already been started in setRemoteDescription.
          pc._transceive(transceiver,
              params.codecs.length > 0,
              false);
        }
      });
    }

    pc._localDescription = {
      type: description.type,
      sdp: description.sdp
    };
    if (description.type === 'offer') {
      pc._updateSignalingState('have-local-offer');
    } else {
      pc._updateSignalingState('stable');
    }

    return Promise.resolve();
  };

  RTCPeerConnection.prototype.setRemoteDescription = function(description) {
    var pc = this;

    // Note: pranswer is not supported.
    if (['offer', 'answer'].indexOf(description.type) === -1) {
      return Promise.reject(makeError('TypeError',
          'Unsupported type "' + description.type + '"'));
    }

    if (!isActionAllowedInSignalingState('setRemoteDescription',
        description.type, pc.signalingState) || pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not set remote ' + description.type +
          ' in state ' + pc.signalingState));
    }

    var streams = {};
    pc.remoteStreams.forEach(function(stream) {
      streams[stream.id] = stream;
    });
    var receiverList = [];
    var sections = SDPUtils.splitSections(description.sdp);
    var sessionpart = sections.shift();
    var isIceLite = SDPUtils.matchPrefix(sessionpart,
        'a=ice-lite').length > 0;
    var usingBundle = SDPUtils.matchPrefix(sessionpart,
        'a=group:BUNDLE ').length > 0;
    pc.usingBundle = usingBundle;
    var iceOptions = SDPUtils.matchPrefix(sessionpart,
        'a=ice-options:')[0];
    if (iceOptions) {
      pc.canTrickleIceCandidates = iceOptions.substr(14).split(' ')
          .indexOf('trickle') >= 0;
    } else {
      pc.canTrickleIceCandidates = false;
    }

    sections.forEach(function(mediaSection, sdpMLineIndex) {
      var lines = SDPUtils.splitLines(mediaSection);
      var kind = SDPUtils.getKind(mediaSection);
      // treat bundle-only as not-rejected.
      var rejected = SDPUtils.isRejected(mediaSection) &&
          SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
      var protocol = lines[0].substr(2).split(' ')[2];

      var direction = SDPUtils.getDirection(mediaSection, sessionpart);
      var remoteMsid = SDPUtils.parseMsid(mediaSection);

      var mid = SDPUtils.getMid(mediaSection) || SDPUtils.generateIdentifier();

      // Reject datachannels which are not implemented yet.
      if (rejected || (kind === 'application' && (protocol === 'DTLS/SCTP' ||
          protocol === 'UDP/DTLS/SCTP'))) {
        // TODO: this is dangerous in the case where a non-rejected m-line
        //     becomes rejected.
        pc.transceivers[sdpMLineIndex] = {
          mid: mid,
          kind: kind,
          protocol: protocol,
          rejected: true
        };
        return;
      }

      if (!rejected && pc.transceivers[sdpMLineIndex] &&
          pc.transceivers[sdpMLineIndex].rejected) {
        // recycle a rejected transceiver.
        pc.transceivers[sdpMLineIndex] = pc._createTransceiver(kind, true);
      }

      var transceiver;
      var iceGatherer;
      var iceTransport;
      var dtlsTransport;
      var rtpReceiver;
      var sendEncodingParameters;
      var recvEncodingParameters;
      var localCapabilities;

      var track;
      // FIXME: ensure the mediaSection has rtcp-mux set.
      var remoteCapabilities = SDPUtils.parseRtpParameters(mediaSection);
      var remoteIceParameters;
      var remoteDtlsParameters;
      if (!rejected) {
        remoteIceParameters = SDPUtils.getIceParameters(mediaSection,
            sessionpart);
        remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection,
            sessionpart);
        remoteDtlsParameters.role = 'client';
      }
      recvEncodingParameters =
          SDPUtils.parseRtpEncodingParameters(mediaSection);

      var rtcpParameters = SDPUtils.parseRtcpParameters(mediaSection);

      var isComplete = SDPUtils.matchPrefix(mediaSection,
          'a=end-of-candidates', sessionpart).length > 0;
      var cands = SDPUtils.matchPrefix(mediaSection, 'a=candidate:')
          .map(function(cand) {
            return SDPUtils.parseCandidate(cand);
          })
          .filter(function(cand) {
            return cand.component === 1;
          });

      // Check if we can use BUNDLE and dispose transports.
      if ((description.type === 'offer' || description.type === 'answer') &&
          !rejected && usingBundle && sdpMLineIndex > 0 &&
          pc.transceivers[sdpMLineIndex]) {
        pc._disposeIceAndDtlsTransports(sdpMLineIndex);
        pc.transceivers[sdpMLineIndex].iceGatherer =
            pc.transceivers[0].iceGatherer;
        pc.transceivers[sdpMLineIndex].iceTransport =
            pc.transceivers[0].iceTransport;
        pc.transceivers[sdpMLineIndex].dtlsTransport =
            pc.transceivers[0].dtlsTransport;
        if (pc.transceivers[sdpMLineIndex].rtpSender) {
          pc.transceivers[sdpMLineIndex].rtpSender.setTransport(
              pc.transceivers[0].dtlsTransport);
        }
        if (pc.transceivers[sdpMLineIndex].rtpReceiver) {
          pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(
              pc.transceivers[0].dtlsTransport);
        }
      }
      if (description.type === 'offer' && !rejected) {
        transceiver = pc.transceivers[sdpMLineIndex] ||
            pc._createTransceiver(kind);
        transceiver.mid = mid;

        if (!transceiver.iceGatherer) {
          transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex,
              usingBundle);
        }

        if (cands.length && transceiver.iceTransport.state === 'new') {
          if (isComplete && (!usingBundle || sdpMLineIndex === 0)) {
            transceiver.iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function(candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        localCapabilities = window.RTCRtpReceiver.getCapabilities(kind);

        // filter RTX until additional stuff needed for RTX is implemented
        // in adapter.js
        if (edgeVersion < 15019) {
          localCapabilities.codecs = localCapabilities.codecs.filter(
              function(codec) {
                return codec.name !== 'rtx';
              });
        }

        sendEncodingParameters = transceiver.sendEncodingParameters || [{
          ssrc: (2 * sdpMLineIndex + 2) * 1001
        }];

        // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
        var isNewTrack = false;
        if (direction === 'sendrecv' || direction === 'sendonly') {
          isNewTrack = !transceiver.rtpReceiver;
          rtpReceiver = transceiver.rtpReceiver ||
              new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);

          if (isNewTrack) {
            var stream;
            track = rtpReceiver.track;
            // FIXME: does not work with Plan B.
            if (remoteMsid && remoteMsid.stream === '-') {
              // no-op. a stream id of '-' means: no associated stream.
            } else if (remoteMsid) {
              if (!streams[remoteMsid.stream]) {
                streams[remoteMsid.stream] = new window.MediaStream();
                Object.defineProperty(streams[remoteMsid.stream], 'id', {
                  get: function() {
                    return remoteMsid.stream;
                  }
                });
              }
              Object.defineProperty(track, 'id', {
                get: function() {
                  return remoteMsid.track;
                }
              });
              stream = streams[remoteMsid.stream];
            } else {
              if (!streams.default) {
                streams.default = new window.MediaStream();
              }
              stream = streams.default;
            }
            if (stream) {
              addTrackToStreamAndFireEvent(track, stream);
              transceiver.associatedRemoteMediaStreams.push(stream);
            }
            receiverList.push([track, rtpReceiver, stream]);
          }
        } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
          transceiver.associatedRemoteMediaStreams.forEach(function(s) {
            var nativeTrack = s.getTracks().find(function(t) {
              return t.id === transceiver.rtpReceiver.track.id;
            });
            if (nativeTrack) {
              removeTrackFromStreamAndFireEvent(nativeTrack, s);
            }
          });
          transceiver.associatedRemoteMediaStreams = [];
        }

        transceiver.localCapabilities = localCapabilities;
        transceiver.remoteCapabilities = remoteCapabilities;
        transceiver.rtpReceiver = rtpReceiver;
        transceiver.rtcpParameters = rtcpParameters;
        transceiver.sendEncodingParameters = sendEncodingParameters;
        transceiver.recvEncodingParameters = recvEncodingParameters;

        // Start the RTCRtpReceiver now. The RTPSender is started in
        // setLocalDescription.
        pc._transceive(pc.transceivers[sdpMLineIndex],
            false,
            isNewTrack);
      } else if (description.type === 'answer' && !rejected) {
        transceiver = pc.transceivers[sdpMLineIndex];
        iceGatherer = transceiver.iceGatherer;
        iceTransport = transceiver.iceTransport;
        dtlsTransport = transceiver.dtlsTransport;
        rtpReceiver = transceiver.rtpReceiver;
        sendEncodingParameters = transceiver.sendEncodingParameters;
        localCapabilities = transceiver.localCapabilities;

        pc.transceivers[sdpMLineIndex].recvEncodingParameters =
            recvEncodingParameters;
        pc.transceivers[sdpMLineIndex].remoteCapabilities =
            remoteCapabilities;
        pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;

        if (cands.length && iceTransport.state === 'new') {
          if ((isIceLite || isComplete) &&
              (!usingBundle || sdpMLineIndex === 0)) {
            iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function(candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        if (!usingBundle || sdpMLineIndex === 0) {
          if (iceTransport.state === 'new') {
            iceTransport.start(iceGatherer, remoteIceParameters,
                'controlling');
          }
          if (dtlsTransport.state === 'new') {
            dtlsTransport.start(remoteDtlsParameters);
          }
        }

        // If the offer contained RTX but the answer did not,
        // remove RTX from sendEncodingParameters.
        var commonCapabilities = getCommonCapabilities(
          transceiver.localCapabilities,
          transceiver.remoteCapabilities);

        var hasRtx = commonCapabilities.codecs.filter(function(c) {
          return c.name.toLowerCase() === 'rtx';
        }).length;
        if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
          delete transceiver.sendEncodingParameters[0].rtx;
        }

        pc._transceive(transceiver,
            direction === 'sendrecv' || direction === 'recvonly',
            direction === 'sendrecv' || direction === 'sendonly');

        // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
        if (rtpReceiver &&
            (direction === 'sendrecv' || direction === 'sendonly')) {
          track = rtpReceiver.track;
          if (remoteMsid) {
            if (!streams[remoteMsid.stream]) {
              streams[remoteMsid.stream] = new window.MediaStream();
            }
            addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
            receiverList.push([track, rtpReceiver, streams[remoteMsid.stream]]);
          } else {
            if (!streams.default) {
              streams.default = new window.MediaStream();
            }
            addTrackToStreamAndFireEvent(track, streams.default);
            receiverList.push([track, rtpReceiver, streams.default]);
          }
        } else {
          // FIXME: actually the receiver should be created later.
          delete transceiver.rtpReceiver;
        }
      }
    });

    if (pc._dtlsRole === undefined) {
      pc._dtlsRole = description.type === 'offer' ? 'active' : 'passive';
    }

    pc._remoteDescription = {
      type: description.type,
      sdp: description.sdp
    };
    if (description.type === 'offer') {
      pc._updateSignalingState('have-remote-offer');
    } else {
      pc._updateSignalingState('stable');
    }
    Object.keys(streams).forEach(function(sid) {
      var stream = streams[sid];
      if (stream.getTracks().length) {
        if (pc.remoteStreams.indexOf(stream) === -1) {
          pc.remoteStreams.push(stream);
          var event = new Event('addstream');
          event.stream = stream;
          window.setTimeout(function() {
            pc._dispatchEvent('addstream', event);
          });
        }

        receiverList.forEach(function(item) {
          var track = item[0];
          var receiver = item[1];
          if (stream.id !== item[2].id) {
            return;
          }
          fireAddTrack(pc, track, receiver, [stream]);
        });
      }
    });
    receiverList.forEach(function(item) {
      if (item[2]) {
        return;
      }
      fireAddTrack(pc, item[0], item[1], []);
    });

    // check whether addIceCandidate({}) was called within four seconds after
    // setRemoteDescription.
    window.setTimeout(function() {
      if (!(pc && pc.transceivers)) {
        return;
      }
      pc.transceivers.forEach(function(transceiver) {
        if (transceiver.iceTransport &&
            transceiver.iceTransport.state === 'new' &&
            transceiver.iceTransport.getRemoteCandidates().length > 0) {
          console.warn('Timeout for addRemoteCandidate. Consider sending ' +
              'an end-of-candidates notification');
          transceiver.iceTransport.addRemoteCandidate({});
        }
      });
    }, 4000);

    return Promise.resolve();
  };

  RTCPeerConnection.prototype.close = function() {
    this.transceivers.forEach(function(transceiver) {
      /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */
      if (transceiver.iceTransport) {
        transceiver.iceTransport.stop();
      }
      if (transceiver.dtlsTransport) {
        transceiver.dtlsTransport.stop();
      }
      if (transceiver.rtpSender) {
        transceiver.rtpSender.stop();
      }
      if (transceiver.rtpReceiver) {
        transceiver.rtpReceiver.stop();
      }
    });
    // FIXME: clean up tracks, local streams, remote streams, etc
    this._isClosed = true;
    this._updateSignalingState('closed');
  };

  // Update the signaling state.
  RTCPeerConnection.prototype._updateSignalingState = function(newState) {
    this.signalingState = newState;
    var event = new Event('signalingstatechange');
    this._dispatchEvent('signalingstatechange', event);
  };

  // Determine whether to fire the negotiationneeded event.
  RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
    var pc = this;
    if (this.signalingState !== 'stable' || this.needNegotiation === true) {
      return;
    }
    this.needNegotiation = true;
    window.setTimeout(function() {
      if (pc.needNegotiation) {
        pc.needNegotiation = false;
        var event = new Event('negotiationneeded');
        pc._dispatchEvent('negotiationneeded', event);
      }
    }, 0);
  };

  // Update the ice connection state.
  RTCPeerConnection.prototype._updateIceConnectionState = function() {
    var newState;
    var states = {
      'new': 0,
      closed: 0,
      checking: 0,
      connected: 0,
      completed: 0,
      disconnected: 0,
      failed: 0
    };
    this.transceivers.forEach(function(transceiver) {
      if (transceiver.iceTransport && !transceiver.rejected) {
        states[transceiver.iceTransport.state]++;
      }
    });

    newState = 'new';
    if (states.failed > 0) {
      newState = 'failed';
    } else if (states.checking > 0) {
      newState = 'checking';
    } else if (states.disconnected > 0) {
      newState = 'disconnected';
    } else if (states.new > 0) {
      newState = 'new';
    } else if (states.connected > 0) {
      newState = 'connected';
    } else if (states.completed > 0) {
      newState = 'completed';
    }

    if (newState !== this.iceConnectionState) {
      this.iceConnectionState = newState;
      var event = new Event('iceconnectionstatechange');
      this._dispatchEvent('iceconnectionstatechange', event);
    }
  };

  // Update the connection state.
  RTCPeerConnection.prototype._updateConnectionState = function() {
    var newState;
    var states = {
      'new': 0,
      closed: 0,
      connecting: 0,
      connected: 0,
      completed: 0,
      disconnected: 0,
      failed: 0
    };
    this.transceivers.forEach(function(transceiver) {
      if (transceiver.iceTransport && transceiver.dtlsTransport &&
          !transceiver.rejected) {
        states[transceiver.iceTransport.state]++;
        states[transceiver.dtlsTransport.state]++;
      }
    });
    // ICETransport.completed and connected are the same for this purpose.
    states.connected += states.completed;

    newState = 'new';
    if (states.failed > 0) {
      newState = 'failed';
    } else if (states.connecting > 0) {
      newState = 'connecting';
    } else if (states.disconnected > 0) {
      newState = 'disconnected';
    } else if (states.new > 0) {
      newState = 'new';
    } else if (states.connected > 0) {
      newState = 'connected';
    }

    if (newState !== this.connectionState) {
      this.connectionState = newState;
      var event = new Event('connectionstatechange');
      this._dispatchEvent('connectionstatechange', event);
    }
  };

  RTCPeerConnection.prototype.createOffer = function() {
    var pc = this;

    if (pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not call createOffer after close'));
    }

    var numAudioTracks = pc.transceivers.filter(function(t) {
      return t.kind === 'audio';
    }).length;
    var numVideoTracks = pc.transceivers.filter(function(t) {
      return t.kind === 'video';
    }).length;

    // Determine number of audio and video tracks we need to send/recv.
    var offerOptions = arguments[0];
    if (offerOptions) {
      // Reject Chrome legacy constraints.
      if (offerOptions.mandatory || offerOptions.optional) {
        throw new TypeError(
            'Legacy mandatory/optional constraints not supported.');
      }
      if (offerOptions.offerToReceiveAudio !== undefined) {
        if (offerOptions.offerToReceiveAudio === true) {
          numAudioTracks = 1;
        } else if (offerOptions.offerToReceiveAudio === false) {
          numAudioTracks = 0;
        } else {
          numAudioTracks = offerOptions.offerToReceiveAudio;
        }
      }
      if (offerOptions.offerToReceiveVideo !== undefined) {
        if (offerOptions.offerToReceiveVideo === true) {
          numVideoTracks = 1;
        } else if (offerOptions.offerToReceiveVideo === false) {
          numVideoTracks = 0;
        } else {
          numVideoTracks = offerOptions.offerToReceiveVideo;
        }
      }
    }

    pc.transceivers.forEach(function(transceiver) {
      if (transceiver.kind === 'audio') {
        numAudioTracks--;
        if (numAudioTracks < 0) {
          transceiver.wantReceive = false;
        }
      } else if (transceiver.kind === 'video') {
        numVideoTracks--;
        if (numVideoTracks < 0) {
          transceiver.wantReceive = false;
        }
      }
    });

    // Create M-lines for recvonly streams.
    while (numAudioTracks > 0 || numVideoTracks > 0) {
      if (numAudioTracks > 0) {
        pc._createTransceiver('audio');
        numAudioTracks--;
      }
      if (numVideoTracks > 0) {
        pc._createTransceiver('video');
        numVideoTracks--;
      }
    }

    var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId,
        pc._sdpSessionVersion++);
    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      // For each track, create an ice gatherer, ice transport,
      // dtls transport, potentially rtpsender and rtpreceiver.
      var track = transceiver.track;
      var kind = transceiver.kind;
      var mid = transceiver.mid || SDPUtils.generateIdentifier();
      transceiver.mid = mid;

      if (!transceiver.iceGatherer) {
        transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex,
            pc.usingBundle);
      }

      var localCapabilities = window.RTCRtpSender.getCapabilities(kind);
      // filter RTX until additional stuff needed for RTX is implemented
      // in adapter.js
      if (edgeVersion < 15019) {
        localCapabilities.codecs = localCapabilities.codecs.filter(
            function(codec) {
              return codec.name !== 'rtx';
            });
      }
      localCapabilities.codecs.forEach(function(codec) {
        // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
        // by adding level-asymmetry-allowed=1
        if (codec.name === 'H264' &&
            codec.parameters['level-asymmetry-allowed'] === undefined) {
          codec.parameters['level-asymmetry-allowed'] = '1';
        }

        // for subsequent offers, we might have to re-use the payload
        // type of the last offer.
        if (transceiver.remoteCapabilities &&
            transceiver.remoteCapabilities.codecs) {
          transceiver.remoteCapabilities.codecs.forEach(function(remoteCodec) {
            if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() &&
                codec.clockRate === remoteCodec.clockRate) {
              codec.preferredPayloadType = remoteCodec.payloadType;
            }
          });
        }
      });
      localCapabilities.headerExtensions.forEach(function(hdrExt) {
        var remoteExtensions = transceiver.remoteCapabilities &&
            transceiver.remoteCapabilities.headerExtensions || [];
        remoteExtensions.forEach(function(rHdrExt) {
          if (hdrExt.uri === rHdrExt.uri) {
            hdrExt.id = rHdrExt.id;
          }
        });
      });

      // generate an ssrc now, to be used later in rtpSender.send
      var sendEncodingParameters = transceiver.sendEncodingParameters || [{
        ssrc: (2 * sdpMLineIndex + 1) * 1001
      }];
      if (track) {
        // add RTX
        if (edgeVersion >= 15019 && kind === 'video' &&
            !sendEncodingParameters[0].rtx) {
          sendEncodingParameters[0].rtx = {
            ssrc: sendEncodingParameters[0].ssrc + 1
          };
        }
      }

      if (transceiver.wantReceive) {
        transceiver.rtpReceiver = new window.RTCRtpReceiver(
            transceiver.dtlsTransport, kind);
      }

      transceiver.localCapabilities = localCapabilities;
      transceiver.sendEncodingParameters = sendEncodingParameters;
    });

    // always offer BUNDLE and dispose on return if not supported.
    if (pc._config.bundlePolicy !== 'max-compat') {
      sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }
    sdp += 'a=ice-options:trickle\r\n';

    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      sdp += writeMediaSection(transceiver, transceiver.localCapabilities,
          'offer', transceiver.stream, pc._dtlsRole);
      sdp += 'a=rtcp-rsize\r\n';

      if (transceiver.iceGatherer && pc.iceGatheringState !== 'new' &&
          (sdpMLineIndex === 0 || !pc.usingBundle)) {
        transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
          cand.component = 1;
          sdp += 'a=' + SDPUtils.writeCandidate(cand) + '\r\n';
        });

        if (transceiver.iceGatherer.state === 'completed') {
          sdp += 'a=end-of-candidates\r\n';
        }
      }
    });

    var desc = new window.RTCSessionDescription({
      type: 'offer',
      sdp: sdp
    });
    return Promise.resolve(desc);
  };

  RTCPeerConnection.prototype.createAnswer = function() {
    var pc = this;

    if (pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not call createAnswer after close'));
    }

    if (!(pc.signalingState === 'have-remote-offer' ||
        pc.signalingState === 'have-local-pranswer')) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not call createAnswer in signalingState ' + pc.signalingState));
    }

    var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId,
        pc._sdpSessionVersion++);
    if (pc.usingBundle) {
      sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }
    sdp += 'a=ice-options:trickle\r\n';

    var mediaSectionsInOffer = SDPUtils.getMediaSections(
        pc._remoteDescription.sdp).length;
    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      if (sdpMLineIndex + 1 > mediaSectionsInOffer) {
        return;
      }
      if (transceiver.rejected) {
        if (transceiver.kind === 'application') {
          if (transceiver.protocol === 'DTLS/SCTP') { // legacy fmt
            sdp += 'm=application 0 DTLS/SCTP 5000\r\n';
          } else {
            sdp += 'm=application 0 ' + transceiver.protocol +
                ' webrtc-datachannel\r\n';
          }
        } else if (transceiver.kind === 'audio') {
          sdp += 'm=audio 0 UDP/TLS/RTP/SAVPF 0\r\n' +
              'a=rtpmap:0 PCMU/8000\r\n';
        } else if (transceiver.kind === 'video') {
          sdp += 'm=video 0 UDP/TLS/RTP/SAVPF 120\r\n' +
              'a=rtpmap:120 VP8/90000\r\n';
        }
        sdp += 'c=IN IP4 0.0.0.0\r\n' +
            'a=inactive\r\n' +
            'a=mid:' + transceiver.mid + '\r\n';
        return;
      }

      // FIXME: look at direction.
      if (transceiver.stream) {
        var localTrack;
        if (transceiver.kind === 'audio') {
          localTrack = transceiver.stream.getAudioTracks()[0];
        } else if (transceiver.kind === 'video') {
          localTrack = transceiver.stream.getVideoTracks()[0];
        }
        if (localTrack) {
          // add RTX
          if (edgeVersion >= 15019 && transceiver.kind === 'video' &&
              !transceiver.sendEncodingParameters[0].rtx) {
            transceiver.sendEncodingParameters[0].rtx = {
              ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
            };
          }
        }
      }

      // Calculate intersection of capabilities.
      var commonCapabilities = getCommonCapabilities(
          transceiver.localCapabilities,
          transceiver.remoteCapabilities);

      var hasRtx = commonCapabilities.codecs.filter(function(c) {
        return c.name.toLowerCase() === 'rtx';
      }).length;
      if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
        delete transceiver.sendEncodingParameters[0].rtx;
      }

      sdp += writeMediaSection(transceiver, commonCapabilities,
          'answer', transceiver.stream, pc._dtlsRole);
      if (transceiver.rtcpParameters &&
          transceiver.rtcpParameters.reducedSize) {
        sdp += 'a=rtcp-rsize\r\n';
      }
    });

    var desc = new window.RTCSessionDescription({
      type: 'answer',
      sdp: sdp
    });
    return Promise.resolve(desc);
  };

  RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
    var pc = this;
    var sections;
    if (candidate && !(candidate.sdpMLineIndex !== undefined ||
        candidate.sdpMid)) {
      return Promise.reject(new TypeError('sdpMLineIndex or sdpMid required'));
    }

    // TODO: needs to go into ops queue.
    return new Promise(function(resolve, reject) {
      if (!pc._remoteDescription) {
        return reject(makeError('InvalidStateError',
            'Can not add ICE candidate without a remote description'));
      } else if (!candidate || candidate.candidate === '') {
        for (var j = 0; j < pc.transceivers.length; j++) {
          if (pc.transceivers[j].rejected) {
            continue;
          }
          pc.transceivers[j].iceTransport.addRemoteCandidate({});
          sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
          sections[j] += 'a=end-of-candidates\r\n';
          pc._remoteDescription.sdp =
              SDPUtils.getDescription(pc._remoteDescription.sdp) +
              sections.join('');
          if (pc.usingBundle) {
            break;
          }
        }
      } else {
        var sdpMLineIndex = candidate.sdpMLineIndex;
        if (candidate.sdpMid) {
          for (var i = 0; i < pc.transceivers.length; i++) {
            if (pc.transceivers[i].mid === candidate.sdpMid) {
              sdpMLineIndex = i;
              break;
            }
          }
        }
        var transceiver = pc.transceivers[sdpMLineIndex];
        if (transceiver) {
          if (transceiver.rejected) {
            return resolve();
          }
          var cand = Object.keys(candidate.candidate).length > 0 ?
              SDPUtils.parseCandidate(candidate.candidate) : {};
          // Ignore Chrome's invalid candidates since Edge does not like them.
          if (cand.protocol === 'tcp' && (cand.port === 0 || cand.port === 9)) {
            return resolve();
          }
          // Ignore RTCP candidates, we assume RTCP-MUX.
          if (cand.component && cand.component !== 1) {
            return resolve();
          }
          // when using bundle, avoid adding candidates to the wrong
          // ice transport. And avoid adding candidates added in the SDP.
          if (sdpMLineIndex === 0 || (sdpMLineIndex > 0 &&
              transceiver.iceTransport !== pc.transceivers[0].iceTransport)) {
            if (!maybeAddCandidate(transceiver.iceTransport, cand)) {
              return reject(makeError('OperationError',
                  'Can not add ICE candidate'));
            }
          }

          // update the remoteDescription.
          var candidateString = candidate.candidate.trim();
          if (candidateString.indexOf('a=') === 0) {
            candidateString = candidateString.substr(2);
          }
          sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
          sections[sdpMLineIndex] += 'a=' +
              (cand.type ? candidateString : 'end-of-candidates')
              + '\r\n';
          pc._remoteDescription.sdp =
              SDPUtils.getDescription(pc._remoteDescription.sdp) +
              sections.join('');
        } else {
          return reject(makeError('OperationError',
              'Can not add ICE candidate'));
        }
      }
      resolve();
    });
  };

  RTCPeerConnection.prototype.getStats = function(selector) {
    if (selector && selector instanceof window.MediaStreamTrack) {
      var senderOrReceiver = null;
      this.transceivers.forEach(function(transceiver) {
        if (transceiver.rtpSender &&
            transceiver.rtpSender.track === selector) {
          senderOrReceiver = transceiver.rtpSender;
        } else if (transceiver.rtpReceiver &&
            transceiver.rtpReceiver.track === selector) {
          senderOrReceiver = transceiver.rtpReceiver;
        }
      });
      if (!senderOrReceiver) {
        throw makeError('InvalidAccessError', 'Invalid selector.');
      }
      return senderOrReceiver.getStats();
    }

    var promises = [];
    this.transceivers.forEach(function(transceiver) {
      ['rtpSender', 'rtpReceiver', 'iceGatherer', 'iceTransport',
          'dtlsTransport'].forEach(function(method) {
            if (transceiver[method]) {
              promises.push(transceiver[method].getStats());
            }
          });
    });
    return Promise.all(promises).then(function(allStats) {
      var results = new Map();
      allStats.forEach(function(stats) {
        stats.forEach(function(stat) {
          results.set(stat.id, stat);
        });
      });
      return results;
    });
  };

  // fix low-level stat names and return Map instead of object.
  var ortcObjects = ['RTCRtpSender', 'RTCRtpReceiver', 'RTCIceGatherer',
    'RTCIceTransport', 'RTCDtlsTransport'];
  ortcObjects.forEach(function(ortcObjectName) {
    var obj = window[ortcObjectName];
    if (obj && obj.prototype && obj.prototype.getStats) {
      var nativeGetstats = obj.prototype.getStats;
      obj.prototype.getStats = function() {
        return nativeGetstats.apply(this)
        .then(function(nativeStats) {
          var mapStats = new Map();
          Object.keys(nativeStats).forEach(function(id) {
            nativeStats[id].type = fixStatsType(nativeStats[id]);
            mapStats.set(id, nativeStats[id]);
          });
          return mapStats;
        });
      };
    }
  });

  // legacy callback shims. Should be moved to adapter.js some days.
  var methods = ['createOffer', 'createAnswer'];
  methods.forEach(function(method) {
    var nativeMethod = RTCPeerConnection.prototype[method];
    RTCPeerConnection.prototype[method] = function() {
      var args = arguments;
      if (typeof args[0] === 'function' ||
          typeof args[1] === 'function') { // legacy
        return nativeMethod.apply(this, [arguments[2]])
        .then(function(description) {
          if (typeof args[0] === 'function') {
            args[0].apply(null, [description]);
          }
        }, function(error) {
          if (typeof args[1] === 'function') {
            args[1].apply(null, [error]);
          }
        });
      }
      return nativeMethod.apply(this, arguments);
    };
  });

  methods = ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'];
  methods.forEach(function(method) {
    var nativeMethod = RTCPeerConnection.prototype[method];
    RTCPeerConnection.prototype[method] = function() {
      var args = arguments;
      if (typeof args[1] === 'function' ||
          typeof args[2] === 'function') { // legacy
        return nativeMethod.apply(this, arguments)
        .then(function() {
          if (typeof args[1] === 'function') {
            args[1].apply(null);
          }
        }, function(error) {
          if (typeof args[2] === 'function') {
            args[2].apply(null, [error]);
          }
        });
      }
      return nativeMethod.apply(this, arguments);
    };
  });

  // getStats is special. It doesn't have a spec legacy method yet we support
  // getStats(something, cb) without error callbacks.
  ['getStats'].forEach(function(method) {
    var nativeMethod = RTCPeerConnection.prototype[method];
    RTCPeerConnection.prototype[method] = function() {
      var args = arguments;
      if (typeof args[1] === 'function') {
        return nativeMethod.apply(this, arguments)
        .then(function() {
          if (typeof args[1] === 'function') {
            args[1].apply(null);
          }
        });
      }
      return nativeMethod.apply(this, arguments);
    };
  });

  return RTCPeerConnection;
};

},{"sdp":17}],17:[function(require,module,exports){
 /* eslint-env node */
'use strict';

// SDP helpers.
var SDPUtils = {};

// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
SDPUtils.generateIdentifier = function() {
  return Math.random().toString(36).substr(2, 10);
};

// The RTCP CNAME used by all peerconnections from the same JS.
SDPUtils.localCName = SDPUtils.generateIdentifier();

// Splits SDP into lines, dealing with both CRLF and LF.
SDPUtils.splitLines = function(blob) {
  return blob.trim().split('\n').map(function(line) {
    return line.trim();
  });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
SDPUtils.splitSections = function(blob) {
  var parts = blob.split('\nm=');
  return parts.map(function(part, index) {
    return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
  });
};

// returns the session description.
SDPUtils.getDescription = function(blob) {
  var sections = SDPUtils.splitSections(blob);
  return sections && sections[0];
};

// returns the individual media sections.
SDPUtils.getMediaSections = function(blob) {
  var sections = SDPUtils.splitSections(blob);
  sections.shift();
  return sections;
};

// Returns lines that start with a certain prefix.
SDPUtils.matchPrefix = function(blob, prefix) {
  return SDPUtils.splitLines(blob).filter(function(line) {
    return line.indexOf(prefix) === 0;
  });
};

// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
SDPUtils.parseCandidate = function(line) {
  var parts;
  // Parse both variants.
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }

  var candidate = {
    foundation: parts[0],
    component: parseInt(parts[1], 10),
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    address: parts[4], // address is an alias for ip.
    port: parseInt(parts[5], 10),
    // skip parts[6] == 'typ'
    type: parts[7]
  };

  for (var i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;
      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;
      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;
      case 'ufrag':
        candidate.ufrag = parts[i + 1]; // for backward compability.
        candidate.usernameFragment = parts[i + 1];
        break;
      default: // extension handling, in particular ufrag
        candidate[parts[i]] = parts[i + 1];
        break;
    }
  }
  return candidate;
};

// Translates a candidate object into SDP candidate attribute.
SDPUtils.writeCandidate = function(candidate) {
  var sdp = [];
  sdp.push(candidate.foundation);
  sdp.push(candidate.component);
  sdp.push(candidate.protocol.toUpperCase());
  sdp.push(candidate.priority);
  sdp.push(candidate.address || candidate.ip);
  sdp.push(candidate.port);

  var type = candidate.type;
  sdp.push('typ');
  sdp.push(type);
  if (type !== 'host' && candidate.relatedAddress &&
      candidate.relatedPort) {
    sdp.push('raddr');
    sdp.push(candidate.relatedAddress);
    sdp.push('rport');
    sdp.push(candidate.relatedPort);
  }
  if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
    sdp.push('tcptype');
    sdp.push(candidate.tcpType);
  }
  if (candidate.usernameFragment || candidate.ufrag) {
    sdp.push('ufrag');
    sdp.push(candidate.usernameFragment || candidate.ufrag);
  }
  return 'candidate:' + sdp.join(' ');
};

// Parses an ice-options line, returns an array of option tags.
// a=ice-options:foo bar
SDPUtils.parseIceOptions = function(line) {
  return line.substr(14).split(' ');
};

// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
SDPUtils.parseRtpMap = function(line) {
  var parts = line.substr(9).split(' ');
  var parsed = {
    payloadType: parseInt(parts.shift(), 10) // was: id
  };

  parts = parts[0].split('/');

  parsed.name = parts[0];
  parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
  parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
  // legacy alias, got renamed back to channels in ORTC.
  parsed.numChannels = parsed.channels;
  return parsed;
};

// Generate an a=rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
SDPUtils.writeRtpMap = function(codec) {
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  var channels = codec.channels || codec.numChannels || 1;
  return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate +
      (channels !== 1 ? '/' + channels : '') + '\r\n';
};

// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
SDPUtils.parseExtmap = function(line) {
  var parts = line.substr(9).split(' ');
  return {
    id: parseInt(parts[0], 10),
    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
    uri: parts[1]
  };
};

// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
SDPUtils.writeExtmap = function(headerExtension) {
  return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) +
      (headerExtension.direction && headerExtension.direction !== 'sendrecv'
          ? '/' + headerExtension.direction
          : '') +
      ' ' + headerExtension.uri + '\r\n';
};

// Parses an ftmp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
SDPUtils.parseFmtp = function(line) {
  var parsed = {};
  var kv;
  var parts = line.substr(line.indexOf(' ') + 1).split(';');
  for (var j = 0; j < parts.length; j++) {
    kv = parts[j].trim().split('=');
    parsed[kv[0].trim()] = kv[1];
  }
  return parsed;
};

// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeFmtp = function(codec) {
  var line = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.parameters && Object.keys(codec.parameters).length) {
    var params = [];
    Object.keys(codec.parameters).forEach(function(param) {
      if (codec.parameters[param]) {
        params.push(param + '=' + codec.parameters[param]);
      } else {
        params.push(param);
      }
    });
    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
  }
  return line;
};

// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
SDPUtils.parseRtcpFb = function(line) {
  var parts = line.substr(line.indexOf(' ') + 1).split(' ');
  return {
    type: parts.shift(),
    parameter: parts.join(' ')
  };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeRtcpFb = function(codec) {
  var lines = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
    // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function(fb) {
      lines += 'a=rtcp-fb:' + pt + ' ' + fb.type +
      (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') +
          '\r\n';
    });
  }
  return lines;
};

// Parses an RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
SDPUtils.parseSsrcMedia = function(line) {
  var sp = line.indexOf(' ');
  var parts = {
    ssrc: parseInt(line.substr(7, sp - 7), 10)
  };
  var colon = line.indexOf(':', sp);
  if (colon > -1) {
    parts.attribute = line.substr(sp + 1, colon - sp - 1);
    parts.value = line.substr(colon + 1);
  } else {
    parts.attribute = line.substr(sp + 1);
  }
  return parts;
};

SDPUtils.parseSsrcGroup = function(line) {
  var parts = line.substr(13).split(' ');
  return {
    semantics: parts.shift(),
    ssrcs: parts.map(function(ssrc) {
      return parseInt(ssrc, 10);
    })
  };
};

// Extracts the MID (RFC 5888) from a media section.
// returns the MID or undefined if no mid line was found.
SDPUtils.getMid = function(mediaSection) {
  var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
  if (mid) {
    return mid.substr(6);
  }
};

SDPUtils.parseFingerprint = function(line) {
  var parts = line.substr(14).split(' ');
  return {
    algorithm: parts[0].toLowerCase(), // algorithm is case-sensitive in Edge.
    value: parts[1]
  };
};

// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
      'a=fingerprint:');
  // Note: a=setup line is ignored since we use the 'auto' role.
  // Note2: 'algorithm' is not case sensitive except in Edge.
  return {
    role: 'auto',
    fingerprints: lines.map(SDPUtils.parseFingerprint)
  };
};

// Serializes DTLS parameters to SDP.
SDPUtils.writeDtlsParameters = function(params, setupType) {
  var sdp = 'a=setup:' + setupType + '\r\n';
  params.fingerprints.forEach(function(fp) {
    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
  });
  return sdp;
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.splitLines(mediaSection);
  // Search in session part, too.
  lines = lines.concat(SDPUtils.splitLines(sessionpart));
  var iceParameters = {
    usernameFragment: lines.filter(function(line) {
      return line.indexOf('a=ice-ufrag:') === 0;
    })[0].substr(12),
    password: lines.filter(function(line) {
      return line.indexOf('a=ice-pwd:') === 0;
    })[0].substr(10)
  };
  return iceParameters;
};

// Serializes ICE parameters to SDP.
SDPUtils.writeIceParameters = function(params) {
  return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' +
      'a=ice-pwd:' + params.password + '\r\n';
};

// Parses the SDP media section and returns RTCRtpParameters.
SDPUtils.parseRtpParameters = function(mediaSection) {
  var description = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: [],
    rtcp: []
  };
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  for (var i = 3; i < mline.length; i++) { // find all codecs from mline[3..]
    var pt = mline[i];
    var rtpmapline = SDPUtils.matchPrefix(
        mediaSection, 'a=rtpmap:' + pt + ' ')[0];
    if (rtpmapline) {
      var codec = SDPUtils.parseRtpMap(rtpmapline);
      var fmtps = SDPUtils.matchPrefix(
          mediaSection, 'a=fmtp:' + pt + ' ');
      // Only the first a=fmtp:<pt> is considered.
      codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
      codec.rtcpFeedback = SDPUtils.matchPrefix(
          mediaSection, 'a=rtcp-fb:' + pt + ' ')
        .map(SDPUtils.parseRtcpFb);
      description.codecs.push(codec);
      // parse FEC mechanisms from rtpmap lines.
      switch (codec.name.toUpperCase()) {
        case 'RED':
        case 'ULPFEC':
          description.fecMechanisms.push(codec.name.toUpperCase());
          break;
        default: // only RED and ULPFEC are recognized as FEC mechanisms.
          break;
      }
    }
  }
  SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function(line) {
    description.headerExtensions.push(SDPUtils.parseExtmap(line));
  });
  // FIXME: parse rtcp.
  return description;
};

// Generates parts of the SDP media section describing the capabilities /
// parameters.
SDPUtils.writeRtpDescription = function(kind, caps) {
  var sdp = '';

  // Build the mline.
  sdp += 'm=' + kind + ' ';
  sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
  sdp += ' UDP/TLS/RTP/SAVPF ';
  sdp += caps.codecs.map(function(codec) {
    if (codec.preferredPayloadType !== undefined) {
      return codec.preferredPayloadType;
    }
    return codec.payloadType;
  }).join(' ') + '\r\n';

  sdp += 'c=IN IP4 0.0.0.0\r\n';
  sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';

  // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
  caps.codecs.forEach(function(codec) {
    sdp += SDPUtils.writeRtpMap(codec);
    sdp += SDPUtils.writeFmtp(codec);
    sdp += SDPUtils.writeRtcpFb(codec);
  });
  var maxptime = 0;
  caps.codecs.forEach(function(codec) {
    if (codec.maxptime > maxptime) {
      maxptime = codec.maxptime;
    }
  });
  if (maxptime > 0) {
    sdp += 'a=maxptime:' + maxptime + '\r\n';
  }
  sdp += 'a=rtcp-mux\r\n';

  if (caps.headerExtensions) {
    caps.headerExtensions.forEach(function(extension) {
      sdp += SDPUtils.writeExtmap(extension);
    });
  }
  // FIXME: write fecMechanisms.
  return sdp;
};

// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
  var encodingParameters = [];
  var description = SDPUtils.parseRtpParameters(mediaSection);
  var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
  var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;

  // filter a=ssrc:... cname:, ignore PlanB-msid
  var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
  .map(function(line) {
    return SDPUtils.parseSsrcMedia(line);
  })
  .filter(function(parts) {
    return parts.attribute === 'cname';
  });
  var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
  var secondarySsrc;

  var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID')
  .map(function(line) {
    var parts = line.substr(17).split(' ');
    return parts.map(function(part) {
      return parseInt(part, 10);
    });
  });
  if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
    secondarySsrc = flows[0][1];
  }

  description.codecs.forEach(function(codec) {
    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
      var encParam = {
        ssrc: primarySsrc,
        codecPayloadType: parseInt(codec.parameters.apt, 10)
      };
      if (primarySsrc && secondarySsrc) {
        encParam.rtx = {ssrc: secondarySsrc};
      }
      encodingParameters.push(encParam);
      if (hasRed) {
        encParam = JSON.parse(JSON.stringify(encParam));
        encParam.fec = {
          ssrc: primarySsrc,
          mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
        };
        encodingParameters.push(encParam);
      }
    }
  });
  if (encodingParameters.length === 0 && primarySsrc) {
    encodingParameters.push({
      ssrc: primarySsrc
    });
  }

  // we support both b=AS and b=TIAS but interpret AS as TIAS.
  var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
  if (bandwidth.length) {
    if (bandwidth[0].indexOf('b=TIAS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(7), 10);
    } else if (bandwidth[0].indexOf('b=AS:') === 0) {
      // use formula from JSEP to convert b=AS to TIAS value.
      bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95
          - (50 * 40 * 8);
    } else {
      bandwidth = undefined;
    }
    encodingParameters.forEach(function(params) {
      params.maxBitrate = bandwidth;
    });
  }
  return encodingParameters;
};

// parses http://draft.ortc.org/#rtcrtcpparameters*
SDPUtils.parseRtcpParameters = function(mediaSection) {
  var rtcpParameters = {};

  // Gets the first SSRC. Note tha with RTX there might be multiple
  // SSRCs.
  var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
      .map(function(line) {
        return SDPUtils.parseSsrcMedia(line);
      })
      .filter(function(obj) {
        return obj.attribute === 'cname';
      })[0];
  if (remoteSsrc) {
    rtcpParameters.cname = remoteSsrc.value;
    rtcpParameters.ssrc = remoteSsrc.ssrc;
  }

  // Edge uses the compound attribute instead of reducedSize
  // compound is !reducedSize
  var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
  rtcpParameters.reducedSize = rsize.length > 0;
  rtcpParameters.compound = rsize.length === 0;

  // parses the rtcp-mux attrіbute.
  // Note that Edge does not support unmuxed RTCP.
  var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
  rtcpParameters.mux = mux.length > 0;

  return rtcpParameters;
};

// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
SDPUtils.parseMsid = function(mediaSection) {
  var parts;
  var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
  if (spec.length === 1) {
    parts = spec[0].substr(7).split(' ');
    return {stream: parts[0], track: parts[1]};
  }
  var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
  .map(function(line) {
    return SDPUtils.parseSsrcMedia(line);
  })
  .filter(function(msidParts) {
    return msidParts.attribute === 'msid';
  });
  if (planB.length > 0) {
    parts = planB[0].value.split(' ');
    return {stream: parts[0], track: parts[1]};
  }
};

// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
SDPUtils.generateSessionId = function() {
  return Math.random().toString().substr(2, 21);
};

// Write boilder plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
  var sessionId;
  var version = sessVer !== undefined ? sessVer : 2;
  if (sessId) {
    sessionId = sessId;
  } else {
    sessionId = SDPUtils.generateSessionId();
  }
  var user = sessUser || 'thisisadapterortc';
  // FIXME: sess-id should be an NTP timestamp.
  return 'v=0\r\n' +
      'o=' + user + ' ' + sessionId + ' ' + version +
        ' IN IP4 127.0.0.1\r\n' +
      's=-\r\n' +
      't=0 0\r\n';
};

SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);

  // Map ICE parameters (ufrag, pwd) to SDP.
  sdp += SDPUtils.writeIceParameters(
      transceiver.iceGatherer.getLocalParameters());

  // Map DTLS parameters to SDP.
  sdp += SDPUtils.writeDtlsParameters(
      transceiver.dtlsTransport.getLocalParameters(),
      type === 'offer' ? 'actpass' : 'active');

  sdp += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.direction) {
    sdp += 'a=' + transceiver.direction + '\r\n';
  } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    // spec.
    var msid = 'msid:' + stream.id + ' ' +
        transceiver.rtpSender.track.id + '\r\n';
    sdp += 'a=' + msid;

    // for Chrome.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  // FIXME: this should be written by writeRtpDescription.
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
};

// Gets the direction from the mediaSection or the sessionpart.
SDPUtils.getDirection = function(mediaSection, sessionpart) {
  // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
  var lines = SDPUtils.splitLines(mediaSection);
  for (var i = 0; i < lines.length; i++) {
    switch (lines[i]) {
      case 'a=sendrecv':
      case 'a=sendonly':
      case 'a=recvonly':
      case 'a=inactive':
        return lines[i].substr(2);
      default:
        // FIXME: What should happen here?
    }
  }
  if (sessionpart) {
    return SDPUtils.getDirection(sessionpart);
  }
  return 'sendrecv';
};

SDPUtils.getKind = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  return mline[0].substr(2);
};

SDPUtils.isRejected = function(mediaSection) {
  return mediaSection.split(' ', 2)[1] === '0';
};

SDPUtils.parseMLine = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var parts = lines[0].substr(2).split(' ');
  return {
    kind: parts[0],
    port: parseInt(parts[1], 10),
    protocol: parts[2],
    fmt: parts.slice(3).join(' ')
  };
};

SDPUtils.parseOLine = function(mediaSection) {
  var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
  var parts = line.substr(2).split(' ');
  return {
    username: parts[0],
    sessionId: parts[1],
    sessionVersion: parseInt(parts[2], 10),
    netType: parts[3],
    addressType: parts[4],
    address: parts[5]
  };
};

// a very naive interpretation of a valid SDP.
SDPUtils.isValidSDP = function(blob) {
  if (typeof blob !== 'string' || blob.length === 0) {
    return false;
  }
  var lines = SDPUtils.splitLines(blob);
  for (var i = 0; i < lines.length; i++) {
    if (lines[i].length < 2 || lines[i].charAt(1) !== '=') {
      return false;
    }
    // TODO: check the modifier a bit more.
  }
  return true;
};

// Expose public methods.
if (typeof module === 'object') {
  module.exports = SDPUtils;
}

},{}]},{},[1])(1)
});

/*
 * arrive.js
 * v2.4.1
 * https://github.com/uzairfarooq/arrive
 * MIT licensed
 *
 * Copyright (c) 2014-2017 Uzair Farooq
 */

var Arrive=function(e,t,n){"use strict";function r(e,t,n){l.addMethod(t,n,e.unbindEvent),l.addMethod(t,n,e.unbindEventWithSelectorOrCallback),l.addMethod(t,n,e.unbindEventWithSelectorAndCallback)}function i(e){e.arrive=f.bindEvent,r(f,e,"unbindArrive"),e.leave=d.bindEvent,r(d,e,"unbindLeave")}if(e.MutationObserver&&"undefined"!=typeof HTMLElement){var o=0,l=function(){var t=HTMLElement.prototype.matches||HTMLElement.prototype.webkitMatchesSelector||HTMLElement.prototype.mozMatchesSelector||HTMLElement.prototype.msMatchesSelector;return{matchesSelector:function(e,n){return e instanceof HTMLElement&&t.call(e,n)},addMethod:function(e,t,r){var i=e[t];e[t]=function(){return r.length==arguments.length?r.apply(this,arguments):"function"==typeof i?i.apply(this,arguments):n}},callCallbacks:function(e,t){t&&t.options.onceOnly&&1==t.firedElems.length&&(e=[e[0]]);for(var n,r=0;n=e[r];r++)n&&n.callback&&n.callback.call(n.elem,n.elem);t&&t.options.onceOnly&&1==t.firedElems.length&&t.me.unbindEventWithSelectorAndCallback.call(t.target,t.selector,t.callback)},checkChildNodesRecursively:function(e,t,n,r){for(var i,o=0;i=e[o];o++)n(i,t,r)&&r.push({callback:t.callback,elem:i}),i.childNodes.length>0&&l.checkChildNodesRecursively(i.childNodes,t,n,r)},mergeArrays:function(e,t){var n,r={};for(n in e)e.hasOwnProperty(n)&&(r[n]=e[n]);for(n in t)t.hasOwnProperty(n)&&(r[n]=t[n]);return r},toElementsArray:function(t){return n===t||"number"==typeof t.length&&t!==e||(t=[t]),t}}}(),c=function(){var e=function(){this._eventsBucket=[],this._beforeAdding=null,this._beforeRemoving=null};return e.prototype.addEvent=function(e,t,n,r){var i={target:e,selector:t,options:n,callback:r,firedElems:[]};return this._beforeAdding&&this._beforeAdding(i),this._eventsBucket.push(i),i},e.prototype.removeEvent=function(e){for(var t,n=this._eventsBucket.length-1;t=this._eventsBucket[n];n--)if(e(t)){this._beforeRemoving&&this._beforeRemoving(t);var r=this._eventsBucket.splice(n,1);r&&r.length&&(r[0].callback=null)}},e.prototype.beforeAdding=function(e){this._beforeAdding=e},e.prototype.beforeRemoving=function(e){this._beforeRemoving=e},e}(),a=function(t,r){var i=new c,o=this,a={fireOnAttributesModification:!1};return i.beforeAdding(function(n){var i,l=n.target;(l===e.document||l===e)&&(l=document.getElementsByTagName("html")[0]),i=new MutationObserver(function(e){r.call(this,e,n)});var c=t(n.options);i.observe(l,c),n.observer=i,n.me=o}),i.beforeRemoving(function(e){e.observer.disconnect()}),this.bindEvent=function(e,t,n){t=l.mergeArrays(a,t);for(var r=l.toElementsArray(this),o=0;o<r.length;o++)i.addEvent(r[o],e,t,n)},this.unbindEvent=function(){var e=l.toElementsArray(this);i.removeEvent(function(t){for(var r=0;r<e.length;r++)if(this===n||t.target===e[r])return!0;return!1})},this.unbindEventWithSelectorOrCallback=function(e){var t,r=l.toElementsArray(this),o=e;t="function"==typeof e?function(e){for(var t=0;t<r.length;t++)if((this===n||e.target===r[t])&&e.callback===o)return!0;return!1}:function(t){for(var i=0;i<r.length;i++)if((this===n||t.target===r[i])&&t.selector===e)return!0;return!1},i.removeEvent(t)},this.unbindEventWithSelectorAndCallback=function(e,t){var r=l.toElementsArray(this);i.removeEvent(function(i){for(var o=0;o<r.length;o++)if((this===n||i.target===r[o])&&i.selector===e&&i.callback===t)return!0;return!1})},this},s=function(){function e(e){var t={attributes:!1,childList:!0,subtree:!0};return e.fireOnAttributesModification&&(t.attributes=!0),t}function t(e,t){e.forEach(function(e){var n=e.addedNodes,i=e.target,o=[];null!==n&&n.length>0?l.checkChildNodesRecursively(n,t,r,o):"attributes"===e.type&&r(i,t,o)&&o.push({callback:t.callback,elem:i}),l.callCallbacks(o,t)})}function r(e,t){return l.matchesSelector(e,t.selector)&&(e._id===n&&(e._id=o++),-1==t.firedElems.indexOf(e._id))?(t.firedElems.push(e._id),!0):!1}var i={fireOnAttributesModification:!1,onceOnly:!1,existing:!1};f=new a(e,t);var c=f.bindEvent;return f.bindEvent=function(e,t,r){n===r?(r=t,t=i):t=l.mergeArrays(i,t);var o=l.toElementsArray(this);if(t.existing){for(var a=[],s=0;s<o.length;s++)for(var u=o[s].querySelectorAll(e),f=0;f<u.length;f++)a.push({callback:r,elem:u[f]});if(t.onceOnly&&a.length)return r.call(a[0].elem,a[0].elem);setTimeout(l.callCallbacks,1,a)}c.call(this,e,t,r)},f},u=function(){function e(){var e={childList:!0,subtree:!0};return e}function t(e,t){e.forEach(function(e){var n=e.removedNodes,i=[];null!==n&&n.length>0&&l.checkChildNodesRecursively(n,t,r,i),l.callCallbacks(i,t)})}function r(e,t){return l.matchesSelector(e,t.selector)}var i={};d=new a(e,t);var o=d.bindEvent;return d.bindEvent=function(e,t,r){n===r?(r=t,t=i):t=l.mergeArrays(i,t),o.call(this,e,t,r)},d},f=new s,d=new u;t&&i(t.fn),i(HTMLElement.prototype),i(NodeList.prototype),i(HTMLCollection.prototype),i(HTMLDocument.prototype),i(Window.prototype);var h={};return r(f,h,"unbindAllArrive"),r(d,h,"unbindAllLeave"),h}}(window,"undefined"==typeof jQuery?null:jQuery,void 0);
// Last time updated at Oct 24, 2015, 08:32:23

// Latest file can be found here: https://cdn.webrtc-experiment.com/getScreenId.js

// Muaz Khan         - www.MuazKhan.com
// MIT License       - www.WebRTC-Experiment.com/licence
// Documentation     - https://github.com/muaz-khan/getScreenId.

// ______________
// getScreenId.js

/*
getScreenId(function (error, sourceId, screen_constraints) {
    // error    == null || 'permission-denied' || 'not-installed' || 'installed-disabled' || 'not-chrome'
    // sourceId == null || 'string' || 'firefox'

    if(sourceId == 'firefox') {
        navigator.mozGetUserMedia(screen_constraints, onSuccess, onFailure);
    }
    else navigator.webkitGetUserMedia(screen_constraints, onSuccess, onFailure);
});
*/

(function() {
    window.getScreenId = function(callback) {
        // for Firefox:
        // sourceId == 'firefox'
        // screen_constraints = {...}
        if (!!navigator.mozGetUserMedia) {
            callback(null, 'firefox', {
                video: {
                    mozMediaSource: 'window',
                    mediaSource: 'window'
                }
            });
            return;
        }

        postMessage();

        window.addEventListener('message', onIFrameCallback);

        function onIFrameCallback(event) {
            if (!event.data) return;

            if (event.data.chromeMediaSourceId) {
                if (event.data.chromeMediaSourceId === 'PermissionDeniedError') {
                    callback('permission-denied');
                } else callback(null, event.data.chromeMediaSourceId, getScreenConstraints(null, event.data.chromeMediaSourceId));
            }

            if (event.data.chromeExtensionStatus) {
                callback(event.data.chromeExtensionStatus, null, getScreenConstraints(event.data.chromeExtensionStatus));
            }

            // this event listener is no more needed
            window.removeEventListener('message', onIFrameCallback);
        }
    };

    function getScreenConstraints(error, sourceId) {
        var screen_constraints = {
            audio: false,
            video: {
                mandatory: {
                    chromeMediaSource: error ? 'screen' : 'desktop',
                    maxWidth: window.screen.width > 1920 ? window.screen.width : 1920,
                    maxHeight: window.screen.height > 1080 ? window.screen.height : 1080
                },
                optional: []
            }
        };

        if (sourceId) {
            screen_constraints.video.mandatory.chromeMediaSourceId = sourceId;
        }

        return screen_constraints;
    }

    function postMessage() {
        if (!iframe) {
            loadIFrame(postMessage);
            return;
        }

        if (!iframe.isLoaded) {
            setTimeout(postMessage, 100);
            return;
        }

        iframe.contentWindow.postMessage({
            captureSourceId: true
        }, '*');
    }

    function loadIFrame(loadCallback) {
        if (iframe) {
            loadCallback();
            return;
        }

        iframe = document.createElement('iframe');
        iframe.onload = function() {
            iframe.isLoaded = true;

            loadCallback();
        };
        iframe.src = 'https://www.webrtc-experiment.com/getSourceId/'; // https://wwww.yourdomain.com/getScreenId.html
        iframe.style.display = 'none';
        (document.body || document.documentElement).appendChild(iframe);
    }

    var iframe;

    // this function is used in v3.0
    window.getScreenConstraints = function(callback) {
        loadIFrame(function() {
            getScreenId(function(error, sourceId, screen_constraints) {
                callback(error, screen_constraints.video);
            });
        });
    };
})();

(function() {
    if(document.domain.indexOf('webrtc-experiment.com') === -1) {
        return;
    }

    window.getScreenId = function(callback) {
        // for Firefox:
        // sourceId == 'firefox'
        // screen_constraints = {...}
        if (!!navigator.mozGetUserMedia) {
            callback(null, 'firefox', {
                video: {
                    mozMediaSource: 'window',
                    mediaSource: 'window'
                }
            });
            return;
        }

        postMessage();

        window.addEventListener('message', onIFrameCallback);

        function onIFrameCallback(event) {
            if (!event.data) return;

            if (event.data.chromeMediaSourceId) {
                if (event.data.chromeMediaSourceId === 'PermissionDeniedError') {
                    callback('permission-denied');
                } else callback(null, event.data.chromeMediaSourceId, getScreenConstraints(null, event.data.chromeMediaSourceId));
            }

            if (event.data.chromeExtensionStatus) {
                callback(event.data.chromeExtensionStatus, null, getScreenConstraints(event.data.chromeExtensionStatus));
            }

            // this event listener is no more needed
            window.removeEventListener('message', onIFrameCallback);
        }
    };

    function getScreenConstraints(error, sourceId) {
        var screen_constraints = {
            audio: false,
            video: {
                mandatory: {
                    chromeMediaSource: error ? 'screen' : 'desktop',
                    maxWidth: window.screen.width > 1920 ? window.screen.width : 1920,
                    maxHeight: window.screen.height > 1080 ? window.screen.height : 1080
                },
                optional: []
            }
        };

        if (sourceId) {
            screen_constraints.video.mandatory.chromeMediaSourceId = sourceId;
        }

        return screen_constraints;
    }

    function postMessage() {
        if (!iframe) {
            loadIFrame(postMessage);
            return;
        }

        if (!iframe.isLoaded) {
            setTimeout(postMessage, 100);
            return;
        }

        iframe.contentWindow.postMessage({
            captureSourceId: true
        }, '*');
    }

    function loadIFrame(loadCallback) {
        if (iframe) {
            loadCallback();
            return;
        }

        iframe = document.createElement('iframe');
        iframe.onload = function() {
            iframe.isLoaded = true;

            loadCallback();
        };
        iframe.src = 'https://www.webrtc-experiment.com/getSourceId/'; // https://wwww.yourdomain.com/getScreenId.html
        iframe.style.display = 'none';
        (document.body || document.documentElement).appendChild(iframe);
    }

    var iframe;

    // this function is used in v3.0
    window.getScreenConstraints = function(callback) {
        loadIFrame(function() {
            getScreenId(function(error, sourceId, screen_constraints) {
                callback(error, screen_constraints.video);
            });
        });
    };
})();

/*
 * JavaScript MD5 1.0.1
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
!function(a){"use strict";function b(a,b){var c=(65535&a)+(65535&b),d=(a>>16)+(b>>16)+(c>>16);return d<<16|65535&c}function c(a,b){return a<<b|a>>>32-b}function d(a,d,e,f,g,h){return b(c(b(b(d,a),b(f,h)),g),e)}function e(a,b,c,e,f,g,h){return d(b&c|~b&e,a,b,f,g,h)}function f(a,b,c,e,f,g,h){return d(b&e|c&~e,a,b,f,g,h)}function g(a,b,c,e,f,g,h){return d(b^c^e,a,b,f,g,h)}function h(a,b,c,e,f,g,h){return d(c^(b|~e),a,b,f,g,h)}function i(a,c){a[c>>5]|=128<<c%32,a[(c+64>>>9<<4)+14]=c;var d,i,j,k,l,m=1732584193,n=-271733879,o=-1732584194,p=271733878;for(d=0;d<a.length;d+=16)i=m,j=n,k=o,l=p,m=e(m,n,o,p,a[d],7,-680876936),p=e(p,m,n,o,a[d+1],12,-389564586),o=e(o,p,m,n,a[d+2],17,606105819),n=e(n,o,p,m,a[d+3],22,-1044525330),m=e(m,n,o,p,a[d+4],7,-176418897),p=e(p,m,n,o,a[d+5],12,1200080426),o=e(o,p,m,n,a[d+6],17,-1473231341),n=e(n,o,p,m,a[d+7],22,-45705983),m=e(m,n,o,p,a[d+8],7,1770035416),p=e(p,m,n,o,a[d+9],12,-1958414417),o=e(o,p,m,n,a[d+10],17,-42063),n=e(n,o,p,m,a[d+11],22,-1990404162),m=e(m,n,o,p,a[d+12],7,1804603682),p=e(p,m,n,o,a[d+13],12,-40341101),o=e(o,p,m,n,a[d+14],17,-1502002290),n=e(n,o,p,m,a[d+15],22,1236535329),m=f(m,n,o,p,a[d+1],5,-165796510),p=f(p,m,n,o,a[d+6],9,-1069501632),o=f(o,p,m,n,a[d+11],14,643717713),n=f(n,o,p,m,a[d],20,-373897302),m=f(m,n,o,p,a[d+5],5,-701558691),p=f(p,m,n,o,a[d+10],9,38016083),o=f(o,p,m,n,a[d+15],14,-660478335),n=f(n,o,p,m,a[d+4],20,-405537848),m=f(m,n,o,p,a[d+9],5,568446438),p=f(p,m,n,o,a[d+14],9,-1019803690),o=f(o,p,m,n,a[d+3],14,-187363961),n=f(n,o,p,m,a[d+8],20,1163531501),m=f(m,n,o,p,a[d+13],5,-1444681467),p=f(p,m,n,o,a[d+2],9,-51403784),o=f(o,p,m,n,a[d+7],14,1735328473),n=f(n,o,p,m,a[d+12],20,-1926607734),m=g(m,n,o,p,a[d+5],4,-378558),p=g(p,m,n,o,a[d+8],11,-2022574463),o=g(o,p,m,n,a[d+11],16,1839030562),n=g(n,o,p,m,a[d+14],23,-35309556),m=g(m,n,o,p,a[d+1],4,-1530992060),p=g(p,m,n,o,a[d+4],11,1272893353),o=g(o,p,m,n,a[d+7],16,-155497632),n=g(n,o,p,m,a[d+10],23,-1094730640),m=g(m,n,o,p,a[d+13],4,681279174),p=g(p,m,n,o,a[d],11,-358537222),o=g(o,p,m,n,a[d+3],16,-722521979),n=g(n,o,p,m,a[d+6],23,76029189),m=g(m,n,o,p,a[d+9],4,-640364487),p=g(p,m,n,o,a[d+12],11,-421815835),o=g(o,p,m,n,a[d+15],16,530742520),n=g(n,o,p,m,a[d+2],23,-995338651),m=h(m,n,o,p,a[d],6,-198630844),p=h(p,m,n,o,a[d+7],10,1126891415),o=h(o,p,m,n,a[d+14],15,-1416354905),n=h(n,o,p,m,a[d+5],21,-57434055),m=h(m,n,o,p,a[d+12],6,1700485571),p=h(p,m,n,o,a[d+3],10,-1894986606),o=h(o,p,m,n,a[d+10],15,-1051523),n=h(n,o,p,m,a[d+1],21,-2054922799),m=h(m,n,o,p,a[d+8],6,1873313359),p=h(p,m,n,o,a[d+15],10,-30611744),o=h(o,p,m,n,a[d+6],15,-1560198380),n=h(n,o,p,m,a[d+13],21,1309151649),m=h(m,n,o,p,a[d+4],6,-145523070),p=h(p,m,n,o,a[d+11],10,-1120210379),o=h(o,p,m,n,a[d+2],15,718787259),n=h(n,o,p,m,a[d+9],21,-343485551),m=b(m,i),n=b(n,j),o=b(o,k),p=b(p,l);return[m,n,o,p]}function j(a){var b,c="";for(b=0;b<32*a.length;b+=8)c+=String.fromCharCode(a[b>>5]>>>b%32&255);return c}function k(a){var b,c=[];for(c[(a.length>>2)-1]=void 0,b=0;b<c.length;b+=1)c[b]=0;for(b=0;b<8*a.length;b+=8)c[b>>5]|=(255&a.charCodeAt(b/8))<<b%32;return c}function l(a){return j(i(k(a),8*a.length))}function m(a,b){var c,d,e=k(a),f=[],g=[];for(f[15]=g[15]=void 0,e.length>16&&(e=i(e,8*a.length)),c=0;16>c;c+=1)f[c]=909522486^e[c],g[c]=1549556828^e[c];return d=i(f.concat(k(b)),512+8*b.length),j(i(g.concat(d),640))}function n(a){var b,c,d="0123456789abcdef",e="";for(c=0;c<a.length;c+=1)b=a.charCodeAt(c),e+=d.charAt(b>>>4&15)+d.charAt(15&b);return e}function o(a){return unescape(encodeURIComponent(a))}function p(a){return l(o(a))}function q(a){return n(p(a))}function r(a,b){return m(o(a),o(b))}function s(a,b){return n(r(a,b))}function t(a,b,c){return b?c?r(b,a):s(b,a):c?p(a):q(a)}"function"==typeof define&&define.amd?define(function(){return t}):a.md5=t}(this);
/*
The MIT License (MIT)

Copyright (c) 2014 Chris Wilson

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

/*

Usage:
audioNode = createAudioMeter(audioContext,clipLevel,averaging,clipLag);

audioContext: the AudioContext you're using.
clipLevel: the level (0 to 1) that you would consider "clipping".
   Defaults to 0.98.
averaging: how "smoothed" you would like the meter to be over time.
   Should be between 0 and less than 1.  Defaults to 0.95.
clipLag: how long you would like the "clipping" indicator to show
   after clipping has occured, in milliseconds.  Defaults to 750ms.

Access the clipping through node.checkClipping(); use node.shutdown to get rid of it.
*/

function createAudioMeter(audioContext,clipLevel,averaging,clipLag) {
	var processor = audioContext.createScriptProcessor(512);
	processor.onaudioprocess = volumeAudioProcess;
	processor.clipping = false;
	processor.lastClip = 0;
	processor.volume = 0;
	processor.clipLevel = clipLevel || 0.98;
	processor.averaging = averaging || 0.95;
	processor.clipLag = clipLag || 750;

	// this will have no effect, since we don't copy the input to the output,
	// but works around a current Chrome bug.
	processor.connect(audioContext.destination);

	processor.checkClipping =
		function(){
			if (!this.clipping)
				return false;
			if ((this.lastClip + this.clipLag) < window.performance.now())
				this.clipping = false;
			return this.clipping;
		};

	processor.shutdown =
		function(){
			this.disconnect();
			this.onaudioprocess = null;
		};

	return processor;
}

function volumeAudioProcess( event ) {
	var buf = event.inputBuffer.getChannelData(0);
    var bufLength = buf.length;
	var sum = 0;
    var x;

	// Do a root-mean-square on the samples: sum up the squares...
    for (var i=0; i<bufLength; i++) {
    	x = buf[i];
    	if (Math.abs(x)>=this.clipLevel) {
    		this.clipping = true;
    		this.lastClip = window.performance.now();
    	}
    	sum += x * x;
    }

    // ... then take the square root of the sum.
    var rms =  Math.sqrt(sum / bufLength);

    // Now smooth this out with the averaging factor applied
    // to the previous sample - take the max here because we
    // want "fast attack, slow release."
    this.volume = Math.max(rms, this.volume*this.averaging);
}

(function () {
  "use strict";

  var vertoApp = angular.module("vertoApp", [
    "timer",
    "ngRoute",
    "vertoControllers",
    "vertoDirectives",
    "vertoFilters",
    "vertoConstants",
    "ngStorage",
    "ngAnimate",
    "ngSanitize",
    "ngCookies",
    "toastr",
    "cgPrompt",
    "720kb.tooltips",
    "ui.gravatar",
    "ui.bootstrap",
    "directive.g+signin",
    "pascalprecht.translate",
    "angular-click-outside",
    "xeditable",
    "vaertoComponentsModule",
    "vcRecaptcha",
  ]);

  vertoApp.constant("configLanguages", {
    languages: [
      { id: "en", name: "English" },
      { id: "it", name: "Italiano" },
      { id: "fr", name: "Français" },
      { id: "de", name: "Deutsch" },
      { id: "pt", name: "Português" },
      { id: "pl", name: "Polski" },
      { id: "zh", name: "中國" },
      { id: "ru", name: "Pусский" },
      { id: "sv", name: "Svenska" },
      { id: "da", name: "Dansk" },
      { id: "es", name: "Español" },
      { id: "id", name: "Indonesia" },
    ],

    dialects: {
      en: "en",
      en_GB: "en",
      en_US: "en",
      it: "it",
      it_IT: "it",
      fr: "fr",
      fr_FR: "fr",
      fr_CA: "fr",
      pt: "pt",
      pt_BR: "pt",
      pt_PT: "pt",
      de: "de",
      de_DE: "de",
      es: "es",
      es_ES: "es",
      pl: "pl",
      pl_PL: "pl",
      ru: "ru",
      ru_RU: "ru",
      sv: "sv",
      sv_SV: "sv",
      sv_FI: "sv",
      da: "da",
      da_DK: "da",
      id: "id",
      id_ID: "id",
      zh: "zh",
      zh_CN: "zh",
      zh_TW: "zh",
      zh_HK: "zh",
    },
  });

  vertoApp.config([
    "$routeProvider",
    "gravatarServiceProvider",
    "$translateProvider",
    "configLanguages",
    function (
      $routeProvider,
      gravatarServiceProvider,
      $translateProvider,
      configLanguages
    ) {
      var loginGuard = {
          guard: [
            "routeService",
            function (routeService) {
              return routeService.loginGuard();
            },
          ],
        },
        loggedGuard = {
          guard: [
            "routeService",
            function (routeService) {
              return routeService.loggedGuard();
            },
          ],
        },
        adminGuard = {
          guard: [
            "routeService",
            function (routeService) {
              return routeService.adminGuard();
            },
          ],
        },
        userGuard = {
          guard: [
            "routeService",
            function (routeService) {
              return routeService.userGuard();
            },
          ],
        },
        userAdminGuard = {
          guard: [
            "routeService",
            function (routeService) {
              return routeService.userAdminGuard();
            },
          ],
        },
        mobileBrowseGuard = {
          guard: [
            "routeService",
            function (routeService) {
              return routeService.mobileBrowseGuard();
            },
          ],
        };

      $routeProvider
        .when("/login", {
          title: "Login",
          templateUrl: "partials/login.html",
          controller: "LoginController",
          resolve: loginGuard,
        })
        .when("/login/guest", {
          title: "LoginGuest",
          templateUrl: "partials/login_guest_name.html",
          controller: "LoginController",
          resolve: loginGuard,
        })
        .when("/", {
          title: "Loading",
          templateUrl: "partials/splash_screen.html",
          controller: "SplashScreenController",
        })
        .when("/register", {
          title: "User Register",
          templateUrl: "partials/register.html",
          controller: "RegisterController",
        })
        .when("/phone-verify", {
          title: "Phone Verfication",
          templateUrl: "partials/phone_verify.html",
          controller: "PhoneVerifyController",
        })
        .when("/dialpad", {
          title: "Dialpad",
          templateUrl: "partials/dialpad.html",
          controller: "DialPadController",
          resolve: loggedGuard,
        })
        .when("/success", {
          title: "Success",
          templateUrl: "partials/success.html",
          controller: "SuccessController",
        })
        .when("/incall", {
          title: "In a Call",
          templateUrl: "partials/incall.html",
          controller: "InCallController",
          resolve: loggedGuard,
        })
        .when("/loading", {
          title: "Loading Verto Communicator",
          templateUrl: "partials/loading.html",
          controller: "LoadingController",
          resolve: loggedGuard,
        })
        .when("/preview", {
          title: "Preview Video",
          templateUrl: "partials/preview.html",
          controller: "PreviewController",
          resolve: loggedGuard,
        })
        .when("/browser-upgrade", {
          title: "",
          templateUrl: "partials/browser_upgrade.html",
          controller: "BrowserUpgradeController",
          resolve: loggedGuard,
        })
        .when("/conference", {
          title: "Conference",
          templateUrl: "partials/conference.html",
          controller: "ConferenceController",
          resolve: userAdminGuard,
        })
        .when("/user-manager", {
          title: "User Manager",
          templateUrl: "partials/user_manager.html",
          controller: "UserManagerController",
          resolve: adminGuard,
        })
        .when("/mobileEnter", {
          title: "Mobile Enter",
          templateUrl: "partials/mobile_enter.html",
          controller: "MobileEnterController",
          resolve: mobileBrowseGuard,
        })
        .otherwise({
          title: "Loading",
          redirectTo: "/",
        });

      gravatarServiceProvider.defaults = {
        default: "mm", // Mystery man as default for missing avatars
      };

      var reg_langs = [];
      angular.forEach(configLanguages.languages, function (value, key) {
        reg_langs.push(value.id);
      });

      $translateProvider
        .useStaticFilesLoader({
          prefix: "locales/locale-",
          suffix: ".json",
        })
        .registerAvailableLanguageKeys(reg_langs, configLanguages.dialects)
        .preferredLanguage("en")
        .determinePreferredLanguage()
        .fallbackLanguage("en")
        .useSanitizeValueStrategy(null);
    },
  ]);

  vertoApp.run([
    "$rootScope",
    "editableOptions",
    function ($rootScope, editableOptions) {
      editableOptions.theme = "bs3"; // bootstrap3 theme. Can be also 'bs2', 'default'

      $rootScope.$on(
        "$routeChangeSuccess",
        function (event, current, previous) {
          if (current.$$route) {
            $rootScope.title = current.$$route.title;
          }
        }
      );

      $rootScope.safeProtocol = window.location.protocol === "https:";
    },
  ]);
})();

(function() {
  'use strict';

  angular.module('vertoControllers', [
    'ui.bootstrap',
    'vertoService',
    'storageService',
    'ui.gravatar'
  ]);

})();
(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("SplashScreenController", [
      "$scope",
      "$rootScope",
      "$location",
      "$timeout",
      "storage",
      "splashscreen",
      "verto",
      "authenticationService",
      "listenerService",
      "conferenceService",
      SplashScreenController,
    ]);

  function SplashScreenController(
    $scope,
    $rootScope,
    $location,
    $timeout,
    storage,
    splashscreen,
    verto,
    authenticationService,
    listenerService,
    conferenceService
  ) {
    $scope.progress_percentage = splashscreen.progress_percentage;
    $scope.message = "";
    $scope.interrupt_next = false;
    $scope.errors = [];

    var redirectTo = function (link, activity) {
      if (activity) {
        if (activity === "browser-upgrade") {
          link = activity;
        }
      }

      $location.path(link);
    };

    var checkProgressState = function (
      current_progress,
      status,
      promise,
      activity,
      soft,
      interrupt,
      message
    ) {
      $scope.progress_percentage = splashscreen.calculate(current_progress);
      $scope.message = message;

      if (interrupt && status === "error") {
        $scope.message = "";
        $scope.errors.push(message);
        if (!soft) {
          redirectTo("", activity);
          return;
        }

        message = message + ". Continue?";

        if (!confirm(message)) {
          $scope.interrupt_next = true;
        }
      }

      if ($scope.interrupt_next) {
        return;
      }

      $scope.message = splashscreen.getProgressMessage(current_progress + 1);

      return true;
    };

    $rootScope.$on(
      "progress.next",
      function (
        ev,
        current_progress,
        status,
        promise,
        activity,
        soft,
        interrupt,
        message
      ) {
        $timeout(function () {
          if (promise) {
            promise.then(function (response) {
              message = response.message;
              status = response.status;
              if (
                checkProgressState(
                  current_progress,
                  status,
                  promise,
                  activity,
                  soft,
                  interrupt,
                  message
                )
              ) {
                splashscreen.next();
              }
            });

            return;
          }

          if (
            !checkProgressState(
              current_progress,
              status,
              promise,
              activity,
              soft,
              interrupt,
              message
            )
          ) {
            return;
          }

          splashscreen.next();
        }, 400);
      }
    );

    $rootScope.$on("progress.complete", function () {
      $scope.message = "Complete";
      listenerService.hangupOnUnload();
      conferenceService.setRoomNumber();
      var isLogged = authenticationService.isLogged();
      var isPhoneVerified = authenticationService.isPhoneVerified();
      var username = authenticationService.getUsername();
      storage.data.name = verto.data.name = username;

      conferenceService.isMobile();

      console.log("splashscreencontroller:", storage.data.isMobile);

      if (storage.data.isMobile) {
        redirectTo("/mobileEnter");
      } else {
        isLogged && isPhoneVerified
          ? authenticationService.redirectAfterLogin()
          : isLogged && isPhoneVerified == false
          ? redirectTo("/phone-verify")
          : redirectTo("/login");
      }
      // authenticationService.isLogged() &&
      // authenticationService.isPhoneVerified() == true
      //   ? authenticationService.redirectAfterLogin()
      //   : redirectTo("/login");
    });

    splashscreen.next();
  }
})();

(function() {
  'use strict';

  angular
    .module('vertoControllers')
    .controller('BrowserUpgradeController', ['$scope', '$http',
      '$location', 'verto', 'storage', 'Fullscreen',
      function($scope, $http, $location, verto, storage, Fullscreen) {
        console.debug('Executing BrowserUpgradeController.');

      }
    ]);

})();
(function () {
  "use strict";

  angular.module("vertoControllers").controller("ChatController", [
    "$scope",
    "$rootScope",
    "$timeout",
    "$translate",
    "verto",
    "storage",
    "prompt",
    function (
      $scope,
      $rootScope,
      $timeout,
      $translate,
      verto,
      storage,
      prompt
    ) {
      $scope.disableCamera = storage.data.selectedVideo === "none";
      $scope.activePane = "members";
      $scope.chatCounter = 0;
      $scope.openChat = null;

      var CLEAN_MESSAGE = "";

      function clearConferenceChat() {
        $scope.members = [];
        $scope.messages = [];
        $scope.message = CLEAN_MESSAGE;
      }

      clearConferenceChat();

      function getResByLayout(layout) {
        var layoutsData = verto.data.confLayoutsData;
        if (layoutsData) {
          for (var i = 0; i < layoutsData.length; i++) {
            if (layoutsData[i].name === layout) {
              return layoutsData[i].resIDS;
            }
          }
        }
      }

      // @preserve - a array of values to be preserved
      function clearMembersResID(preserve) {
        $scope.members.forEach(function (member) {
          var resID = member.status.video.reservationID;
          if (resID && preserve && preserve.indexOf(resID) !== -1) return;
          if (resID) {
            $scope.confResID(member.id, resID);
          }
        });
      }

      function findMemberByUUID(uuid) {
        var found = false;
        for (var idx in $scope.members) {
          if ($scope.members.hasOwnProperty(idx)) {
            var member = $scope.members[idx];
            if (member.uuid === uuid) {
              found = true;
              break;
            }
          }
        }

        return found ? idx : -1;
      }

      function translateMember(member) {
        return {
          uuid: member[0],
          id: member[1][0],
          number: member[1][1],
          name: member[1][2],
          codec: member[1][3],
          status: JSON.parse(member[1][4]),
          email: member[1][5].email,
        };
      }

      function addMember(member) {
        $scope.members.push(translateMember(member));
        console.log("CHAT MEMBERS COUNT=>>>>>>>>", $scope.members.length);
        $rootScope.$emit("chat.membersCount", $scope.members.length);
      }

      var openChatListener = $rootScope.$on("openChat", function () {
        $scope.onOpenChat();
      });

      var closeChatListener = $rootScope.$on("closeChat", function () {
        $scope.onCloseChat();
      });

      var newMsgListener = $rootScope.$on(
        "chat.newMessage",
        function (event, data) {
          data.created_at = new Date();
          $scope.messages.push(data);

          if (data.from !== verto.data.name && $scope.activePane !== "chat") {
            $scope.chatCounter++;
            console.log("CHAT COUNTER =>>>>>>>>>", $scope.chatCounter);
            $rootScope.$emit("chat.messageCount", $scope.chatCounter);
          }

          $timeout(function scrollToChatBottom() {
            var obj = document.querySelector(".chat-messages");
            obj.scrollTop = obj.scrollHeight;
          });
        }
      );

      var callistener = $rootScope.$on("call.conference", function () {
        $timeout(function () {
          $scope.conf = verto.data.conf.params.laData;
        });
      });

      var chageVideoLayoutListener = $rootScope.$on(
        "changedVideoLayout",
        function (event, layout) {
          $scope.resIDs = getResByLayout(layout);

          // remove resIDs param to clear every members resID.
          // passing $scope.resIDs results in preserving resIDs compatible
          // with the current layout
          clearMembersResID($scope.resIDs);
        }
      );

      var canvasLayoutListener = $rootScope.$on(
        "conference.canvasInfo",
        function (event, data) {
          $scope.currentLayout = data[0].layoutName;
          $scope.resIDs = getResByLayout($scope.currentLayout);
        }
      );

      var hangupListener = $rootScope.$on("hangupCall", function () {
        $scope.openId = null;
        $scope.onCloseChat();
      });

      var bootMemberListener = $rootScope.$on(
        "members.boot",
        function (event, members) {
          $scope.$apply(function () {
            clearConferenceChat();
            for (var idx in members) {
              if (members.hasOwnProperty(idx)) {
                var member = members[idx];
                addMember(member);
              }
            }
          });
        }
      );

      var addMemeberListener = $rootScope.$on(
        "members.add",
        function (event, member) {
          $scope.$apply(function () {
            addMember(member);
          });
        }
      );

      var delMemeberListener = $rootScope.$on(
        "members.del",
        function (event, uuid) {
          if ($rootScope.watcher && $rootScope.master === uuid) {
            verto.hangup();
            window.close();
          }

          $scope.$apply(function () {
            var memberIdx = findMemberByUUID(uuid);
            if (memberIdx != -1) {
              // Removing the member.
              $scope.members.splice(memberIdx, 1);
              $rootScope.$emit("chat.membersCount", $scope.members.length);
            }
          });
        }
      );

      var updateMemeberListener = $rootScope.$on(
        "members.update",
        function (event, member) {
          member = translateMember(member);
          var memberIdx = findMemberByUUID(member.uuid);
          if (memberIdx < 0) {
            console.log("Didn't find the member uuid " + member.uuid);
          } else {
            $scope.$apply(function () {
              // console.log('Updating', memberIdx, ' <', $scope.members[memberIdx],
              // '> with <', member, '>');
              // Checking if it's me
              if (
                parseInt(member.id) === parseInt(verto.data.conferenceMemberID)
              ) {
                verto.data.mutedMic = member.status.audio.muted;
                verto.data.mutedVideo = member.status.video.muted;
                verto.data.call.setMute(
                  member.status.audio.muted ? "off" : "on"
                );
                verto.data.call.setVideoMute(
                  member.status.video.muted ? "off" : "on"
                );
              }
              angular.extend($scope.members[memberIdx], member);
            });
          }
        }
      );

      var clearMemeberListener = $rootScope.$on("members.clear", function () {
        $scope.$applyAsync(function () {
          clearConferenceChat();
        });
      });

      var toggleActivePaneListener = $rootScope.$on(
        "togglePane",
        function (evt, data) {
          $scope.toggleActivePane(data);
        }
      );

      $scope.$on("$destroy", function () {
        openChatListener();
        closeChatListener();
        newMsgListener();
        callistener();
        chageVideoLayoutListener();
        canvasLayoutListener();
        hangupListener();
        bootMemberListener();
        addMemeberListener();
        delMemeberListener();
        updateMemeberListener();
        clearMemeberListener();
        toggleActivePaneListener();
      });

      /**
       * Public methods.
       */

      $scope.toggleActivePane = function (pane) {
        $rootScope.$emit("togglePane.change", pane);
        if (pane === "chat") {
          $scope.chatCounter = 0;
          $rootScope.$emit("chat.messageCount", $scope.chatCounter);
        }
        $scope.activePane = pane;
      };

      $scope.onOpenChat = function () {
        $scope.openChat = true;
      };

      $scope.onCloseChat = function () {
        $scope.openChat = false;
      };

      $scope.toggleModMenu = function (index) {
        if (verto.data.confRole !== "moderator") return;
        $scope.openId = $scope.openId == index ? null : index;
      };

      $scope.send = function (event) {
        // Only conferencing chat is supported for now
        // but still calling method with the conference prefix
        // so we know that explicitly.
        if (event && event.type === "keydown") {
          event.preventDefault();
        }
        verto.sendConferenceChat($scope.message);
        $scope.message = CLEAN_MESSAGE;
      };

      // Participants moderation.
      $scope.confKick = function (memberID) {
        verto.data.conf.kick(memberID);
      };

      $scope.confMuteMic = function (memberID) {
        if (verto.data.confRole === "moderator") {
          verto.data.conf.muteMic(memberID);
        }
      };

      $scope.confMuteVideo = function (memberID) {
        if (verto.data.confRole === "moderator") {
          verto.data.conf.muteVideo(memberID);
        }
      };

      $scope.confPresenter = function (memberID) {
        verto.data.conf.presenter(memberID);
      };

      $scope.confResID = function (memberID, resID) {
        verto.setResevartionId(memberID, resID);
      };

      $scope.confVideoFloor = function (memberID) {
        verto.data.conf.videoFloor(memberID);
      };

      $scope.confBanner = function (memberID) {
        console.log("$scope.confBanner");

        prompt({
          title: $translate.instant("TITLE_INSERT_BANNER"),
          input: true,
          label: "",
          value: "",
        }).then(function (text) {
          if (text) {
            verto.data.conf.banner(memberID, text);
          }
        });
      };

      $scope.confCanvasIn = function (memberID, canvasID) {
        if (canvasID) {
          verto.setCanvasIn(memberID, canvasID);
          return;
        }

        shortPrompt(
          $translate.instant("TITLE_INSERT_CANVAS_ID"),
          function (canvasID) {
            verto.setCanvasIn(memberID, canvasID);
          }
        );
      };

      $scope.confCanvasOut = function (memberID, canvasID) {
        if (canvasID) {
          verto.setCanvasOut(memberID, canvasID);
          return;
        }

        shortPrompt(
          $translate.instant("TITLE_INSERT_CANVAS_ID"),
          function (canvasID) {
            verto.setCanvasOut(memberID, canvasID);
          }
        );
      };

      $scope.confLayer = function (memberID, canvasID) {
        if (canvasID) {
          verto.setLayer(memberID, canvasID);
          return;
        }

        shortPrompt(
          $translate.instant("TITLE_INSERT_LAYER"),
          function (canvasID) {
            verto.setLayer(memberID, canvasID);
          }
        );
      };

      $scope.confResetBanner = function (memberID) {
        console.log("$scope.confResetBanner");
        var text = "reset";
        verto.data.conf.banner(memberID, text);
      };

      $scope.confVolumeDown = function (memberID) {
        console.log("$scope.confVolumeDown");
        verto.data.conf.volumeDown(memberID);
      };

      $scope.confVolumeUp = function (memberID) {
        console.log("$scope.confVolumeUp");
        verto.data.conf.volumeUp(memberID);
      };

      $scope.confGainDown = function (memberID) {
        console.log("$scope.confGainDown");
        verto.data.conf.gainDown(memberID);
      };

      $scope.confGainUp = function (memberID) {
        console.log("$scope.confGainUp");
        verto.data.conf.gainUp(memberID);
      };

      $scope.confTransfer = function (memberID) {
        console.log("$scope.confTransfer");
        $rootScope.disableOnKeydownDtmf();
        prompt({
          title: $translate.instant("TITLE_TRANSFER"),
          message: $translate.instant("MESSAGE_TRANSFER"),
          input: true,
          label: $translate.instant("LABEL_TRANSFER"),
          value: "",
        })
          .then(function (exten) {
            $rootScope.enableOnKeydownDtmf();
            if (exten) {
              verto.data.conf.transfer(memberID, exten);
            }
          })
          .catch(function () {
            $rootScope.enableOnKeydownDtmf();
          });
      };

      $scope.confToggleDeaf = function (member) {
        if (verto.data.confRole == "moderator") {
          console.log("$scope.confToggleDeaf");

          if (member.status.audio.deaf) {
            verto.data.conf.undeaf(member.id);
          } else {
            verto.data.conf.deaf(member.id);
          }
        }
      };

      function shortPrompt(text, cb) {
        prompt({
          title: text,
          input: true,
          label: "",
          value: "",
        }).then(function (val) {
          if (val && cb) {
            cb(val);
          }
        });
      }
    },
  ]);
})();

(function() {
  'use strict';

  angular
    .module('vertoControllers')
    .controller('ContributorsController', ['$scope', '$http',
      'toastr',
      function($scope, $http, toastr) {
        var url = window.location.origin + window.location.pathname;
        $http.get(url + 'contributors.txt')
          .success(function(data) {

            var contributors = [];

            angular.forEach(data, function(value, key) {
              var re = /(.*) <(.*)>/;
              var name = value.replace(re, "$1");
              var email = value.replace(re, "$2");

              this.push({
                'name': name,
                'email': email
              });
            }, contributors);

            $scope.contributors = contributors;
          })
          .error(function() {
            toastr.error('contributors not found.');
          });
      }
    ]);
})();

(function() {
  'use strict';

  angular
    .module('vertoControllers')
    .controller('AboutController', ['$scope', '$http',
      'toastr',
      function($scope, $http, toastr) {
	    var githash = 'baa503d' || 'something is not right';
            $scope.githash = githash;

	/* leave this here for later, but its not needed right now
        $http.get(window.location.pathname + '/contributors.txt')
          .success(function(data) {

          })
          .error(function() {
            toastr.error('contributors not found.');
          });
	 */
      }
    ]);
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("DialPadController", [
      "$rootScope",
      "$scope",
      "$location",
      "$timeout",
      "$document",
      "toastr",
      "verto",
      "storage",
      "callHistory",
      "eventQueue",
      "notificationService",
      "conferenceService",
      "authenticationService",
      "modalService",
      DialPadController,
    ]);

  function DialPadController(
    $rootScope,
    $scope,
    $location,
    $timeout,
    $document,
    toastr,
    verto,
    storage,
    callHistory,
    eventQueue,
    notificationService,
    conferenceService,
    authenticationService,
    modalService
  ) {
    eventQueue.process();

    $scope.callHistoryIsOpen = false;
    $scope.call_history = callHistory.all();
    $scope.history_control = callHistory.all_control();
    $scope.has_history = Object.keys($scope.call_history).length;
    storage.data.videoCall = false;
    storage.data.userStatus = "connecting";
    storage.data.calling = false;
    $scope.connecting = false;
    $scope.cancelled = false;
    $scope.dialpadNumber = "";
    $scope.lastCalledNumber = storage.data.called_number;
    $scope.userRooms = [];
    $scope.userPhoneNumber = authenticationService.getPhoneNumber();
    $scope.limit = 100;
    $scope.activeTab = "callHistory";
    $scope.isMobile = storage.data.isMobile;

    var parseDate = function (date) {
      var padZero = function (value) {
        return value.toString().padStart(2, "0");
      };

      return (
        padZero(date.getDate()) +
        "-" +
        padZero(date.getMonth() + 1) +
        "-" +
        date.getFullYear().toString().substr(-2) +
        " " +
        date.getHours() +
        ":" +
        padZero(date.getMinutes())
      );
    };
    function fetchUserRooms() {
      conferenceService
        .getConferencesByPhoneNumber($scope.userPhoneNumber, $scope.limit)
        .then(function (response) {
          $scope.userRooms = response.data.map(function (conf) {
            conf.isUnlimited = conferenceService.isUnlimited(conf.begin_date);
            conf.beginLocal = new Date(conf.begin_date + " UTC");
            conf.beginParsed = parseDate(new Date(conf.begin_date + " UTC"));
            conf.lastUpdateParsed = parseDate(new Date(conf.last_status_date));
            return conf;
          });
        });
    }

    // Listeneres start
    var couldNotConnectListener = $rootScope.$on(
      "call.cannot.connect",
      function () {
        $scope.connecting = false;
        notificationService.alertError({
          errorMessage: "MSG_COLD_NOT_CONNECT",
        });
      }
    );

    var callActiveListener = $rootScope.$on("call.active", function () {
      verto.data.mutedMic = storage.data.mutedMic;
      verto.data.mutedVideo = storage.data.mutedVideo;

      if (!storage.data.cur_call) {
        $rootScope.start_time = storage.data.call_start = new Date();
      }

      storage.data.userStatus = "connected";
      storage.data.calling = false;
      storage.data.cur_call = 1;
      $location.path("/incall");
      $scope.$apply();
    });

    var callDeniedListener = $rootScope.$on("call.denied", function () {
      toastr.error("Call denied");
      $scope.connecting = false;
    });
    // Listeneres end

    $scope.clearCallHistory = function () {
      callHistory.clear();
      $scope.call_history = callHistory.all();
      $scope.history_control = callHistory.all_control();
      $scope.has_history = Object.keys($scope.call_history).length;
      return $scope.history_control;
    };

    $scope.viewCallsList = function (calls) {
      return ($scope.call_list = calls);
    };

    $scope.fillDialpadNumber = function (number) {
      $scope.dialpadNumber = number;
    };

    $scope.preview = function () {
      $location.path("/preview");
    };

    $rootScope.transfer = function () {
      if (!$scope.dialpadNumber) {
        return false;
      }
      verto.data.call.transfer($scope.dialpadNumber);
    };

    $scope.digitEntered = function (number) {
      $scope.dialpadNumber += number;
    };

    $scope.paste = function (dialpadNumber) {
      $scope.dialpadNumber = dialpadNumber;
    };

    $scope.backspace = function () {
      $scope.dialpadNumber = $scope.dialpadNumber.slice(0, -1);
    };

    $scope.call = function () {
      var call = function () {
        storage.data.onHold = false;
        storage.data.cur_call = 0;
        if (!$scope.dialpadNumber && storage.data.called_number) {
          $scope.dialpadNumber = storage.data.called_number;
          return false;
        } else if (!$scope.dialpadNumber && !storage.data.called_number) {
          toastr.warning("Enter a room, please.");
          return false;
        }

        if (verto.data.call) {
          console.debug("A call is already in progress.");
          return false;
        }
        storage.data.mutedVideo = false;
        storage.data.mutedMic = false;

        storage.data.videoCall = false;
        verto.call($scope.dialpadNumber);

        storage.data.called_number = $scope.dialpadNumber;
        callHistory.add($scope.dialpadNumber, "outbound");
      };

      $scope.callHistoryIsOpen = false;
      if (!storage.data.testSpeedJoin || !$scope.dialpadNumber) {
        return call();
      }

      // TODO: Need an api to get a room
      conferenceService.getAllConferences(1000).then(function (response) {
        var confData = response.data.find(function (conf) {
          return $scope.dialpadNumber === conf.number;
        });

        if (!confData) {
          toastr.warning("Room does not exist");
          return;
        }

        if (
          !confData.allow_not_registered &&
          !authenticationService.hasCredentials()
        ) {
          toastr.warning("Room is not opened for guests");
          return;
        }

        if (!conferenceService.isUnlimited(confData.begin_date)) {
          confData.beginLocal = new Date(confData.begin_date + " UTC");

          var now = new Date().setSeconds(0),
            begin = confData.beginLocal.getTime(),
            end = new Date(confData.begin_date + " UTC").setDate(
              confData.beginLocal.getDate() + 1
            );

          if (now < begin || now > end) {
            var message = "Room is not open";
            if (authenticationService.isAdmin()) {
              message =
                'Room is not open. <span style="text-decoration: underline" id="open-edit-conf">Open the room</span>';
            }

            toastr.warning(message, null, {
              allowHtml: true,
              tapToDismiss: false,
              onShown: function () {
                document
                  .getElementById("open-edit-conf")
                  .addEventListener("click", function () {
                    var modalOptions = {
                      windowClass: "modal-conference-form",
                      resolve: {
                        conference: function () {
                          return angular.copy(confData);
                        },
                      },
                    };
                    modalService.openModal(
                      "partials/modal_conference_edit_date.html",
                      "ModalEditConferenceDateController",
                      modalOptions
                    );
                  });
              },
            });

            return;
          }
        }

        conferenceService.currentConf = confData;

        $scope.connecting = true;

        verto.testSpeed();
        call();
      });
    };

    $scope.hangup = function () {
      $scope.connecting = false;
      verto.hangup(function () {
        verto.manageVideo("off");
      });
    };

    $scope.redialLastCall = function () {
      $scope.dialpadNumber = $scope.lastCalledNumber;
      $scope.call();
    };

    $scope.toggleCallHistory = function () {
      $scope.callHistoryIsOpen = !$scope.callHistoryIsOpen;
    };

    $scope.roomPaneClick = function () {
      if ($scope.activeTab !== "userRooms") {
        fetchUserRooms();
      }
    };
    $scope.setActivePane = function (pane) {
      $scope.activeTab = pane;
    };

    if (storage.data.room) {
      $scope.dialpadNumber = storage.data.room;
      conferenceService.unsetRoomNumber();
      $scope.call();
    }

    $scope.$on("$destroy", function () {
      couldNotConnectListener();
      callActiveListener();
      callDeniedListener();
    });
  }
})();

(function () {
  "use strict";

  angular.module("vertoControllers").controller("InCallController", [
    "$rootScope",
    "$scope",
    "$timeout",
    "$location",
    "verto",
    "storage",
    "modalService",
    "screenService",
    "conferenceService",
    "notificationService",
    "toastr",
    "$translate",
    function (
      $rootScope,
      $scope,
      $timeout,
      $location,
      verto,
      storage,
      modalService,
      screenService,
      conferenceService,
      notificationService,
      toastr,
      $translate
    ) {
      $scope.layout = null;
      // $scope.callTemplate = storage.data.videoCall ? 'partials/video_call.html' : 'partials/phone_call.html';
      $scope.callTemplate = "partials/video_call.html";
      $scope.dialpadTemplate = "";
      $scope.incall = true;
      $scope.pin = "";
      $scope.sreenSharingIsOn = false;
      $scope.fullscreenEnabled = false;
      $scope.disableMic = storage.data.selectedAudio === "none";
      $scope.disableCamera = storage.data.selectedVideo === "none";
      $scope.isRecord = false;
      $scope.storage = storage;
      $scope.chatCounter = 0;
      $scope.membersCounter = 1;
      $scope.isMember = "member";

      var pinModalInstance;

      if (storage.data.autoBand) {
        verto.testSpeed();
      }

      if (
        conferenceService.currentConf &&
        conferenceService.currentConf.pin &&
        !conferenceService.inCall
      ) {
        pinModalInstance = modalService.openModal(
          "partials/modal_dialpad_pin.html",
          "ModalPinDialpadController",
          {
            keyboard: false,
            windowClass: "dialpad-modal",
            resolve: {
              pin: function () {
                return conferenceService.currentConf.pin.toString();
              },
            },
          }
        );

        pinModalInstance.result.then(function () {
          $scope.hangup();
        });
      }

      var callConferenceListener = $rootScope.$on(
        "call.conference",
        function () {
          $rootScope.$emit("openChat");
          $scope.$broadcast("timer-start");
          conferenceService.inCall = true;

          if (pinModalInstance) {
            pinModalInstance.dismiss();
          }

          if (storage.data.muteMic || storage.data.selectedAudio === "none") {
            $scope.muteMic();
          }

          if (storage.data.muteVideo && storage.data.selectedVideo !== "none") {
            $scope.muteVideo();
          }

          $timeout(
            function () {
              // buildCanvasesData
              $scope.conf = verto.data.conf.params.laData;
              $scope.canvases = [
                {
                  id: 1,
                  name: "Super Canvas",
                },
              ];
              for (var i = 1; i < $scope.conf.canvasCount; i++) {
                $scope.canvases.push({
                  id: i + 1,
                  name: "Canvas " + (i + 1),
                });
              }
            },
            0,
            false
          );
        }
      );

      $rootScope.$on("testSpeed", function (e, data) {
        var vidQual = storage.data.vidQual;
        var bwp = 4;

        $scope.bandDown = data.downKPS;
        $scope.bandUp = data.upKPS;

        if (data.downKPS < 2000) {
          bwp--;
        }

        if (data.upKPS < 2000) {
          bwp--;
        }

        $scope.iconClass = "mdi-device-signal-wifi-4-bar green";

        if (bwp < 4) {
          $scope.iconClass = "mdi-device-signal-wifi-3-bar yellow";
        } else if (bwp < 2) {
          $scope.iconClass = "mdi-device-signal-wifi-1-bar red";
        }

        verto.videoQuality.forEach(function (vid) {
          if (vid.id == vidQual) {
            $scope.vidRes = vid.label;
          }
        });

        $scope.$apply();
      });

      $rootScope.$on("chat.messageCount", function (e, data) {
        console.log("CHAT RECEIVED CHAT COUNTER=>>>>>>>", data);
        $scope.chatCounter = data;
      });

      $rootScope.$on("chat.membersCount", function (e, data) {
        console.log("CHAT RECEIVED MEMBERS COUNTER=>>>>>>>", data);
        $scope.membersCounter = data;
      });

      $rootScope.$on("togglePane.change", function (e, data) {
        $scope.isMember = data;
      });

      // var videoLayoutListener = $rootScope.$on('changedVideoLayout', function (event, layout) {
      //   var videoTracks = document.getElementById('webcam').srcObject.getVideoTracks();
      //   if (videoTracks.length) {
      //     if (layout === '1x1') {
      //       videoTracks[0].applyConstraints({aspectRatio: 1.777});
      //     } else if (videoTracks[0].getSettings().aspectRatio > 1.4) {
      //       videoTracks[0].applyConstraints({aspectRatio: 1.333});
      //     }
      //   }
      // });

      $scope.$on("$destroy", function () {
        if (pinModalInstance) {
          pinModalInstance.dismiss();
        }
        callConferenceListener();
        // videoLayoutListener();
      });

      $scope.hangup = function () {
        if (!verto.data.call) {
          toastr.warning($translate.instant("MESSAGE_NO_HANGUP_CALL"));
          $location.path("/dialpad");
          return;
        }

        if ($rootScope.watcher) {
          window.close();
          return;
        }

        if (verto.data.shareCall) {
          verto.screenshareHangup();
        }

        verto.hangup();
        conferenceService.inCall = false;

        $rootScope.$emit("hangupCall");
        $location.path("/dialpad");
      };

      $scope.toggleDialpad = function () {
        modalService.openModal(
          "partials/modal_dialpad_incall.html",
          "ModalDialpadController",
          { windowClass: "dialpad-modal" }
        );
      };

      $scope.confChangeVideoLayout = function (layout, canvasID) {
        verto.data.conf.setVideoLayout(layout, canvasID);
        $scope.videoLayout = layout;
      };

      $scope.confChangeSpeaker = function (speakerId) {
        storage.data.selectedSpeaker = speakerId;
        $rootScope.$emit("changedSpeaker", speakerId);
      };

      $scope.confPopup = function (canvas_id) {
        var s = window.location.href;
        var curCall = verto.data.call.callID;
        var extension = verto.data.call.params.remote_caller_id_number;
        var width = webcam.offsetWidth;
        var height = webcam.offsetHeight + 100;
        var x = (screen.width - width) / 2;
        var y = (screen.height - height) / 2;

        s = s.replace(/#.*/, "");
        s +=
          "#/?sessid=random&master=" +
          curCall +
          "&watcher=true&extension=" +
          extension +
          "&canvas_id=" +
          canvas_id;

        console.log("opening new window to " + s);
        var popup = window.open(
          s,
          "canvas_window_" + canvas_id,
          "toolbar=0,location=0,menubar=0,directories=0,width=" +
            width +
            ",height=" +
            height,
          +",left=" + x + ",top=" + y
        );
        popup.moveTo(x, y);
      };

      $scope.screenshare = function () {
        var screenshareCallback = function (isOn) {
          $scope.sreenSharingIsOn = !!isOn;
        };

        if (verto.data.shareCall) {
          screenshareCallback(false);
          verto.screenshareHangup();
          return;
        }

        if (verto.data.conf) {
          verto.screenshare(
            verto.data.conf.params.laData.laName,
            screenshareCallback
          );
        } else {
          verto.screenshare(storage.data.called_number, screenshareCallback);
        }
      };

      $scope.muteMic = function () {
        verto.muteMic();
      };

      $scope.muteVideo = function () {
        verto.muteVideo();
      };

      $scope.goFullscreen = function () {
        var showNavbar = function () {
          angular.element("#main-nav").show();
        };

        var hideNav = function () {
          angular.element("#main-nav").hide();
        };

        $scope.fullscreenEnabled = !$scope.fullscreenEnabled;
        if ($scope.fullscreenEnabled) {
          hideNav();
          screenService.openFullscreen();
          screenService.addFullscreenListener(function () {
            $scope.fullscreenEnabled = false;
            showNavbar();
          });
          $rootScope.$emit("closeChat");
        } else {
          showNavbar();
          screenService.closeFullscreen();
          $rootScope.$emit("openChat");
        }
      };

      $scope.play = function () {
        _pormpt().then(function (file) {
          verto.data.conf.play(file);
        });
      };

      $scope.stop = function () {
        verto.data.conf.stop();
      };

      $scope.record = function () {
        _pormpt().then(function (file) {
          $scope.isRecord = true;
          verto.data.conf.record(file);
        });
      };

      $scope.stopRecord = function () {
        $scope.isRecord = false;
        verto.data.conf.stopRecord();
      };

      $scope.snapshot = function () {
        _pormpt().then(function (file) {
          verto.data.conf.snapshot(file);
        });
      };

      $scope.onOpenChat = function () {
        $rootScope.$emit("openChat");
      };

      $scope.onCloseChat = function () {
        $rootScope.$emit("closeChat");
      };

      $scope.onMembersPaneActive = function () {
        if ($scope.isMember === "members") {
          $scope.onCloseChat();
          $scope.isMember = "no";
        } else {
          $scope.onOpenChat();
          $rootScope.$emit("togglePane", "members");
          $scope.isMember = "members";
        }
      };

      $scope.onChatPaneActive = function () {
        if ($scope.isMember === "chat") {
          $scope.onCloseChat();
          $scope.isMember = "no";
        } else {
          $scope.onOpenChat();
          $rootScope.$emit("togglePane", "chat");
          $scope.isMember = "chat";
        }
      };

      $scope.toggleSettings = function () {
        $rootScope.$emit("menuToggledSettings");
      };

      function _pormpt() {
        return notificationService.promptInput(
          $translate.instant("MESSAGE_ENTER_FILENAME"),
          "",
          "File"
        );
      }
    },
  ]);
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("LoginController", [
      "$scope",
      "$location",
      "conferenceService",
      "verto",
      "authenticationService",
      "storage",
      LoginController,
    ]);

  function LoginController(
    $scope,
    $location,
    conferenceService,
    verto,
    authenticationService,
    storage
  ) {
    $scope.loginData = {
      username: undefined,
      pass: undefined,
    };
    $scope.name = "";
    // $scope.showPass = !conferenceService.getRoomNumber();
    $scope.showPass = true;
    $scope.inputType = "password";
    $scope.loading = false;

    $scope.login = function () {
      if (!$scope.showPass) {
        $scope.loginData.pass = "anonymous";
      }

      $scope.loading = true;
      authenticationService
        .login($scope.loginData)
        .then(function (data) {
          console.log("Login Response Data", data);
          if (data.profile === "guest") {
            storage.data.name = verto.data.name = data.username;
            storage.setUserSessionData(
              false,
              false,
              "",
              $scope.showPass,
              true,
              data.username
            );
            authenticationService.redirectAfterLogin();
            $scope.loading = false;
          } else {
            var params = Object.assign({}, data, { type: "register" });
            authenticationService
              .getPhoneVerifyStatus(params)
              .then(function (response) {
                console.log(
                  "Phone Verify Status",
                  response,
                  typeof response,
                  response == true
                );
                storage.data.name = verto.data.name = data.username;
                storage.data.phoneNumber = data.phoneNumber;
                storage.setUserSessionData(
                  data.profile === "admin",
                  data.profile === "user",
                  data.phoneNumber,
                  $scope.showPass,
                  JSON.parse(response),
                  data.username
                );
                if (JSON.parse(response) === true) {
                  authenticationService.redirectAfterLogin().then(function () {
                    $scope.loading = false;
                  });
                } else {
                  $location.path("/phone-verify");
                  $scope.loading = false;
                }
              });
          }
        })
        .catch(function () {
          $scope.loading = false;
        });
    };
    $scope.hideShowPassword = function () {
      if ($scope.inputType == "password") $scope.inputType = "text";
      else $scope.inputType = "password";
    };
    $scope.redirectToGuestLogin = function () {
      $location.path("/login/guest");
    };
    $scope.redirectToRegister = function () {
      $location.path("/register");
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('vertoControllers')
    .controller('MainController',
      ['$scope', '$rootScope', '$location', '$uibModal', '$timeout', '$q', 'verto', 'storage', 'callHistory',
        'toastr', 'prompt', 'eventQueue', '$translate', 'screenService', 'modalService', MainController]);

  function MainController($scope, $rootScope, $location, $uibModal, $timeout, $q, verto, storage, callHistory, toastr,
                          prompt, eventQueue, $translate, screenService, modalService) {
    $.material.init();

    $.verto.haltClosure = function () {
      if (verto.data.callState === 'active') {
        return true;
      }
    };

    if (storage.data.language && storage.data.language !== 'browser') {
      $translate.use(storage.data.language);
    } else {
      storage.data.language = 'browser';
    }

    $scope.verto = verto;
    $scope.storage = storage;
    $scope.call_history = angular.element("#call_history").hasClass('active');
    $rootScope.chatStatus = angular.element('#wrapper').hasClass('toggled');
    $scope.showReconnectModal = true;

    // If verto is not connected, redirects to login page.
    if (!verto.data.connected) {
      console.debug('MainController: WebSocket not connected. Redirecting to login.');
      $location.path('/');
    }

    $rootScope.$on('config.http.success', function (ev) {
      $scope.login(false);
    });

    $rootScope.$on('changedSpeaker', function (event, speakerId) {
      if (verto.data.call) {
        verto.data.call.setAudioPlaybackDevice(speakerId, sinkIdCallback);
      }
    });

    $rootScope.$on('ws.close', onWSClose);
    $rootScope.$on('ws.login', onWSLogin);

    $rootScope.ws_modalInstance;

    function onWSClose(ev, data) {
      // if ($rootScope.ws_modalInstance) {
      //     return;
      // }
      // var options = {
      //     backdrop: 'static',
      //     keyboard: false
      // };
      // if ($scope.showReconnectModal) {
      //     $rootScope.ws_modalInstance = modalService.openModal('partials/ws_reconnect.html', 'ModalWsReconnectController', options);
      // }
    }

    function onWSLogin(ev, data) {
      if (storage.data.autoBand) {
        verto.testSpeed();
      }
      if (!$rootScope.ws_modalInstance) {
        return;
      }

      $rootScope.ws_modalInstance.close();
      $rootScope.ws_modalInstance = null;
    }

    $scope.showAbout = function () {
      modalService.openModal('partials/about.html', 'AboutController');
    };

    $scope.showContributors = function () {
      modalService.openModal('partials/contributors.html', 'ContributorsController');
    };

    $rootScope.$on('call.hangup', function (event, data) {
      screenService.closeFullscreen();

      if (!$rootScope.chatStatus) {
        angular.element('#wrapper').toggleClass('toggled');
        $rootScope.chatStatus = angular.element('#wrapper').hasClass('toggled');
      }

      $location.path('/dialpad');

      // try {
      //   $rootScope.$digest();
      // } catch (e) {
      //   console.error('not digest');
      // }
    });

    $rootScope.$on('page.incall', function (event, data) {
      var page_incall = function () {
        return $q(function (resolve, reject) {
          if (storage.data.askRecoverCall) {
            prompt({
              title: $translate.instant('TITLE_ACTIVE_CALL'),
              message: $translate.instant('MESSAGE_ACTIVE_CALL_BACK')
            }).then(function () {
              console.log('redirect to incall page');
              $location.path('/incall');
            }, function () {
              storage.data.userStatus = 'connecting';
              verto.hangup();
            });
          } else {
            console.log('redirect to incall page');
            $location.path('/incall');
          }
          resolve();
        });
      };
      eventQueue.events.push(page_incall);
    });

    $scope.$on('event:google-plus-signin-success', function (event, authResult) {
      // Send login to server or save into cookie
      console.log('Google+ Login Success');
      console.log(authResult);
      gapi.client.load('plus', 'v1', gapiClientLoaded);
    });

    function gapiClientLoaded() {
      gapi.client.plus.people.get({
        userId: 'me'
      }).execute(handleEmailResponse);
    }

    function handleEmailResponse(resp) {
      var primaryEmail;
      for (var i = 0; i < resp.emails.length; i++) {
        if (resp.emails[i].type === 'account') primaryEmail = resp.emails[i].value;
      }
      console.debug("Primary Email: " + primaryEmail);
      console.debug("display name: " + resp.displayName);
      console.debug("imageurl: " + resp.image.url);
      console.debug(resp);
      console.debug(verto.data);
      verto.data.email = primaryEmail;
      verto.data.name = resp.displayName;
      storage.data.name = verto.data.name;
      storage.data.email = verto.data.email;

      $scope.login();
    }

    $scope.$on('event:google-plus-signin-failure', function (event, authResult) {
      // Auth failure or signout detected
      console.log('Google+ Login Failure');
    });

    $rootScope.$on('call.calling', function (event, data) {
      storage.data.calling = true;
    });

    $rootScope.$on('call.incoming', function (event, data) {
      console.log('Incoming call from: ' + data);

      storage.data.cur_call = 0;
      $scope.incomingCall = true;
      storage.data.videoCall = false;
      storage.data.mutedVideo = false;
      storage.data.mutedMic = false;

      prompt({
        title: $translate.instant('TITLE_INCOMING_CALL'),
        message: $translate.instant('MESSAGE_INCOMING_CALL') + data
      }).then(function () {
        var call_start = new Date(storage.data.call_start);
        $rootScope.start_time = call_start;
        console.log($rootScope.start_time);

        $scope.answerCall();
        storage.data.called_number = data;
        callHistory.add(data, 'inbound', true);
        $location.path('/incall');
      }, function () {
        $scope.declineCall();
        callHistory.add(data, 'inbound', false);
      });
    });

    $scope.hold = function () {
      storage.data.onHold = !storage.data.onHold;
      verto.data.call.toggleHold();
    };

    $scope.answerCall = function () {
      storage.data.onHold = false;

      verto.data.call.answer({
        useStereo: storage.data.useStereo,
        useCamera: storage.data.selectedVideo,
        useVideo: storage.data.useVideo,
        useMic: storage.data.useMic,
        callee_id_name: verto.data.name,
        callee_id_number: verto.data.login
      });


      $location.path('/incall');
    };

    $scope.declineCall = function () {
      $scope.hangup();
      $scope.incomingCall = false;
    };

    function sinkIdCallback(success, deviceName) {
      if (success) {
        toastr.info('Speaker is now <span class="install">' + deviceName + '</a>', 'Success', {
          allowHtml: true
        });
      } else {
        toastr.error('Your browser doesn\'t seem to support this feature', 'Error');
      }
    }
  }

})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("MenuController", [
      "$rootScope",
      "$routeParams",
      "$scope",
      "$location",
      "$translate",
      "$uibModal",
      "conferenceService",
      "verto",
      "storage",
      "prompt",
      "authenticationService",
      MenuController,
    ]);

  function MenuController(
    $rootScope,
    $routeParams,
    $scope,
    $location,
    $translate,
    $uibModal,
    conferenceService,
    verto,
    storage,
    prompt,
    authenticationService
  ) {
    $scope.storage = storage;
    $scope.chatCounter = 0;

    $rootScope.$on("testSpeed", function (e, data) {
      var vidQual = storage.data.vidQual;
      var bwp = 4;

      $scope.bandDown = data.downKPS;
      $scope.bandUp = data.upKPS;

      if (data.downKPS < 2000) {
        bwp--;
      }

      if (data.upKPS < 2000) {
        bwp--;
      }

      $scope.iconClass = "mdi-device-signal-wifi-4-bar green";

      if (bwp < 4) {
        $scope.iconClass = "mdi-device-signal-wifi-3-bar yellow";
      } else if (bwp < 2) {
        $scope.iconClass = "mdi-device-signal-wifi-1-bar red";
      }

      verto.videoQuality.forEach(function (vid) {
        if (vid.id == vidQual) {
          $scope.vidRes = vid.label;
        }
      });

      $scope.$apply();
    });

    $scope.$on("$routeChangeStart", function ($event, next, current) {
      $scope.hasCredentials = authenticationService.hasCredentials();
      $scope.isAdmin = authenticationService.isAdmin();
      $scope.isUser = authenticationService.isUser();
      $scope.isLogged = authenticationService.isLogged();
      $scope.showBackToCall =
        conferenceService.inCall && next.$$route.originalPath !== "/incall";
    });

    $scope.toggleSettings = function () {
      $rootScope.$emit("toggledSettings");
    };

    $scope.logout = function () {
      var logout = function () {
        authenticationService.logout().then(function () {
          storage.reset();
          $location.path("/login");
        });
      };

      if (verto.data.call) {
        prompt({
          title: $translate.instant("TITLE_ACTIVE_CALL"),
          message: $translate.instant("MESSAGE_ACTIVE_CALL_HANGUP"),
        }).then(function () {
          verto.hangup(function () {
            logout();
            $scope.closeChat();
          });
        });
      } else {
        logout();
      }
    };

    $scope.openProfileModal = function () {
      $uibModal.open({
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        templateUrl: "partials/modal_profile_info.html",
        controller: "ModalProfileInformationController",
        backdrop: "static",
        windowClass: "modal-edit-user",
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("vertoControllers").controller("SettingsController", [
    "$scope",
    "$http",
    "$location",
    "$rootScope",
    "storage",
    "verto",
    "$translate",
    "toastr",
    "configLanguages",
    function (
      $scope,
      $http,
      $location,
      $rootScope,
      storage,
      verto,
      $translate,
      toastr,
      configLanguages
    ) {
      $scope.speakerFeature =
        typeof document.getElementById("webcam").sinkId !== "undefined";
      $scope.storage = storage;
      $scope.verto = verto;
      $scope.mydata = angular.copy(storage.data);
      $scope.languages = configLanguages.languages;
      $scope.languages.unshift({
        id: "browser",
        name: $translate.instant("BROWSER_LANGUAGE"),
      });
      $scope.mydata.language = storage.data.language || "browser";
      $scope.settingsToggled = false;

      $rootScope.$on("$translateChangeSuccess", function () {
        $translate("BROWSER_LANGUAGE").then(function (translation) {
          $scope.languages[0].name = translation;
        });
      });

      $rootScope.$on("toggledSettings", function () {
        $scope.settingsToggled = !$scope.settingsToggled;
        $scope.mydata = angular.copy(storage.data);

        // Add click listener to #app-view, so when click outside settings, the settings will close
        var appViewEl = angular.element("#app-view");
        appViewEl.off("click");
        if ($scope.settingsToggled) {
          appViewEl.on("click", function () {
            appViewEl.off("click");
            $scope.close();
            $scope.$apply();
          });
        }
      });

      $rootScope.$on("menuToggledSettings", function () {
        $scope.settingsToggled = !$scope.settingsToggled;
        $scope.mydata = angular.copy(storage.data);

        // Add click listener to #app-view, so when click outside settings, the settings will close
        var appViewEl = angular.element("#video-call-content");
        appViewEl.off("click");
        if ($scope.settingsToggled) {
          appViewEl.on("click", function () {
            appViewEl.off("click");
            $scope.close();
            $scope.$apply();
          });
        }
      });

      $scope.ok = function () {
        angular.forEach(verto.data.videoDevices, function (video) {
          if (video.id === $scope.mydata.selectedVideo) {
            $scope.mydata.selectedVideoName = video.label;
          }
        });

        if ($scope.mydata.selectedSpeaker !== storage.data.selectedSpeaker) {
          $rootScope.$emit("changedSpeaker", $scope.mydata.selectedSpeaker);
        }

        storage.changeData($scope.mydata);
        verto.data.instance.iceServers(storage.data.useSTUN);

        if (storage.data.autoBand) {
          $scope.testSpeed();
        }

        verto.data.instance.options.audioParams = {
          googEchoCancellation:
            storage.data.googEchoCancellation === undefined
              ? true
              : storage.data.googEchoCancellation,
          googNoiseSuppression:
            storage.data.googNoiseSuppression === undefined
              ? true
              : storage.data.googNoiseSuppression,
          googHighpassFilter:
            storage.data.googHighpassFilter === undefined
              ? true
              : storage.data.googHighpassFilter,
          googAutoGainControl:
            storage.data.googAutoGainControl === undefined
              ? true
              : storage.data.googAutoGainControl,
          googAutoGainControl2:
            storage.data.googAutoGainControl === undefined
              ? true
              : storage.data.googAutoGainControl,
        };
      };

      $scope.changedLanguage = function (langKey) {
        if (langKey === "browser") {
          storage.data.language = "browser";
          var browserlang = $translate.preferredLanguage();
          $translate.use(browserlang).then(
            function (lang) {},
            function (fail_lang) {
              $translate.use("en");
            }
          );
        } else {
          $translate.use(langKey);
          storage.data.language = langKey;
        }
      };

      $scope.refreshDeviceList = function () {
        return verto.refreshDevices();
      };

      $scope.showPreview = function () {
        var settingsEl = angular.element(document.querySelector("#settings"));
        settingsEl.toggleClass("toggled");
        if (!verto.data.call) {
          $location.path("/preview");
        } else {
          toastr.warning($translate.instant("MESSAGE_DISPLAY_SETTINGS"));
        }
      };

      $scope.testSpeed = function () {
        $scope.isTestingSpeed = true;
        return verto.testSpeed(cb);

        function cb(data) {
          $scope.mydata.vidQual = storage.data.vidQual;
          $scope.speedMsg = "Up: " + data.upKPS + " Down: " + data.downKPS;
          $scope.isTestingSpeed = false;
          $scope.$apply();
        }
      };

      $scope.resetSettings = function () {
        if (confirm("Factory Reset Settings?")) {
          storage.factoryReset();
          $scope.logout();
          window.location.reload();
        }
      };

      $scope.checkAutoBand = function (option) {
        $scope.mydata.useDedenc = false;
        var bestres = videoQuality[videoQuality.length - 1];
        $scope.mydata.vidQual = bestres.id;
        storage.data.vidQual = bestres.id;
        verto.data.instance.videoParams({
          minWidth: bestres.width,
          minHeight: bestres.height,
          maxWidth: bestres.width,
          maxHeight: bestres.height,
          minFrameRate: 15,
          vertoBestFrameRate: storage.data.bestFrameRate,
        });
        storage.data.vidQual = bestres.id;
        if (!option) {
          $scope.mydata.outgoingBandwidth = "default";
          $scope.mydata.incomingBandwidth = "default";
          $scope.mydata.testSpeedJoin = false;
        } else {
          $scope.mydata.testSpeedJoin = true;
        }
      };

      $scope.checkUseDedRemoteEncoder = function (option) {
        $scope.mydata.useDedenc =
          ["0", "default", "5120"].indexOf(option) === -1;
      };

      $scope.checkVideoQuality = function (resolution) {
        var w = videoResolution[resolution]["width"];
        var h = videoResolution[resolution]["height"];
        storage.data.vidQual = resolution;
        verto.data.instance.videoParams({
          minWidth: w,
          minHeight: h,
          maxWidth: w,
          maxHeight: h,
          minFrameRate: 15,
          vertoBestFrameRate: storage.data.bestFrameRate,
        });
      };

      $scope.close = function () {
        $scope.settingsToggled = false;
        $scope.ok();
      };
    },
  ]);
})();

(function () {
    'use strict';

    angular
        .module('vertoControllers')
        .controller('PreviewController', ['$scope', '$location', 'verto', 'storage', 'prompt', '$translate',
            function ($scope, $location, verto, storage, prompt, $translate) {
                $scope.storage = storage;
                var localVideo = document.getElementById('videopreview');
                var volumes = document.querySelector('#mic-meter .volumes');
                if (volumes) {
                    volumes = volumes.children;
                }

                $scope.localVideo = function () {
                    var constraints = {
                        mirrored: true,
                        audio: {
                            optional: [{
                                sourceId: storage.data.selectedAudio
                            }]
                        }
                    };

                    var newDevice = verto.data.videoDevices.find(function (device) {
                        return device.id == storage.data.selectedVideo;
                    });

                    storage.data.selectedVideo = newDevice.id;
                    storage.data.selectedVideoName = newDevice.label;

                    if (newDevice.id !== 'none') {
                        constraints.video = {
                            optional: [{
                                sourceId: newDevice.id
                            }]
                        };
                    }

                    navigator.getUserMedia(constraints, handleMedia, function (err, data) {

                    });
                };
                var audioContext = null;
                if (typeof AudioContext !== "undefined") {
                    audioContext = new AudioContext();
                }

                var mediaStreamSource = null;
                var meter = null;
                var streamObj = {};

                function stopMedia(stream) {
                    if (typeof stream == 'function') {
                        stream.stop();
                    } else {
                        if (stream.active) {
                            var tracks = stream.getTracks();
                            tracks.forEach(function (track, index) {
                                track.stop();
                            });
                        }
                    }
                }

                function handleMedia(stream) {
                    if (streamObj) {
                        stopMedia(streamObj);
                    }

                    streamObj = stream;
                    FSRTCattachMediaStream(localVideo, stream);
                    if (audioContext) {
                        mediaStreamSource = audioContext.createMediaStreamSource(stream);
                        meter = createAudioMeter(audioContext);
                        mediaStreamSource.connect(meter);
                    }
                }

                function renderMic() {
                    // meter.volume;
                    var n = Math.round(meter.volume * 25);
                    for (var i = volumes.length - 1, j = 0; i >= 0; i--, j++) {
                        var el = angular.element(volumes[j]);
                        if (i >= n) el.removeClass('active');
                        else el.addClass('active');
                    }

                    if (!verto.data.call) {
                        window.requestAnimationFrame(renderMic);
                    }
                }

                /**
                 * TODO: useless?
                 */

                $scope.refreshDeviceList = function () {
                    return verto.refreshDevices();
                };

                $scope.videoCall = function () {
                    prompt({
                        title: $translate.instant('TITLE_ENABLE_VIDEO'),
                        message: $translate.instant('MESSAGE_ENABLE_VIDEO')
                    }).then(function () {
                        storage.data.videoCall = true;
                        $scope.callTemplate = 'partials/video_call.html';
                    });
                };

                $scope.cbMuteVideo = function (event, data) {
                    storage.data.mutedVideo = !storage.data.mutedVideo;
                };

                $scope.cbMuteMic = function (event, data) {
                    storage.data.mutedMic = !storage.data.mutedMic;
                };

                $scope.confChangeVideoLayout = function (layout) {
                    verto.data.conf.setVideoLayout(layout);
                };

                $scope.endPreview = function () {
                    localVideo.src = null;
                    if (audioContext) {
                        meter.shutdown();
                        meter.onaudioprocess = null;
                    }
                    stopMedia(streamObj);
                    $location.path('/dialpad');
                    storage.data.preview = false;
                };

                $scope.localVideo();
            }
        ]);
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("RegisterController", [
      "$scope",
      "$location",
      "$q",
      "dataService",
      "storage",
      "verto",
      "authenticationService",
      "notificationService",
      RegisterController,
    ]);

  function RegisterController(
    $scope,
    $location,
    $q,
    dataService,
    storage,
    verto,
    authenticationService,
    notificationService
  ) {
    $scope.registerData = dataService.registerData;
    $scope.user = {
      captcharesponse: false,
    };
    $scope.invalidCaptcha = true;
    $scope.inputType = "password";
    $scope.loading = false;

    $scope.captchaCreate = function () {
      console.log("CREATED");
      //                 vcRecaptchaService.reload();
    };

    $scope.invalidCaptcha = false;

    $scope.setResponse = function (response) {
      $scope.user.captcharesponse = response;
      if (response !== null && response !== undefined && response !== "") {
        $scope.invalidCaptcha = false;
      }
    };

    $scope.resetCaptcha = function () {
      vcRecaptchaService.reload();
    };

    $scope.registerUser = function () {
      var deferred = $q.defer();
      authenticationService
        .register($scope.registerData)
        .then(function (data) {
          storage.data.name = verto.data.name = $scope.registerData.username;
          storage.setUserSessionData(
            false,
            true,
            $scope.registerData.phone,
            true,
            false,
            $scope.registerData.username
          );
          deferred.resolve();
        })
        .catch(function (err) {
          deferred.reject(err);
        });

      return deferred.promise;
    };

    $scope.hideShowPassword = function () {
      if ($scope.inputType == "password") $scope.inputType = "text";
      else $scope.inputType = "password";
    };

    $scope.redirectToPhoneVerification = function () {
      $location.path("/phone-verify");
    };

    $scope.getRegisterData = function () {
      return $scope.registerData;
    };

    $scope.submitForm = function () {
      console.log("called");
      $scope.loading = true;
      if ($scope.form.$valid) {
        $scope
          .registerUser()
          .then(function (data) {
            authenticationService
              .sendVerificationCode({
                phoneNumber: $scope.registerData.phone,
                type: "register",
              })
              .then(function (response) {
                if (response.includes("SENT SUCCESS") > 0) {
                  $scope.loading = false;
                  $scope.redirectToPhoneVerification();
                } else {
                  $scope.loading = false;
                  notificationService.alertError({
                    errorMessage: "Verification code sent failed",
                  });
                }
              })
              .catch(function (err) {
                $scope.loading = false;
              });
          })
          .catch(function (err) {
            $scope.loading = false;
          });
      }
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('vertoControllers')
        .controller('LoadingController', ['$rootScope', '$scope', '$location', '$interval', 'verto',
            function($rootScope, $scope, $location, $interval, verto) {
                console.log('Loading controller');
                var int_id;

                $scope.stopInterval = function() {
                    $interval.cancel(int_id);
                };

                int_id = $interval(function() {
                  if (verto.data.resCheckEnded) {
                    $scope.stopInterval();
                    $location.path('/preview');
                  }
                }, 1000);

            }
        ]);
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("UserManagerController", [
      "$scope",
      "$uibModal",
      "userManagerService",
      UserManagerController,
    ]);

  function UserManagerController($scope, $uibModal, userManagerService) {
    $scope.search = "";
    $scope.sortBy = "Login";
    $scope.sortReverse = false;
    $scope.currentPage = 1;
    $scope.usersPerPage = 15;
    $scope.totalUsers = 1;

    var setUsersOffset = function () {
        $scope.usersOffset =
          $scope.usersPerPage * $scope.currentPage - $scope.usersPerPage;
      },
      getAllUsers = function () {
        userManagerService.getAllUsers().then(function (response) {
          $scope.users = response.data;
          $scope.totalUsers = $scope.users.length;
        });
      };

    setUsersOffset();
    getAllUsers();

    $scope.pageChanged = function () {
      setUsersOffset();
    };

    $scope.searchChange = function () {
      $scope.totalUsers = $scope.users.filter(function (user) {
        return (
          user.name.toLowerCase().includes($scope.search.toLowerCase()) ||
          user.email.toLowerCase().includes($scope.search.toLowerCase()) ||
          user.telephone.toLowerCase().includes($scope.search.toLowerCase())
        );
      }).length;

      $scope.currentPage = 1;
      $scope.usersOffset = 0;
    };

    $scope.createUser = function () {
      var modalInstance = $uibModal.open({
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        templateUrl: "partials/modal_create_user.html",
        controller: "ModalCreateUserController",
        backdrop: "static",
        windowClass: "modal-create-user",
      });

      modalInstance.result.then(getAllUsers);
    };

    $scope.editUser = function (user) {
      var modalInstance = $uibModal.open({
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        templateUrl: "partials/modal_edit_user.html",
        controller: "ModalEditUserController",
        backdrop: "static",
        windowClass: "modal-edit-user",
        resolve: {
          user: function () {
            return angular.copy(user);
          },
        },
      });
      modalInstance.result.then(function (editedUser) {
        if (editedUser) {
          user.Login = editedUser.Login;
          user.PhoneNumber = editedUser.PhoneNumber;
          user.Email = editedUser.Email;
          user.Profile = editedUser.Profile;
          user.Suspended = editedUser.Suspended;
        }
      });
    };

    $scope.deleteUser = function (phoneNumber) {
      var modalInstance = $uibModal.open({
        templateUrl: "partials/modal_delete_confirm.html",
        controller: "ModalDeleteConfirmController",
        windowClass: "modal-delete-user",
        resolve: {
          phoneNumber: function () {
            return phoneNumber;
          },
        },
      });

      modalInstance.result.then(function () {
        userManagerService.deleteUser(phoneNumber).then(
          function () {
            userManagerService.getAllUsers().then(function (response) {
              $scope.users = response.data;
              $scope.totalUsers = $scope.users.length;
            });
          },
          function (error) {
            console.error("Error occurred:", error);
          }
        );
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("ConferenceController", [
      "$scope",
      "$uibModal",
      "$location",
      "conferenceService",
      "notificationService",
      "authenticationService",
      "storage",
      ConferenceController,
    ]);

  function ConferenceController(
    $scope,
    $uibModal,
    $location,
    conferenceService,
    notificationService,
    authenticationService,
    storage
  ) {
    $scope.search = "";
    $scope.currentPage = 1;
    $scope.conferencesPerPage = 10;
    $scope.conferences = [];
    var requestCount = 100;

    var setConferenceOffset = function () {
        $scope.conferencesOffset =
          $scope.conferencesPerPage * $scope.currentPage -
          $scope.conferencesPerPage;
      },
      generateConfLink = function (number) {
        return (
          $location.protocol() + "://" + $location.host() + "?room=" + number
        );
      },
      parseDate = function (date) {
        var padZero = function (value) {
          return value.toString().padStart(2, "0");
        };

        return (
          padZero(date.getDate()) +
          "-" +
          padZero(date.getMonth() + 1) +
          "-" +
          date.getFullYear().toString().substr(-2) +
          " " +
          date.getHours() +
          ":" +
          padZero(date.getMinutes())
        );
      },
      getAllConferences = function (count) {
        conferenceService.getAllConferences(count).then(function (response) {
          $scope.conferences = response.data.map(function (conf) {
            conf.isUnlimited = conferenceService.isUnlimited(conf.begin_date);
            conf.beginLocal = new Date(conf.begin_date + " UTC");
            conf.beginParsed = parseDate(new Date(conf.begin_date + " UTC"));
            conf.lastUpdateParsed = parseDate(new Date(conf.last_status_date));
            conf.link = generateConfLink(conf.number);
            return conf;
          });
          setConferenceOffset();
        });
      },
      getConferencesByPhoneNumber = function (limit) {
        var phoneNumber = storage.data.phoneNumber;
        conferenceService
          .getConferencesByPhoneNumber(phoneNumber, limit)
          .then(function (response) {
            $scope.conferences = response.data.map(function (conf) {
              conf.isUnlimited = conferenceService.isUnlimited(conf.begin_date);
              conf.beginLocal = new Date(conf.begin_date + " UTC");
              conf.beginParsed = parseDate(new Date(conf.begin_date + " UTC"));
              conf.lastUpdateParsed = parseDate(
                new Date(conf.last_status_date)
              );
              conf.link = generateConfLink(conf.number);
              return conf;
            });
            setConferenceOffset();
          });
      };

    if (authenticationService.isAdmin()) {
      getAllConferences(requestCount);
    } else if (authenticationService.isUser()) {
      getConferencesByPhoneNumber(requestCount);
    }

    $scope.pageChanged = function () {
      var BUFFER_PAGE = $scope.conferencesPerPage * 2;
      var pages = $scope.currentPage * $scope.conferencesPerPage + BUFFER_PAGE;

      if (requestCount <= pages) {
        requestCount += 100;
        // getAllConferences(requestCount);
        if (authenticationService.isAdmin()) {
          getAllConferences(requestCount);
        } else if (authenticationService.isUser()) {
          getConferencesByPhoneNumber(requestCount);
        }
      } else {
        setConferenceOffset();
      }
    };

    $scope.copyLink = function (link, $event) {
      $event.stopPropagation();
      var input = document.getElementById("link");
      input.value = link;
      input.select();
      document.execCommand("copy");
      notificationService.alertSuccess("COPIED");
    };

    $scope.createConference = function () {
      var modalInstance = $uibModal.open({
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        templateUrl: "partials/modal_conference_form.html",
        controller: "ModalCreateConferenceController",
        backdrop: "static",
        windowClass: "modal-conference-form",
        resolve: {
          conferenceRooms: function () {
            return $scope.conferences.map(function (conference) {
              return conference.number;
            });
          },
        },
      });

      modalInstance.result.then(function () {
        $scope.currentPage = 1;
        if ($scope.conferences.length === requestCount) {
          requestCount++;
        }
        // getAllConferences(requestCount);
        if (authenticationService.isAdmin()) {
          getAllConferences(requestCount);
        } else if (authenticationService.isUser()) {
          getConferencesByPhoneNumber(requestCount);
        }
      });
    };

    $scope.editConference = function (conference, index) {
      var modalInstance = $uibModal.open({
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        templateUrl: "partials/modal_conference_form.html",
        controller: "ModalEditConferenceController",
        backdrop: "static",
        windowClass: "modal-conference-form",
        resolve: {
          conference: function () {
            return angular.copy(conference);
          },
          conferenceRooms: function () {
            var confNumber = conference.number;
            return $scope.conferences
              .filter(function (c) {
                return confNumber !== c.number;
              })
              .map(function (c) {
                return c.number;
              });
          },
        },
      });
      modalInstance.result.then(function (conf) {
        switch (conf.type) {
          case "edit":
            var data = conf.data;
            conference.isUnlimited = conferenceService.isUnlimited(
              data.begin_date
            );
            conference.begin_date = data.begin_date;
            conference.beginLocal = data.beginLocal;
            conference.beginParsed = parseDate(data.beginLocal);
            conference.lastUpdateParsed = parseDate(new Date());
            conference.moderator = data.moderator;
            conference.participants = data.participants;
            conference.pin = data.pin;
            conference.number = data.number;
            conference.description = data.description;
            conference.send_mail = data.send_mail;
            conference.allow_not_registered = data.allow_not_registered;
            conference.link = generateConfLink(data.number);
            break;
          case "delete":
            $scope.conferences.splice(index, 1);
            break;
        }
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("PhoneVerifyController", [
      "$scope",
      "$location",
      "dataService",
      "authenticationService",
      "notificationService",
      "storage",
      PhoneVerifyController,
    ]);

  function PhoneVerifyController(
    $scope,
    $location,
    dataService,
    authenticationService,
    notificationService,
    storage
  ) {
    // $scope.phone = dataService.registerData.phone;

    $scope.phone = authenticationService.getPhoneNumber();
    console.log("Phone Verify Phone Number:", $scope.phone);
    $scope.verificationCode = "";
    $scope.loading = false;

    $scope.inputFunc = function (myValue) {
      var myEl = document.getElementById("otp-number-input");
      var num1 = document.getElementById("otp-number-input-1");
      var num2 = document.getElementById("otp-number-input-2");
      var num3 = document.getElementById("otp-number-input-3");
      var num4 = document.getElementById("otp-number-input-4");

      myEl.value = parseInt(num1.value + num2.value + num3.value + num4.value);
      $scope.verificationCode =
        num1.value + num2.value + num3.value + num4.value;
      var container = document.getElementsByClassName("input-code")[0];
      container.onkeydown = function (e) {
        var target = e.target;

        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while ((next = next.nextElementSibling)) {
            if (next == null) break;
            if (next.tagName.toLowerCase() == "input") {
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while ((prev = prev.previousElementSibling)) {
            if (prev == null) break;

            if (prev.tagName.toLowerCase() == "input") {
              prev.focus();
              break;
            }
          }
        }
      };
    };

    $scope.redirectToSuccess = function () {
      $location.path("/success");
    };
    $scope.submitForm = function () {
      $scope.loading = true;
      authenticationService
        .checkVerificationCode({
          phoneNumber: $scope.phone,
          verificationCode: $scope.verificationCode,
          type: "register",
        })
        .then(function () {
          $scope.loading = false;
        })
        .catch(function () {
          $scope.loading = false;
        });
    };
    $scope.sendVerifCode = function () {
      authenticationService
        .sendVerificationCode({ phoneNumber: $scope.phone, type: "register" })
        .then(function (response) {
          if (response.includes("SENT SUCCESS") > 0) {
            notificationService.alertSuccess("Verfication code sent success");
          } else {
            notificationService.alertError({
              errorMessage: "Verification code sent failed",
            });
          }
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("SuccessController", [
      "$scope",
      "$location",
      "authenticationService",
      SuccessController,
    ]);

  function SuccessController($scope, $location, authenticationService) {
    $scope.loading = false;

    $scope.toDialPage = function () {
      $scope.loading = true;
      authenticationService.redirectAfterLogin().then(function () {
        $scope.loading = false;
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("MobileEnterController", [
      "$scope",
      "$location",
      "$routeParams",
      "conferenceService",
      "storage",
      MobileEnterController,
    ]);

  function MobileEnterController(
    $scope,
    $location,
    $routeParams,
    conferenceService,
    storage
  ) {
    $scope.isMobile = storage.data.isMobile;
    $scope.room = $routeParams.room;
    $scope.link = window.location.origin + "?room=" + $routeParams.room;
    storage.data.room = $routeParams.room;

    $scope.continueWebVersion = function () {
      if (storage.data.name) {
        $location.path("/dialpad");
      } else {
        $location.path("/login");
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('vertoControllers')
    .controller('ModalDialpadController', ['$scope', '$uibModalInstance', 'verto', ModalDialpadController]);

  function ModalDialpadController($scope, $uibModalInstance, verto) {
    $scope.extensionNumber = '';

    $scope.dialExtension = function (number) {
      $scope.extensionNumber += number;
      verto.dtmf(number);
    };

    $scope.closeDialpad = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('vertoControllers')
        .controller('ModalWsReconnectController', ModalWsReconnectController);

    ModalWsReconnectController.$inject = ['$rootScope', '$scope', 'storage', 'verto'];

    function ModalWsReconnectController($rootScope, $scope, storage, verto) {
        console.debug('Executing ModalWsReconnectController');

        $scope.closeReconnect = closeReconnect;

        function closeReconnect() {
            if ($rootScope.ws_modalInstance && verto.data.instance) {
                verto.data.instance.rpcClient.stopRetrying();
                $rootScope.ws_modalInstance.close();
                delete verto.data.instance;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vertoControllers')
        .controller('ModalProfileInformationController', ['$scope', '$uibModalInstance', 'verto', 'storage',
            'userManagerService', ModalProfileInformationController]);

    function ModalProfileInformationController($scope, $uibModalInstance, verto, storage, userManagerService) {
        $scope.user = {
            Id: storage.data.userId,
            Login: storage.data.name,
            Email: storage.data.email,
            PhoneNumber: storage.data.phone
        };
        $scope.passwordChange = {
            username: storage.data.name,
            oldpass: undefined,
            newpass: undefined
        };
        $scope.editProfileForm = false;

        $scope.editProfile = function () {
            userManagerService.editUser($scope.user).then(function () {
                storage.data.name = verto.data.name = $scope.user.Login;
                storage.data.email = verto.data.email = $scope.user.Email;
                storage.data.phone = $scope.user.PhoneNumber;
                $uibModalInstance.close();
            });
        };

        $scope.changePassword = function () {
            userManagerService.changeLoggedInUserPassword($scope.passwordChange).then($uibModalInstance.close);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss();
        };
    }

})();

(function () {
  'use strict';

  angular
    .module('vertoControllers')
    .controller('ModalEditUserController', ['$scope', '$uibModalInstance', 'user', 'userManagerService',
      ModalEditUserController]);

  function ModalEditUserController($scope, $uibModalInstance, user, userManagerService) {
    $scope.editProfileForm = true;
    $scope.user = user;
    $scope.password = undefined;
    $scope.loading = false;

    $scope.editProfile = function () {
      $scope.loading = true;
      userManagerService.editUser($scope.user).then(function () {
        $uibModalInstance.close($scope.user);
        $scope.loading = false;
      }).catch(function () {
        $scope.loading = false;
      });;
    }

    $scope.changePassword = function () {
      userManagerService.changePassword($scope.user.Id, $scope.password).then($uibModalInstance.close);
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("ModalCreateUserController", [
      "$scope",
      "$uibModalInstance",
      "userManagerService",
      ModalCreateUserController,
    ]);

  function ModalCreateUserController(
    $scope,
    $uibModalInstance,
    userManagerService
  ) {
    $scope.user = {
      Profile: "user",
    };
    $scope.loading = false;

    $scope.create = function () {
      $scope.loading = true;
      userManagerService.createUser($scope.user).then(function () {
        $uibModalInstance.close();
        $scope.loading = false;
      }).catch(function() {
        $scope.loading = false;
      });
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

angular
  .module("vertoControllers")
  .controller(
    "ModalDeleteConfirmController",
    ["$scope", "$uibModalInstance", "phoneNumber", function ($scope, $uibModalInstance, phoneNumber) {
      $scope.phoneNumber = phoneNumber;

      $scope.ok = function () {
        $uibModalInstance.close();
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }]
  );

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("ModalCreateConferenceController", [
      "$scope",
      "$uibModal",
      "$uibModalInstance",
      "conferenceService",
      "authenticationService",
      "VALIDATOR",
      "conferenceRooms",
      ModalEditConferenceController,
    ]);

  function ModalEditConferenceController(
    $scope,
    $uibModal,
    $uibModalInstance,
    conferenceService,
    authenticationService,
    VALIDATOR,
    conferenceRooms
  ) {
    $scope.openDate = false;
    $scope.new = true;
    $scope.conf = {
      number: undefined,
      pin: undefined,
      moderator: undefined,
      begin_date: new Date(),
      description: undefined,
      send_mail: 1,
      allow_not_registered: 1,
      status: 1,
      participants: "",
    };
    $scope.emailRegex = VALIDATOR.EMAIL;
    $scope.unlimitedConf = false;
    $scope.confNumberDigits = 5;
    $scope.participants = "";
    $scope.loading = false;

    $scope.conf.number = Math.floor(
      Math.pow(10, $scope.confNumberDigits) +
        Math.random() * 9 * Math.pow(10, $scope.confNumberDigits)
    ).toString();

    $scope.roomNumberChanged = function (modelCtrl) {
      if (isNaN($scope.conf.number)) {
        $scope.conf.number = $scope.conf.number.slice(0, -1);
        return;
      }
      modelCtrl.$setValidity(
        "roomAlreadyExists",
        conferenceRooms.indexOf($scope.conf.number) === -1
      );
    };

    $scope.save = function () {
      $scope.loading = true;
      $scope.conf.moderator = authenticationService.getPhoneNumber();
      $scope.conf.participants = $scope.participants.split(",");
      if ($scope.unlimitedConf) {
        $scope.conf.begin_date = conferenceService.toUnlimitedDate();
      }
      console.log($scope.conf);
      conferenceService.createConf($scope.conf).then(function() {
        $uibModalInstance.close();
        $scope.loading = false;
      }).catch(function () {
        $scope.loading = false;
      });
    };

    $scope.addParticipants = function () {
      var modalInstance = $uibModal.open({
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        templateUrl: "partials/modal_add_user_conference_form.html",
        controller: "ModalAddUserConferenceController",
        backdrop: "static",
        windowClass: "modal-add-user-conference-form",
        resolve: {
          conference: function () {
            return angular.copy($scope.conf);
          },
        },
      });

      modalInstance.result.then(function (users) {
        $scope.conf.participants = users;
      });
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("vertoControllers")
    .controller("ModalEditConferenceController", [
      "$scope",
      "$uibModalInstance",
      "conferenceService",
      "modalService",
      "VALIDATOR",
      "conference",
      "conferenceRooms",
      ModalEditConferenceController,
    ]);

  function ModalEditConferenceController(
    $scope,
    $uibModalInstance,
    conferenceService,
    modalService,
    VALIDATOR,
    conference,
    conferenceRooms
  ) {
    $scope.emailRegex = VALIDATOR.EMAIL;
    $scope.conf = angular.copy(conference);
    var isUnlimited = conferenceService.isUnlimited(conference.begin_date);
    $scope.conf.begin_date = isUnlimited ? new Date() : conference.beginLocal;
    $scope.unlimitedConf = isUnlimited;
    $scope.participants = conference.participants.join(",");
    $scope.loading = false;

    $scope.roomNumberChanged = function (modelCtrl) {
      if (isNaN($scope.conf.number)) {
        $scope.conf.number = $scope.conf.number.slice(0, -1);
        return;
      }
      modelCtrl.$setValidity(
        "roomAlreadyExists",
        conferenceRooms.indexOf($scope.conf.number) === -1
      );
    };

    $scope.setDateToNow = function () {
      $scope.conf.begin_date = new Date();
    };

    $scope.addParticipants = function () {
      var modalInstance = modalService.openModal(
        "partials/modal_add_user_conference_form.html",
        "ModalAddUserConferenceController",
        {
          windowClass: "modal-add-user-conference-form",
          resolve: {
            conference: function () {
              return angular.copy(conference);
            },
          },
        }
      );

      modalInstance.result.then(function (users) {
        $scope.conf.participants = users;
      });
    };

    $scope.save = function () {
      $scope.loading = true;
      $scope.conf.participants = $scope.participants.split(",");
      if ($scope.unlimitedConf) {
        $scope.conf.begin_date = conferenceService.toUnlimitedDate();
      }
      conferenceService.editConf($scope.conf).then(function (conf) {
        $uibModalInstance.close({ type: "edit", data: conf });
      });
      $scope.loading = false;
    };

    $scope.deleteConf = function () {
      $scope.loading = true;
      conferenceService.deleteConf($scope.conf.id).then(function () {
        $uibModalInstance.close({ type: "delete" });
      });
      $scope.loading = false;
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('vertoControllers')
    .controller('ModalEditConferenceDateController', ['$scope', '$uibModalInstance', 'conferenceService', 'conference',
      ModalEditConferenceDateController]);

  function ModalEditConferenceDateController($scope, $uibModalInstance, conferenceService, conference) {
    $scope.conf = conference;
    $scope.conf.number = +$scope.conf.number;
    $scope.conf.begin_date = conference.beginLocal;

    $scope.setDateToNow = function () {
      $scope.conf.begin_date = new Date();
    };

    $scope.save = function () {
      conferenceService.editConf($scope.conf).then(function () {
        $scope.cancel();
      });
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('vertoControllers')
    .controller('ModalAddUserConferenceController', ['$scope', '$uibModalInstance', 'conference', 'conferenceService', 'userManagerService', ModalAddUserConferenceController]);

  function ModalAddUserConferenceController($scope, $uibModalInstance, conference, conferenceService, userManagerService) {
    $scope.search = '';
    $scope.sortBy = 'Login';

    var getAllConfUsers = function () {
      userManagerService.getAllUsers().then(function (response) {
        $scope.users = response.data.map(function (user) {
          user.selected = !!conference.participants.find(function (email) {
            return email === user.Email;
          });
          return user;
        });
      });
    };

    getAllConfUsers();

    $scope.addUser = function (user) {
      user.selected = !user.selected;
    };

    $scope.save = function () {
      var selectedUsers = $scope.users.reduce(function (selected, currentUser) {
        if (currentUser.selected) {
          selected.push(currentUser.Email);
        }
        return selected;
      }, []);

      var notRegisterdParticipants = conference.participants.reduce(function (filtered, currentParticipant) {
        var current = currentParticipant.trim();
        var registered = $scope.users.find(function (user) {
          return user.Email === current;
        });

        if (!registered) filtered.push(current);

        return filtered;
      }, []);
      var output = selectedUsers.concat(notRegisterdParticipants);
      $uibModalInstance.close(output);
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('vertoControllers')
    .controller('ModalPinDialpadController', ['$scope', '$uibModalInstance', 'verto', 'toastr', 'pin', ModalDialpadController]);

  function ModalDialpadController($scope, $uibModalInstance, verto, toastr, pin) {
    $scope.dialpadPin = '';

    $scope.addDigitToPin = function (number) {
      $scope.dialpadPin += number;
    };

    $scope.backspace = function () {
      $scope.dialpadPin = $scope.dialpadPin.slice(0, -1);
    };

    $scope.submitPin = function () {
      if ($scope.dialpadPin === pin) {
        verto.dtmf($scope.dialpadPin);
      } else {
        toastr.error('Enter valid pin');
      }
    };

    $scope.endCall = function () {
      $uibModalInstance.close();
    };
  }
})();

(function() {
  'use strict';
  angular.module('vertoDirectives', []);
})();

/*
Sometimes autofocus HTML5 directive just isn't enough with SPAs.
This directive will force autofocus to work properly under those circumstances.
*/
(function () {
  'use strict';

  angular
  .module('vertoDirectives')
  .directive('autofocus', ['$timeout',
    function ($timeout) {
      return {
        restrict: 'A',
        link: function ($scope, $element) {
          $timeout(function () {
            $element[0].focus();
          });
        }
      };
    }
  ]);
})();
(function () {
  'use strict';

  angular
    .module('vertoDirectives')
    .directive('showControls', ['screenService', function (screenService) {
      var link = function (scope, element, attrs) {
        var i = null;
        jQuery('.video-footer').fadeIn('slow');
        jQuery('.video-hover-buttons').fadeIn('slow');
        element.parent().bind('mousemove', function () {
          if (screenService.isInFullscreenMode) {
            clearTimeout(i);
            jQuery('.video-footer').fadeIn('slow');
            jQuery('.video-hover-buttons').fadeIn(500);
            i = setTimeout(function () {
              if (screenService.isInFullscreenMode) {
                jQuery('.video-footer').fadeOut('slow');
                jQuery('.video-hover-buttons').fadeOut(500);
              }
            }, 3000);
          }
        });
        element.parent().bind('mouseleave', function () {
          jQuery('.video-footer').fadeIn();
          jQuery('.video-hover-buttons').fadeIn();
        });
      }


      return {
        link: link
      };
    }]);

})();

(function () {
    'use strict';

    angular
        .module('vertoDirectives').directive('userStatus',
        function () {
            return {
                scope: {
                    'condition': '='
                },
                link: function (scope, element, attrs) {
                    scope.$watch('condition', function (condition) {
                        element.removeClass('connected');
                        element.removeClass('disconnected');
                        element.removeClass('connecting');

                        element.addClass(condition);
                    });
                }
            };
        });
})();

/**
 * To RTC work properly we need to give a <video> tag as soon as possible
 * because it needs to attach the video and audio stream to the tag.
 *
 * This directive is responsible for moving the video tag from the body to
 * the right place when a call start and move back to the body when the
 * call ends. It also hides and display the tag when its convenient.
 */
(function () {
  'use strict';

  angular
    .module('vertoDirectives')
    .directive('videoTag', ['storage',
      function (storage) {

        function link(scope, element, attrs) {
          // Moving the video tag to the new place inside the incall page.
          console.log('Moving the video to element.');
          var videoElem = $('#webcam');

          var newParent = document.getElementsByClassName('video-tag-wrapper');
          newParent[0].appendChild(document.getElementById('webcam'));
          videoElem.removeClass('hide');
          videoElem.css('display', 'block');

          storage.data.videoCall = true;

          element.on('$destroy', function () {
            // Move the video back to the body.
            console.log('Moving the video back to body.');
            videoElem.addClass('hide').appendTo($('body'));
          });
        }

        return {
          link: link
        }
      }]);

})();

(function () {
  'use strict';

  angular
    .module('vertoDirectives')
    .directive('parseConfParicipants', ['VALIDATOR', function (VALIDATOR) {
      return {
        restrict: 'A',
        scope: {},
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
          ngModelCtrl.$validators.participants = function(modelValue) {
            if (ngModelCtrl.$isEmpty(modelValue)) {
              return true;
            }

            var emails = Array.isArray(modelValue) ? modelValue : modelValue.split(',');
            var isValid = true;
            for (var i = 0; i < emails.length; i++) {
              var email = emails[i].trim();
              if (email.length && !VALIDATOR.EMAIL.test(email)) {
                isValid = false;
                break;
              }
            }

            return isValid;
          };

          element.bind('blur', function (event) {
            var value = event.currentTarget.value;
            if (value) {
              var participants = value.split(',').reduce(function (filtered, current) {
                if (current) {
                  filtered.push(current.trim());
                }
                return filtered;
              }, []);
              ngModelCtrl.$setViewValue(participants);
            } else {
              ngModelCtrl.$setViewValue([]);
            }
          });
        }
      }
    }]);
})();

(function () {
  "use strict";
  angular.module("vertoDirectives").directive("numericOnly", [
    "notificationService",
    function (notificationService) {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {
          element.on("keypress", function (event) {
            var keyCode = event.which;
            // keyCode 48 to 57 are the key codes for numbers 0 to 9
            if (keyCode < 48 || keyCode > 57) {
              event.preventDefault();
              notificationService.alertError({
                errorMessage: "Only numbers are allowed",
              });
            }
          });

          element.on("paste", function (event) {
            var clipboardData =
              event.originalEvent.clipboardData || window.clipboardData;
            var pastedText = clipboardData.getData("text");
            if (pastedText && /\D/g.test(pastedText)) {
              // \D is the regex for non-digits
              event.preventDefault();
              notificationService.alertError({
                errorMessage: "Only numbers are allowed",
              });
            }
          });
        },
      };
    },
  ]);
})();

(function () {
  "use strict";
  angular.module("vertoDirectives").directive("googleAd", [
    "$timeout",
    function ($timeout) {
      return {
        restrict: "A",
        link: function (scope, element, attr) {
          return $timeout(function () {
            var adsbygoogle, html, rand;
            rand = Math.random();
            html =
              "<ins class='adsbygoogle' style='display:block' data-ad-client='ca-pub-7855840777576985' data-ad-slot='1674676730' data-ad-format='auto'></ins>";
            $(element).append(html);
            return (adsbygoogle = window.adsbygoogle || []).push({});
          });
        },
      };
    },
  ]);
})();

(function() {
  'use strict';
  angular.module('vaertoComponentsModule', []);
})();

(function () {
  'use strict';

  angular
    .module('vaertoComponentsModule')
    .component('thSort', {
      template: '<span>{{$ctrl.label | translate}}</span>' +
        '<i ng-show="$ctrl.sort !== $ctrl.by" class="mdi-navigation-unfold-more"></i>' +
        '<i ng-show="$ctrl.sort === $ctrl.by && !$ctrl.dir" class="mdi-navigation-expand-less"></i>' +
        '<i ng-show="$ctrl.sort === $ctrl.by && $ctrl.dir" class="mdi-navigation-expand-more"></i>',
      bindings: {
        label: '@',
        sort: '<',
        by: '@',
        dir: '<'
      }
    });
})();

(function () {
  "use strict";

  angular.module("vaertoComponentsModule").component("dialpadDigit", {
    template:
      "" +
      // '<div class="{{::($ctrl.colClass || \'col-lg-4 col-md-4 col-xs-4\')}}">' +
      '<div ng-class="{{::($ctrl.colClass)}}">' +
      ' <div role="button" class="dialpad-number {{::$ctrl.classes}}">' +
      '<i class="{{::$ctrl.icon}}" ng-if="$ctrl.icon"></i>' +
      // '<span ng-if="$ctrl.digit">{{::$ctrl.digit}}</span>' +
      "{{::$ctrl.digit}}" +
      '<img ng-src="{{::$ctrl.image}}" ng-if="$ctrl.image"/>' +
      "</div>" +
      "</div>",
    bindings: {
      digit: "@",
      icon: "@",
      image: "@",
      colClass: "@",
      classes: "@",
    },
  });
})();

(function () {
  "use strict";

  angular.module("vaertoComponentsModule").component("dialpadDigits", {
    template:
      "" +
      '<div id="dialpad-digits-component" ng-click="$ctrl.digitClicked($event)">' +
      '  <div class="digital-row">' +
      '    <dialpad-digit digit="1"></dialpad-digit>' +
      '    <dialpad-digit digit="2"></dialpad-digit>' +
      '    <dialpad-digit digit="3" ></dialpad-digit>' +
      "  </div>" +
      '  <div class="digital-row">' +
      '    <dialpad-digit digit="4"></dialpad-digit>' +
      '    <dialpad-digit digit="5"></dialpad-digit>' +
      '    <dialpad-digit digit="6" ></dialpad-digit>' +
      "  </div>" +
      '  <div class="digital-row">' +
      '    <dialpad-digit digit="7"></dialpad-digit>' +
      '    <dialpad-digit digit="8"></dialpad-digit>' +
      '    <dialpad-digit digit="9" ></dialpad-digit>' +
      "  </div>" +
      '  <div class="digital-row">' +
      '    <dialpad-digit classes="digit-redial" image="assets/images/dialpad_redial.svg" ng-click="$ctrl.redialLastCall()" ng-if="$ctrl.isRedial"></dialpad-digit>' +
      '    <dialpad-digit classes="digit-pin-submit" ng-click="$ctrl.pinSubmit()" ng-if="$ctrl.isPinSubmit" icon="mdi-action-done"></dialpad-digit>' +
      '    <dialpad-digit classes="digit-in-call" ng-if="$ctrl.isInCallDialpad"></dialpad-digit>' +
      '    <dialpad-digit digit="0"></dialpad-digit>' +
      '    <dialpad-digit classes="digit-call" image="assets/images/dialpad_call.svg" ng-click="$ctrl.call()" ng-if="$ctrl.isCall"></dialpad-digit>' +
      '    <dialpad-digit classes="digit-end-call" ng-click="$ctrl.endCall()" ng-if="$ctrl.isEndCall" icon="mdi-communication-call-end"></dialpad-digit>' +
      '    <dialpad-digit classes="digit-end-call" ng-click="$ctrl.closeDialpad()" ng-if="$ctrl.isInCallDialpad" icon="mdi-navigation-cancel"></dialpad-digit>' +
      "  </div>" +
      "</div>",
    controller: DialpadDigitsController,
    bindings: {
      onPress: "&",
      onRedial: "&?",
      onCall: "&?",
      onPinSubmit: "&?",
      onEndCall: "&?",
      onCloseDialpad: "&?",
      isRedial: "@?",
      isCall: "@?",
      isPinSubmit: "@?",
      isEndCall: "@?",
      isInCallDialpad: "@?",
    },
  });

  function DialpadDigitsController() {
    var ctrl = this;

    ctrl.digitClicked = function (event) {
      if (event.target.getAttribute("role") === "button") {
        ctrl.onPress({ digit: event.target.innerText });
      }
    };

    ctrl.redialLastCall = function () {
      ctrl.onRedial();
    };

    ctrl.call = function () {
      ctrl.onCall();
    };

    ctrl.pinSubmit = function () {
      ctrl.onPinSubmit();
    };

    ctrl.endCall = function () {
      ctrl.onEndCall();
    };

    ctrl.closeDialpad = function () {
      ctrl.onCloseDialpad();
    };
  }
})();

(function () {
  "use strict";

  angular.module("vaertoComponentsModule").component("dialpadKeyListener", {
    controller: ["$scope", "$document", DialpadKeyListenerController],
    bindings: {
      onDigit: "&",
      onBackspace: "&",
      onEnter: "&",
      onEsc: "&",
      onPaste: "&",
    },
  });

  function DialpadKeyListenerController($scope, $document) {
    var ctrl = this;

    function onKeydown(event) {
      var keyValue = event.key;

      if (!isNaN(keyValue)) {
        ctrl.onDigit({ digit: keyValue });
      } else {
        switch (keyValue) {
          case "Backspace":
            ctrl.onBackspace();
            break;
          case "Enter":
            ctrl.onEnter();
            break;
          case "Escape":
            ctrl.onEsc();
            break;
          default:
            return;
        }
      }

      $scope.$apply();
    }

    function onPasteFunc(event) {
      var clipboardData =
        event.originalEvent.clipboardData || window.clipboardData;
      var pastedText = clipboardData.getData("text");

      ctrl.onPaste({ dialpadNumber: pastedText });

      $scope.$apply();
    }

    ctrl.$onInit = function () {
      $document.bind("keydown", onKeydown);
      $document.bind("paste", onPasteFunc);
    };

    ctrl.$onDestroy = function () {
      $document.unbind("keydown", onKeydown);
      $document.unbind("paste", onPasteFunc);
    };
  }
})();

// (function () {
//   "use strict";

//   angular
//     .module("vaertoComponentsModule", ["ngIntlTelInput"])
//     .config(function (ngIntlTelInputProvider) {
//       ngIntlTelInputProvider.set({ initialCountry: "us" });
//     })
//     .component("phoneInput", {
//       template:
//         "" +
//         '<input id="phone" type="tel" name="phone" class="default-phone phone-input" ng-model="$ctrl.phone" />',
//       bindings: {
//         phone: "=",
//       },
//     });
// })();

(function () {
  "use strict";

  angular.module("vaertoComponentsModule").component("phoneInput", {
    template:
      '<input id="{{::$ctrl.id}}" name="{{::$ctrl.name}}" class="phone phone-input" ng-model="$ctrl.phone" required />',
    bindings: {
      phone: "=",
      id: "@",
      name: "@",
    },
    controller: function () {
      // const phoneInputField = document.querySelector(".phone");
      // window.intlTelInput(phoneInputField, {
      //   utilsScript:
      //     "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
      // });
    },
  });
})();

(function() {
  'use strict';
  var vertoFilters = angular.module('vertoFilters', []);
})();

(function () {
  'use strict';

  angular
  .module('vertoFilters')
  .filter('picturify', function() {
    var regex = /<a (|target="\s*\S*" )href="(\s*\S*.(png|jpg|svg|gif|webp|bmp))">\s*\S*<\/a>/i;
    var regex64 = /data:image\/(\s*\S*);base64,((?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=))/g;

    return function (text, width, n) {
      var i = 0;
      width = width || 150; //default width
      if(regex64.test(text)) {
        text = text.replace(regex64, '<a href="$1" target="_blank"><img class="chat-img" width="'+ width +'" src="data:image/png;base64,$2"/></a>')
      }

      do {
        text = text.replace(regex, '<a $1href="$2"><img class="chat-img" width="'+ width +'" src="$2"/></a>');
      } while((!n || (n && i++ < n)) && regex.test(text));

      return text;
    }

  });

})();

angular.module('vertoService', ['ngCookies']);

"use strict";

/* Controllers */
var videoQuality = [];
var videoQualitySource = [
  {
    id: "qqvga",
    label: "QQVGA 160x120",
    width: 160,
    height: 120,
  },
  {
    id: "qvga",
    label: "QVGA 320x240",
    width: 320,
    height: 240,
  },
  {
    id: "vga",
    label: "VGA 640x480",
    width: 640,
    height: 480,
  },
  {
    id: "qvga_wide",
    label: "QVGA WIDE 320x180",
    width: 320,
    height: 180,
  },
  {
    id: "vga_wide",
    label: "VGA WIDE 640x360",
    width: 640,
    height: 360,
  },
  {
    id: "hd",
    label: "HD 1280x720",
    width: 1280,
    height: 720,
  },
  {
    id: "hhd",
    label: "HHD 1920x1080",
    width: 1920,
    height: 1080,
  },
];

var videoResolution = {
  qqvga: {
    width: 160,
    height: 120,
  },
  qvga: {
    width: 320,
    height: 240,
  },
  vga: {
    width: 640,
    height: 480,
  },
  qvga_wide: {
    width: 320,
    height: 180,
  },
  vga_wide: {
    width: 640,
    height: 360,
  },
  hd: {
    width: 1280,
    height: 720,
  },
  hhd: {
    width: 1920,
    height: 1080,
  },
};

var bandwidth = [
  {
    id: "250",
    label: "250kb",
  },
  {
    id: "500",
    label: "500kb",
  },
  {
    id: "1024",
    label: "1mb",
  },
  {
    id: "1536",
    label: "1.5mb",
  },
  {
    id: "2048",
    label: "2mb",
  },
  {
    id: "3196",
    label: "3mb",
  },
  {
    id: "4192",
    label: "4mb",
  },
  {
    id: "5120",
    label: "5mb",
  },
  {
    id: "0",
    label: "No Limit",
  },
  {
    id: "default",
    label: "Server Default",
  },
];

var framerate = [
  {
    id: "15",
    label: "15 FPS",
  },
  {
    id: "20",
    label: "20 FPS",
  },
  {
    id: "30",
    label: "30 FPS",
  },
];

var updateReq;

angular.module("vertoService").factory("verto", [
  "$rootScope",
  "$location",
  "storage",
  "VERTO_CONFIG",
  "BROWSER",
  function ($rootScope, $location, storage, VERTO_CONFIG, BROWSER) {
    var data = {
      // Connection data.
      instance: null,
      connected: false,

      // Call data.
      call: null,
      shareCall: null,
      callState: null,
      conf: null,
      confLayouts: [],
      confRole: null,
      chattingWith: null,
      liveArray: null,

      // Settings data.
      videoDevices: [],
      audioDevices: [],
      shareDevices: [],
      videoQuality: [],
      extension: null,
      name: "",
      email: "",
      cid: undefined,
      textTo: undefined,
      login: VERTO_CONFIG.LOGIN,
      password: VERTO_CONFIG.PASSWORD,
      hostname: VERTO_CONFIG.HOSTNAME,
      wsURL: VERTO_CONFIG.WEBSOCKET_URL,
      socketFallbackUrl: null,
      turnServer: null,
      resCheckEnded: false,
      number: 1111,
    };

    function cleanShareCall(that) {
      data.shareCall = null;
      data.callState = "active";
      that.refreshDevices();
    }

    function cleanCall() {
      data.call = null;
      data.callState = null;
      data.conf = null;
      data.confLayouts = [];
      data.confRole = null;
      data.chattingWith = null;

      $rootScope.$emit("call.hangup", "hangup");
    }

    function inCall() {
      $rootScope.$emit("page.incall", "call");
    }

    function callActive(last_state, params) {
      $rootScope.$emit("call.active", last_state, params);
    }

    function calling() {
      $rootScope.$emit("call.calling", "calling");
    }

    function incomingCall(number) {
      $rootScope.$emit("call.incoming", number);
    }

    function updateResolutions(supportedResolutions) {
      console.debug("Attempting to sync supported and available resolutions");

      //var removed = 0;

      console.debug("VQ length: " + videoQualitySource.length);
      console.debug(supportedResolutions);

      angular.forEach(videoQualitySource, function (resolution, id) {
        angular.forEach(supportedResolutions, function (res) {
          var width = res[0];
          var height = res[1];

          if (resolution.width == width && resolution.height == height) {
            videoQuality.push(resolution);
          }
        });
      });

      // videoQuality.length = videoQuality.length - removed;
      console.debug("VQ length 2: " + videoQuality.length);
      data.videoQuality = videoQuality;
      console.debug(videoQuality);
      data.vidQual =
        videoQuality.length > 0
          ? videoQuality[videoQuality.length - 1].id
          : null;
      console.debug(data.vidQual);

      return videoQuality;
    }

    return {
      data: data,

      // Options to compose the interface.
      videoQuality: videoQuality,
      videoResolution: videoResolution,
      bandwidth: bandwidth,
      framerate: framerate,

      refreshDevicesCallback: function refreshDevicesCallback(callback) {
        data.videoDevices = [
          {
            id: "none",
            label: "No Camera",
          },
        ];
        data.shareDevices = [
          {
            id: "screen",
            label: "Screen",
          },
        ];
        data.audioDevices = [
          {
            id: "any",
            label: "Default Microphone",
          },
          {
            id: "none",
            label: "No Microphone",
          },
        ];
        data.speakerDevices = [
          {
            id: "any",
            label: "Default Speaker",
          },
        ];

        if (!storage.data.selectedShare) {
          storage.data.selectedShare = data.shareDevices[0]["id"];
        }

        for (var i in jQuery.verto.videoDevices) {
          var device = jQuery.verto.videoDevices[i];
          if (!device.label) {
            data.videoDevices.push({
              id: "Camera " + i,
              label: "Camera " + i,
            });
          } else {
            data.videoDevices.push({
              id: device.id,
              label: device.label || device.id,
            });
          }

          // Selecting the first source.
          if (i == 0 && !storage.data.selectedVideo) {
            storage.data.selectedVideo = device.id;
          }

          if (!device.label) {
            data.shareDevices.push({
              id: "Share Device " + i,
              label: "Share Device " + i,
            });
            continue;
          }

          data.shareDevices.push({
            id: device.id,
            label: device.label || device.id,
          });
        }

        for (var i in jQuery.verto.audioInDevices) {
          var device = jQuery.verto.audioInDevices[i];
          // Selecting the first source.
          if (i == 0 && !storage.data.selectedAudio) {
            storage.data.selectedAudio = device.id;
          }

          if (!device.label) {
            data.audioDevices.push({
              id: "Microphone " + i,
              label: "Microphone " + i,
            });
            continue;
          }
          data.audioDevices.push({
            id: device.id,
            label: device.label || device.id,
          });
        }

        for (var i in jQuery.verto.audioOutDevices) {
          var device = jQuery.verto.audioOutDevices[i];
          // Selecting the first source.
          if (i == 0 && !storage.data.selectedSpeaker) {
            storage.data.selectedSpeaker = device.id;
          }

          if (!device.label) {
            data.speakerDevices.push({
              id: "Speaker " + i,
              label: "Speaker " + i,
            });
            continue;
          }
          data.speakerDevices.push({
            id: device.id,
            label: device.label || device.id,
          });
        }
        console.debug("Devices were refreshed, checking that we have cameras.");

        // Verify if selected devices are valid
        var videoFlag = data.videoDevices.some(function (device) {
          console.log("Evaluating device ", device);
          if (device.label == storage.data.selectedVideoName) {
            console.log("Matched video selection by name: ", device.label);
            storage.data.selectedVideo = device.id;
            return true;
          }
          return (
            device.id == storage.data.selectedVideo &&
            storage.data.selectedVideo !== "none"
          );
        });

        var shareFlag = data.shareDevices.some(function (device) {
          return device.id == storage.data.selectedShare;
        });

        var audioFlag = data.audioDevices.some(function (device) {
          return device.id == storage.data.selectedAudio;
        });

        var speakerFlag = data.speakerDevices.some(function (device) {
          return device.id == storage.data.selectedSpeaker;
        });

        console.log("Storage Video: ", storage.data.selectedVideo);
        console.log("Video Flag: ", videoFlag);

        if (!videoFlag)
          storage.data.selectedVideo =
            data.videoDevices[data.videoDevices.length - 1].id;
        if (!shareFlag) storage.data.selectedShare = data.shareDevices[0].id;
        if (!audioFlag) storage.data.selectedAudio = data.audioDevices[0].id;
        if (!speakerFlag && data.speakerDevices.length > 0)
          storage.data.selectedSpeaker = data.speakerDevices[0].id;

        // This means that we cannot use video!
        if (data.videoDevices.length === 0) {
          console.log("No camera, disabling video.");
          data.canVideo = false;
          data.videoDevices.push({
            id: "none",
            label: "No camera",
          });
        } else {
          data.canVideo = true;
        }

        if (angular.isFunction(callback)) {
          callback();
        }
      },

      refreshDevices: function (callback) {
        console.debug("Attempting to refresh the devices.");
        if (callback) {
          jQuery.verto.refreshDevices(callback);
        } else {
          jQuery.verto.refreshDevices(this.refreshDevicesCallback);
        }
      },

      /**
       * Updates the video resolutions based on settings.
       */
      refreshVideoResolution: function (resolutions) {
        console.debug("Attempting to refresh video resolutions.");

        if (data.instance) {
          // var w = resolutions.bestResSupported[0];
          // var h = resolutions.bestResSupported[1];

          // if (h >= 1080) {
          //   w = 1280;
          //   h = 720;
          // }

          var w = 640;
          var h = 360;

          updateResolutions(resolutions.validRes);

          /* Do not touch video device resolution if autoBand is off and we have selected a vidQual */
          if (!storage.data.autoBand && storage.data.vidQual) {
            w = videoResolution[storage.data.vidQual].width;
            h = videoResolution[storage.data.vidQual].height;
          }

          data.instance.videoParams({
            width: w,
            height: h,
            aspectRatio: 1.777,
            minFrameRate: 15,
            vertoBestFrameRate: storage.data.bestFrameRate,
          });

          videoQuality.forEach(function (qual) {
            if (
              w === qual.width &&
              h === qual.height &&
              (storage.data.vidQual !== qual.id ||
                storage.data.vidQual === undefined)
            ) {
              storage.data.vidQual = qual.id;
            }
          });

          data.resCheckEnded = true;
        } else {
          console.log("There is no instance of verto.");
        }
      },

      /**
       * Connects to the verto server. Automatically calls `onWSLogin`
       * callback set in the verto object.
       *
       * @param callback
       */
      connect: function (callback) {
        console.debug("Attempting to connect to verto.");
        var that = this;

        function startConference(v, dialog, pvtData) {
          // $rootScope.$emit('call.video', 'video');
          console.log(pvtData);
          data.chattingWith = pvtData.chatID;
          data.confRole = pvtData.role;
          data.conferenceMemberID = pvtData.conferenceMemberID;
          var conf = new $.verto.conf(v, {
            dialog: dialog,
            hasVid: storage.data.useVideo,
            laData: pvtData,
            chatCallback: function (v, e) {
              var from = e.data.fromDisplay || e.data.from || "Unknown";
              var message = e.data.message || "";
              $rootScope.$emit("chat.newMessage", {
                from: from,
                body: message,
              });
            },
            onBroadcast: function (v, conf, message) {
              console.log(">>> conf.onBroadcast:", arguments);
              if (message.action === "response") {
                // This is a response with the video layouts list.

                switch (message["conf-command"]) {
                  case "list-videoLayouts":
                    var rdata = [];

                    for (var i in message.responseData) {
                      rdata.push(message.responseData[i].name);
                    }

                    var options = rdata.sort(function (a, b) {
                      var ga = a.substring(0, 6) === "group:";
                      var gb = b.substring(0, 6) === "group:";

                      if ((ga || gb) && ga !== gb) {
                        return ga ? -1 : 1;
                      }

                      return a === b ? 0 : a > b ? 1 : -1;
                    });
                    data.confLayoutsData = message.responseData;
                    data.confLayouts = options;
                    break;
                  case "canvasInfo":
                    data.canvasInfo = message.responseData;
                    $rootScope.$emit(
                      "conference.canvasInfo",
                      message.responseData
                    );
                    break;
                }
              }
            },
            infoCallback: function (verto, event) {
              if (
                event &&
                event.eventData &&
                event.eventData.contentType === "layout-info"
              ) {
                $rootScope.$emit(
                  "changedVideoLayout",
                  event.eventData.canvasInfo.layoutName
                );
              }
            },
          });

          if (data.confRole === "moderator") {
            console.log(">>> conf.listVideoLayouts();");
            conf.listVideoLayouts();
            conf.modCommand("canvasInfo");
          }

          data.conf = conf;

          data.liveArray = new $.verto.liveArray(
            data.instance,
            pvtData.laChannel,
            pvtData.laName,
            {
              subParams: {
                callID: dialog ? dialog.callID : null,
              },
            }
          );

          data.liveArray.onErr = function (obj, args) {
            console.error("liveArray.onErr", obj, args);
          };

          data.liveArray.onChange = function (obj, args) {
            switch (args.action) {
              case "bootObj":
                args.data.forEach(function (member) {
                  var callId = member[0];
                  var status = angular.fromJson(member[1][4]);
                  if (callId === data.call.callID) {
                    $rootScope.$apply(function () {
                      data.mutedMic = status.audio.muted;
                      data.mutedVideo = status.video.muted;
                    });
                  }
                });
                $rootScope.$emit("members.boot", args.data);
                break;
              case "add":
                var member = [args.key, args.data];
                $rootScope.$emit("members.add", member);
                if (data.confRole === "moderator") {
                  conf.modCommand("canvasInfo");
                }
                break;
              case "del":
                var uuid = args.key;
                $rootScope.$emit("members.del", uuid);
                break;
              case "clear":
                $rootScope.$emit("members.clear");
                break;
              case "modify":
                $rootScope.$emit("members.update", [args.key, args.data]);
                break;
              default:
                console.log("NotImplemented", args.action);
                break;
            }
          };

          $rootScope.$emit("call.conference");
        }

        function stopConference() {
          console.log("stopConference()");
          if (data.liveArray) {
            data.liveArray.destroy();
            console.log("Has data.liveArray.");
            $rootScope.$emit("members.clear");
            data.liveArray = null;
          } else {
            console.log("Doesn't found data.liveArray.");
          }

          if (data.conf) {
            data.conf.destroy();
            data.conf = null;
          }
        }

        var callbacks = {
          onWSLogin: function (v, success) {
            data.connected = success;
            $rootScope.loginFailed = !success;
            $rootScope.$emit("ws.login", success);
            console.debug("Connected to verto server:", success);

            if (angular.isFunction(callback)) {
              callback(v, success);
            }
          },

          onMessage: function (v, dialog, msg, params) {
            console.debug("onMessage:", v, dialog, msg, params);

            switch (msg) {
              case $.verto.enum.message.pvtEvent:
                if (params.pvtData) {
                  switch (params.pvtData.action) {
                    case "conference-liveArray-join":
                      if (
                        !params.pvtData.screenShare &&
                        !params.pvtData.videoOnly
                      ) {
                        console.debug("conference-liveArray-join");
                        stopConference();
                        startConference(v, dialog, params.pvtData);
                      }
                      break;
                    case "conference-liveArray-part":
                      if (
                        !params.pvtData.screenShare &&
                        !params.pvtData.videoOnly
                      ) {
                        console.debug("conference-liveArray-part");
                        stopConference();
                      }
                      break;
                  }
                }
                break;
              /**
               * This is not being used for conferencing chat
               * anymore (see conf.chatCallback for that).
               */
              case $.verto.enum.message.info:
                var body = params.body;
                var from = params.from_msg_name || params.from;
                if (!body) {
                  console.log("Received an empty body: ", params);
                  return;
                }
                $rootScope.$emit("chat.newMessage", {
                  from: from,
                  body: body,
                });
                break;
              case $.verto.enum.message.display:
                $rootScope.$apply(function () {});
                break;
              case $.verto.enum.message.clientReady:
                $rootScope.$emit("clientReady", {
                  reattached_sessions: params.reattached_sessions,
                });
                break;
              default:
                console.warn(
                  "Got a not implemented message:",
                  msg,
                  dialog,
                  params
                );
                break;
            }
          },

          onDialogState: function (d) {
            if (!data.call) {
              data.call = d;
            }

            switch (d.state.name) {
              case "ringing":
                incomingCall(d.params.caller_id_number);
                break;
              case "trying":
                console.debug("Calling:", d.cidString());
                data.callState = "trying";
                break;
              case "early":
                console.debug("Talking to:", d.cidString());
                data.callState = "active";
                calling();
                break;
              case "active":
                console.debug("Talking to:", d.cidString());
                data.callState = "active";
                callActive(d.lastState.name, d.params);

                break;
              case "hangup":
                console.debug("Call ended with cause: " + d.cause);
                if (data.callState === "trying") {
                  $rootScope.$emit("call.cannot.connect");
                }
                data.callState = "hangup";
                break;
              case "destroy":
                console.debug("Destroying: " + d.cause);
                if (d.params.screenShare) {
                  cleanShareCall(that);
                } else {
                  stopConference();
                  if (!that.reloaded) {
                    cleanCall();
                  }
                }
                break;
              default:
                console.warn("Got a not implemented state:", d);
                break;
            }
          },

          onWSClose: function (v, success) {
            console.debug("onWSClose:", success);
            $rootScope.$emit("ws.close", success);
          },

          onEvent: function (v, e) {
            console.debug("onEvent:", e);
          },
          permissionCallback: {
            onDenied: function () {
              $rootScope.$emit("call.denied");
            },
          },
        };

        var that = this;

        function ourBootstrap() {
          var sessid = $location.search().sessid;
          if (sessid === "random") {
            sessid = $.verto.genUUID();
            $location.search().sessid = sessid;
          }
          // Checking if we have a failed connection attempt before
          // connecting again.
          if (data.instance && !data.instance.rpcClient.socketReady()) {
            data.instance.rpcClient.stopRetrying();
            data.instance.login();
            return;
          }
          data.instance = new jQuery.verto(
            {
              login: data.login + "@" + data.hostname,
              passwd: data.password,
              socketUrl: data.wsURL,
              socketFallbackUrl: data.socketFallbackUrl,
              turnServer: data.turnServer,
              tag: "webcam",
              ringFile: "sounds/bell_ring2.wav",
              audioParams: {
                googEchoCancellation:
                  storage.data.googEchoCancellation === undefined
                    ? true
                    : storage.data.googEchoCancellation,
                googNoiseSuppression:
                  storage.data.googNoiseSuppression === undefined
                    ? true
                    : storage.data.googNoiseSuppression,
                googHighpassFilter:
                  storage.data.googHighpassFilter === undefined
                    ? true
                    : storage.data.googHighpassFilter,
                googAutoGainControl:
                  storage.data.googAutoGainControl === undefined
                    ? true
                    : storage.data.googAutoGainControl,
                googAutoGainControl2:
                  storage.data.googAutoGainControl === undefined
                    ? true
                    : storage.data.googAutoGainControl,
              },
              sessid: sessid,
              // iceServers: storage.data.useSTUN,
              iceServers: true,
            },
            callbacks
          );

          // We need to know when user reloaded page and not react to
          // verto events in order to not stop the reload and redirect user back
          // to the dialpad.
          that.reloaded = false;
          jQuery.verto.unloadJobs.push(function () {
            that.reloaded = true;
          });

          data.instance.deviceParams({
            useCamera: storage.data.selectedVideo,
            useSpeak: storage.data.selectedSpeaker,
            useMic: storage.data.selectedAudio,
            onResCheck: that.refreshVideoResolution,
          });
        }

        if (data.mediaPerm) {
          ourBootstrap();
        } else {
          $.FSRTC.checkPerms(ourBootstrap, true, true);
        }
      },

      mediaPerm: function (callback) {
        $.FSRTC.checkPerms(callback, true, true);
      },

      /**
       * Login the client.
       *
       * @param callback
       */
      login: function (callback) {
        data.instance.loginData({
          login: data.login + "@" + data.hostname,
          passwd: data.password,
        });
        data.instance.login();

        if (angular.isFunction(callback)) {
          callback(data.instance, true);
        }
      },

      /**
       * Disconnects from the verto server. Automatically calls `onWSClose`
       * callback set in the verto object.
       *
       * @param callback
       */
      disconnect: function (callback) {
        console.debug("Attempting to disconnect to verto.");

        data.instance.logout();
        data.connected = false;

        console.debug("Disconnected from verto server.");

        if (angular.isFunction(callback)) {
          callback(data.instance, data.connected);
        }
      },

      call: function (destination, callback, custom) {
        var call = data.instance.newCall(
          angular.extend(
            {
              destination_number: destination,
              caller_id_name: data.name,
              caller_id_number: data.callerid ? data.callerid : data.email,
              outgoingBandwidth: storage.data.outgoingBandwidth,
              incomingBandwidth: storage.data.incomingBandwidth,
              // useVideo: storage.data.useVideo,
              useVideo: true,
              useStereo: storage.data.useStereo,
              useCamera: storage.data.selectedVideo,
              useSpeak: storage.data.selectedSpeaker,
              useMic: storage.data.selectedAudio,
              // dedEnc: storage.data.useDedenc,
              dedEnc: false,
              mirrorInput: storage.data.mirrorInput,
              userVariables: {
                email: storage.data.email,
                avatar:
                  "http://gravatar.com/avatar/" +
                  md5(storage.data.email) +
                  ".png?s=600",
              },
            },
            custom
          )
        );

        data.call = call;

        data.mutedMic = false;
        data.mutedVideo = false;
        data.callState = "connecting";

        if (angular.isFunction(callback)) {
          callback(data.instance, call);
        }
      },

      screenshare: function (destination, callback) {
        var that = this;

        if (storage.data.selectedShare !== "screen") {
          var call = data.instance.newCall({
            destination_number: destination + "-screen",
            caller_id_name: data.name + " (Screen)",
            caller_id_number: data.login + " (screen)",
            outgoingBandwidth: storage.data.outgoingBandwidth,
            incomingBandwidth: storage.data.incomingBandwidth,
            useCamera: storage.data.selectedShare,
            useVideo: true,
            screenShare: true,
            dedEnc: storage.data.useDedenc,
            mirrorInput: storage.data.mirrorInput,
            userVariables: {
              email: storage.data.email,
              avatar:
                "http://gravatar.com/avatar/" +
                md5(storage.data.email) +
                ".png?s=600",
            },
          });

          // Override onStream callback in $.FSRTC instance
          call.rtc.options.callbacks.onStream = function (rtc, stream) {
            if (stream) {
              var StreamTrack = stream.getVideoTracks()[0];
              StreamTrack.addEventListener("ended", stopSharing);
              // (stream.getVideoTracks()[0]).onended = stopSharing;
            }

            function stopSharing() {
              if (that.data.shareCall) {
                that.screenshareHangup();
                console.log("screenshare ended");
              }
            }
          };

          data.shareCall = call;

          data.mutedMic = false;
          data.mutedVideo = false;

          that.refreshDevices();

          return;
        }

        var makeSharescreenCall = function (stream) {
          data.shareCall = data.instance.newCall(
            {
              destination_number: destination + "-screen",
              caller_id_name: data.name + " (Screen)",
              caller_id_number: data.login + " (Screen)",
              outgoingBandwidth: storage.data.outgoingBandwidth,
              incomingBandwidth: storage.data.incomingBandwidth,
              useStream: stream,
              useVideo: false,
              videoParams: {},
              screenShare: true,
              useMic: "none",
              dedEnc: storage.data.useDedenc,
              mirrorInput: storage.data.mirrorInput,
              userVariables: {
                email: storage.data.email,
                avatar:
                  "http://gravatar.com/avatar/" +
                  md5(storage.data.email) +
                  ".png?s=600",
              },
            },
            {
              permissionCallback: {
                onGranted: function (stream) {
                  callback(true);
                  var streamTrack = stream.getVideoTracks()[0];
                  streamTrack.addEventListener("ended", function stopSharing() {
                    callback(false);
                    that.screenshareHangup();
                  });
                },
                onDenied: function () {
                  $rootScope.$emit("call.denied");
                },
              },
            }
          );
        };

        if (BROWSER.IS_FIREFOX) {
          makeSharescreenCall();
        } else {
          var onShareError = function (error) {
            console.error(error);
          };

          var displayMediaStreamConstraints = {
            video: true,
            audio: {
              echoCancellation: true,
              noiseSuppression: true,
              sampleRate: 44100,
            },
          };

          navigator.mediaDevices
            .getDisplayMedia(displayMediaStreamConstraints)
            .then(makeSharescreenCall)
            .catch(onShareError);
        }
      },

      screenshareHangup: function () {
        if (!data.shareCall) {
          console.log("There is no call to hangup.");
          return;
        }

        data.shareCall.hangup();
        data.shareCall.rtc.localStream.getVideoTracks()[0].stop();
        data.shareCall = undefined;
      },

      /**
       * Hangup the current call.
       *
       * @param callback
       */
      hangup: function (callback) {
        if (!data.call) {
          console.debug("There is no call to hangup.");
          return false;
        }

        data.call.hangup();

        if (data.conf) {
          data.conf.destroy();
          data.conf = null;
        }

        if (angular.isFunction(callback)) {
          callback(data.instance, true);
        }
      },

      manageVideo: function (status) {
        // $.FSRTC.setVideoMute(status);
      },

      /**
       * Send a DTMF to the current call.
       *
       * @param {string|number} number
       * @param callback
       */
      dtmf: function (number, callback) {
        console.debug('Attempting to send DTMF "' + number + '".');

        if (!data.call) {
          console.debug("There is no call to send DTMF.");
          return false;
        }

        data.call.dtmf(number.toString());
        console.debug("The DTMF was sent for the call.");

        if (angular.isFunction(callback)) {
          callback(data.instance, true);
        }
      },

      /**
       * Do speed test.
       *
       * @param cb
       */
      testSpeed: function (cb) {
        data.instance.rpcClient.speedTest(1024 * 256, function (e, data) {
          var upBand = Math.ceil(data.upKPS * 0.75),
            downBand = Math.ceil(data.downKPS * 0.75);

          if (storage.data.autoBand) {
            storage.data.incomingBandwidth = downBand;
            storage.data.outgoingBandwidth = upBand;
            storage.data.useDedenc = false;
            storage.data.vidQual = "hd";

            if (upBand < 256) {
              storage.data.vidQual = "qqvga";
            } else if (upBand < 512) {
              storage.data.vidQual = "qvga";
            } else if (upBand < 1024) {
              storage.data.vidQual = "vga";
            }
          }

          if (cb) {
            cb(data);
          }

          $rootScope.$emit("testSpeed", data);
        });
      },
      muteMic: function (callback) {
        if (!data.call) {
          console.log("There is no call to mute.");
          return false;
        }

        data.call.dtmf("0");
        data.mutedMic = !data.mutedMic;
        storage.data.mutedMic = !storage.data.mutedMic;

        if (angular.isFunction(callback)) {
          callback(data.instance, true);
        }
      },

      muteVideo: function (callback) {
        if (!data.call) {
          console.log("There is no call to mute.");
          return false;
        }

        data.call.dtmf("*0");
        data.mutedVideo = !data.mutedVideo;
        storage.data.mutedVideo = !storage.data.mutedVideo;

        if (angular.isFunction(callback)) {
          callback(data.instance, true);
        }
      },
      /*
       * Method is used to send conference chats ONLY.
       */
      sendConferenceChat: function (message) {
        data.conf.sendChat(message, "message");
      },
      setCanvasIn: function (memberID, canvasID) {
        data.conf.modCommand("vid-canvas", memberID, canvasID);
      },
      setCanvasOut: function (memberID, canvasID) {
        data.conf.modCommand("vid-watching-canvas", memberID, canvasID);
      },
      setLayer: function (memberID, canvasID) {
        data.conf.modCommand("vid-layer", memberID, canvasID);
      },
      /*
       * Method is used to set a member's resevartion Id.
       */
      setResevartionId: function (memberID, resID) {
        data.conf.modCommand("vid-res-id", memberID, resID);
      },
      /*
       * Method is used to send user2user chats.
       * VC does not yet support that.
       */
      sendMessage: function (body, callback) {
        data.call.message({
          to: data.chattingWith,
          body: body,
          from_msg_name: data.name,
          from_msg_number: data.cid,
        });

        if (angular.isFunction(callback)) {
          callback(data.instance, true);
        }
      },
    };
  },
]);

'use strict';

var vertoService = angular.module('vertoService');

vertoService.service('config', ['$rootScope', '$http', '$location', 'storage', 'verto',
    function ($rootScope, $http, $location, storage, verto) {
        var configure = function () {
            /**
             * Load stored user info into verto service
             */
            if (storage.data.name) {
                verto.data.name = storage.data.name;
            }
            if (storage.data.email) {
                verto.data.email = storage.data.email;
            }
            if (storage.data.login) {
                verto.data.login = storage.data.login;
            }
            if (storage.data.password) {
                verto.data.password = storage.data.password;
            }

            /*
             * Load the Configs before logging in
             * with cache buster
             */
            var url = window.location.origin + window.location.pathname;
            var httpRequest = $http.get(url + 'config.json?cachebuster=' + Math.floor((Math.random() * 1000000) + 1));

            var httpReturn = httpRequest.then(function (response) {
                var data = response.data;

                /* save these for later as we're about to possibly over write them */
                var name = verto.data.name;
                var email = verto.data.email;

                console.debug('googlelogin: ' + data.googlelogin);
                if (data.googlelogin) {
                    verto.data.googlelogin = data.googlelogin;
                    verto.data.googleclientid = data.googleclientid;
                }

                if (data.wsFallbackURL) {
                    verto.data.wsFallbackURL = data.wsFallbackURL;
                }

                if (data.turnServer) {
                    verto.data.turnServer = data.turnServer;
                }

                angular.extend(verto.data, data);

                /**
                 * use stored data (localStorage) for login, allow config.json to take precedence
                 */

                if (name !== '' && data.name === '') {
                    verto.data.name = name;
                }
                if (email !== '' && data.email === '') {
                    verto.data.email = email;
                }
                if (verto.data.login === '' && verto.data.password === '' && storage.data.login !== '' && storage.data.password !== '') {
                    verto.data.login = storage.data.login;
                    verto.data.password = storage.data.password;
                }

                if (verto.data.autologin == 'true' && !verto.data.autologin_done) {
                    console.debug("auto login per config.json");
                    verto.data.autologin_done = true;
                }

                if (verto.data.autologin && storage.data.name.length && storage.data.email.length && storage.data.login.length && storage.data.password.length) {
                    $rootScope.$emit('config.http.success', data);
                }
                return response;
            }, function (response) {
                $rootScope.$emit('config.http.error', response);
                return response;
            });

            return httpReturn;
        };

        return {
            'configure': configure
        };
    }]);

'use strict';

angular
    .module('vertoService')
    .service('eventQueue', ['$rootScope', function ($rootScope) {

        var events = [];

        var next = function () {
            var fn, fnReturn;

            fn = events.shift();

            if (fn === undefined) {
                $rootScope.$emit('eventqueue.complete');
                return;
            }
            fnReturn = fn();

            var emitNextProgress = function () {
                $rootScope.$emit('eventqueue.next');
            };

            fnReturn.then(
                emitNextProgress,
                emitNextProgress
            );
        };

        var process = function () {
            $rootScope.$on('eventqueue.next', next);

            next();
        };

        return {
            'next': next,
            'process': process,
            'events': events
        };

    }
    ]);

(function () {
    'use strict';

    angular
        .module('vertoService')
        .factory('userManagerService', ['$http', '$q', 'notificationService', 'API', userManagerService]);

    function userManagerService($http, $q, notificationService, API) {
        return {
            getAllUsers: function () {
                return $http.get(API.SERVER_URL + 'agent');
            },
            getUser: function (id) {
                return $http.get(API.SERVER_URL + 'agent/' + id);
            },
            createUser: function(userData) {
                var deferred = $q.defer();

                $http.post(API.SERVER_URL + 'agent', userData).then(function () {
                    notificationService.alertSuccess('MSG_USER_CREATED');
                    deferred.resolve();
                }, function (error) {
                    notificationService.alertError(error.data, error.statusText);
                    deferred.reject();
                });

                return deferred.promise;
            },
            editUser: function (user) {
                var deferred = $q.defer();

                $http.put(API.SERVER_URL + 'agent/' + user.Id, user).then(function () {
                    notificationService.alertSuccess('MSG_USER_UPDATED');
                    deferred.resolve();
                }, function (error) {
                    notificationService.alertError(error.data);
                    deferred.reject();
                });

                return deferred.promise;
            },
            deleteUser: function (phoneNumber) {   
                // Specify phoneNumber in data property of a config object
                return $http.delete(API.SERVER_URL + 'agent?PhoneNumber=' + phoneNumber)
                .then(function() {
                    notificationService.alertSuccess('MSG_USER_DELETED')
                })
                .catch(function (error) {
                    notificationService.alertError(error);
                })
            },
            
            changePassword: function (userId, newPassword) {
                var deferred = $q.defer();

                $http.put(API.SERVER_URL + 'newPassword/' + userId, {psw: newPassword}).then(function () {
                    notificationService.alertSuccess('MSG_PASSWORD_CHANGED');
                    deferred.resolve();
                }, function (error) {
                    notificationService.alertError(error.data, error.statusText);
                    deferred.reject();
                });

                return deferred.promise;
            },
            changeLoggedInUserPassword: function (data) {
                var deferred = $q.defer();

                $http.put(API.SERVER_URL + 'changePassword', data).then(function () {
                    notificationService.alertSuccess('MSG_PASSWORD_CHANGED');
                    deferred.resolve();
                }, function (error) {
                    if (error.status === 401) {
                        error.data = {errorMessage: 'ERR_INVALID_OLD_PASSWORD'};
                    }
                    notificationService.alertError(error.data, error.statusText);
                    deferred.reject();
                });

                return deferred.promise;
            }
        };
    }
})();

(function () {
  "use strict";

  angular
    .module("vertoService")
    .factory("authenticationService", [
      "$http",
      "$q",
      "$location",
      "notificationService",
      "verto",
      "storage",
      "API",
      authenticationService,
    ]);

  function authenticationService(
    $http,
    $q,
    $location,
    notificationService,
    verto,
    storage,
    API
  ) {
    var _redirectAfterLogin = function () {
        var deferred = $q.defer();
        if (verto.data.connected) {
          var path = storage.data.preview ? "/preview" : "/dialpad";
          $location.path(path);
          deferred.resolve("success");
        } else {
          var connectCallback = function (v, connected) {
            verto.data.connecting = false;
            console.log(verto.data.connecting);
            if (connected) {
              storage.data.hostname = verto.data.hostname;
              storage.data.wsURL = verto.data.wsURL;
              storage.data.ui_connected = verto.data.connected;
              storage.data.ws_connected = verto.data.connected;

              if (storage.data.autoBand) {
                verto.testSpeed();
              }
              $location.path("/dialpad");
            }
          };

          verto.data.connecting = true;
          verto.connect(connectCallback);
          deferred.resolve("success");
        }
        return deferred.promise;
      },
      _getSessionData = function () {
        if (storage.sessionData.user) {
          try {
            var dec = atob(storage.sessionData.user);
            return JSON.parse(dec);
          } catch (e) {
            return {};
          }
        }

        return {};
      };

    return {
      hasCredentials: function () {
        return _getSessionData().hasCredentials;
      },
      isLogged: function () {
        return _getSessionData().logged;
      },
      isPhoneVerified: function () {
        return _getSessionData().isPhoneVerified;
      },
      isAdmin: function () {
        return _getSessionData().isAdmin;
      },
      isUser: function () {
        return _getSessionData().isUser;
      },
      getPhoneNumber: function () {
        return _getSessionData().phoneNumber;
      },
      getUsername: function () {
        return _getSessionData().username;
      },
      redirectAfterLogin: _redirectAfterLogin,
      login: function (loginData) {
        var deferred = $q.defer();

        $http.post(API.SERVER_URL + "authenticateUser", loginData).then(
          function (response) {
            deferred.resolve(response.data);
          },
          function (error) {
            if (error.status === 401) {
              error.data = { errorMessage: "ERR_INVALID_CREDENTIALS" };
            }
            notificationService.alertError(error.data, error.statusText);
            deferred.reject();
          }
        );

        return deferred.promise;
      },
      register: function (registerData) {
        var deferred = $q.defer();

        $http.post(API.SERVER_URL + "RegisterUser", registerData).then(
          function (response) {
            deferred.resolve(response.data);
          },
          function (error) {
            if (error.status === 404) {
              error.data = { errorMessage: "ERR_INVALID_INPUTS" };
            } else if (error.status === 400) {
              error.data = { errorMessage: "ERR_USER_PHONE_DUPLICATED" };
            }
            notificationService.alertError(error.data, error.statusText);
            deferred.reject();
          }
        );

        return deferred.promise;
      },
      sendVerificationCode: function (data) {
        var deferred = $q.defer();

        $http.post(API.SERVER_URL + "PhoneVerify", data).then(
          function (response) {
            deferred.resolve(response.data);
          },
          function (error) {
            if (error.status === 401) {
              error.data = {
                errorMessage: "Error in sending Verification Code",
              };
            }
            notificationService.alertError(error.data, error.statusText);
            deferred.reject();
          }
        );

        return deferred.promise;
      },
      checkVerificationCode: function (data) {
        var deferred = $q.defer();
        $http
          .get(
            API.SERVER_URL +
              "PhoneVerify?code=" +
              data.verificationCode +
              "&phone=" +
              data.phoneNumber +
              "&type=" +
              data.type
          )
          .then(function (response) {
            if (response.data.Response === "Verification Code is incorrect") {
              notificationService.alertError({
                errorMessage: "Verification code doesn't match",
              });
              // deferred.resolve(response.data.Response)
              deferred.reject(response.data.Response);
            } else if (response.data.Response === "Verified") {
              var sessionData = _getSessionData();
              storage.setUserSessionData(
                sessionData.isAdmin,
                sessionData.isUser,
                sessionData.phoneNumber,
                sessionData.hasCredentials,
                true,
                sessionData.username
              );
              console.log("Session Daaaa", sessionData, _getSessionData());
              notificationService.alertSuccess("Your phone is Verified");
              $location.path("/success");
              deferred.resolve(response.data.Response);
            }
            return response.data.Response;
          });
        return deferred.promise;
      },
      getPhoneVerifyStatus: function (data) {
        var deferred = $q.defer();
        $http
          .get(
            API.SERVER_URL +
              "PhoneVerify?phone=" +
              data.phoneNumber +
              "&type=" +
              data.type
          )
          .then(function (response) {
            deferred.resolve(response.data);
          });

        return deferred.promise;
      },
      logout: function () {
        return $http.delete(API.SERVER_URL + "logoutUser");
      },
      isAuthorized: function () {
        return $http.get(API.SERVER_URL + "isUserAuthorized");
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('vertoService')
    .factory('notificationService', ['$translate', 'toastr', 'prompt', notificationService]);

  function notificationService($translate, toastr, prompt) {
    return {
      alertSuccess: function (message) {
        toastr.success($translate.instant(message));
      },
      alertError: function (messages, statusText) {
        if (messages) {
          if (angular.isArray(messages)) {
            messages.forEach(function (message) {
              toastr.error($translate.instant(message.errorMessage));
            });
          } else {
            toastr.error($translate.instant(messages.errorMessage));
          }
        } else {
          toastr.error(statusText);
        }
      },
      promptInput: function (title, message, label) {
        return prompt({
          title: title,
          message: message,
          input: true,
          label: label
        })
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("vertoService")
    .factory("routeService", [
      "$q",
      "$location",
      "authenticationService",
      "conferenceService",
      "storage",
      routeService,
    ]);

  function routeService(
    $q,
    $location,
    authenticationService,
    conferenceService,
    storage
  ) {
    return {
      loginGuard: function () {
        return !authenticationService.isLogged() ? true : $q.reject();
      },
      loggedGuard: function () {
        return authenticationService.isLogged() ? true : $q.reject();
      },
      adminGuard: function () {
        if (authenticationService.isLogged()) {
          if (authenticationService.isAdmin()) {
            return true;
          }
          $location.path("/dialpad");
          return $q.reject();
        }

        $location.path("/login");
        return $q.reject();
      },
      userAdminGuard: function () {
        if (authenticationService.isLogged()) {
          if (
            authenticationService.isAdmin() ||
            authenticationService.isUser()
          ) {
            return true;
          }
          $location.path("/dialpad");
          return $q.reject();
        }

        $location.path("/login");
        return $q.reject();
      },
      userGuard: function () {
        if (authenticationService.isLogged()) {
          if (authenticationService.isUser()) {
            return true;
          }
          $location.path("/login");
          return $q.reject();
        }

        $location.path("/login");
        return $q.reject();
      },
      mobileBrowseGuard: function () {
        conferenceService.isMobile();
        if (storage.data.isMobile) {
          $location.path("/mobileEnter");
        } else {
          $location.path("/login");
        }
      },
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("vertoService")
    .factory("conferenceService", [
      "$http",
      "$q",
      "$routeParams",
      "notificationService",
      "storage",
      "API",
      conferenceService,
    ]);

  function conferenceService(
    $http,
    $q,
    $routeParams,
    notificationService,
    storage,
    API
  ) {
    var _parseDate = function (date) {
        var utc = date.toISOString().split(/[T.]/);
        return utc[0] + " " + utc[1];
      },
      _unlimitedDate = function () {
        return Date.UTC(1971, 0, 1);
      },
      _currentConf;

    return {
      get currentConf() {
        return _currentConf;
      },
      set currentConf(value) {
        _currentConf = value;
      },
      unsetRoomNumber: function () {
        storage.data.room = undefined;
      },
      setRoomNumber: function () {
        storage.data.room = $routeParams.room;
      },
      getRoomNumber: function () {
        return storage.data.room;
      },
      getAllConferences: function (count, maxId) {
        var params = "?count=" + count;
        if (maxId) {
          params += "&maxId=" + maxId;
        }
        return $http.get(API.SERVER_URL + "conference" + params);
      },
      getConferencesByPhoneNumber: function (phoneNumber, limit) {
        var params = "?username=" + phoneNumber;
        if (limit) {
          params += "&limit=" + limit;
        }
        return $http.get(API.SERVER_URL + "conference/user" + params);
      },

      createConf: function (conf) {
        var confCopy = angular.copy(conf);
        confCopy.begin_date = _parseDate(conf.begin_date);

        var deferred = $q.defer();
        $http.post(API.SERVER_URL + "conference", confCopy).then(
          function () {
            notificationService.alertSuccess("MSG_CONF_CREATED");
            deferred.resolve();
          },
          function (error) {
            notificationService.alertError(error.data, error.statusText);
            deferred.reject();
          }
        );

        return deferred.promise;
      },
      editConf: function (conf) {
        var confCopy = angular.copy(conf);
        confCopy.begin_date.setSeconds(0);
        confCopy.begin_date = _parseDate(confCopy.begin_date);

        delete confCopy.beginParsed;
        delete confCopy.lastUpdateParsed;
        delete confCopy.beginLocal;
        delete confCopy.last_status_date;
        delete confCopy.insert_date;

        var deferred = $q.defer();
        $http.put(API.SERVER_URL + "conference", confCopy).then(
          function () {
            notificationService.alertSuccess("MSG_CONF_UPDATED");
            confCopy.beginLocal = new Date(confCopy.begin_date);
            deferred.resolve(confCopy);
          },
          function (error) {
            notificationService.alertError(error.data, error.statusText);
            deferred.reject();
          }
        );

        return deferred.promise;
      },
      deleteConf: function (id) {
        var deferred = $q.defer();
        $http.delete(API.SERVER_URL + "conference?id=" + id).then(
          function () {
            notificationService.alertSuccess("MSG_CONF_DELETE");
            deferred.resolve();
          },
          function (error) {
            notificationService.alertError(error.data, error.statusText);
            deferred.reject();
          }
        );

        return deferred.promise;
      },
      inCall: false,
      isUnlimited: function (beginDate) {
        var date = new Date(beginDate);
        return (
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) ===
          _unlimitedDate()
        );
      },
      toUnlimitedDate: function () {
        return new Date(_unlimitedDate());
      },
      isMobile: function () {
        var userAgent = window.navigator.userAgent;
        console.log(
          "UserAgent:",
          userAgent,
          /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(userAgent),
          $routeParams.room
        );
        if (
          /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(userAgent) &&
          $routeParams.room
        ) {
          storage.data.isMobile = true;
        } else {
          storage.data.isMobile = false;
        }
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('vertoService')
    .factory('screenService', [screenService]);

  function screenService() {
    var elem = document.documentElement;
    return {
      openFullscreen: function () {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen();
        }
      },
      closeFullscreen: function () {
        if (!document.fullscreenElement) return;

        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      },
      addFullscreenListener: function (callback) {
        var listener = function() {
          if (!document.fullscreenElement) {
            callback();
            document.removeEventListener('fullscreenchange', listener);
          }
        }
        document.addEventListener('fullscreenchange', listener);
      },
      isInFullscreenMode: document.fullscreenElement
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('vertoService')
    .factory('listenerService', ['$window', 'verto', listenerService]);

  function listenerService($window, verto) {
    return {
      hangupOnUnload: function () {
        $window.addEventListener('unload', function () {
          verto.hangup();
        });
      }
    };
  }
})();

(function () {
  'use strict';
  
  angular.module('vertoService')
    .factory('modalService', ['$uibModal', modalService]);
  
  function modalService($uibModal) {

    return {
      openModal: function (templateUrl, controller, options) {
        var constOptions = {
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          backdrop: 'static',
          templateUrl: templateUrl,
          controller: controller
        };

        if (options) {
          angular.extend(constOptions, options);
        }

        return $uibModal.open(constOptions);
      }
    }
  }
})();

// (function () {
//   "use strict";

//   angular.module("vertoService").service("dataService", function () {
//     this.registerData = {
//       username: undefined,
//       pass: undefined,
//       phone: undefined,
//     };

//     this.getResigterData = function () {
//       return this.registerData;
//     };
//   });
// })();

(function () {
  "use strict";

  angular.module("vertoService").factory("dataService", [dataService]);

  function dataService() {
    return {
      registerData: {
        username: undefined,
        pass: undefined,
        phone: undefined,
      },
      getResigterData: function () {
        return this.registerData;
      },
    };
  }
})();

(function () {
  'use strict';
  angular.module('storageService', ['ngStorage']);
})();

"use strict";

angular.module("storageService").factory("storage", [
  "$localStorage",
  "$sessionStorage",
  function ($localStorage, $sessionStorage) {
    var localData = $localStorage,
      sessiobData = $sessionStorage,
      defaultSettings = {
        ui_connected: false,
        ws_connected: false,
        cur_call: 0,
        called_number: "",
        useVideo: true,
        call_history: {},
        history_control: [],
        call_start: false,
        name: "",
        email: "",
        phoneNumber: "",
        userStatus: "disconnected",
        mutedVideo: false,
        mutedMic: false,
        preview: true,
        selectedVideo: null,
        selectedVideoName: null,
        selectedAudio: null,
        selectedShare: null,
        selectedSpeaker: null,
        useStereo: true,
        useSTUN: true,
        useDedenc: false,
        mirrorInput: false,
        outgoingBandwidth: "default",
        incomingBandwidth: "default",
        isMobile: false,
        vidQual: undefined,
        askRecoverCall: false,
        googNoiseSuppression: true,
        googHighpassFilter: true,
        googEchoCancellation: true,
        googAutoGainControl: true,
        autoBand: true,
        testSpeedJoin: true,
        bestFrameRate: "15",
        language: undefined,
        hasAccess: false,
      };

    localData.$default(defaultSettings);

    function changeData(verto_data) {
      $.extend(true, localData, verto_data);
    }

    return {
      data: localData,
      sessionData: sessiobData,
      setUserSessionData: function (
        isAdmin,
        isUser,
        phoneNumber,
        hasCredentials,
        isPhoneVerified,
        username
      ) {
        var dataToString = JSON.stringify({
          logged: true,
          isAdmin: isAdmin,
          isUser: isUser,
          phoneNumber: phoneNumber,
          hasCredentials: hasCredentials,
          isPhoneVerified: isPhoneVerified,
          username: username,
        });
        // sessiobData.$default({ user: btoa(dataToString) });
        sessiobData.user = btoa(dataToString);
      },
      changeData: changeData,
      reset: function () {
        localData.ui_connected = false;
        localData.ws_connected = false;
        localData.cur_call = 0;
        localData.userStatus = "disconnected";
        localData.profile = undefined;
        localData.called_number = undefined;
        localData.email = undefined;
        sessiobData.$reset();
      },
      factoryReset: function () {
        sessionStorage.clear();
        localStorage.clear();
        localData.$reset(defaultSettings);
      },
    };
  },
]);

'use strict';

  angular
  .module('vertoService')
  .factory('callHistory', ["storage", function(storage) {

    var history = storage.data.call_history;
    var history_control = storage.data.history_control;

    var addCallToHistory = function(number, direction, status) {
      if(history[number] == undefined) {
        history[number] = [];
      }

      history[number].unshift({
        'number': number,
        'direction': direction,
        'status': status,
        'call_start': Date()
      });

      var index = history_control.indexOf(number);
      console.log(index);
      if(index > -1) {
        history_control.splice(index, 1);
      }

      history_control.unshift(number);

    };

    var getCallsFromHistory = function(number) {
      return history[number];
    };

    return {
      all: function() {
        return history;
      },
      all_control: function() {
        return history_control;
      },
      get: function(number) {
        return getCallsFromHistory(number);
      },
      add: function(number, direction, status) {
        return addCallToHistory(number, direction, status);
      },
      clear: function() {
        storage.data.call_history = {};
        storage.data.history_control = [];
        history = storage.data.call_history;
        history_control = storage.data.history_control;
        return history_control;
      }
    }
}]);

'use strict';

angular
  .module('storageService')
  .service('splashscreen', ['$rootScope', '$q', 'storage', 'config', 'verto', '$translate',
    function ($rootScope, $q, storage, config, verto, $translate) {

      var checkBrowser = function () {
        return $q(function (resolve, reject) {
          var activity = 'browser-upgrade';
          var result = {
            'activity': activity,
            'soft': false,
            'status': 'success',
            'message': $translate.instant('BROWSER_COMPATIBILITY')
          };
          if (!navigator.mediaDevices.getUserMedia) {
            result['status'] = 'error';
            result['message'] = $translate.instant('BROWSER_WITHOUT_WEBRTC');
            reject(result);
          }

          resolve(result);

        });
      };

      var checkMediaPerm = function () {
        return $q(function (resolve, reject) {
          var activity = 'media-perm';
          var result = {
            'activity': activity,
            'soft': false,
            'status': 'success',
            'message': $translate.instant('CHECK_PERMISSION_MEDIA')
          };

          verto.mediaPerm(function (status) {
            if (!status) {
              result['status'] = 'error';
              result['message'] = $translate.instant('ERROR_PERMISSION_MEDIA');
              verto.data.mediaPerm = false;
              reject(result);
            }
            verto.data.mediaPerm = true;
            resolve(result);
          });
        });
      };

      var refreshMediaDevices = function () {
        return $q(function (resolve, reject) {
          var activity = 'refresh-devices';
          var result = {
            'status': 'success',
            'soft': true,
            'activity': activity,
            'message': $translate.instant('REFRESH_MEDIA_DEVICES')
          };

          verto.refreshDevices(function (status) {
            verto.refreshDevicesCallback(function () {
              resolve(result);
            });
          });

        });
      };

      var checkConnectionSpeed = function () {
        return $q(function (resolve, reject) {
          var activity = 'check-connection-speed';
          var result = {
            'status': 'success',
            'soft': true,
            'activity': activity,
            'message': $translate.instant('CHECK_CONNECTION_SPEED')
          };

          if (storage.data.autoBand && verto.data.instance) {
            verto.testSpeed(cb);
          } else {
            resolve(result);
          }

          function cb(data) {
            resolve(result);
          }
        });
      };

      var provisionConfig = function () {
        return $q(function (resolve, reject) {
          var activity = 'provision-config';
          var result = {
            'status': 'promise',
            'soft': true,
            'activity': activity,
            'message': $translate.instant('CHECK_PROVISIONING_CONF')
          };

          var configResponse = config.configure();

          var configPromise = configResponse.then(
            function (response) {
              /**
               * from angular docs:
               * A response status code between 200 and 299 is considered a success status and will result in the success callback being called
               */
              if (response.status >= 200 && response.status <= 299) {
                return result;
              } else {
                result['status'] = 'error';
                result['message'] = $translate.instant('ERROR_PROVISIONING_CONF');
                return result;
              }
            });

          result.promise = configPromise;

          resolve(result);
        });
      };

      var checkLogin = function () {
        return $q(function (resolve, reject) {
          var activity = 'check-login';
          var result = {
            'status': 'success',
            'soft': true,
            'activity': activity,
            'message': $translate.instant('CHECK_LOGIN'),
          };

          if (verto.data.connecting || verto.data.connected) {
            resolve(result);
            return;
          }

          var checkUserStored = function () {
            /**
             * if user data saved, use stored data for logon and not connecting
             * not connecting prevent two connects
             */
            if (storage.data.ui_connected && storage.data.ws_connected && !verto.data.connecting) {
              verto.data.hostname = storage.data.hostname || verto.data.hostname;
              verto.data.wsURL = storage.data.wsURL || verto.data.wsURL;
              verto.data.name = storage.data.name;
              verto.data.email = storage.data.email;
              // verto.data.login = storage.data.login;
              // verto.data.password = storage.data.password;

              verto.data.connecting = true;
              verto.connect(function (v, connected) {
                verto.data.connecting = false;
                resolve(result);
              });
            }
          };

          if (storage.data.ui_connected && storage.data.ws_connected) {
            checkUserStored();
          } else {
            resolve(result);
          }
        });
      };

      var progress = [
        checkBrowser,
        checkMediaPerm,
        refreshMediaDevices,
        provisionConfig,
        checkLogin,
        checkConnectionSpeed
      ];

      var progress_message = [
        $translate.instant('BROWSER_COMPATIBILITY'),
        $translate.instant('CHECK_PERMISSION_MEDIA'),
        $translate.instant('REFRESH_MEDIA_DEVICES'),
        $translate.instant('CHECK_PROVISIONING_CONF'),
        $translate.instant('CHECK_LOGIN'),
        $translate.instant('CHECK_CONNECTION_SPEED'),
      ];

      var getProgressMessage = function (current_progress) {
        if (progress_message[current_progress] != undefined) {
          return progress_message[current_progress];
        } else {
          return $translate.instant('PLEASE_WAIT');
        }
      };

      var current_progress = -1;
      var progress_percentage = 0;

      var calculateProgress = function (index) {
        var _progress;

        _progress = index + 1;
        progress_percentage = (_progress / progress.length) * 100;
        return progress_percentage;
      };

      var nextProgress = function () {
        var fn, fn_return, status, interrupt, activity, soft, message, promise;
        interrupt = false;
        current_progress++;

        if (current_progress >= progress.length) {
          $rootScope.$emit('progress.complete', current_progress);
          return;
        }

        fn = progress[current_progress];
        fn_return = fn();

        var emitNextProgress = function (fn_return) {
          if (fn_return['promise'] != undefined) {
            promise = fn_return['promise'];
          }

          status = fn_return['status'];
          soft = fn_return['soft'];
          activity = fn_return['activity'];
          message = fn_return['message'];

          if (status != 'success') {
            interrupt = true;
          }

          $rootScope.$emit('progress.next', current_progress, status, promise, activity, soft, interrupt, message);
        };

        fn_return.then(
          function (fn_return) {
            emitNextProgress(fn_return);
          },
          function (fn_return) {
            emitNextProgress(fn_return);
          }
        );

      };
     return {
        'next': nextProgress,
        'getProgressMessage': getProgressMessage,
        'progress_percentage': progress_percentage,
        'calculate': calculateProgress
      };

    }
  ]);

(function() {
  'use strict';
  angular.module('vertoConstants', []);
})();

(function () {
  "use strict";
  angular.module("vertoConstants").constant("API", {
    // SERVER_URL: 'https://conf.mg-comm.com/WebConf/',
    SERVER_URL: window.location.origin + "/WebConf/",
    // SERVER_URL: window.location.origin + '/conf-backend'
  });
})();

(function() {
    'use strict';
    angular.module('vertoConstants')
        .constant('VERTO_CONFIG', {
            HOSTNAME: window.location.hostname,
            WEBSOCKET_URL: 'wss://' + window.location.hostname + ':8082',
            LOGIN: '1008',
            PASSWORD: '56781234'
        });
})();

(function () {
  'use strict';
  angular
    .module('vertoConstants')
    .constant('BROWSER', {
      IS_FIREFOX: !!navigator.mozGetUserMedia
    });
})();

(function() {
    'use strict';
    angular.module('vertoConstants')
        .constant('VALIDATOR', {
            EMAIL: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
        });
})();
